/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/*!******************!*\
  !*** multi main ***!
  \******************/
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(/*! ./pixo/js/src/pixo.js */1);


/***/ },
/* 1 */
/*!*****************************!*\
  !*** ./pixo/js/src/pixo.js ***!
  \*****************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ===================================================== */
	/*	Theme Javascript
	/* ===================================================== */
	
	// Requires
	__webpack_require__(/*! ./smooth */ 3);
	__webpack_require__(/*! ./alerts */ 4);
	__webpack_require__(/*! ./isMobile */ 6);
	__webpack_require__(/*! waitForImages */ 7);
	__webpack_require__(/*! portfolio */ 9);
	module.exports = __webpack_require__(/*! ./jquery.portfolio.js */ 9);
	
	// Includes without loading as a module, usefull for plugins that don't have module support
	__webpack_require__(/*! script!../../assets/jquery.mb.YTPlayer/jquery.mb.YTPlayer.js */ 10);
	__webpack_require__(/*! script!../../assets/flexibility/flexibility.js */ 13);
	
	
	(function ($, window, document) {
	    "use strict";
	
	    // Include JS
	    var Isotope = __webpack_require__(/*! isotope */ 15);
	    __webpack_require__(/*! jquery-bridget */ 32);
	    $.bridget('isotope', Isotope);
	
	    window.pixo = {
	
	        settings: {
	            pageTransition: {
	                enabled: true,
	                excluded: '.disable-transition, .prettyPhoto, .lightbox-btn, .main_menu a'
	            },
	            transitionEvent: 'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
	            animationEvent: 'webkitAnimationEnd oAnimationEnd  msAnimationEnd animationend',
	            equalHeights: '.cols-equal .contents > .col, .cols-equal .container > .col'
	        },
	
	        SliderSettings: {
	            auto: true,
	            speed: 1000,
	            pause: 8000,
	            mode: 'fade',
	            pager: true,
	            controls: true
	        },
	
	        init: function () {
	            this.menu();
	            this.selector();
	            this.video_bg();
	
	            $('.alert').alerts();
	
	            __webpack_require__(/*! fitVids */ 34);
	            $('.video-wrapper, .responsive-video').fitVids();
	
	            //if( pixo.override.SliderSettings ) {
	            //    pixo.SliderSettings = pixo.override.SliderSettings ;
	            //}
	
	            __webpack_require__(/*! prettyphoto */ 36);
	            $("a[data-pp^='prettyPhoto']").prettyPhoto({
	                hook: 'data-pp',
	                theme: 'light_square',
	                social_tools: '',
	                deeplinking: false
	            });
	
	
	            $(document).ready(function () {
	                pixo.scroller();
	                if (pixo.settings.pageTransition.enabled) {
	                    pixo.page_transitions();
	                }
	                pixo.back_to_top(); // Must be after scroller
	                pixo.equal_heights();
	                pixo.slider();
	                pixo.shapes();
	                pixo.skills();
	                pixo.maps();
	                pixo.preloader();
	                __webpack_require__(/*! ytplayer */ 106);
	
	                //mb_YTPlayer('.player');
	
	                if (isMobile.any() === null) {
	                    $(".player").mb_YTPlayer();
	                }
	            });
	
	            $(window).on("load", function () {
	                pixo.blog_masonry();
	
	            });
	        },
	
	        equal_heights: function () {
	            __webpack_require__(/*! matchHeight */ 107);
	            $(pixo.settings.equalHeights).matchHeight();
	        },
	
	        slider: function () {
	            __webpack_require__(/*! bxslider */ 108);
	            $('.testimonial').bxSlider(pixo.SliderSettings);
	            $('.post-slider').bxSlider({
	                auto: true,
	                speed: 1000,
	                pause: 8000,
	                mode: 'fade',
	                pager: false,
	                adaptiveHeight: true
	            });
	        },
	        preloader: function () {
	        $('body').waitForImages(function () {
	            $('.preloader').fadeOut(1000);
	        });
	    },
	        page_transitions: function () {
	
	            $('body').waitForImages(function () {
	                $(this).addClass('page-animate-in');
	            });
	
	            var siteURL = "http://" + top.location.host.toString();
	
	            $("a[href^='" + siteURL + "']").not(pixo.settings.pageTransition.excluded).click(function (e) {
	                e.preventDefault();
	                var newLocation = jQuery(this).attr('href');
	                $('body').addClass('page-animate-out');
	
	                $('.page-animate-out').one(pixo.settings.animationEvent, function () {
	                    window.location = newLocation;
	                });
	            });
	        },
	
	        scroller: function () {
	            // Only run if there is more than
	            // one defined section
	            var pageScroller = $('.page-scroller');
	            if (1 < pageScroller.length) {
	
	                $('html').addClass('enable-page-scroller');
	
	                var pageScrollerWrap = $('<div id="page-scroller-wrap" />');
	
	                var footer = $('.footer');
	
	                if (1 < pageScroller.length) {
	
	                    // We want the retain HTML5 structure & we want to center contents
	                    footer.wrapInner('<div class="centerer"></div>');
	
	                    // Because scroll sections must be a scroll tag
	                    footer.wrap('<section class="page-scroller"></section>');
	
	                    $('.page-scroller').wrapAll(pageScrollerWrap);
	
	                    __webpack_require__(/*! onepage-scroll */ 109);
	                    $('#page-scroller-wrap').onepage_scroll({
	                        responsiveFallback: 1000,
	                        direction: zorbix_settings.scroller_direction,
	                        loop: false,
	                        afterMove: function(index) {
	                            pixo.back_to_top_scroller()
	                        }
	                    }); // Must be sections
	
	                    $('.scroll-jump a').click(function(e){
	                        e.preventDefault();
	                        if( $('body').hasClass('disabled-onepage-scroll') ) {
	                            $.smooth({elem: $(this).attr('href')});
	                        }
	                    });
	
	                    $('.scroll-jump').click(function () {
	                        if( !$('body').hasClass('disabled-onepage-scroll') ) {
	                            var num = $(this).data('scrolljump');
	                            $(".main").moveTo(num);
	                        } else {
	                            var url = $(this).find('a').attr('href');
	                            $.smooth({ elem: url });
	                        }
	                    });
	
	                    $('.menu-triangle a').click(function () {
	                        var url = $(this).attr('href');
	                        if (url.charAt(0) ==='#' && $.isNumeric(url.charAt(1))) {
	                            var num = url.charAt(1);
	                            $(".main").moveTo(num);
	                            var menu_triangle = $('.triangle-menu-wrap');
	                            menu_triangle.toggleClass('switch');
	                            $('.menu-btn').find('i').toggleClass('fa-times fa-bars');
	                        }
	
	                    });
	                }
	
	            } else {
	                $('.scroll-jump a').click( function(e){
	                    var url = $(this).attr('href');
	                    if (url.charAt(0) ==='#' && url != '#' && url != '#.html') {
	                        e.preventDefault();
	                        $.smooth({elem: url});
	                    }
	                });
	            }
	        },
	
	        selector: function () {
	            if (1 === $('.selector').length) {
	                //$('.triangle-menu').fadeIn();
	            }
	        },
	
	
	        menu: function () {
	
	            var menu_triangle = $('.triangle-menu-wrap');
	
	            // Open menu function
	            $('.menu-btn').click(function () {
	                menu_triangle.toggleClass('switch');
	                $(this).find('i').toggleClass('fa-times fa-bars');
	            });
	
	            // Moves triangle to first selector
	            var logo_triangle = $('.logo-triangle');
	            if (!logo_triangle.hasClass('sticky-triangle')) {
	                var element = logo_triangle.remove();
	                $('.selector').append(element);
	            }
	
	            // Mobile Dropdowns
	            $('.main_menu li a').on('click', function (event) {
	                // If it's not mobile menu, stop
	                var sub_menu = $(this).parent().find('.sub-menu');
	                if (0 < sub_menu.length) {
	                    // Remove all current classes
	                    $('.main_menu .sub-menu').parent().removeClass('current')
	                    // Slide up everything but the parents of the current item
	                    $('.main_menu .sub-menu').not($(this).parents('.sub-menu')).slideUp()
	
	                    $(this).parent().toggleClass('current');
	                    sub_menu.first().slideToggle();
	                    event.preventDefault();
	
	                }
	            });
	        },
	
	
	        video_bg: function () {
	
	            // Only run video on desktop
	            $('.video-background').each(function () {
	                var videoBackground = $(this);
	
	                __webpack_require__(/*! ./isMobile */ 6);
	                if (isMobile.any() === null) {
	                    videoBackground.parent().append('<div class="video_controls"><a href="#" class="video_pause"><i class="fa fa-play"></i></a> <a href="#" class="video_mute"><i class="fa fa-volume-off"></i></a></div>');
	
	                    // Pause Video
	                    var video_controls = videoBackground.parent().find('.video_controls');
	                    video_controls.find('.video_pause').on('click', function (e) {
	                        e.preventDefault();
	                        if (videoBackground.get(0).paused === false) {
	                            videoBackground.get(0).pause();
	                            $(this).find('i').removeClass('fa-play').addClass('fa-pause');
	                        } else {
	                            videoBackground.get(0).play();
	                            $(this).find('i').removeClass('fa-pause').addClass('fa-play');
	                        }
	                    });
	
	                    // Unmute
	                    video_controls.find('.video_mute').on('click', function (e) {
	                        e.preventDefault();
	                        videoBackground.get(0).muted = !videoBackground.get(0).muted;
	                        $(this).find('i').toggleClass('fa-volume-off').toggleClass('fa-volume-up');
	                    });
	
	                }
	
	            });
	        },
	
	
	        shapes: function () { // Append SVG CLip templates
	            var body = $('body');
	
	            if (0 === $('.hidden_mask').length) {
	                // Feature shapes circle
	                body.prepend('<svg class="hidden_mask"><clipPath id="cirlce_mask"><path d="M125,25 C180.228,25 225,69.772 225,125 C225,180.228 180.228,225 125,225 C69.772,225 25,180.228 25,125 C25,69.772 69.772,25 125,25 z"/></clipPath></svg>');
	            }
	
	// Create SVG Masks
	            $('.create-svg').each(function () {
	                var src = $(this).attr('src');
	                var clip_mask = $(this).data('clip');
	                if (clip_mask === '#circle_mask') {
	                    var svg_circle = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="220" height="220" viewBox="0, 0, 250, 250"><g>' +
	                        '<image xlink:href="' + src + '" opacity="1" x="25" y="25" width="200" height="200" preserveAspectRatio="xMidYMid" clip-path="url(#cirlce_mask)"/>' +
	                        '<path d="M125,245.734 C58.32,245.734 4.266,191.68 4.266,125 C4.266,58.32 58.32,4.266 125,4.266 C191.68,4.266 245.734,58.32 245.734,125 C245.734,191.68 191.68,245.734 125,245.734 z" fill-opacity="0" stroke="#000" stroke-width="1"/>' +
	                        '</g></svg>';
	                    $(this).after(svg_circle);
	                }
	                $(this).remove();
	            });
	        },
	
	
	        skills: function () {
	            __webpack_require__(/*! easypiechart */ 113);
	            if ($.isFunction($.fn.easyPieChart)) {
	
	                $('.skill-bar').each(function () {
	
	                    var barColor = null !== $('.skill-bar').data('bar-color') ? $('.skill-bar').data('bar-color') : '';
	
	                    $(this).easyPieChart({
	                        // easing: 'easeOutBounce',
	                        size: 170,
	                        animate: 2000,
	                        lineWidth: 10,
	                        lineCap: 'butt',
	                        scaleColor: false,
	                        rotate: 270,
	                        barColor: barColor
	                    });
	
	                });
	
	            } else {
	                console.log('easypiechart plugin required');
	            }
	        },
	
	        milestones: function ($) {
	
	            $('.milestone').each(function () {
	                $(this).appear(function () {
	                    var countElem = $(this).find('.count');
	                    var numCountTo = countElem.data('count').toString();
	
	                    numCountTo = numCountTo.replace(',', '');
	                    numCountTo.replace('.', '');
	
	                    countElem.countTo({
	                        from: 0,
	                        to: numCountTo,
	                        speed: 2200,
	                        refreshInterval: 60,
	                        formatter: function (value, options) {
	                            value = value.toFixed(options.decimals);
	                            value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	                            return value;
	                        }
	                    });
	                });
	
	            });
	        },
	
	        maps: function () {
	            // http://www.smashinglabs.pl/gmap/documentation
	            __webpack_require__(/*! gmap/jquery.gmap.js */ 114);
	            if ($.isFunction($.fn.gMap)) {
	
	                var mapStyles = [{
	                    "featureType": "landscape",
	                    "stylers": [{
	                        "saturation": -100
	                    }, {
	                        "lightness": 65
	                    }, {
	                        "visibility": "on"
	                    }]
	                }, {
	                    "featureType": "poi",
	                    "stylers": [{
	                        "saturation": -100
	                    }, {
	                        "lightness": 51
	                    }, {
	                        "visibility": "simplified"
	                    }]
	                }, {
	                    "featureType": "road.highway",
	                    "stylers": [{
	                        "saturation": -100
	                    }, {
	                        "visibility": "simplified"
	                    }]
	                }, {
	                    "featureType": "road.arterial",
	                    "stylers": [{
	                        "saturation": -100
	                    }, {
	                        "lightness": 30
	                    }, {
	                        "visibility": "on"
	                    }]
	                }, {
	                    "featureType": "road.local",
	                    "stylers": [{
	                        "saturation": -100
	                    }, {
	                        "lightness": 40
	                    }, {
	                        "visibility": "on"
	                    }]
	                }, {
	                    "featureType": "transit",
	                    "stylers": [{
	                        "saturation": -100
	                    }, {
	                        "visibility": "simplified"
	                    }]
	                }, {
	                    "featureType": "administrative.province",
	                    "stylers": [{
	                        "visibility": "off"
	                    }]
	                }, {
	                    "featureType": "water",
	                    "elementType": "labels",
	                    "stylers": [{
	                        "visibility": "on"
	                    }, {
	                        "lightness": -25
	                    }, {
	                        "saturation": -100
	                    }]
	                }, {
	                    "featureType": "water",
	                    "elementType": "geometry",
	                    "stylers": [{
	                        "hue": "#ffff00"
	                    }, {
	                        "lightness": -25
	                    }, {
	                        "saturation": -97
	                    }]
	                }];
	
	
	                // var address = "Kensington Gardens Square, London, UK";
	
	                $('.google-map').each(function () {
	
	                    var address = $(this).data('address');
	                    var markers = $(this).data('markers');
	                    var zoom = $(this).data('zoom');
	                    zoom = ( zoom ) ? zoom : 16;
	
	                    // If no markers are set default to the address
	                    // Format to json
	                    if (!markers) {
	                        markers = [{"address": address}];
	                    } else {
	                        if (markers.indexOf('{') !== -1) {
	                            markers = markers.replace(/{/gi, '{"address":"');
	                            markers = markers.replace(/}/gi, '"}');
	                            markers = '[' + markers + ']';
	                            markers = jQuery.parseJSON(markers);
	                        } else {
	                            markers = [{"address": markers}];
	                        }
	                    }
	
	                    $(this).gMap({
	                        address: address,
	                        markers: markers,
	                        zoom: zoom,
	                        styles: mapStyles,
	                        scrollwheel: false
	                    });
	
	                });
	
	                $('.map-overlay').on('click', function (event) {
	                    event.preventDefault();
	                    $('.map-holder .close-btn').fadeIn();
	                    $(this).fadeOut(function () {
	                        $('.map-holder').css('height', '400');
	                    });
	                });
	
	                $('.map-holder .close-btn').on('click', function (e) {
	                    e.preventDefault();
	                    var elem = this;
	                    $('.map-overlay').fadeIn(function () {
	                        $('.map-holder').css('height', '100');
	                        $(elem).fadeOut();
	                    });
	                });
	            } else {
	                console.warn('gmap not found');
	            }
	        },
	
	
	        blog_masonry: function () {
	
	
	            jQuery('.blog-masonry').waitForImages(function () {
	                __webpack_require__(/*! isotope */ 15);
	                jQuery('.blog-masonry').isotope({
	                    itemSelector: '.blog-post',
	                    layoutMode: 'masonry',
	                });
	            });
	
	            jQuery('.latest-posts').waitForImages(function () {
	                jQuery('.latest-posts').isotope({
	                    itemSelector: '.col',
	                    layoutMode: 'masonry',
	                });
	            });
	        },
	
	        back_to_top_scroller: function() {
	            var $topBtn = $('.top-btn');
	            $topBtn.find('i').removeClass('fa-chevron-up');
	            $topBtn.find('i').addClass('fa-chevron-left');
	            if( !$topBtn.hasClass('show') ) {
	                if( !$('body').hasClass('viewing-page-1') ) {
	                   $topBtn.addClass('show');
	                    $topBtn.on('click', function (event) {
	                            $(".page-scroller").moveTo(1);
	                    })
	                }
	            } else {
	                if( $('body').hasClass('viewing-page-1') ) {
	                    $topBtn.removeClass('show');
	                }
	            }
	        },
	
	        back_to_top: function () {
	            var $topBtn = $('.top-btn');
	            if ($topBtn.length) {
	
	
	
	                if( 1 !== jQuery('#page-scroller-wrap').length ) {
	                    $topBtn.on('click', function (event) {
	                        event.preventDefault();
	                        $.smooth({elem: 'body', offset: -60});
	                    });
	
	                    showTopButton();
	                    $(window).on('scroll', function () {
	                        showTopButton();
	                    });
	                }
	
	            }
	
	            function showTopButton() {
	                if (jQuery(window).scrollTop() > 100) {
	                    $topBtn.addClass('show');
	                } else {
	                    $topBtn.removeClass('show');
	                }
	            }
	        }
	
	
	    }
	    window.pixo.init();
	})
	(jQuery, window, document);
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 2)))

/***/ },
/* 2 */
/*!*************************!*\
  !*** external "jQuery" ***!
  \*************************/
/***/ function(module, exports) {

	module.exports = jQuery;

/***/ },
/* 3 */
/*!*******************************!*\
  !*** ./pixo/js/src/smooth.js ***!
  \*******************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {
	/* ===================================================== */
	/* Smooth Scrolling                                      */
	/* ===================================================== */
	
	(function ($) {
	    "use strict";
	
	    /**
	     *
	     * @param { options }
	     * scrollSpeed
	     * offset
	     * func
	     */
	    $.smooth = function (options) {
	
	        var defaults = {
	            scrollSpeed: 2000,
	            offset: 0,
	            func: function () {}
	        };
	
	        // Merge options
	        var settings = $.extend({}, defaults, options);
	
	        var pos;
	
	        // Get scroll to position
	        if ($.isNumeric(settings.elem)) {
	            pos = settings.elem;
	        } else {
	
	            // Exit if we can't find the element
	            if ( 0 === $(settings.elem).length ) {
	                console.warn( 'Cannot find Item with ID', settings.elem );
	                return;
	            }
	
	            pos = $(settings.elem).offset().top;
	        }
	
	        // Animate
	        $('html, body').animate({
	            scrollTop: pos + settings.offset
	        }, settings.scrollSpeed, function () {
	            settings.func();
	        });
	    };
	
	})(jQuery);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 2)))

/***/ },
/* 4 */
/*!*******************************!*\
  !*** ./pixo/js/src/alerts.js ***!
  \*******************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery, module) {module.export = (function ($) {
	    $.fn.alerts = function () {
	
	        var button = $(this).prepend('<a class="alert-button" href="#"></a>')
	
	        $('.alert-button').click(function () {
	            $(this).parent().animate({
	                opacity: "toggle"
	            });
	            return false;
	        });
	
	    };
	})(jQuery);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 2), __webpack_require__(/*! ./../../../~/webpack/buildin/module.js */ 5)(module)))

/***/ },
/* 5 */
/*!***********************************!*\
  !*** (webpack)/buildin/module.js ***!
  \***********************************/
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 6 */
/*!*********************************!*\
  !*** ./pixo/js/src/isMobile.js ***!
  \*********************************/
/***/ function(module, exports) {

	isMobile = {
	    Android: function () {
	        return navigator.userAgent.match(/Android/i);
	    },
	    BlackBerry: function () {
	        return navigator.userAgent.match(/BlackBerry/i);
	    },
	    iOS: function () {
	        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
	    },
	    Opera: function () {
	        return navigator.userAgent.match(/Opera Mini/i);
	    },
	    Windows: function () {
	        return navigator.userAgent.match(/IEMobile/i);
	    },
	    any: function () {
	        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
	    }
	};

/***/ },
/* 7 */
/*!***************************************!*\
  !*** waitForImages (bower component) ***!
  \***************************************/
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(/*! ./src/jquery.waitforimages.js */ 8);

/***/ },
/* 8 */
/*!***************************************************************!*\
  !*** ./pixo/assets/waitForImages/src/jquery.waitforimages.js ***!
  \***************************************************************/
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;;(function (factory) {
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! jquery */ 2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        // CommonJS / nodejs module
	        module.exports = factory(require('jquery'));
	    } else {
	        // Browser globals
	        factory(jQuery);
	    }
	}(function ($) {
	    // Namespace all events.
	    var eventNamespace = 'waitForImages';
	
	    // CSS properties which contain references to images.
	    $.waitForImages = {
	        hasImageProperties: [
	            'backgroundImage',
	            'listStyleImage',
	            'borderImage',
	            'borderCornerImage',
	            'cursor'
	        ],
	        hasImageAttributes: ['srcset']
	    };
	
	    // Custom selector to find all `img` elements with a valid `src` attribute.
	    $.expr[':']['has-src'] = function (obj) {
	        // Ensure we are dealing with an `img` element with a valid
	        // `src` attribute.
	        return $(obj).is('img[src][src!=""]');
	    };
	
	    // Custom selector to find images which are not already cached by the
	    // browser.
	    $.expr[':'].uncached = function (obj) {
	        // Ensure we are dealing with an `img` element with a valid
	        // `src` attribute.
	        if (!$(obj).is(':has-src')) {
	            return false;
	        }
	
	        return !obj.complete;
	    };
	
	    $.fn.waitForImages = function () {
	
	        var allImgsLength = 0;
	        var allImgsLoaded = 0;
	        var deferred = $.Deferred();
	
	        var finishedCallback;
	        var eachCallback;
	        var waitForAll;
	
	        // Handle options object (if passed).
	        if ($.isPlainObject(arguments[0])) {
	
	            waitForAll = arguments[0].waitForAll;
	            eachCallback = arguments[0].each;
	            finishedCallback = arguments[0].finished;
	
	        } else {
	
	            // Handle if using deferred object and only one param was passed in.
	            if (arguments.length === 1 && $.type(arguments[0]) === 'boolean') {
	                waitForAll = arguments[0];
	            } else {
	                finishedCallback = arguments[0];
	                eachCallback = arguments[1];
	                waitForAll = arguments[2];
	            }
	
	        }
	
	        // Handle missing callbacks.
	        finishedCallback = finishedCallback || $.noop;
	        eachCallback = eachCallback || $.noop;
	
	        // Convert waitForAll to Boolean
	        waitForAll = !! waitForAll;
	
	        // Ensure callbacks are functions.
	        if (!$.isFunction(finishedCallback) || !$.isFunction(eachCallback)) {
	            throw new TypeError('An invalid callback was supplied.');
	        }
	
	        this.each(function () {
	            // Build a list of all imgs, dependent on what images will
	            // be considered.
	            var obj = $(this);
	            var allImgs = [];
	            // CSS properties which may contain an image.
	            var hasImgProperties = $.waitForImages.hasImageProperties || [];
	            // Element attributes which may contain an image.
	            var hasImageAttributes = $.waitForImages.hasImageAttributes || [];
	            // To match `url()` references.
	            // Spec: http://www.w3.org/TR/CSS2/syndata.html#value-def-uri
	            var matchUrl = /url\(\s*(['"]?)(.*?)\1\s*\)/g;
	
	            if (waitForAll) {
	
	                // Get all elements (including the original), as any one of
	                // them could have a background image.
	                obj.find('*').addBack().each(function () {
	                    var element = $(this);
	
	                    // If an `img` element, add it. But keep iterating in
	                    // case it has a background image too.
	                    if (element.is('img:has-src')) {
	                        allImgs.push({
	                            src: element.attr('src'),
	                            element: element[0]
	                        });
	                    }
	
	                    $.each(hasImgProperties, function (i, property) {
	                        var propertyValue = element.css(property);
	                        var match;
	
	                        // If it doesn't contain this property, skip.
	                        if (!propertyValue) {
	                            return true;
	                        }
	
	                        // Get all url() of this element.
	                        while (match = matchUrl.exec(propertyValue)) {
	                            allImgs.push({
	                                src: match[2],
	                                element: element[0]
	                            });
	                        }
	                    });
	
	                    $.each(hasImageAttributes, function (i, attribute) {
	                        var attributeValue = element.attr(attribute);
	                        var attributeValues;
	
	                        // If it doesn't contain this property, skip.
	                        if (!attributeValue) {
	                            return true;
	                        }
	
	                        // Check for multiple comma separated images
	                        attributeValues = attributeValue.split(',');
	
	                        $.each(attributeValues, function(i, value) {
	                            // Trim value and get string before first
	                            // whitespace (for use with srcset).
	                            value = $.trim(value).split(' ')[0];
	                            allImgs.push({
	                                src: value,
	                                element: element[0]
	                            });
	                        });
	                    });
	                });
	            } else {
	                // For images only, the task is simpler.
	                obj.find('img:has-src')
	                    .each(function () {
	                    allImgs.push({
	                        src: this.src,
	                        element: this
	                    });
	                });
	            }
	
	            allImgsLength = allImgs.length;
	            allImgsLoaded = 0;
	
	            // If no images found, don't bother.
	            if (allImgsLength === 0) {
	                finishedCallback.call(obj[0]);
	                deferred.resolveWith(obj[0]);
	            }
	
	            $.each(allImgs, function (i, img) {
	
	                var image = new Image();
	                var events =
	                  'load.' + eventNamespace + ' error.' + eventNamespace;
	
	                // Handle the image loading and error with the same callback.
	                $(image).one(events, function me (event) {
	                    // If an error occurred with loading the image, set the
	                    // third argument accordingly.
	                    var eachArguments = [
	                        allImgsLoaded,
	                        allImgsLength,
	                        event.type == 'load'
	                    ];
	                    allImgsLoaded++;
	
	                    eachCallback.apply(img.element, eachArguments);
	                    deferred.notifyWith(img.element, eachArguments);
	
	                    // Unbind the event listeners. I use this in addition to
	                    // `one` as one of those events won't be called (either
	                    // 'load' or 'error' will be called).
	                    $(this).off(events, me);
	
	                    if (allImgsLoaded == allImgsLength) {
	                        finishedCallback.call(obj[0]);
	                        deferred.resolveWith(obj[0]);
	                        return false;
	                    }
	
	                });
	
	                image.src = img.src;
	            });
	        });
	
	        return deferred.promise();
	
	    };
	}));


/***/ },
/* 9 */
/*!*****************************************!*\
  !*** ./pixo/js/src/jquery.portfolio.js ***!
  \*****************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/*
	 *  Zorbix ajax portfolio loader
	 *
	 */
	(function ($, window, document, undefined) {
	
	    window.zorbixPortfolio = {
	
	        settings: {
	            propertyName: "value",
	            portItem: '.port-item',
	            noItems: 4,
	            projectBtn: '.port-item .port-overlay',
	            scrollOffset: -$('.main_menu').outerHeight() + 10,
	            load_more_in_category: true,
	            filter: '.port-item',
	            slider_name: '.portfolio-slider-ajax',
	            scrollOff: true
	        },
	
	        init: function () {
	            this.portfolio = '.portfolio';
	            this.portfolioElement = $('.portfolio');
	
	            this.noItems = ($(this.portfolio).data('show')) ? $(this.portfolio).data('show') : this.settings.noItems;
	            //this.init_project_btn(); // For in page load
	            this.init_filter_menu();
	            this.init_load_more_btn();
	            this.hide_show_more_btn();
	
	            this.portItems = this.portfolioElement.find('.port-item');
	            this.portfolioElement.find('.port-item:lt(' + this.noItems + ')').addClass('showme');
	
	            this.set_heights();
	            this.init_isotope();
	
	            this.onLoadFilter();
	            console.log('loaded');
	        },
	
	        set_heights: function() {
	
	            if( this.portfolioElement.hasClass('pixo_port_thumb_rectangle') ) {
	            this.portfolioElement.waitForImages(function () {
	
	                    var height = Math.floor($('.port-item img').outerHeight() - 1);
	                    $('.port-item').css('height', height);
	                    $('.port-item.tall').css('height', ( height * 2));
	
	                    $('.port-item.tall').css('height', ( height * 2));
	                    $(window).resize(function () {
	                        var height = Math.floor($('.port-item img').outerHeight());
	                        $('.port-item').css('height', height);
	                        $('.port-item.tall').css('height', ( height * 2));
	                    });
	
	            });
	            }
	        },
	
	        init_isotope: function () {
	            var fnc = this;
	            jQuery(window).load({fnc: this}, function (e) {
	                // main.js
	                var portfolioElement = e.data.fnc.portfolioElement;
	
	                        portfolioElement.isotope();
	
	
	                //var isotope = require('isotope');
	                //isotope = new isotope(e.data.fnc.portfolioElement);
	                //isotope(e.data.fnc.portfolioElement);
	            });
	        },
	
	        init_project_btn: function () {
	            var projectBtn = this.settings.projectBtn;
	            $(this.portfolio).find(projectBtn).on('touchstart', function (e) {
	            });
	            $(this.portfolio).find(projectBtn).on("click", {fnc: this}, function (event) {
	                event.preventDefault();
	                $('.loader').stop();
	                if (!$('.port-overlay .project-btn').hasClass('disabled')) {
	                    $('.port-overlay .project-btn').addClass('disabled');
	                    event.data.fnc.projectInit($(this));
	                }
	            });
	        },
	
	        init_load_more_btn: function () {
	            // > LOAD MORE ITEMS
	            $('#load-more').click({fnc: this}, function (e) {
	                e.preventDefault();
	                var fnc = e.data.fnc;
	
	                $(this).prepend('<i class="loader spin fa fa-spinner"></i>');
	
	                $('#load-more i.spin').css('display', 'none').fadeIn('fast');
	
	                // How many to load
	                var numToLoad = ($(this).data('num')) ? $(this).data('num') : 4;
	                console.log('numtoload', numToLoad);
	                var noItems = 0;
	                if (noItems < $('.port-item').length) {
	                    noItems += parseInt(numToLoad);
	                }
	
	                // Create Filter
	                var selector = $('.filter-menu .selected').data('cat');
	                var filter = '.port-item[data-cat*=' + selector + ']';
	                if (selector === '*' || !load_more_in_category) {
	                    filter = '.port-item';
	                }
	
	                // Reapply showme class
	                fnc.noItems = noItems + fnc.portfolioElement.find('.showme').length;
	                $('.port-item').removeClass('showme');
	                // Add filter
	                fnc.portfolioElement.find(filter + ':lt(' + fnc.noItems + ')').addClass('showme');
	
	
	                // Load all unloaded images
	                fnc.portfolioElement.find('div[data-port-thumb]:nth-child(-n+' + numToLoad + ')').each(function () {
	                    var path = $(this).data('port-thumb');
	                    var portItem = $(this).parent();
	                    var alt = $(this).attr('alt');
	
	                    $(this).after('<img src="' + path + '" alt="' + alt + '">');
	                    $(this).find('img').css('display', 'none');
	                    $(this).remove();
	                    $(this).addClass('new');
	                });
	
	
	                // Init isotope
	                fnc.portfolioElement.waitForImages(function () {
	                    $('#load-more i.spin').stop().delay(1000).fadeOut('fast', function () {
	                        $(this).remove();
	                    });
	                    $(this).find('.showme').fadeIn();
	                    $(this).isotope({filter: '.showme'});
	                });
	
	                $(this).find('i').fadeOut();
	                fnc.hide_show_more_btn();
	            });
	
	        },
	
	        onLoadFilter: function () {
	
	            var query = location.search.substring(1).split('=');
	
	            if ('filter' === query[0]) {
	                zorbixPortfolio.filter_port(query[1]);
	            }
	
	        },
	
	        filter_port: function (selector) {
	
	            var filter = '.port-item[data-cat*=' + selector + ']';
	            if (selector === '*') {
	                filter = '.port-item';
	            }
	
	            //$('.showme').removeClass('showme');
	
	            filter = filter + ':lt(' + zorbixPortfolio.noItems + ')';
	
	            zorbixPortfolio.portfolioElement.isotope({
	                filter: filter
	            });
	
	        },
	
	        init_filter_menu: function () {
	
	            var filter = $('.filter-menu li');
	            filter.css({
	                'cursor': 'pointer'
	            });
	
	            filter.click({fnc: this}, function (event) {
	
	                var fnc = event.data.fnc;
	
	                if (!$(this).hasClass('selected')) {
	                    var bgColor = $(this).css('background');
	                }
	                $(this).fadeTo('background', 'white');
	
	                $(this).siblings().removeClass('selected');
	                $(this).addClass('selected');
	                var selector = $(this).attr('data-cat');
	
	                fnc.filter_port(selector);
	
	            });
	        },
	
	
	        // HIDE SHOW BTN
	        // If there are no more items to show
	        // If the number to show is greater then the number of items available
	        hide_show_more_btn: function () {
	            if (0 === this.portfolioElement.find('div[data-port-thumb]').length) {
	                $('.load-more').attr('disabled', true);
	            } else if (this.settings.load_more_in_category) {
	                // Whats selected
	                var selector = $('.filter-menu li.selected').data('cat');
	                // If we are not loading from all
	                if (selector !== '*') {
	                    var filter = '.port-item[data-cat*=' + selector + ']';
	                } else {
	                    var filter = '.port-item';
	                }
	
	                var num_items_in_cat = $(filter).length;
	                if (num_items_in_cat <= this.noItems) {
	                    $('.load-more').attr('disabled', true);
	                } else {
	                    $('.load-more').attr('disabled', false);
	                }
	            }
	        }, // END: hide_show_more_btn
	
	        // PROJECT SLIDER INIT
	        setSlidler: function () {
	            if ($.isFunction($.fn.vc_js)) {
	                vc_js(); // Run VC scripts for VC shortcodes
	            }
	            $('.video-wrapper').fitVids();
	        }, // End setSlider
	
	        // SHOW THE PROJECT
	        showProject: function (elem, projectWrapper, fnc) {
	            var projectWrapperHeight;
	
	            // Append project to wrapper
	            var projectHTML = $('<div class="project">' + elem + '</div>').appendTo(projectWrapper);
	
	            projectWrapper = this.projectWrapper = $($(this.portfolioWrapper).find('.project-wrapper'));
	
	            var project = this.projectWrapper.find('.project');
	
	            fnc.closeButton();
	
	            projectHTML.waitForImages(function () {
	                fnc.setSlidler();
	                // init_internal_video();
	                projectWrapper.find('.video-wrapper').fitVids();
	
	                //projectWrapperHeight = project.outerHeight() + 110; // Get height of project
	                //
	                ////project.css('height', '100%'); // To fix ie visibility bug
	                //
	                //// Animate wrapper height, fade in project and remove loader
	                //projectWrapper.animate({
	                //    height: projectWrapperHeight
	                //}, 600, function () {
	                //    //projectWrapper.css('height', 'auto'); // Remove fixed height
	                //    project.fadeIn('slow');
	                //    fnc.hideSpinner();
	                //});
	
	                projectWrapper.addClass('open');
	                $('.port-overlay .project-btn').removeClass('disabled');
	            });
	
	        }, // End ShowProject
	
	        // FETCH THE PROJECT
	        getProject: function (elem, scrollDfd, projectDfd) {
	            $.get(elem.attr('href'), {ajax: "true"}, function (projectHTML) {
	                projectDfd.resolve(projectHTML);
	            }, 'html');
	        }, // End getProject
	
	        // ADD CLOSE BUTTON
	        closeButton: function () {
	            // Needs to know not to add to the project-
	            // Prepend close button if it doesn't exist
	            if (this.projectWrapper.find('.project .close-btn').length === 0) {
	                this.projectWrapper.find('.project').prepend('<a href="#" class="close-btn"><i class="fa fa-times-circle-o"></i></a>');
	            } else {
	            }
	            var projectWrapper = this.projectWrapper;
	            this.projectWrapper.find('.close-btn').click(function () {
	                // hideLoader();
	                //projectWrapper.animate({
	                //    height: 0
	                //});
	
	
	                projectWrapper.find('.project').fadeOut('slow', function () {
	                    projectWrapper.removeClass('open');
	                    projectWrapper.find('.project').remove();
	                });
	                return false;
	            });
	        }, // End closeButton
	
	        // SWITCH TO ANOTHER PROJECT
	        changeProject: function (projectHTML, projectWrapper, fnc) {
	            projectWrapper.css('height', projectWrapper.outerHeight());
	            projectWrapper.find('.project').fadeOut('slow', function () {
	                projectWrapper.find('.project').remove();
	                fnc.showProject(projectHTML, projectWrapper, fnc);
	            });
	        },
	
	
	        showLoader: function (projectWrapper) {
	            if (typeof(this.loader) !== "undefined" && this.loader.hasClass('temp-hide')) {
	                this.showSpinner();
	            }
	
	            if (typeof(this.loader) === "undefined") {
	                this.addLoader();
	            }
	        },
	
	        addLoader: function () {
	            var preloadedHTML = '<div class="loader"><i class="fa fa-spinner spin"></i></div>';
	            this.projectWrapper.prepend(preloadedHTML);
	            this.loader = this.projectWrapper.find('.loader');
	        },
	
	        hideSpinner: function () {
	            //this.loader.addClass('temp-hide').find('i').fadeOut();
	        },
	
	        showSpinner: function () {
	            this.projectWrapper.find('.loader i').fadeIn();
	        },
	
	        projectInit: function (elem) {
	
	            var scrollFinished = '';
	            // Vars
	            this.portfolioWrapper = elem.closest('.portfolio-wrapper');
	            var projectWrapper = this.projectWrapper = elem.closest('.portfolio-wrapper').find('.project-wrapper'),
	                projectFinishedLoading = $.Deferred();
	
	            var fnc = this;
	            console.log('scroll off', this.settings.scrollOff);
	
	            if (true === this.settings.scrollOff) {
	                console.log('scroll off');
	                scrollFinished = false;
	
	                var projectHTML = this.getProject(elem, scrollFinished, projectFinishedLoading);
	
	                $.when(projectFinishedLoading).done(function (projectHTML) {
	                    if (projectWrapper.hasClass('open')) {
	                        fnc.changeProject(projectHTML, projectWrapper, fnc);
	                    } else {
	                        fnc.showProject(projectHTML, projectWrapper, fnc);
	                    }
	                });
	
	            } else {
	                console.log('else');
	                var scrollFinished = this.projectScroll();
	
	                this.getProject(elem, scrollFinished, projectFinishedLoading);
	
	                $.when(projectFinishedLoading, scrollFinished).done(function (projectHTML) {
	                    if (projectWrapper.hasClass('open')) {
	                        fnc.changeProject(projectHTML, projectWrapper, fnc);
	                    } else {
	                        fnc.showProject(projectHTML, projectWrapper, fnc);
	                    }
	                });
	            }
	
	            // When project is loaded and page finished loading
	            // Load or change project
	
	
	        }, // End projectInit
	
	        projectScroll: function () {
	            var scrollPosOffset;
	            var header = $('.header');
	            // If header is sticky add header height to scroll pos
	            if (header.css("position") === "fixed") {
	                scrollPosOffset = -( header.outerHeight() - 5);
	            } else {
	                scrollPosOffset = 0;
	            }
	
	            var scrollFinished = $.Deferred();
	
	            this.showLoader(this.projectWrapper);
	
	            // Scroll up to project loader
	            $.smooth(this.projectWrapper, scrollPosOffset, function () {
	                return scrollFinished.resolve();
	            });
	        }
	
	    }
	    window.zorbixPortfolio.init();
	
	})(jQuery, window, document);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 2)))

/***/ },
/* 10 */
/*!********************************************************************************!*\
  !*** ./~/script-loader!./pixo/assets/jquery.mb.YTPlayer/jquery.mb.YTPlayer.js ***!
  \********************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(/*! !./~/script-loader/addScript.js */ 11)(__webpack_require__(/*! !./~/raw-loader!./pixo/assets/jquery.mb.YTPlayer/jquery.mb.YTPlayer.js */ 12)+"\n\n// SCRIPT-LOADER FOOTER\n//# sourceURL=script:///Users/admin/dev/pixo_dev/pixo/assets/jquery.mb.YTPlayer/jquery.mb.YTPlayer.js")

/***/ },
/* 11 */
/*!**************************************!*\
  !*** ./~/script-loader/addScript.js ***!
  \**************************************/
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	module.exports = function(src) {
		if (typeof execScript === "function")
			execScript(src);
		else
			eval.call(null, src);
	}

/***/ },
/* 12 */
/*!*****************************************************************************!*\
  !*** ./~/raw-loader!./pixo/assets/jquery.mb.YTPlayer/jquery.mb.YTPlayer.js ***!
  \*****************************************************************************/
/***/ function(module, exports) {

	module.exports = "/*___________________________________________________________________________________________________________________________________________________\n _ jquery.mb.components                                                                                                                             _\n _                                                                                                                                                  _\n _ file: jquery.mb.YTPlayer.src.js                                                                                                                  _\n _ last modified: 05/01/16 17.43                                                                                                                    _\n _                                                                                                                                                  _\n _ Open Lab s.r.l., Florence - Italy                                                                                                                _\n _                                                                                                                                                  _\n _ email: matteo@open-lab.com                                                                                                                       _\n _ site: http://pupunzi.com                                                                                                                         _\n _       http://open-lab.com                                                                                                                        _\n _ blog: http://pupunzi.open-lab.com                                                                                                                _\n _ Q&A:  http://jquery.pupunzi.com                                                                                                                  _\n _                                                                                                                                                  _\n _ Licences: MIT, GPL                                                                                                                               _\n _    http://www.opensource.org/licenses/mit-license.php                                                                                            _\n _    http://www.gnu.org/licenses/gpl.html                                                                                                          _\n _                                                                                                                                                  _\n _ Copyright (c) 2001-2016. Matteo Bicocchi (Pupunzi);                                                                                              _\n ___________________________________________________________________________________________________________________________________________________*/\nvar ytp = ytp || {};\n\nfunction onYouTubeIframeAPIReady() {\n\tif( ytp.YTAPIReady ) return;\n\tytp.YTAPIReady = true;\n\tjQuery( document ).trigger( \"YTAPIReady\" );\n}\n\nvar getYTPVideoID = function( url ) {\n\tvar videoID, playlistID;\n\tif( url.indexOf( \"youtu.be\" ) > 0 ) {\n\t\tvideoID = url.substr( url.lastIndexOf( \"/\" ) + 1, url.length );\n\t\tplaylistID = videoID.indexOf( \"?list=\" ) > 0 ? videoID.substr( videoID.lastIndexOf( \"=\" ), videoID.length ) : null;\n\t\tvideoID = playlistID ? videoID.substr( 0, videoID.lastIndexOf( \"?\" ) ) : videoID;\n\t} else if( url.indexOf( \"http\" ) > -1 ) {\n\t\t//videoID = url.match( /([\\/&]v\\/([^&#]*))|([\\\\?&]v=([^&#]*))/ )[ 1 ];\n\t\tvideoID = url.match( /[\\\\?&]v=([^&#]*)/ )[ 1 ];\n\t\tplaylistID = url.indexOf( \"list=\" ) > 0 ? url.match( /[\\\\?&]list=([^&#]*)/ )[ 1 ] : null;\n\t} else {\n\t\tvideoID = url.length > 15 ? null : url;\n\t\tplaylistID = videoID ? null : url;\n\t}\n\treturn {\n\t\tvideoID: videoID,\n\t\tplaylistID: playlistID\n\t};\n};\n\n( function( jQuery, ytp ) {\n\n\tjQuery.mbYTPlayer = {\n\t\tname: \"jquery.mb.YTPlayer\",\n\t\tversion: \"2.9.12\",\n\t\tbuild: \"5815\",\n\t\tauthor: \"Matteo Bicocchi\",\n\t\tapiKey: \"\",\n\t\tdefaults: {\n\t\t\tcontainment: \"body\",\n\t\t\tratio: \"auto\", // \"auto\", \"16/9\", \"4/3\"\n\t\t\tvideoURL: null,\n\t\t\tplaylistURL: null,\n\t\t\tstartAt: 0,\n\t\t\tstopAt: 0,\n\t\t\tautoPlay: true,\n\t\t\tvol: 50, // 1 to 100\n\t\t\taddRaster: false,\n\t\t\topacity: 1,\n\t\t\tquality: \"default\", //or “small”, “medium”, “large”, “hd720”, “hd1080”, “highres”\n\t\t\tmute: false,\n\t\t\tloop: true,\n\t\t\tshowControls: true,\n\t\t\tshowAnnotations: false,\n\t\t\tshowYTLogo: true,\n\t\t\tstopMovieOnBlur: true,\n\t\t\trealfullscreen: true,\n\t\t\tgaTrack: true,\n\t\t\toptimizeDisplay: true,\n\t\t\tonReady: function( player ) {}\n\t\t},\n\t\t/**\n\t\t *  @fontface icons\n\t\t *  */\n\t\tcontrols: {\n\t\t\tplay: \"P\",\n\t\t\tpause: \"p\",\n\t\t\tmute: \"M\",\n\t\t\tunmute: \"A\",\n\t\t\tonlyYT: \"O\",\n\t\t\tshowSite: \"R\",\n\t\t\tytLogo: \"Y\"\n\t\t},\n\t\tlocationProtocol: \"https:\",\n\t\t/**\n\t\t *\n\t\t * @param options\n\t\t * @returns [players]\n\t\t */\n\t\tbuildPlayer: function( options ) {\n\t\t\treturn this.each( function() {\n\t\t\t\tvar YTPlayer = this;\n\t\t\t\tvar $YTPlayer = jQuery( YTPlayer );\n\t\t\t\tYTPlayer.loop = 0;\n\t\t\t\tYTPlayer.opt = {};\n\t\t\t\tYTPlayer.state = {};\n\t\t\t\tYTPlayer.filtersEnabled = true;\n\t\t\t\tYTPlayer.filters = {\n\t\t\t\t\tgrayscale: {\n\t\t\t\t\t\tvalue: 0,\n\t\t\t\t\t\tunit: \"%\"\n\t\t\t\t\t},\n\t\t\t\t\thue_rotate: {\n\t\t\t\t\t\tvalue: 0,\n\t\t\t\t\t\tunit: \"deg\"\n\t\t\t\t\t},\n\t\t\t\t\tinvert: {\n\t\t\t\t\t\tvalue: 0,\n\t\t\t\t\t\tunit: \"%\"\n\t\t\t\t\t},\n\t\t\t\t\topacity: {\n\t\t\t\t\t\tvalue: 0,\n\t\t\t\t\t\tunit: \"%\"\n\t\t\t\t\t},\n\t\t\t\t\tsaturate: {\n\t\t\t\t\t\tvalue: 0,\n\t\t\t\t\t\tunit: \"%\"\n\t\t\t\t\t},\n\t\t\t\t\tsepia: {\n\t\t\t\t\t\tvalue: 0,\n\t\t\t\t\t\tunit: \"%\"\n\t\t\t\t\t},\n\t\t\t\t\tbrightness: {\n\t\t\t\t\t\tvalue: 0,\n\t\t\t\t\t\tunit: \"%\"\n\t\t\t\t\t},\n\t\t\t\t\tcontrast: {\n\t\t\t\t\t\tvalue: 0,\n\t\t\t\t\t\tunit: \"%\"\n\t\t\t\t\t},\n\t\t\t\t\tblur: {\n\t\t\t\t\t\tvalue: 0,\n\t\t\t\t\t\tunit: \"px\"\n\t\t\t\t\t}\n\t\t\t\t};\n\t\t\t\t$YTPlayer.addClass( \"mb_YTPlayer\" );\n\t\t\t\tvar property = $YTPlayer.data( \"property\" ) && typeof $YTPlayer.data( \"property\" ) == \"string\" ? eval( '(' + $YTPlayer.data( \"property\" ) + ')' ) : $YTPlayer.data( \"property\" );\n\t\t\t\tif( typeof property != \"undefined\" && typeof property.vol != \"undefined\" ) property.vol = property.vol === 0 ? property.vol = 1 : property.vol;\n\n\t\t\t\tjQuery.extend( YTPlayer.opt, jQuery.mbYTPlayer.defaults, options, property );\n\n\t\t\t\tif( !YTPlayer.hasChanged ) {\n\t\t\t\t\tYTPlayer.defaultOpt = {};\n\t\t\t\t\t//\t\t\t\t\tjQuery.extend( YTPlayer.defaultOpt, jQuery.mbYTPlayer.defaults, options, property );\n\t\t\t\t\tjQuery.extend( YTPlayer.defaultOpt, jQuery.mbYTPlayer.defaults, options );\n\t\t\t\t}\n\n\t\t\t\tif( YTPlayer.opt.loop == \"true\" )\n\t\t\t\t\tYTPlayer.opt.loop = 9999;\n\n\t\t\t\tYTPlayer.isRetina = ( window.retina || window.devicePixelRatio > 1 );\n\t\t\t\tvar isIframe = function() {\n\t\t\t\t\tvar isIfr = false;\n\t\t\t\t\ttry {\n\t\t\t\t\t\tif( self.location.href != top.location.href ) isIfr = true;\n\t\t\t\t\t} catch( e ) {\n\t\t\t\t\t\tisIfr = true;\n\t\t\t\t\t}\n\t\t\t\t\treturn isIfr;\n\t\t\t\t};\n\t\t\t\tYTPlayer.canGoFullScreen = !( jQuery.browser.msie || jQuery.browser.opera || isIframe() );\n\t\t\t\tif( !YTPlayer.canGoFullScreen ) YTPlayer.opt.realfullscreen = false;\n\t\t\t\tif( !$YTPlayer.attr( \"id\" ) ) $YTPlayer.attr( \"id\", \"video_\" + new Date().getTime() );\n\t\t\t\tvar playerID = \"mbYTP_\" + YTPlayer.id;\n\t\t\t\tYTPlayer.isAlone = false;\n\t\t\t\tYTPlayer.hasFocus = true;\n\t\t\t\tvar videoID = this.opt.videoURL ? getYTPVideoID( this.opt.videoURL ).videoID : $YTPlayer.attr( \"href\" ) ? getYTPVideoID( $YTPlayer.attr( \"href\" ) ).videoID : false;\n\t\t\t\tvar playlistID = this.opt.videoURL ? getYTPVideoID( this.opt.videoURL ).playlistID : $YTPlayer.attr( \"href\" ) ? getYTPVideoID( $YTPlayer.attr( \"href\" ) ).playlistID : false;\n\t\t\t\tYTPlayer.videoID = videoID;\n\t\t\t\tYTPlayer.playlistID = playlistID;\n\t\t\t\tYTPlayer.opt.showAnnotations = ( YTPlayer.opt.showAnnotations ) ? '0' : '3';\n\t\t\t\tvar playerVars = {\n\t\t\t\t\t'autoplay': 0,\n\t\t\t\t\t'modestbranding': 1,\n\t\t\t\t\t'controls': 0,\n\t\t\t\t\t'showinfo': 0,\n\t\t\t\t\t'rel': 0,\n\t\t\t\t\t'enablejsapi': 1,\n\t\t\t\t\t'version': 3,\n\t\t\t\t\t'playerapiid': playerID,\n\t\t\t\t\t'origin': '*',\n\t\t\t\t\t'allowfullscreen': true,\n\t\t\t\t\t'wmode': 'transparent',\n\t\t\t\t\t'iv_load_policy': YTPlayer.opt.showAnnotations\n\t\t\t\t};\n\t\t\t\tif( document.createElement( 'video' ).canPlayType ) jQuery.extend( playerVars, {\n\t\t\t\t\t'html5': 1\n\t\t\t\t} );\n\t\t\t\tif( jQuery.browser.msie && jQuery.browser.version < 9 ) this.opt.opacity = 1;\n\t\t\t\tvar playerBox = jQuery( \"<div/>\" ).attr( \"id\", playerID ).addClass( \"playerBox\" );\n\t\t\t\tvar overlay = jQuery( \"<div/>\" ).css( {\n\t\t\t\t\tposition: \"absolute\",\n\t\t\t\t\ttop: 0,\n\t\t\t\t\tleft: 0,\n\t\t\t\t\twidth: \"100%\",\n\t\t\t\t\theight: \"100%\"\n\t\t\t\t} ).addClass( \"YTPOverlay\" );\n\t\t\t\tYTPlayer.isSelf = YTPlayer.opt.containment == \"self\";\n\t\t\t\tYTPlayer.defaultOpt.containment = YTPlayer.opt.containment = YTPlayer.opt.containment == \"self\" ? jQuery( this ) : jQuery( YTPlayer.opt.containment );\n\t\t\t\tYTPlayer.isBackground = YTPlayer.opt.containment.get( 0 ).tagName.toLowerCase() == \"body\";\n\t\t\t\tif( YTPlayer.isBackground && ytp.backgroundIsInited ) return;\n\t\t\t\tvar isPlayer = YTPlayer.opt.containment.is( jQuery( this ) );\n\t\t\t\tYTPlayer.canPlayOnMobile = isPlayer && jQuery( this ).children().length === 0;\n\t\t\t\tif( !isPlayer ) {\n\t\t\t\t\t$YTPlayer.hide();\n\t\t\t\t} else {\n\t\t\t\t\tYTPlayer.isPlayer = true;\n\t\t\t\t}\n\n\t\t\t\tif( jQuery.browser.mobile && !YTPlayer.canPlayOnMobile ) {\n\t\t\t\t\t$YTPlayer.remove();\n\t\t\t\t\treturn;\n\t\t\t\t}\n\n\t\t\t\tvar wrapper = jQuery( \"<div/>\" ).addClass( \"mbYTP_wrapper\" ).attr( \"id\", \"wrapper_\" + playerID );\n\t\t\t\twrapper.css( {\n\t\t\t\t\tposition: \"absolute\",\n\t\t\t\t\tzIndex: 0,\n\t\t\t\t\tminWidth: \"100%\",\n\t\t\t\t\tminHeight: \"100%\",\n\t\t\t\t\tleft: 0,\n\t\t\t\t\ttop: 0,\n\t\t\t\t\toverflow: \"hidden\",\n\t\t\t\t\topacity: 0\n\t\t\t\t} );\n\n\t\t\t\tplayerBox.css( {\n\t\t\t\t\tposition: \"absolute\",\n\t\t\t\t\tzIndex: 0,\n\t\t\t\t\twidth: \"100%\",\n\t\t\t\t\theight: \"100%\",\n\t\t\t\t\ttop: 0,\n\t\t\t\t\tleft: 0,\n\t\t\t\t\toverflow: \"hidden\"\n\t\t\t\t} );\n\t\t\t\twrapper.append( playerBox );\n\t\t\t\tYTPlayer.opt.containment.children().not( \"script, style\" ).each( function() {\n\t\t\t\t\tif( jQuery( this ).css( \"position\" ) == \"static\" ) jQuery( this ).css( \"position\", \"relative\" );\n\t\t\t\t} );\n\t\t\t\tif( YTPlayer.isBackground ) {\n\t\t\t\t\tjQuery( \"body\" ).css( {\n\t\t\t\t\t\tboxSizing: \"border-box\"\n\t\t\t\t\t} );\n\t\t\t\t\twrapper.css( {\n\t\t\t\t\t\tposition: \"fixed\",\n\t\t\t\t\t\ttop: 0,\n\t\t\t\t\t\tleft: 0,\n\t\t\t\t\t\tzIndex: 0\n\t\t\t\t\t} );\n\t\t\t\t\t$YTPlayer.hide();\n\t\t\t\t} else if( YTPlayer.opt.containment.css( \"position\" ) == \"static\" )\n\t\t\t\t\tYTPlayer.opt.containment.css( {\n\t\t\t\t\t\tposition: \"relative\"\n\t\t\t\t\t} );\n\n\t\t\t\tYTPlayer.opt.containment.prepend( wrapper );\n\t\t\t\tYTPlayer.wrapper = wrapper;\n\t\t\t\tplayerBox.css( {\n\t\t\t\t\topacity: 1\n\t\t\t\t} );\n\n\t\t\t\tif( !jQuery.browser.mobile ) {\n\t\t\t\t\tplayerBox.after( overlay );\n\t\t\t\t\tYTPlayer.overlay = overlay;\n\t\t\t\t}\n\n\t\t\t\tif( !YTPlayer.isBackground ) {\n\t\t\t\t\toverlay.on( \"mouseenter\", function() {\n\t\t\t\t\t\tif( YTPlayer.controlBar ) YTPlayer.controlBar.addClass( \"visible\" );\n\t\t\t\t\t} ).on( \"mouseleave\", function() {\n\t\t\t\t\t\tif( YTPlayer.controlBar ) YTPlayer.controlBar.removeClass( \"visible\" );\n\t\t\t\t\t} );\n\t\t\t\t}\n\t\t\t\tif( !ytp.YTAPIReady ) {\n\t\t\t\t\tjQuery( \"#YTAPI\" ).remove();\n\t\t\t\t\tvar tag = jQuery( \"<script></script>\" ).attr( {\n\t\t\t\t\t\t\"src\": jQuery.mbYTPlayer.locationProtocol + \"//www.youtube.com/iframe_api?v=\" + jQuery.mbYTPlayer.version,\n\t\t\t\t\t\t\"id\": \"YTAPI\"\n\t\t\t\t\t} );\n\t\t\t\t\tjQuery( \"head\" ).prepend( tag );\n\t\t\t\t} else {\n\t\t\t\t\tsetTimeout( function() {\n\t\t\t\t\t\tjQuery( document ).trigger( \"YTAPIReady\" );\n\t\t\t\t\t}, 100 )\n\t\t\t\t}\n\n\t\t\t\tjQuery( document ).on( \"YTAPIReady\", function() {\n\t\t\t\t\tif( ( YTPlayer.isBackground && ytp.backgroundIsInited ) || YTPlayer.isInit ) return;\n\t\t\t\t\tif( YTPlayer.isBackground ) {\n\t\t\t\t\t\tytp.backgroundIsInited = true;\n\t\t\t\t\t}\n\n\t\t\t\t\tYTPlayer.opt.autoPlay = typeof YTPlayer.opt.autoPlay == \"undefined\" ? ( YTPlayer.isBackground ? true : false ) : YTPlayer.opt.autoPlay;\n\t\t\t\t\tYTPlayer.opt.vol = YTPlayer.opt.vol ? YTPlayer.opt.vol : 100;\n\t\t\t\t\tjQuery.mbYTPlayer.getDataFromAPI( YTPlayer );\n\t\t\t\t\tjQuery( YTPlayer ).on( \"YTPChanged\", function() {\n\t\t\t\t\t\tif( YTPlayer.isInit ) return;\n\t\t\t\t\t\tYTPlayer.isInit = true;\n\n\t\t\t\t\t\t//if is mobile && isPlayer fallback to the default YT player\n\t\t\t\t\t\tif( jQuery.browser.mobile && YTPlayer.canPlayOnMobile ) {\n\t\t\t\t\t\t\t// Try to adjust the player dimention\n\t\t\t\t\t\t\tif( YTPlayer.opt.containment.outerWidth() > jQuery( window ).width() ) {\n\t\t\t\t\t\t\t\tYTPlayer.opt.containment.css( {\n\t\t\t\t\t\t\t\t\tmaxWidth: \"100%\"\n\t\t\t\t\t\t\t\t} );\n\t\t\t\t\t\t\t\tvar h = YTPlayer.opt.containment.outerWidth() * .6;\n\t\t\t\t\t\t\t\tYTPlayer.opt.containment.css( {\n\t\t\t\t\t\t\t\t\tmaxHeight: h\n\t\t\t\t\t\t\t\t} );\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\tnew YT.Player( playerID, {\n\t\t\t\t\t\t\t\tvideoId: YTPlayer.videoID.toString(),\n\t\t\t\t\t\t\t\theight: '100%',\n\t\t\t\t\t\t\t\twidth: '100%',\n\t\t\t\t\t\t\t\tevents: {\n\t\t\t\t\t\t\t\t\t'onReady': function( event ) {\n\t\t\t\t\t\t\t\t\t\tYTPlayer.player = event.target;\n\t\t\t\t\t\t\t\t\t\tplayerBox.css( {\n\t\t\t\t\t\t\t\t\t\t\topacity: 1\n\t\t\t\t\t\t\t\t\t\t} );\n\t\t\t\t\t\t\t\t\t\tYTPlayer.wrapper.css( {\n\t\t\t\t\t\t\t\t\t\t\topacity: 1\n\t\t\t\t\t\t\t\t\t\t} );\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t} );\n\t\t\t\t\t\t\treturn;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\tnew YT.Player( playerID, {\n\t\t\t\t\t\t\tvideoId: YTPlayer.videoID.toString(),\n\t\t\t\t\t\t\tplayerVars: playerVars,\n\t\t\t\t\t\t\tevents: {\n\t\t\t\t\t\t\t\t'onReady': function( event ) {\n\t\t\t\t\t\t\t\t\tYTPlayer.player = event.target;\n\t\t\t\t\t\t\t\t\tif( YTPlayer.isReady ) return;\n\t\t\t\t\t\t\t\t\tYTPlayer.isReady = YTPlayer.isPlayer && !YTPlayer.opt.autoPlay ? false : true;\n\t\t\t\t\t\t\t\t\tYTPlayer.playerEl = YTPlayer.player.getIframe();\n\n\t\t\t\t\t\t\t\t\tjQuery( YTPlayer.playerEl ).unselectable();\n\n\t\t\t\t\t\t\t\t\t$YTPlayer.optimizeDisplay();\n\t\t\t\t\t\t\t\t\tYTPlayer.videoID = videoID;\n\t\t\t\t\t\t\t\t\tjQuery( window ).off( \"resize.YTP\" ).on( \"resize.YTP\", function() {\n\t\t\t\t\t\t\t\t\t\t$YTPlayer.optimizeDisplay();\n\t\t\t\t\t\t\t\t\t} );\n\n\t\t\t\t\t\t\t\t\tjQuery.mbYTPlayer.checkForState( YTPlayer );\n\t\t\t\t\t\t\t\t},\n\t\t\t\t\t\t\t\t/**\n\t\t\t\t\t\t\t\t *\n\t\t\t\t\t\t\t\t * @param event\n\t\t\t\t\t\t\t\t *\n\t\t\t\t\t\t\t\t * -1 (unstarted)\n\t\t\t\t\t\t\t\t * 0 (ended)\n\t\t\t\t\t\t\t\t * 1 (playing)\n\t\t\t\t\t\t\t\t * 2 (paused)\n\t\t\t\t\t\t\t\t * 3 (buffering)\n\t\t\t\t\t\t\t\t * 5 (video cued).\n\t\t\t\t\t\t\t\t *\n\t\t\t\t\t\t\t\t *\n\t\t\t\t\t\t\t\t */\n\t\t\t\t\t\t\t\t'onStateChange': function( event ) {\n\t\t\t\t\t\t\t\t\tif( typeof event.target.getPlayerState != \"function\" ) return;\n\t\t\t\t\t\t\t\t\tvar state = event.target.getPlayerState();\n\n\t\t\t\t\t\t\t\t\tif( YTPlayer.state == state ) return;\n\n\t\t\t\t\t\t\t\t\tif( YTPlayer.preventTrigger ) {\n\t\t\t\t\t\t\t\t\t\tYTPlayer.preventTrigger = false;\n\t\t\t\t\t\t\t\t\t\treturn\n\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\tYTPlayer.state = state;\n\n\t\t\t\t\t\t\t\t\tvar eventType;\n\t\t\t\t\t\t\t\t\tswitch( state ) {\n\t\t\t\t\t\t\t\t\t\tcase -1: //----------------------------------------------- unstarted\n\t\t\t\t\t\t\t\t\t\t\teventType = \"YTPUnstarted\";\n\t\t\t\t\t\t\t\t\t\t\tbreak;\n\t\t\t\t\t\t\t\t\t\tcase 0: //------------------------------------------------ ended\n\t\t\t\t\t\t\t\t\t\t\teventType = \"YTPEnd\";\n\t\t\t\t\t\t\t\t\t\t\tbreak;\n\t\t\t\t\t\t\t\t\t\tcase 1: //------------------------------------------------ play\n\t\t\t\t\t\t\t\t\t\t\teventType = \"YTPPlay\";\n\t\t\t\t\t\t\t\t\t\t\tif( YTPlayer.controlBar ) YTPlayer.controlBar.find( \".mb_YTPPlaypause\" ).html( jQuery.mbYTPlayer.controls.pause );\n\n\t\t\t\t\t\t\t\t\t\t\tif( typeof _gaq != \"undefined\" && eval( YTPlayer.opt.gaTrack ) ) _gaq.push( [ '_trackEvent', 'YTPlayer', 'Play', ( YTPlayer.hasData ? YTPlayer.videoData.title : YTPlayer.videoID.toString() ) ] );\n\t\t\t\t\t\t\t\t\t\t\tif( typeof ga != \"undefined\" && eval( YTPlayer.opt.gaTrack ) ) ga( 'send', 'event', 'YTPlayer', 'play', ( YTPlayer.hasData ? YTPlayer.videoData.title : YTPlayer.videoID.toString() ) );\n\n\t\t\t\t\t\t\t\t\t\t\tbreak;\n\t\t\t\t\t\t\t\t\t\tcase 2: //------------------------------------------------ pause\n\t\t\t\t\t\t\t\t\t\t\teventType = \"YTPPause\";\n\t\t\t\t\t\t\t\t\t\t\tif( YTPlayer.controlBar ) YTPlayer.controlBar.find( \".mb_YTPPlaypause\" ).html( jQuery.mbYTPlayer.controls.play );\n\t\t\t\t\t\t\t\t\t\t\tbreak;\n\t\t\t\t\t\t\t\t\t\tcase 3: //------------------------------------------------ buffer\n\t\t\t\t\t\t\t\t\t\t\tYTPlayer.player.setPlaybackQuality( YTPlayer.opt.quality );\n\t\t\t\t\t\t\t\t\t\t\teventType = \"YTPBuffering\";\n\t\t\t\t\t\t\t\t\t\t\tif( YTPlayer.controlBar ) YTPlayer.controlBar.find( \".mb_YTPPlaypause\" ).html( jQuery.mbYTPlayer.controls.play );\n\t\t\t\t\t\t\t\t\t\t\tbreak;\n\t\t\t\t\t\t\t\t\t\tcase 5: //------------------------------------------------ cued\n\t\t\t\t\t\t\t\t\t\t\teventType = \"YTPCued\";\n\t\t\t\t\t\t\t\t\t\t\tbreak;\n\t\t\t\t\t\t\t\t\t\tdefault:\n\t\t\t\t\t\t\t\t\t\t\tbreak;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t// Trigger state events\n\t\t\t\t\t\t\t\t\tvar YTPEvent = jQuery.Event( eventType );\n\t\t\t\t\t\t\t\t\tYTPEvent.time = YTPlayer.player.time;\n\t\t\t\t\t\t\t\t\tif( YTPlayer.canTrigger ) jQuery( YTPlayer ).trigger( YTPEvent );\n\t\t\t\t\t\t\t\t},\n\t\t\t\t\t\t\t\t/**\n\t\t\t\t\t\t\t\t *\n\t\t\t\t\t\t\t\t * @param e\n\t\t\t\t\t\t\t\t */\n\t\t\t\t\t\t\t\t'onPlaybackQualityChange': function( e ) {\n\t\t\t\t\t\t\t\t\tvar quality = e.target.getPlaybackQuality();\n\t\t\t\t\t\t\t\t\tvar YTPQualityChange = jQuery.Event( \"YTPQualityChange\" );\n\t\t\t\t\t\t\t\t\tYTPQualityChange.quality = quality;\n\t\t\t\t\t\t\t\t\tjQuery( YTPlayer ).trigger( YTPQualityChange );\n\t\t\t\t\t\t\t\t},\n\t\t\t\t\t\t\t\t/**\n\t\t\t\t\t\t\t\t *\n\t\t\t\t\t\t\t\t * @param err\n\t\t\t\t\t\t\t\t */\n\t\t\t\t\t\t\t\t'onError': function( err ) {\n\t\t\t\t\t\t\t\t\tif( err.data == 150 ) {\n\t\t\t\t\t\t\t\t\t\tconsole.log( \"Embedding this video is restricted by Youtube.\" );\n\t\t\t\t\t\t\t\t\t\tif( YTPlayer.isPlayList ) jQuery( YTPlayer ).playNext();\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\tif( err.data == 2 && YTPlayer.isPlayList ) jQuery( YTPlayer ).playNext();\n\t\t\t\t\t\t\t\t\tif( typeof YTPlayer.opt.onError == \"function\" ) YTPlayer.opt.onError( $YTPlayer, err );\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t} );\n\t\t\t\t\t} );\n\t\t\t\t} )\n\t\t\t} );\n\t\t},\n\t\t/**\n\t\t *\n\t\t * @param YTPlayer\n\t\t */\n\t\tgetDataFromAPI: function( YTPlayer ) {\n\t\t\tYTPlayer.videoData = jQuery.mbStorage.get( \"YTPlayer_data_\" + YTPlayer.videoID );\n\t\t\tjQuery( YTPlayer ).off( \"YTPData.YTPlayer\" ).on( \"YTPData.YTPlayer\", function() {\n\t\t\t\tif( YTPlayer.hasData ) {\n\n\t\t\t\t\tif( YTPlayer.isPlayer && !YTPlayer.opt.autoPlay ) {\n\t\t\t\t\t\tvar bgndURL = YTPlayer.videoData.thumb_max || YTPlayer.videoData.thumb_high || YTPlayer.videoData.thumb_medium;\n\t\t\t\t\t\tYTPlayer.opt.containment.css( {\n\t\t\t\t\t\t\tbackground: \"rgba(0,0,0,0.5) url(\" + bgndURL + \") center center\",\n\t\t\t\t\t\t\tbackgroundSize: \"cover\"\n\t\t\t\t\t\t} );\n\t\t\t\t\t\tYTPlayer.opt.backgroundUrl = bgndURL;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t} );\n\n\t\t\tif( YTPlayer.videoData ) {\n\n\t\t\t\tsetTimeout( function() {\n\t\t\t\t\tYTPlayer.opt.ratio = YTPlayer.opt.ratio == \"auto\" ? \"16/9\" : YTPlayer.opt.ratio;\n\t\t\t\t\tYTPlayer.dataReceived = true;\n\t\t\t\t\tjQuery( YTPlayer ).trigger( \"YTPChanged\" );\n\t\t\t\t\tvar YTPData = jQuery.Event( \"YTPData\" );\n\t\t\t\t\tYTPData.prop = {};\n\t\t\t\t\tfor( var x in YTPlayer.videoData ) YTPData.prop[ x ] = YTPlayer.videoData[ x ];\n\t\t\t\t\tjQuery( YTPlayer ).trigger( YTPData );\n\t\t\t\t}, 500 );\n\n\t\t\t\tYTPlayer.hasData = true;\n\t\t\t} else if( jQuery.mbYTPlayer.apiKey ) {\n\t\t\t\t// Get video info from API3 (needs api key)\n\t\t\t\t// snippet,player,contentDetails,statistics,status\n\t\t\t\tjQuery.getJSON( jQuery.mbYTPlayer.locationProtocol + \"//www.googleapis.com/youtube/v3/videos?id=\" + YTPlayer.videoID + \"&key=\" + jQuery.mbYTPlayer.apiKey + \"&part=snippet\", function( data ) {\n\t\t\t\t\tYTPlayer.dataReceived = true;\n\t\t\t\t\tjQuery( YTPlayer ).trigger( \"YTPChanged\" );\n\n\t\t\t\t\tfunction parseYTPlayer_data( data ) {\n\t\t\t\t\t\tYTPlayer.videoData = {};\n\t\t\t\t\t\tYTPlayer.videoData.id = YTPlayer.videoID;\n\t\t\t\t\t\tYTPlayer.videoData.channelTitle = data.channelTitle;\n\t\t\t\t\t\tYTPlayer.videoData.title = data.title;\n\t\t\t\t\t\tYTPlayer.videoData.description = data.description.length < 400 ? data.description : data.description.substring( 0, 400 ) + \" ...\";\n\t\t\t\t\t\tYTPlayer.videoData.aspectratio = YTPlayer.opt.ratio == \"auto\" ? \"16/9\" : YTPlayer.opt.ratio;\n\t\t\t\t\t\tYTPlayer.opt.ratio = YTPlayer.videoData.aspectratio;\n\t\t\t\t\t\tYTPlayer.videoData.thumb_max = data.thumbnails.maxres ? data.thumbnails.maxres.url : null;\n\t\t\t\t\t\tYTPlayer.videoData.thumb_high = data.thumbnails.high ? data.thumbnails.high.url : null;\n\t\t\t\t\t\tYTPlayer.videoData.thumb_medium = data.thumbnails.medium ? data.thumbnails.medium.url : null;\n\t\t\t\t\t\tjQuery.mbStorage.set( \"YTPlayer_data_\" + YTPlayer.videoID, YTPlayer.videoData );\n\t\t\t\t\t}\n\t\t\t\t\tparseYTPlayer_data( data.items[ 0 ].snippet );\n\t\t\t\t\tYTPlayer.hasData = true;\n\t\t\t\t\tvar YTPData = jQuery.Event( \"YTPData\" );\n\t\t\t\t\tYTPData.prop = {};\n\t\t\t\t\tfor( var x in YTPlayer.videoData ) YTPData.prop[ x ] = YTPlayer.videoData[ x ];\n\t\t\t\t\tjQuery( YTPlayer ).trigger( YTPData );\n\t\t\t\t} );\n\t\t\t} else {\n\t\t\t\tsetTimeout( function() {\n\t\t\t\t\tjQuery( YTPlayer ).trigger( \"YTPChanged\" );\n\t\t\t\t}, 50 );\n\t\t\t\tif( YTPlayer.isPlayer && !YTPlayer.opt.autoPlay ) {\n\t\t\t\t\tvar bgndURL = jQuery.mbYTPlayer.locationProtocol + \"//i.ytimg.com/vi/\" + YTPlayer.videoID + \"/hqdefault.jpg\";\n\t\t\t\t\tYTPlayer.opt.containment.css( {\n\t\t\t\t\t\tbackground: \"rgba(0,0,0,0.5) url(\" + bgndURL + \") center center\",\n\t\t\t\t\t\tbackgroundSize: \"cover\"\n\t\t\t\t\t} );\n\t\t\t\t\tYTPlayer.opt.backgroundUrl = bgndURL;\n\t\t\t\t}\n\t\t\t\tYTPlayer.videoData = null;\n\t\t\t\tYTPlayer.opt.ratio = YTPlayer.opt.ratio == \"auto\" ? \"16/9\" : YTPlayer.opt.ratio;\n\t\t\t}\n\t\t\tif( YTPlayer.isPlayer && !YTPlayer.opt.autoPlay ) {\n\t\t\t\tYTPlayer.loading = jQuery( \"<div/>\" ).addClass( \"loading\" ).html( \"Loading\" ).hide();\n\t\t\t\tjQuery( YTPlayer ).append( YTPlayer.loading );\n\t\t\t\tYTPlayer.loading.fadeIn();\n\t\t\t}\n\t\t},\n\t\t/**\n\t\t *\n\t\t */\n\t\tremoveStoredData: function() {\n\t\t\tjQuery.mbStorage.remove();\n\t\t},\n\t\t/**\n\t\t *\n\t\t * @returns {*|YTPlayer.videoData}\n\t\t */\n\t\tgetVideoData: function() {\n\t\t\tvar YTPlayer = this.get( 0 );\n\t\t\treturn YTPlayer.videoData;\n\t\t},\n\t\t/**\n\t\t *\n\t\t * @returns {*|YTPlayer.videoID|boolean}\n\t\t */\n\t\tgetVideoID: function() {\n\t\t\tvar YTPlayer = this.get( 0 );\n\t\t\treturn YTPlayer.videoID || false;\n\t\t},\n\t\t/**\n\t\t *\n\t\t * @param quality\n\t\t */\n\t\tsetVideoQuality: function( quality ) {\n\t\t\tvar YTPlayer = this.get( 0 );\n\t\t\t//if( !jQuery.browser.chrome )\n\t\t\tYTPlayer.player.setPlaybackQuality( quality );\n\t\t},\n\t\t/**\n\t\t * @param videos\n\t\t * @param shuffle\n\t\t * @param callback\n\t\t * @returns {jQuery.mbYTPlayer}\n\t\t */\n\n\t\tplaylist: function( videos, shuffle, callback ) {\n\t\t\tvar $YTPlayer = this;\n\t\t\tvar YTPlayer = $YTPlayer.get( 0 );\n\t\t\tYTPlayer.isPlayList = true;\n\t\t\tif( shuffle ) videos = jQuery.shuffle( videos );\n\t\t\tif( !YTPlayer.videoID ) {\n\t\t\t\tYTPlayer.videos = videos;\n\t\t\t\tYTPlayer.videoCounter = 0;\n\t\t\t\tYTPlayer.videoLength = videos.length;\n\t\t\t\tjQuery( YTPlayer ).data( \"property\", videos[ 0 ] );\n\t\t\t\tjQuery( YTPlayer ).mb_YTPlayer();\n\t\t\t}\n\t\t\tif( typeof callback == \"function\" ) jQuery( YTPlayer ).one( \"YTPChanged\", function() {\n\t\t\t\tcallback( YTPlayer );\n\t\t\t} );\n\t\t\tjQuery( YTPlayer ).on( \"YTPEnd\", function() {\n\t\t\t\tjQuery( YTPlayer ).playNext();\n\t\t\t} );\n\t\t\treturn $YTPlayer;\n\t\t},\n\t\t/**\n\t\t *\n\t\t * @returns {jQuery.mbYTPlayer}\n\t\t */\n\t\tplayNext: function() {\n\t\t\tvar YTPlayer = this.get( 0 );\n\n\t\t\tif( YTPlayer.checkForStartAt ) {\n\t\t\t\tclearTimeout( YTPlayer.checkForStartAt );\n\t\t\t\tclearInterval( YTPlayer.getState );\n\t\t\t}\n\n\t\t\tYTPlayer.videoCounter++;\n\t\t\tif( YTPlayer.videoCounter >= YTPlayer.videoLength ) YTPlayer.videoCounter = 0;\n\t\t\tjQuery( YTPlayer ).changeMovie( YTPlayer.videos[ YTPlayer.videoCounter ] );\n\t\t\treturn this;\n\t\t},\n\t\t/**\n\t\t *\n\t\t * @returns {jQuery.mbYTPlayer}\n\t\t */\n\t\tplayPrev: function() {\n\t\t\tvar YTPlayer = this.get( 0 );\n\n\t\t\tif( YTPlayer.checkForStartAt ) {\n\t\t\t\tclearInterval( YTPlayer.checkForStartAt );\n\t\t\t\tclearInterval( YTPlayer.getState );\n\t\t\t}\n\n\t\t\tYTPlayer.videoCounter--;\n\t\t\tif( YTPlayer.videoCounter < 0 ) YTPlayer.videoCounter = YTPlayer.videoLength - 1;\n\t\t\tjQuery( YTPlayer ).changeMovie( YTPlayer.videos[ YTPlayer.videoCounter ] );\n\t\t\treturn this;\n\t\t},\n\t\t/**\n\t\t *\n\t\t * @param opt\n\t\t */\n\t\tchangeMovie: function( opt ) {\n\n\t\t\tvar YTPlayer = this.get( 0 );\n\t\t\tYTPlayer.opt.startAt = 0;\n\t\t\tYTPlayer.opt.stopAt = 0;\n\t\t\tYTPlayer.opt.mute = true;\n\t\t\tYTPlayer.hasData = false;\n\t\t\tYTPlayer.hasChanged = true;\n\t\t\tYTPlayer.player.loopTime = undefined;\n\n\t\t\tif( opt ) jQuery.extend( YTPlayer.opt, YTPlayer.defaultOpt, opt );\n\t\t\tYTPlayer.videoID = getYTPVideoID( YTPlayer.opt.videoURL ).videoID;\n\n\t\t\tif( YTPlayer.opt.loop == \"true\" )\n\t\t\t\tYTPlayer.opt.loop = 9999;\n\n\t\t\tjQuery( YTPlayer.playerEl ).CSSAnimate( {\n\t\t\t\topacity: 0\n\t\t\t}, 200, function() {\n\n\t\t\t\tvar YTPChangeMovie = jQuery.Event( \"YTPChangeMovie\" );\n\t\t\t\tYTPChangeMovie.time = YTPlayer.player.time;\n\t\t\t\tYTPChangeMovie.videoId = YTPlayer.videoID;\n\t\t\t\tjQuery( YTPlayer ).trigger( YTPChangeMovie );\n\n\t\t\t\tjQuery( YTPlayer ).YTPGetPlayer().cueVideoByUrl( encodeURI( jQuery.mbYTPlayer.locationProtocol + \"//www.youtube.com/v/\" + YTPlayer.videoID ), 1, YTPlayer.opt.quality );\n\t\t\t\tjQuery( YTPlayer ).optimizeDisplay();\n\n\t\t\t\tjQuery.mbYTPlayer.checkForState( YTPlayer );\n\t\t\t\tjQuery.mbYTPlayer.getDataFromAPI( YTPlayer );\n\t\t\t\treturn this;\n\t\t\t} );\n\t\t},\n\t\t/**\n\t\t *\n\t\t * @returns {player}\n\t\t */\n\t\tgetPlayer: function() {\n\t\t\treturn jQuery( this ).get( 0 ).player;\n\t\t},\n\n\t\tplayerDestroy: function() {\n\t\t\tvar YTPlayer = this.get( 0 );\n\t\t\tytp.YTAPIReady = true;\n\t\t\tytp.backgroundIsInited = false;\n\t\t\tYTPlayer.isInit = false;\n\t\t\tYTPlayer.videoID = null;\n\t\t\tvar playerBox = YTPlayer.wrapper;\n\t\t\tplayerBox.remove();\n\t\t\tjQuery( \"#controlBar_\" + YTPlayer.id ).remove();\n\t\t\tclearInterval( YTPlayer.checkForStartAt );\n\t\t\tclearInterval( YTPlayer.getState );\n\t\t\treturn this;\n\t\t},\n\n\t\t/**\n\t\t *\n\t\t * @param real\n\t\t * @returns {jQuery.mbYTPlayer}\n\t\t */\n\t\tfullscreen: function( real ) {\n\t\t\tvar YTPlayer = this.get( 0 );\n\t\t\tif( typeof real == \"undefined\" ) real = YTPlayer.opt.realfullscreen;\n\t\t\treal = eval( real );\n\t\t\tvar controls = jQuery( \"#controlBar_\" + YTPlayer.id );\n\t\t\tvar fullScreenBtn = controls.find( \".mb_OnlyYT\" );\n\t\t\tvar videoWrapper = YTPlayer.isSelf ? YTPlayer.opt.containment : YTPlayer.wrapper;\n\t\t\t//var videoWrapper = YTPlayer.wrapper;\n\t\t\tif( real ) {\n\t\t\t\tvar fullscreenchange = jQuery.browser.mozilla ? \"mozfullscreenchange\" : jQuery.browser.webkit ? \"webkitfullscreenchange\" : \"fullscreenchange\";\n\t\t\t\tjQuery( document ).off( fullscreenchange ).on( fullscreenchange, function() {\n\t\t\t\t\tvar isFullScreen = RunPrefixMethod( document, \"IsFullScreen\" ) || RunPrefixMethod( document, \"FullScreen\" );\n\t\t\t\t\tif( !isFullScreen ) {\n\t\t\t\t\t\tYTPlayer.isAlone = false;\n\t\t\t\t\t\tfullScreenBtn.html( jQuery.mbYTPlayer.controls.onlyYT );\n\t\t\t\t\t\tjQuery( YTPlayer ).YTPSetVideoQuality( YTPlayer.opt.quality );\n\t\t\t\t\t\tvideoWrapper.removeClass( \"YTPFullscreen\" );\n\t\t\t\t\t\tvideoWrapper.CSSAnimate( {\n\t\t\t\t\t\t\topacity: YTPlayer.opt.opacity\n\t\t\t\t\t\t}, 500 );\n\t\t\t\t\t\tvideoWrapper.css( {\n\t\t\t\t\t\t\tzIndex: 0\n\t\t\t\t\t\t} );\n\t\t\t\t\t\tif( YTPlayer.isBackground ) {\n\t\t\t\t\t\t\tjQuery( \"body\" ).after( controls );\n\t\t\t\t\t\t} else {\n\t\t\t\t\t\t\tYTPlayer.wrapper.before( controls );\n\t\t\t\t\t\t}\n\t\t\t\t\t\tjQuery( window ).resize();\n\t\t\t\t\t\tjQuery( YTPlayer ).trigger( \"YTPFullScreenEnd\" );\n\t\t\t\t\t} else {\n\t\t\t\t\t\tjQuery( YTPlayer ).YTPSetVideoQuality( \"default\" );\n\t\t\t\t\t\tjQuery( YTPlayer ).trigger( \"YTPFullScreenStart\" );\n\t\t\t\t\t}\n\t\t\t\t} );\n\t\t\t}\n\t\t\tif( !YTPlayer.isAlone ) {\n\t\t\t\tfunction hideMouse() {\n\t\t\t\t\tYTPlayer.overlay.css( {\n\t\t\t\t\t\tcursor: \"none\"\n\t\t\t\t\t} );\n\t\t\t\t}\n\t\t\t\tjQuery( document ).on( \"mousemove.YTPlayer\", function( e ) {\n\t\t\t\t\tYTPlayer.overlay.css( {\n\t\t\t\t\t\tcursor: \"auto\"\n\t\t\t\t\t} );\n\t\t\t\t\tclearTimeout( YTPlayer.hideCursor );\n\t\t\t\t\tif( !jQuery( e.target ).parents().is( \".mb_YTPBar\" ) ) YTPlayer.hideCursor = setTimeout( hideMouse, 3000 );\n\t\t\t\t} );\n\t\t\t\thideMouse();\n\t\t\t\tif( real ) {\n\t\t\t\t\tvideoWrapper.css( {\n\t\t\t\t\t\topacity: 0\n\t\t\t\t\t} );\n\t\t\t\t\tvideoWrapper.addClass( \"YTPFullscreen\" );\n\t\t\t\t\tlaunchFullscreen( videoWrapper.get( 0 ) );\n\t\t\t\t\tsetTimeout( function() {\n\t\t\t\t\t\tvideoWrapper.CSSAnimate( {\n\t\t\t\t\t\t\topacity: 1\n\t\t\t\t\t\t}, 1000 );\n\t\t\t\t\t\tYTPlayer.wrapper.append( controls );\n\t\t\t\t\t\tjQuery( YTPlayer ).optimizeDisplay();\n\t\t\t\t\t\tYTPlayer.player.seekTo( YTPlayer.player.getCurrentTime() + .1, true );\n\t\t\t\t\t}, 500 )\n\t\t\t\t} else videoWrapper.css( {\n\t\t\t\t\tzIndex: 10000\n\t\t\t\t} ).CSSAnimate( {\n\t\t\t\t\topacity: 1\n\t\t\t\t}, 1000 );\n\t\t\t\tfullScreenBtn.html( jQuery.mbYTPlayer.controls.showSite );\n\t\t\t\tYTPlayer.isAlone = true;\n\t\t\t} else {\n\t\t\t\tjQuery( document ).off( \"mousemove.YTPlayer\" );\n\t\t\t\tYTPlayer.overlay.css( {\n\t\t\t\t\tcursor: \"auto\"\n\t\t\t\t} );\n\t\t\t\tif( real ) {\n\t\t\t\t\tcancelFullscreen();\n\t\t\t\t} else {\n\t\t\t\t\tvideoWrapper.CSSAnimate( {\n\t\t\t\t\t\topacity: YTPlayer.opt.opacity\n\t\t\t\t\t}, 500 );\n\t\t\t\t\tvideoWrapper.css( {\n\t\t\t\t\t\tzIndex: 0\n\t\t\t\t\t} );\n\t\t\t\t}\n\t\t\t\tfullScreenBtn.html( jQuery.mbYTPlayer.controls.onlyYT );\n\t\t\t\tYTPlayer.isAlone = false;\n\t\t\t}\n\n\t\t\tfunction RunPrefixMethod( obj, method ) {\n\t\t\t\tvar pfx = [ \"webkit\", \"moz\", \"ms\", \"o\", \"\" ];\n\t\t\t\tvar p = 0,\n\t\t\t\t\tm, t;\n\t\t\t\twhile( p < pfx.length && !obj[ m ] ) {\n\t\t\t\t\tm = method;\n\t\t\t\t\tif( pfx[ p ] == \"\" ) {\n\t\t\t\t\t\tm = m.substr( 0, 1 ).toLowerCase() + m.substr( 1 );\n\t\t\t\t\t}\n\t\t\t\t\tm = pfx[ p ] + m;\n\t\t\t\t\tt = typeof obj[ m ];\n\t\t\t\t\tif( t != \"undefined\" ) {\n\t\t\t\t\t\tpfx = [ pfx[ p ] ];\n\t\t\t\t\t\treturn( t == \"function\" ? obj[ m ]() : obj[ m ] );\n\t\t\t\t\t}\n\t\t\t\t\tp++;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tfunction launchFullscreen( element ) {\n\t\t\t\tRunPrefixMethod( element, \"RequestFullScreen\" );\n\t\t\t}\n\n\t\t\tfunction cancelFullscreen() {\n\t\t\t\tif( RunPrefixMethod( document, \"FullScreen\" ) || RunPrefixMethod( document, \"IsFullScreen\" ) ) {\n\t\t\t\t\tRunPrefixMethod( document, \"CancelFullScreen\" );\n\t\t\t\t}\n\t\t\t}\n\t\t\treturn this;\n\t\t},\n\t\t/**\n\t\t *\n\t\t * @returns {jQuery.mbYTPlayer}\n\t\t */\n\t\ttoggleLoops: function() {\n\t\t\tvar YTPlayer = this.get( 0 );\n\t\t\tvar data = YTPlayer.opt;\n\t\t\tif( data.loop == 1 ) {\n\t\t\t\tdata.loop = 0;\n\t\t\t} else {\n\t\t\t\tif( data.startAt ) {\n\t\t\t\t\tYTPlayer.player.seekTo( data.startAt );\n\t\t\t\t} else {\n\t\t\t\t\tYTPlayer.player.playVideo();\n\t\t\t\t}\n\t\t\t\tdata.loop = 1;\n\t\t\t}\n\t\t\treturn this;\n\t\t},\n\t\t/**\n\t\t *\n\t\t * @returns {jQuery.mbYTPlayer}\n\t\t */\n\t\tplay: function() {\n\t\t\tvar YTPlayer = this.get( 0 );\n\t\t\tif( !YTPlayer.isReady ) return;\n\n\t\t\tYTPlayer.player.playVideo();\n\t\t\tYTPlayer.wrapper.CSSAnimate( {\n\t\t\t\topacity: YTPlayer.isAlone ? 1 : YTPlayer.opt.opacity\n\t\t\t}, 2000 );\n\n\t\t\tjQuery( YTPlayer.playerEl ).CSSAnimate( {\n\t\t\t\topacity: 1\n\t\t\t}, 1000 );\n\n\t\t\tjQuery( YTPlayer ).css( \"background-image\", \"none\" );\n\t\t\treturn this;\n\t\t},\n\t\t/**\n\t\t *\n\t\t * @param callback\n\t\t * @returns {jQuery.mbYTPlayer}\n\t\t */\n\t\ttogglePlay: function( callback ) {\n\t\t\tvar YTPlayer = this.get( 0 );\n\t\t\tif( YTPlayer.state == 1 ) this.YTPPause();\n\t\t\telse this.YTPPlay();\n\t\t\tif( typeof callback == \"function\" ) {\n\t\t\t\tcallback( YTPlayer.state );\n\t\t\t}\n\t\t\treturn this;\n\t\t},\n\t\t/**\n\t\t *\n\t\t * @returns {jQuery.mbYTPlayer}\n\t\t */\n\t\tstop: function() {\n\t\t\tvar YTPlayer = this.get( 0 );\n\t\t\tvar controls = jQuery( \"#controlBar_\" + YTPlayer.id );\n\t\t\tvar playBtn = controls.find( \".mb_YTPPlaypause\" );\n\t\t\tplayBtn.html( jQuery.mbYTPlayer.controls.play );\n\t\t\tYTPlayer.player.stopVideo();\n\t\t\treturn this;\n\t\t},\n\t\t/**\n\t\t *\n\t\t * @returns {jQuery.mbYTPlayer}\n\t\t */\n\t\tpause: function() {\n\t\t\tvar YTPlayer = this.get( 0 );\n\t\t\tYTPlayer.player.pauseVideo();\n\t\t\treturn this;\n\t\t},\n\t\t/**\n\t\t *\n\t\t * @param val\n\t\t * @returns {jQuery.mbYTPlayer}\n\t\t */\n\t\tseekTo: function( val ) {\n\t\t\tvar YTPlayer = this.get( 0 );\n\t\t\tYTPlayer.player.seekTo( val, true );\n\t\t\treturn this;\n\t\t},\n\t\t/**\n\t\t *\n\t\t * @param val\n\t\t * @returns {jQuery.mbYTPlayer}\n\t\t */\n\t\tsetVolume: function( val ) {\n\t\t\tvar YTPlayer = this.get( 0 );\n\t\t\tif( !val && !YTPlayer.opt.vol && YTPlayer.player.getVolume() == 0 ) jQuery( YTPlayer ).YTPUnmute();\n\t\t\telse if( ( !val && YTPlayer.player.getVolume() > 0 ) || ( val && YTPlayer.opt.vol == val ) ) {\n\t\t\t\tif( !YTPlayer.isMute ) jQuery( YTPlayer ).YTPMute();\n\t\t\t\telse jQuery( YTPlayer ).YTPUnmute();\n\t\t\t} else {\n\t\t\t\tYTPlayer.opt.vol = val;\n\t\t\t\tYTPlayer.player.setVolume( YTPlayer.opt.vol );\n\t\t\t\tif( YTPlayer.volumeBar && YTPlayer.volumeBar.length ) YTPlayer.volumeBar.updateSliderVal( val )\n\t\t\t}\n\t\t\treturn this;\n\t\t},\n\t\t/**\n\t\t *\n\t\t * @returns {jQuery.mbYTPlayer}\n\t\t */\n\t\tmute: function() {\n\t\t\tvar YTPlayer = this.get( 0 );\n\t\t\tif( YTPlayer.isMute ) return;\n\t\t\tYTPlayer.player.mute();\n\t\t\tYTPlayer.isMute = true;\n\t\t\tYTPlayer.player.setVolume( 0 );\n\t\t\tif( YTPlayer.volumeBar && YTPlayer.volumeBar.length && YTPlayer.volumeBar.width() > 10 ) {\n\t\t\t\tYTPlayer.volumeBar.updateSliderVal( 0 );\n\t\t\t}\n\t\t\tvar controls = jQuery( \"#controlBar_\" + YTPlayer.id );\n\t\t\tvar muteBtn = controls.find( \".mb_YTPMuteUnmute\" );\n\t\t\tmuteBtn.html( jQuery.mbYTPlayer.controls.unmute );\n\t\t\tjQuery( YTPlayer ).addClass( \"isMuted\" );\n\t\t\tif( YTPlayer.volumeBar && YTPlayer.volumeBar.length ) YTPlayer.volumeBar.addClass( \"muted\" );\n\t\t\tvar YTPEvent = jQuery.Event( \"YTPMuted\" );\n\t\t\tYTPEvent.time = YTPlayer.player.time;\n\t\t\tif( YTPlayer.canTrigger ) jQuery( YTPlayer ).trigger( YTPEvent );\n\t\t\treturn this;\n\t\t},\n\t\t/**\n\t\t *\n\t\t * @returns {jQuery.mbYTPlayer}\n\t\t */\n\t\tunmute: function() {\n\t\t\tvar YTPlayer = this.get( 0 );\n\t\t\tif( !YTPlayer.isMute ) return;\n\t\t\tYTPlayer.player.unMute();\n\t\t\tYTPlayer.isMute = false;\n\t\t\tYTPlayer.player.setVolume( YTPlayer.opt.vol );\n\t\t\tif( YTPlayer.volumeBar && YTPlayer.volumeBar.length ) YTPlayer.volumeBar.updateSliderVal( YTPlayer.opt.vol > 10 ? YTPlayer.opt.vol : 10 );\n\t\t\tvar controls = jQuery( \"#controlBar_\" + YTPlayer.id );\n\t\t\tvar muteBtn = controls.find( \".mb_YTPMuteUnmute\" );\n\t\t\tmuteBtn.html( jQuery.mbYTPlayer.controls.mute );\n\t\t\tjQuery( YTPlayer ).removeClass( \"isMuted\" );\n\t\t\tif( YTPlayer.volumeBar && YTPlayer.volumeBar.length ) YTPlayer.volumeBar.removeClass( \"muted\" );\n\t\t\tvar YTPEvent = jQuery.Event( \"YTPUnmuted\" );\n\t\t\tYTPEvent.time = YTPlayer.player.time;\n\t\t\tif( YTPlayer.canTrigger ) jQuery( YTPlayer ).trigger( YTPEvent );\n\t\t\treturn this;\n\t\t},\n\t\t/**\n\t\t *\n\t\t * @param filter\n\t\t * @param value\n\t\t * @returns {jQuery.mbYTPlayer}\n\t\t */\n\t\tapplyFilter: function( filter, value ) {\n\t\t\tvar YTPlayer = this.get( 0 );\n\t\t\tYTPlayer.filters[ filter ].value = value;\n\t\t\tif( YTPlayer.filtersEnabled ) this.YTPEnableFilters();\n\t\t\treturn this;\n\t\t},\n\t\t/**\n\t\t *\n\t\t * @param filters\n\t\t * @returns {jQuery.mbYTPlayer}\n\t\t */\n\t\tapplyFilters: function( filters ) {\n\t\t\tvar YTPlayer = this.get( 0 );\n\t\t\tthis.on( \"YTPReady\", function() {\n\t\t\t\tfor( var key in filters ) {\n\t\t\t\t\tYTPlayer.filters[ key ].value = filters[ key ];\n\t\t\t\t\tjQuery( YTPlayer ).YTPApplyFilter( key, filters[ key ] );\n\t\t\t\t}\n\t\t\t\tjQuery( YTPlayer ).trigger( \"YTPFiltersApplied\" );\n\t\t\t} );\n\t\t\treturn this;\n\t\t},\n\t\t/**\n\t\t *\n\t\t * @param filter\n\t\t * @param value\n\t\t * @returns {*}\n\t\t */\n\t\ttoggleFilter: function( filter, value ) {\n\t\t\treturn this.each( function() {\n\t\t\t\tvar YTPlayer = this;\n\t\t\t\tif( !YTPlayer.filters[ filter ].value ) YTPlayer.filters[ filter ].value = value;\n\t\t\t\telse YTPlayer.filters[ filter ].value = 0;\n\t\t\t\tif( YTPlayer.filtersEnabled ) jQuery( this ).YTPEnableFilters();\n\t\t\t} )\n\t\t\treturn this;\n\t\t},\n\t\t/**\n\t\t *\n\t\t * @param callback\n\t\t * @returns {*}\n\t\t */\n\t\ttoggleFilters: function( callback ) {\n\t\t\treturn this.each( function() {\n\t\t\t\tvar YTPlayer = this;\n\t\t\t\tif( YTPlayer.filtersEnabled ) {\n\t\t\t\t\tjQuery( YTPlayer ).trigger( \"YTPDisableFilters\" );\n\t\t\t\t\tjQuery( YTPlayer ).YTPDisableFilters();\n\t\t\t\t} else {\n\t\t\t\t\tjQuery( YTPlayer ).YTPEnableFilters();\n\t\t\t\t\tjQuery( YTPlayer ).trigger( \"YTPEnableFilters\" );\n\t\t\t\t}\n\t\t\t\tif( typeof callback == \"function\" ) callback( YTPlayer.filtersEnabled );\n\t\t\t} )\n\t\t},\n\t\t/**\n\t\t *\n\t\t * @returns {*}\n\t\t */\n\t\tdisableFilters: function() {\n\t\t\treturn this.each( function() {\n\t\t\t\tvar YTPlayer = this;\n\t\t\t\tvar iframe = jQuery( YTPlayer.playerEl );\n\t\t\t\tiframe.css( \"-webkit-filter\", \"\" );\n\t\t\t\tiframe.css( \"filter\", \"\" );\n\t\t\t\tYTPlayer.filtersEnabled = false;\n\t\t\t} )\n\t\t},\n\t\t/**\n\t\t *\n\t\t * @returns {*}\n\t\t */\n\t\tenableFilters: function() {\n\t\t\treturn this.each( function() {\n\t\t\t\tvar YTPlayer = this;\n\t\t\t\tvar iframe = jQuery( YTPlayer.playerEl );\n\t\t\t\tvar filterStyle = \"\";\n\t\t\t\tfor( var key in YTPlayer.filters ) {\n\t\t\t\t\tif( YTPlayer.filters[ key ].value ) filterStyle += key.replace( \"_\", \"-\" ) + \"(\" + YTPlayer.filters[ key ].value + YTPlayer.filters[ key ].unit + \") \";\n\t\t\t\t}\n\t\t\t\tiframe.css( \"-webkit-filter\", filterStyle );\n\t\t\t\tiframe.css( \"filter\", filterStyle );\n\t\t\t\tYTPlayer.filtersEnabled = true;\n\t\t\t} )\n\t\t\treturn this;\n\t\t},\n\t\t/**\n\t\t *\n\t\t * @param filter\n\t\t * @param callback\n\t\t * @returns {*}\n\t\t */\n\t\tremoveFilter: function( filter, callback ) {\n\t\t\treturn this.each( function() {\n\t\t\t\tif( typeof filter == \"function\" ) {\n\t\t\t\t\tcallback = filter;\n\t\t\t\t\tfilter = null;\n\t\t\t\t}\n\t\t\t\tvar YTPlayer = this;\n\t\t\t\tif( !filter )\n\t\t\t\t\tfor( var key in YTPlayer.filters ) {\n\t\t\t\t\t\tjQuery( this ).YTPApplyFilter( key, 0 );\n\t\t\t\t\t\tif( typeof callback == \"function\" ) callback( key );\n\t\t\t\t\t} else {\n\t\t\t\t\t\tjQuery( this ).YTPApplyFilter( filter, 0 );\n\t\t\t\t\t\tif( typeof callback == \"function\" ) callback( filter );\n\t\t\t\t\t}\n\t\t\t} );\n\t\t\treturn this;\n\t\t},\n\t\t/**\n\t\t *\n\t\t * @returns {{totalTime: number, currentTime: number}}\n\t\t */\n\t\tmanageProgress: function() {\n\t\t\tvar YTPlayer = this.get( 0 );\n\t\t\tvar controls = jQuery( \"#controlBar_\" + YTPlayer.id );\n\t\t\tvar progressBar = controls.find( \".mb_YTPProgress\" );\n\t\t\tvar loadedBar = controls.find( \".mb_YTPLoaded\" );\n\t\t\tvar timeBar = controls.find( \".mb_YTPseekbar\" );\n\t\t\tvar totW = progressBar.outerWidth();\n\t\t\tvar currentTime = Math.floor( YTPlayer.player.getCurrentTime() );\n\t\t\tvar totalTime = Math.floor( YTPlayer.player.getDuration() );\n\t\t\tvar timeW = ( currentTime * totW ) / totalTime;\n\t\t\tvar startLeft = 0;\n\t\t\tvar loadedW = YTPlayer.player.getVideoLoadedFraction() * 100;\n\t\t\tloadedBar.css( {\n\t\t\t\tleft: startLeft,\n\t\t\t\twidth: loadedW + \"%\"\n\t\t\t} );\n\t\t\ttimeBar.css( {\n\t\t\t\tleft: 0,\n\t\t\t\twidth: timeW\n\t\t\t} );\n\t\t\treturn {\n\t\t\t\ttotalTime: totalTime,\n\t\t\t\tcurrentTime: currentTime\n\t\t\t};\n\t\t},\n\t\t/**\n\t\t *\n\t\t * @param YTPlayer\n\t\t */\n\t\tbuildControls: function( YTPlayer ) {\n\t\t\tvar data = YTPlayer.opt;\n\t\t\t// @data.printUrl: is deprecated; use data.showYTLogo\n\t\t\tdata.showYTLogo = data.showYTLogo || data.printUrl;\n\t\t\tif( jQuery( \"#controlBar_\" + YTPlayer.id ).length ) return;\n\t\t\tYTPlayer.controlBar = jQuery( \"<span/>\" ).attr( \"id\", \"controlBar_\" + YTPlayer.id ).addClass( \"mb_YTPBar\" ).css( {\n\t\t\t\twhiteSpace: \"noWrap\",\n\t\t\t\tposition: YTPlayer.isBackground ? \"fixed\" : \"absolute\",\n\t\t\t\tzIndex: YTPlayer.isBackground ? 10000 : 1000\n\t\t\t} ).hide();\n\t\t\tvar buttonBar = jQuery( \"<div/>\" ).addClass( \"buttonBar\" );\n\t\t\t/* play/pause button*/\n\t\t\tvar playpause = jQuery( \"<span>\" + jQuery.mbYTPlayer.controls.play + \"</span>\" ).addClass( \"mb_YTPPlaypause ytpicon\" ).click( function() {\n\t\t\t\tif( YTPlayer.player.getPlayerState() == 1 ) jQuery( YTPlayer ).YTPPause();\n\t\t\t\telse jQuery( YTPlayer ).YTPPlay();\n\t\t\t} );\n\t\t\t/* mute/unmute button*/\n\t\t\tvar MuteUnmute = jQuery( \"<span>\" + jQuery.mbYTPlayer.controls.mute + \"</span>\" ).addClass( \"mb_YTPMuteUnmute ytpicon\" ).click( function() {\n\t\t\t\tif( YTPlayer.player.getVolume() == 0 ) {\n\t\t\t\t\tjQuery( YTPlayer ).YTPUnmute();\n\t\t\t\t} else {\n\t\t\t\t\tjQuery( YTPlayer ).YTPMute();\n\t\t\t\t}\n\t\t\t} );\n\t\t\t/* volume bar*/\n\t\t\tvar volumeBar = jQuery( \"<div/>\" ).addClass( \"mb_YTPVolumeBar\" ).css( {\n\t\t\t\tdisplay: \"inline-block\"\n\t\t\t} );\n\t\t\tYTPlayer.volumeBar = volumeBar;\n\t\t\t/* time elapsed */\n\t\t\tvar idx = jQuery( \"<span/>\" ).addClass( \"mb_YTPTime\" );\n\t\t\tvar vURL = data.videoURL ? data.videoURL : \"\";\n\t\t\tif( vURL.indexOf( \"http\" ) < 0 ) vURL = jQuery.mbYTPlayer.locationProtocol + \"//www.youtube.com/watch?v=\" + data.videoURL;\n\t\t\tvar movieUrl = jQuery( \"<span/>\" ).html( jQuery.mbYTPlayer.controls.ytLogo ).addClass( \"mb_YTPUrl ytpicon\" ).attr( \"title\", \"view on YouTube\" ).on( \"click\", function() {\n\t\t\t\twindow.open( vURL, \"viewOnYT\" )\n\t\t\t} );\n\t\t\tvar onlyVideo = jQuery( \"<span/>\" ).html( jQuery.mbYTPlayer.controls.onlyYT ).addClass( \"mb_OnlyYT ytpicon\" ).on( \"click\", function() {\n\t\t\t\tjQuery( YTPlayer ).YTPFullscreen( data.realfullscreen );\n\t\t\t} );\n\t\t\tvar progressBar = jQuery( \"<div/>\" ).addClass( \"mb_YTPProgress\" ).css( \"position\", \"absolute\" ).click( function( e ) {\n\t\t\t\ttimeBar.css( {\n\t\t\t\t\twidth: ( e.clientX - timeBar.offset().left )\n\t\t\t\t} );\n\t\t\t\tYTPlayer.timeW = e.clientX - timeBar.offset().left;\n\t\t\t\tYTPlayer.controlBar.find( \".mb_YTPLoaded\" ).css( {\n\t\t\t\t\twidth: 0\n\t\t\t\t} );\n\t\t\t\tvar totalTime = Math.floor( YTPlayer.player.getDuration() );\n\t\t\t\tYTPlayer.goto = ( timeBar.outerWidth() * totalTime ) / progressBar.outerWidth();\n\t\t\t\tYTPlayer.player.seekTo( parseFloat( YTPlayer.goto ), true );\n\t\t\t\tYTPlayer.controlBar.find( \".mb_YTPLoaded\" ).css( {\n\t\t\t\t\twidth: 0\n\t\t\t\t} );\n\t\t\t} );\n\t\t\tvar loadedBar = jQuery( \"<div/>\" ).addClass( \"mb_YTPLoaded\" ).css( \"position\", \"absolute\" );\n\t\t\tvar timeBar = jQuery( \"<div/>\" ).addClass( \"mb_YTPseekbar\" ).css( \"position\", \"absolute\" );\n\t\t\tprogressBar.append( loadedBar ).append( timeBar );\n\t\t\tbuttonBar.append( playpause ).append( MuteUnmute ).append( volumeBar ).append( idx );\n\t\t\tif( data.showYTLogo ) {\n\t\t\t\tbuttonBar.append( movieUrl );\n\t\t\t}\n\t\t\tif( YTPlayer.isBackground || ( eval( YTPlayer.opt.realfullscreen ) && !YTPlayer.isBackground ) ) buttonBar.append( onlyVideo );\n\t\t\tYTPlayer.controlBar.append( buttonBar ).append( progressBar );\n\t\t\tif( !YTPlayer.isBackground ) {\n\t\t\t\tYTPlayer.controlBar.addClass( \"inlinePlayer\" );\n\t\t\t\tYTPlayer.wrapper.before( YTPlayer.controlBar );\n\t\t\t} else {\n\t\t\t\tjQuery( \"body\" ).after( YTPlayer.controlBar );\n\t\t\t}\n\t\t\tvolumeBar.simpleSlider( {\n\t\t\t\tinitialval: YTPlayer.opt.vol,\n\t\t\t\tscale: 100,\n\t\t\t\torientation: \"h\",\n\t\t\t\tcallback: function( el ) {\n\t\t\t\t\tif( el.value == 0 ) {\n\t\t\t\t\t\tjQuery( YTPlayer ).YTPMute();\n\t\t\t\t\t} else {\n\t\t\t\t\t\tjQuery( YTPlayer ).YTPUnmute();\n\t\t\t\t\t}\n\t\t\t\t\tYTPlayer.player.setVolume( el.value );\n\t\t\t\t\tif( !YTPlayer.isMute ) YTPlayer.opt.vol = el.value;\n\t\t\t\t}\n\t\t\t} );\n\t\t},\n\t\t/**\n\t\t *\n\t\t *\n\t\t * */\n\t\tcheckForState: function( YTPlayer ) {\n\t\t\tvar interval = YTPlayer.opt.showControls ? 100 : 400;\n\t\t\tclearInterval( YTPlayer.getState );\n\t\t\t//Checking if player has been removed from scene\n\t\t\tif( !jQuery.contains( document, YTPlayer ) ) {\n\t\t\t\tjQuery( YTPlayer ).YTPPlayerDestroy();\n\t\t\t\tclearInterval( YTPlayer.getState );\n\t\t\t\tclearInterval( YTPlayer.checkForStartAt );\n\t\t\t\treturn;\n\t\t\t}\n\n\t\t\tjQuery.mbYTPlayer.checkForStart( YTPlayer );\n\n\t\t\tYTPlayer.getState = setInterval( function() {\n\t\t\t\tvar prog = jQuery( YTPlayer ).YTPManageProgress();\n\t\t\t\tvar $YTPlayer = jQuery( YTPlayer );\n\t\t\t\tvar data = YTPlayer.opt;\n\t\t\t\tvar startAt = YTPlayer.opt.startAt ? YTPlayer.opt.startAt : 1;\n\t\t\t\tvar stopAt = YTPlayer.opt.stopAt > YTPlayer.opt.startAt ? YTPlayer.opt.stopAt : 0;\n\t\t\t\tstopAt = stopAt < YTPlayer.player.getDuration() ? stopAt : 0;\n\t\t\t\tif( YTPlayer.player.time != prog.currentTime ) {\n\t\t\t\t\tvar YTPEvent = jQuery.Event( \"YTPTime\" );\n\t\t\t\t\tYTPEvent.time = YTPlayer.player.time;\n\t\t\t\t\tjQuery( YTPlayer ).trigger( YTPEvent );\n\t\t\t\t}\n\t\t\t\tYTPlayer.player.time = prog.currentTime;\n\t\t\t\tif( YTPlayer.player.getVolume() == 0 ) $YTPlayer.addClass( \"isMuted\" );\n\t\t\t\telse $YTPlayer.removeClass( \"isMuted\" );\n\n\t\t\t\tif( YTPlayer.opt.showControls )\n\t\t\t\t\tif( prog.totalTime ) {\n\t\t\t\t\t\tYTPlayer.controlBar.find( \".mb_YTPTime\" ).html( jQuery.mbYTPlayer.formatTime( prog.currentTime ) + \" / \" + jQuery.mbYTPlayer.formatTime( prog.totalTime ) );\n\t\t\t\t\t} else {\n\t\t\t\t\t\tYTPlayer.controlBar.find( \".mb_YTPTime\" ).html( \"-- : -- / -- : --\" );\n\t\t\t\t\t}\n\n\n\t\t\t\tif( eval( YTPlayer.opt.stopMovieOnBlur ) )\n\t\t\t\t\tif( !document.hasFocus() ) {\n\t\t\t\t\t\tif( YTPlayer.state == 1 ) {\n\t\t\t\t\t\t\tYTPlayer.hasFocus = false;\n\t\t\t\t\t\t\t$YTPlayer.YTPPause();\n\t\t\t\t\t\t}\n\t\t\t\t\t} else if( document.hasFocus() && !YTPlayer.hasFocus && !( YTPlayer.state == -1 || YTPlayer.state == 0 ) ) {\n\n\t\t\t\t\tYTPlayer.hasFocus = true;\n\t\t\t\t\t$YTPlayer.YTPPlay();\n\t\t\t\t}\n\n\t\t\t\tif( YTPlayer.controlBar && YTPlayer.controlBar.outerWidth() <= 400 && !YTPlayer.isCompact ) {\n\t\t\t\t\tYTPlayer.controlBar.addClass( \"compact\" );\n\t\t\t\t\tYTPlayer.isCompact = true;\n\t\t\t\t\tif( !YTPlayer.isMute && YTPlayer.volumeBar ) YTPlayer.volumeBar.updateSliderVal( YTPlayer.opt.vol );\n\t\t\t\t} else if( YTPlayer.controlBar && YTPlayer.controlBar.outerWidth() > 400 && YTPlayer.isCompact ) {\n\t\t\t\t\tYTPlayer.controlBar.removeClass( \"compact\" );\n\t\t\t\t\tYTPlayer.isCompact = false;\n\t\t\t\t\tif( !YTPlayer.isMute && YTPlayer.volumeBar ) YTPlayer.volumeBar.updateSliderVal( YTPlayer.opt.vol );\n\t\t\t\t}\n\t\t\t\tif( YTPlayer.player.getPlayerState() == 1 && ( parseFloat( YTPlayer.player.getDuration() - 1.5 ) < YTPlayer.player.getCurrentTime() || ( stopAt > 0 && parseFloat( YTPlayer.player.getCurrentTime() ) > stopAt ) ) ) {\n\t\t\t\t\tif( YTPlayer.isEnded ) return;\n\t\t\t\t\tYTPlayer.isEnded = true;\n\t\t\t\t\tsetTimeout( function() {\n\t\t\t\t\t\tYTPlayer.isEnded = false\n\t\t\t\t\t}, 1000 );\n\n\t\t\t\t\tif( YTPlayer.isPlayList ) {\n\n\t\t\t\t\t\tif( !data.loop || ( data.loop > 0 && YTPlayer.player.loopTime === data.loop - 1 ) ) {\n\n\t\t\t\t\t\t\tYTPlayer.player.loopTime = undefined;\n\t\t\t\t\t\t\tclearInterval( YTPlayer.getState );\n\t\t\t\t\t\t\tvar YTPEnd = jQuery.Event( \"YTPEnd\" );\n\t\t\t\t\t\t\tYTPEnd.time = YTPlayer.player.time;\n\t\t\t\t\t\t\tjQuery( YTPlayer ).trigger( YTPEnd );\n\t\t\t\t\t\t\tYTPlayer.state = 0;\n\n\t\t\t\t\t\t\treturn;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t} else if( !data.loop || ( data.loop > 0 && YTPlayer.player.loopTime === data.loop - 1 ) ) {\n\n\t\t\t\t\t\tYTPlayer.player.loopTime = undefined;\n\t\t\t\t\t\tYTPlayer.preventTrigger = true;\n\t\t\t\t\t\tjQuery( YTPlayer ).YTPPause();\n\t\t\t\t\t\tYTPlayer.state = 0;\n\n\t\t\t\t\t\tYTPlayer.wrapper.CSSAnimate( {\n\t\t\t\t\t\t\topacity: 0\n\t\t\t\t\t\t}, 500, function() {\n\n\t\t\t\t\t\t\tif( YTPlayer.controlBar )\n\t\t\t\t\t\t\t\tYTPlayer.controlBar.find( \".mb_YTPPlaypause\" ).html( jQuery.mbYTPlayer.controls.play );\n\n\t\t\t\t\t\t\tvar YTPEnd = jQuery.Event( \"YTPEnd\" );\n\t\t\t\t\t\t\tYTPEnd.time = YTPlayer.player.time;\n\t\t\t\t\t\t\tjQuery( YTPlayer ).trigger( YTPEnd );\n\n\t\t\t\t\t\t\tYTPlayer.player.seekTo( startAt, true );\n\t\t\t\t\t\t\tif( !YTPlayer.isBackground ) {\n\t\t\t\t\t\t\t\tYTPlayer.opt.containment.css( {\n\t\t\t\t\t\t\t\t\tbackground: \"rgba(0,0,0,0.5) url(\" + YTPlayer.opt.backgroundUrl + \") center center\",\n\t\t\t\t\t\t\t\t\tbackgroundSize: \"cover\"\n\t\t\t\t\t\t\t\t} );\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t} );\n\n\t\t\t\t\t\treturn;\n\n\t\t\t\t\t}\n\n\t\t\t\t\tYTPlayer.player.loopTime = YTPlayer.player.loopTime ? ++YTPlayer.player.loopTime : 1;\n\t\t\t\t\tstartAt = startAt || 1;\n\t\t\t\t\tYTPlayer.preventTrigger = true;\n\t\t\t\t\tjQuery( YTPlayer ).YTPPause();\n\t\t\t\t\tYTPlayer.player.seekTo( startAt, true );\n\t\t\t\t\t$YTPlayer.YTPPlay();\n\n\n\t\t\t\t}\n\t\t\t}, interval );\n\t\t},\n\t\t/**\n\t\t *\n\t\t * */\n\t\tcheckForStart: function( YTPlayer ) {\n\t\t\tvar $YTPlayer = jQuery( YTPlayer );\n\n\t\t\t//Checking if player has been removed from scene\n\t\t\tif( !jQuery.contains( document, YTPlayer ) ) {\n\t\t\t\tjQuery( YTPlayer ).YTPPlayerDestroy();\n\t\t\t\treturn\n\t\t\t}\n\n\t\t\t/*\n\t\t\t if( jQuery.browser.chrome )\n\t\t\t YTPlayer.opt.quality = \"default\";\n\t\t\t */\n\n\t\t\tYTPlayer.preventTrigger = true;\n\t\t\tjQuery( YTPlayer ).YTPPause();\n\n\t\t\tjQuery( YTPlayer ).muteYTPVolume();\n\t\t\tjQuery( \"#controlBar_\" + YTPlayer.id ).remove();\n\n\t\t\tif( YTPlayer.opt.showControls )\n\t\t\t\tjQuery.mbYTPlayer.buildControls( YTPlayer );\n\n\t\t\tif( YTPlayer.opt.addRaster ) {\n\n\t\t\t\tvar classN = YTPlayer.opt.addRaster == \"dot\" ? \"raster-dot\" : \"raster\";\n\t\t\t\tYTPlayer.overlay.addClass( YTPlayer.isRetina ? classN + \" retina\" : classN );\n\n\t\t\t} else {\n\n\t\t\t\tYTPlayer.overlay.removeClass( function( index, classNames ) {\n\t\t\t\t\t// change the list into an array\n\t\t\t\t\tvar current_classes = classNames.split( \" \" ),\n\t\t\t\t\t\t// array of classes which are to be removed\n\t\t\t\t\t\tclasses_to_remove = [];\n\t\t\t\t\tjQuery.each( current_classes, function( index, class_name ) {\n\t\t\t\t\t\t// if the classname begins with bg add it to the classes_to_remove array\n\t\t\t\t\t\tif( /raster.*/.test( class_name ) ) {\n\t\t\t\t\t\t\tclasses_to_remove.push( class_name );\n\t\t\t\t\t\t}\n\t\t\t\t\t} );\n\t\t\t\t\tclasses_to_remove.push( \"retina\" );\n\t\t\t\t\t// turn the array back into a string\n\t\t\t\t\treturn classes_to_remove.join( \" \" );\n\t\t\t\t} )\n\n\t\t\t}\n\n\t\t\t//console.time( \"checkforStart\" );\n\n\t\t\tvar startAt = YTPlayer.opt.startAt ? YTPlayer.opt.startAt : 1;\n\t\t\tYTPlayer.player.playVideo();\n\t\t\tYTPlayer.player.seekTo( startAt, true );\n\n\t\t\tYTPlayer.checkForStartAt = setInterval( function() {\n\n\t\t\t\tjQuery( YTPlayer ).YTPMute();\n\n\t\t\t\tvar canPlayVideo = YTPlayer.player.getVideoLoadedFraction() >= startAt / YTPlayer.player.getDuration();\n\n\t\t\t\t//console.debug( YTPlayer.player.getCurrentTime(), startAt, YTPlayer.player.getVideoLoadedFraction() );\n\n\t\t\t\tif( YTPlayer.player.getDuration() > 0 && YTPlayer.player.getCurrentTime() >= startAt && canPlayVideo ) {\n\n\t\t\t\t\t//YTPlayer.player.playVideo();\n\n\t\t\t\t\t//console.timeEnd( \"checkforStart\" );\n\n\t\t\t\t\t//\tconsole.debug( \"checkForStartAt:: checked ::  \", YTPlayer );\n\n\t\t\t\t\tclearInterval( YTPlayer.checkForStartAt );\n\n\t\t\t\t\tYTPlayer.isReady = true;\n\t\t\t\t\tif( typeof YTPlayer.opt.onReady == \"function\" )\n\t\t\t\t\t\tYTPlayer.opt.onReady( YTPlayer );\n\n\t\t\t\t\tvar YTPready = jQuery.Event( \"YTPReady\" );\n\t\t\t\t\tYTPready.time = YTPlayer.player.time;\n\t\t\t\t\tjQuery( YTPlayer ).trigger( YTPready );\n\n\n\t\t\t\t\tYTPlayer.preventTrigger = true;\n\t\t\t\t\tjQuery( YTPlayer ).YTPPause();\n\n\t\t\t\t\tif( !YTPlayer.opt.mute ) jQuery( YTPlayer ).YTPUnmute();\n\t\t\t\t\tYTPlayer.canTrigger = true;\n\t\t\t\t\tif( YTPlayer.opt.autoPlay ) {\n\t\t\t\t\t\t$YTPlayer.YTPPlay();\n\n\t\t\t\t\t\tvar YTPStart = jQuery.Event( \"YTPStart\" );\n\t\t\t\t\t\tYTPStart.time = YTPlayer.player.time;\n\t\t\t\t\t\tjQuery( YTPlayer ).trigger( YTPStart );\n\n\t\t\t\t\t\t$YTPlayer.css( \"background-image\", \"none\" );\n\t\t\t\t\t\tjQuery( YTPlayer.playerEl ).CSSAnimate( {\n\t\t\t\t\t\t\topacity: 1\n\t\t\t\t\t\t}, 1000 );\n\t\t\t\t\t\tYTPlayer.wrapper.CSSAnimate( {\n\t\t\t\t\t\t\topacity: YTPlayer.isAlone ? 1 : YTPlayer.opt.opacity\n\t\t\t\t\t\t}, 1000 );\n\t\t\t\t\t} else {\n\n\t\t\t\t\t\t$YTPlayer.YTPPause();\n\t\t\t\t\t\t//YTPlayer.player.pauseVideo();\n\t\t\t\t\t\tif( !YTPlayer.isPlayer ) {\n\t\t\t\t\t\t\tjQuery( YTPlayer.playerEl ).CSSAnimate( {\n\t\t\t\t\t\t\t\topacity: 1\n\t\t\t\t\t\t\t}, 500 );\n\n\t\t\t\t\t\t\tYTPlayer.wrapper.CSSAnimate( {\n\t\t\t\t\t\t\t\topacity: YTPlayer.isAlone ? 1 : YTPlayer.opt.opacity\n\t\t\t\t\t\t\t}, 500 );\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\tif( YTPlayer.isPlayer && !YTPlayer.opt.autoPlay ) {\n\t\t\t\t\t\tYTPlayer.loading.html( \"Ready\" );\n\t\t\t\t\t\tsetTimeout( function() {\n\t\t\t\t\t\t\tYTPlayer.loading.fadeOut();\n\t\t\t\t\t\t}, 100 )\n\t\t\t\t\t}\n\t\t\t\t\tif( YTPlayer.controlBar ) YTPlayer.controlBar.slideDown( 1000 );\n\n\t\t\t\t} else if( jQuery.browser.safari ) {\n\t\t\t\t\t//YTPlayer.player.playVideo();\n\t\t\t\t\t//if( startAt >= 0 ) YTPlayer.player.seekTo( startAt, true );\n\t\t\t\t}\n\n\t\t\t}, 1 );\n\n\n\t\t},\n\t\t/**\n\t\t *\n\t\t * @param s\n\t\t * @returns {string}\n\t\t */\n\t\tformatTime: function( s ) {\n\t\t\tvar min = Math.floor( s / 60 );\n\t\t\tvar sec = Math.floor( s - ( 60 * min ) );\n\t\t\treturn( min <= 9 ? \"0\" + min : min ) + \" : \" + ( sec <= 9 ? \"0\" + sec : sec );\n\t\t}\n\t};\n\t/**\n\t *\n\t * @returns {boolean}\n\t */\n\tjQuery.fn.toggleVolume = function() {\n\t\tvar YTPlayer = this.get( 0 );\n\t\tif( !YTPlayer ) return;\n\t\tif( YTPlayer.player.isMuted() ) {\n\t\t\tjQuery( YTPlayer ).YTPUnmute();\n\t\t\treturn true;\n\t\t} else {\n\t\t\tjQuery( YTPlayer ).YTPMute();\n\t\t\treturn false;\n\t\t}\n\t};\n\t/**\n\t *\n\t */\n\tjQuery.fn.optimizeDisplay = function() {\n\t\tvar YTPlayer = this.get( 0 );\n\t\tvar data = YTPlayer.opt;\n\t\tvar playerBox = jQuery( YTPlayer.playerEl );\n\t\tvar win = {};\n\t\tvar el = YTPlayer.wrapper;\n\t\twin.width = el.outerWidth();\n\t\twin.height = el.outerHeight();\n\t\tvar margin = 24;\n\t\tvar overprint = 100;\n\t\tvar vid = {};\n\t\tif( data.optimizeDisplay ) {\n\t\t\tvid.width = win.width + ( ( win.width * margin ) / 100 );\n\t\t\tvid.height = data.ratio == \"16/9\" ? Math.ceil( ( 9 * win.width ) / 16 ) : Math.ceil( ( 3 * win.width ) / 4 );\n\t\t\tvid.marginTop = -( ( vid.height - win.height ) / 2 );\n\t\t\tvid.marginLeft = -( ( win.width * ( margin / 2 ) ) / 100 );\n\t\t\tif( vid.height < win.height ) {\n\t\t\t\tvid.height = win.height + ( ( win.height * margin ) / 100 );\n\t\t\t\tvid.width = data.ratio == \"16/9\" ? Math.floor( ( 16 * win.height ) / 9 ) : Math.floor( ( 4 * win.height ) / 3 );\n\t\t\t\tvid.marginTop = -( ( win.height * ( margin / 2 ) ) / 100 );\n\t\t\t\tvid.marginLeft = -( ( vid.width - win.width ) / 2 );\n\t\t\t}\n\t\t\tvid.width += overprint;\n\t\t\tvid.height += overprint;\n\t\t\tvid.marginTop -= overprint / 2;\n\t\t\tvid.marginLeft -= overprint / 2;\n\t\t} else {\n\t\t\tvid.width = \"100%\";\n\t\t\tvid.height = \"100%\";\n\t\t\tvid.marginTop = 0;\n\t\t\tvid.marginLeft = 0;\n\t\t}\n\t\tplayerBox.css( {\n\t\t\twidth: vid.width,\n\t\t\theight: vid.height,\n\t\t\tmarginTop: vid.marginTop,\n\t\t\tmarginLeft: vid.marginLeft\n\t\t} );\n\t};\n\t/**\n\t *\n\t * @param arr\n\t * @returns {Array|string|Blob|*}\n\t *\n\t */\n\tjQuery.shuffle = function( arr ) {\n\t\tvar newArray = arr.slice();\n\t\tvar len = newArray.length;\n\t\tvar i = len;\n\t\twhile( i-- ) {\n\t\t\tvar p = parseInt( Math.random() * len );\n\t\t\tvar t = newArray[ i ];\n\t\t\tnewArray[ i ] = newArray[ p ];\n\t\t\tnewArray[ p ] = t;\n\t\t}\n\t\treturn newArray;\n\t};\n\n\tjQuery.fn.unselectable = function() {\n\t\treturn this.each( function() {\n\t\t\tjQuery( this ).css( {\n\t\t\t\t\"-moz-user-select\": \"none\",\n\t\t\t\t\"-webkit-user-select\": \"none\",\n\t\t\t\t\"user-select\": \"none\"\n\t\t\t} ).attr( \"unselectable\", \"on\" );\n\t\t} );\n\t};\n\n\n\t/* Exposed public method */\n\tjQuery.fn.YTPlayer = jQuery.mbYTPlayer.buildPlayer;\n\tjQuery.fn.YTPGetPlayer = jQuery.mbYTPlayer.getPlayer;\n\tjQuery.fn.YTPGetVideoID = jQuery.mbYTPlayer.getVideoID;\n\tjQuery.fn.YTPChangeMovie = jQuery.mbYTPlayer.changeMovie;\n\tjQuery.fn.YTPPlayerDestroy = jQuery.mbYTPlayer.playerDestroy;\n\n\tjQuery.fn.YTPPlay = jQuery.mbYTPlayer.play;\n\tjQuery.fn.YTPTogglePlay = jQuery.mbYTPlayer.togglePlay;\n\tjQuery.fn.YTPStop = jQuery.mbYTPlayer.stop;\n\tjQuery.fn.YTPPause = jQuery.mbYTPlayer.pause;\n\tjQuery.fn.YTPSeekTo = jQuery.mbYTPlayer.seekTo;\n\n\tjQuery.fn.YTPlaylist = jQuery.mbYTPlayer.playlist;\n\tjQuery.fn.YTPPlayNext = jQuery.mbYTPlayer.playNext;\n\tjQuery.fn.YTPPlayPrev = jQuery.mbYTPlayer.playPrev;\n\n\tjQuery.fn.YTPMute = jQuery.mbYTPlayer.mute;\n\tjQuery.fn.YTPUnmute = jQuery.mbYTPlayer.unmute;\n\tjQuery.fn.YTPToggleVolume = jQuery.mbYTPlayer.toggleVolume;\n\tjQuery.fn.YTPSetVolume = jQuery.mbYTPlayer.setVolume;\n\n\tjQuery.fn.YTPGetVideoData = jQuery.mbYTPlayer.getVideoData;\n\tjQuery.fn.YTPFullscreen = jQuery.mbYTPlayer.fullscreen;\n\tjQuery.fn.YTPToggleLoops = jQuery.mbYTPlayer.toggleLoops;\n\tjQuery.fn.YTPSetVideoQuality = jQuery.mbYTPlayer.setVideoQuality;\n\tjQuery.fn.YTPManageProgress = jQuery.mbYTPlayer.manageProgress;\n\n\tjQuery.fn.YTPApplyFilter = jQuery.mbYTPlayer.applyFilter;\n\tjQuery.fn.YTPApplyFilters = jQuery.mbYTPlayer.applyFilters;\n\tjQuery.fn.YTPToggleFilter = jQuery.mbYTPlayer.toggleFilter;\n\tjQuery.fn.YTPToggleFilters = jQuery.mbYTPlayer.toggleFilters;\n\tjQuery.fn.YTPRemoveFilter = jQuery.mbYTPlayer.removeFilter;\n\tjQuery.fn.YTPDisableFilters = jQuery.mbYTPlayer.disableFilters;\n\tjQuery.fn.YTPEnableFilters = jQuery.mbYTPlayer.enableFilters;\n\n\n\t/**\n\t *\n\t * @deprecated\n\t *\n\t **/\n\tjQuery.fn.mb_YTPlayer = jQuery.mbYTPlayer.buildPlayer;\n\tjQuery.fn.playNext = jQuery.mbYTPlayer.playNext;\n\tjQuery.fn.playPrev = jQuery.mbYTPlayer.playPrev;\n\tjQuery.fn.changeMovie = jQuery.mbYTPlayer.changeMovie;\n\tjQuery.fn.getVideoID = jQuery.mbYTPlayer.getVideoID;\n\tjQuery.fn.getPlayer = jQuery.mbYTPlayer.getPlayer;\n\tjQuery.fn.playerDestroy = jQuery.mbYTPlayer.playerDestroy;\n\tjQuery.fn.fullscreen = jQuery.mbYTPlayer.fullscreen;\n\tjQuery.fn.buildYTPControls = jQuery.mbYTPlayer.buildControls;\n\tjQuery.fn.playYTP = jQuery.mbYTPlayer.play;\n\tjQuery.fn.toggleLoops = jQuery.mbYTPlayer.toggleLoops;\n\tjQuery.fn.stopYTP = jQuery.mbYTPlayer.stop;\n\tjQuery.fn.pauseYTP = jQuery.mbYTPlayer.pause;\n\tjQuery.fn.seekToYTP = jQuery.mbYTPlayer.seekTo;\n\tjQuery.fn.muteYTPVolume = jQuery.mbYTPlayer.mute;\n\tjQuery.fn.unmuteYTPVolume = jQuery.mbYTPlayer.unmute;\n\tjQuery.fn.setYTPVolume = jQuery.mbYTPlayer.setVolume;\n\tjQuery.fn.setVideoQuality = jQuery.mbYTPlayer.setVideoQuality;\n\tjQuery.fn.manageYTPProgress = jQuery.mbYTPlayer.manageProgress;\n\tjQuery.fn.YTPGetDataFromFeed = jQuery.mbYTPlayer.getVideoData;\n\n\n} )( jQuery, ytp );\n;\n/*\n * ******************************************************************************\n *  jquery.mb.components\n *  file: jquery.mb.CSSAnimate.min.js\n *\n *  Copyright (c) 2001-2014. Matteo Bicocchi (Pupunzi);\n *  Open lab srl, Firenze - Italy\n *  email: matteo@open-lab.com\n *  site: \thttp://pupunzi.com\n *  blog:\thttp://pupunzi.open-lab.com\n * \thttp://open-lab.com\n *\n *  Licences: MIT, GPL\n *  http://www.opensource.org/licenses/mit-license.php\n *  http://www.gnu.org/licenses/gpl.html\n *\n *  last modified: 26/03/14 21.40\n *  *****************************************************************************\n */\n\nfunction uncamel(a){return a.replace(/([A-Z])/g,function(a){return\"-\"+a.toLowerCase()})}function setUnit(a,b){return\"string\"!=typeof a||a.match(/^[\\-0-9\\.]+jQuery/)?\"\"+a+b:a}function setFilter(a,b,c){var d=uncamel(b),e=jQuery.browser.mozilla?\"\":jQuery.CSS.sfx;a[e+\"filter\"]=a[e+\"filter\"]||\"\",c=setUnit(c>jQuery.CSS.filters[b].max?jQuery.CSS.filters[b].max:c,jQuery.CSS.filters[b].unit),a[e+\"filter\"]+=d+\"(\"+c+\") \",delete a[b]}jQuery.support.CSStransition=function(){var a=document.body||document.documentElement,b=a.style;return void 0!==b.transition||void 0!==b.WebkitTransition||void 0!==b.MozTransition||void 0!==b.MsTransition||void 0!==b.OTransition}(),jQuery.CSS={name:\"mb.CSSAnimate\",author:\"Matteo Bicocchi\",version:\"2.0.0\",transitionEnd:\"transitionEnd\",sfx:\"\",filters:{blur:{min:0,max:100,unit:\"px\"},brightness:{min:0,max:400,unit:\"%\"},contrast:{min:0,max:400,unit:\"%\"},grayscale:{min:0,max:100,unit:\"%\"},hueRotate:{min:0,max:360,unit:\"deg\"},invert:{min:0,max:100,unit:\"%\"},saturate:{min:0,max:400,unit:\"%\"},sepia:{min:0,max:100,unit:\"%\"}},normalizeCss:function(a){var b=jQuery.extend(!0,{},a);jQuery.browser.webkit||jQuery.browser.opera?jQuery.CSS.sfx=\"-webkit-\":jQuery.browser.mozilla?jQuery.CSS.sfx=\"-moz-\":jQuery.browser.msie&&(jQuery.CSS.sfx=\"-ms-\");for(var c in b){\"transform\"===c&&(b[jQuery.CSS.sfx+\"transform\"]=b[c],delete b[c]),\"transform-origin\"===c&&(b[jQuery.CSS.sfx+\"transform-origin\"]=a[c],delete b[c]),\"filter\"!==c||jQuery.browser.mozilla||(b[jQuery.CSS.sfx+\"filter\"]=a[c],delete b[c]),\"blur\"===c&&setFilter(b,\"blur\",a[c]),\"brightness\"===c&&setFilter(b,\"brightness\",a[c]),\"contrast\"===c&&setFilter(b,\"contrast\",a[c]),\"grayscale\"===c&&setFilter(b,\"grayscale\",a[c]),\"hueRotate\"===c&&setFilter(b,\"hueRotate\",a[c]),\"invert\"===c&&setFilter(b,\"invert\",a[c]),\"saturate\"===c&&setFilter(b,\"saturate\",a[c]),\"sepia\"===c&&setFilter(b,\"sepia\",a[c]);var d=\"\";\"x\"===c&&(d=jQuery.CSS.sfx+\"transform\",b[d]=b[d]||\"\",b[d]+=\" translateX(\"+setUnit(a[c],\"px\")+\")\",delete b[c]),\"y\"===c&&(d=jQuery.CSS.sfx+\"transform\",b[d]=b[d]||\"\",b[d]+=\" translateY(\"+setUnit(a[c],\"px\")+\")\",delete b[c]),\"z\"===c&&(d=jQuery.CSS.sfx+\"transform\",b[d]=b[d]||\"\",b[d]+=\" translateZ(\"+setUnit(a[c],\"px\")+\")\",delete b[c]),\"rotate\"===c&&(d=jQuery.CSS.sfx+\"transform\",b[d]=b[d]||\"\",b[d]+=\" rotate(\"+setUnit(a[c],\"deg\")+\")\",delete b[c]),\"rotateX\"===c&&(d=jQuery.CSS.sfx+\"transform\",b[d]=b[d]||\"\",b[d]+=\" rotateX(\"+setUnit(a[c],\"deg\")+\")\",delete b[c]),\"rotateY\"===c&&(d=jQuery.CSS.sfx+\"transform\",b[d]=b[d]||\"\",b[d]+=\" rotateY(\"+setUnit(a[c],\"deg\")+\")\",delete b[c]),\"rotateZ\"===c&&(d=jQuery.CSS.sfx+\"transform\",b[d]=b[d]||\"\",b[d]+=\" rotateZ(\"+setUnit(a[c],\"deg\")+\")\",delete b[c]),\"scale\"===c&&(d=jQuery.CSS.sfx+\"transform\",b[d]=b[d]||\"\",b[d]+=\" scale(\"+setUnit(a[c],\"\")+\")\",delete b[c]),\"scaleX\"===c&&(d=jQuery.CSS.sfx+\"transform\",b[d]=b[d]||\"\",b[d]+=\" scaleX(\"+setUnit(a[c],\"\")+\")\",delete b[c]),\"scaleY\"===c&&(d=jQuery.CSS.sfx+\"transform\",b[d]=b[d]||\"\",b[d]+=\" scaleY(\"+setUnit(a[c],\"\")+\")\",delete b[c]),\"scaleZ\"===c&&(d=jQuery.CSS.sfx+\"transform\",b[d]=b[d]||\"\",b[d]+=\" scaleZ(\"+setUnit(a[c],\"\")+\")\",delete b[c]),\"skew\"===c&&(d=jQuery.CSS.sfx+\"transform\",b[d]=b[d]||\"\",b[d]+=\" skew(\"+setUnit(a[c],\"deg\")+\")\",delete b[c]),\"skewX\"===c&&(d=jQuery.CSS.sfx+\"transform\",b[d]=b[d]||\"\",b[d]+=\" skewX(\"+setUnit(a[c],\"deg\")+\")\",delete b[c]),\"skewY\"===c&&(d=jQuery.CSS.sfx+\"transform\",b[d]=b[d]||\"\",b[d]+=\" skewY(\"+setUnit(a[c],\"deg\")+\")\",delete b[c]),\"perspective\"===c&&(d=jQuery.CSS.sfx+\"transform\",b[d]=b[d]||\"\",b[d]+=\" perspective(\"+setUnit(a[c],\"px\")+\")\",delete b[c])}return b},getProp:function(a){var b=[];for(var c in a)b.indexOf(c)<0&&b.push(uncamel(c));return b.join(\",\")},animate:function(a,b,c,d,e){return this.each(function(){function o(){f.called=!0,f.CSSAIsRunning=!1,g.off(jQuery.CSS.transitionEnd+\".\"+f.id),clearTimeout(f.timeout),g.css(jQuery.CSS.sfx+\"transition\",\"\"),\"function\"==typeof e&&e.apply(f),\"function\"==typeof f.CSSqueue&&(f.CSSqueue(),f.CSSqueue=null)}var f=this,g=jQuery(this);f.id=f.id||\"CSSA_\"+(new Date).getTime();var h=h||{type:\"noEvent\"};if(f.CSSAIsRunning&&f.eventType==h.type&&!jQuery.browser.msie&&jQuery.browser.version<=9)return f.CSSqueue=function(){g.CSSAnimate(a,b,c,d,e)},void 0;if(f.CSSqueue=null,f.eventType=h.type,0!==g.length&&a){if(a=jQuery.normalizeCss(a),f.CSSAIsRunning=!0,\"function\"==typeof b&&(e=b,b=jQuery.fx.speeds._default),\"function\"==typeof c&&(d=c,c=0),\"string\"==typeof c&&(e=c,c=0),\"function\"==typeof d&&(e=d,d=\"cubic-bezier(0.65,0.03,0.36,0.72)\"),\"string\"==typeof b)for(var i in jQuery.fx.speeds){if(b==i){b=jQuery.fx.speeds[i];break}b=jQuery.fx.speeds._default}if(b||(b=jQuery.fx.speeds._default),\"string\"==typeof e&&(d=e,e=null),!jQuery.support.CSStransition){for(var j in a){if(\"transform\"===j&&delete a[j],\"filter\"===j&&delete a[j],\"transform-origin\"===j&&delete a[j],\"auto\"===a[j]&&delete a[j],\"x\"===j){var k=a[j],l=\"left\";a[l]=k,delete a[j]}if(\"y\"===j){var k=a[j],l=\"top\";a[l]=k,delete a[j]}(\"-ms-transform\"===j||\"-ms-filter\"===j)&&delete a[j]}return g.delay(c).animate(a,b,e),void 0}var m={\"default\":\"ease\",\"in\":\"ease-in\",out:\"ease-out\",\"in-out\":\"ease-in-out\",snap:\"cubic-bezier(0,1,.5,1)\",easeOutCubic:\"cubic-bezier(.215,.61,.355,1)\",easeInOutCubic:\"cubic-bezier(.645,.045,.355,1)\",easeInCirc:\"cubic-bezier(.6,.04,.98,.335)\",easeOutCirc:\"cubic-bezier(.075,.82,.165,1)\",easeInOutCirc:\"cubic-bezier(.785,.135,.15,.86)\",easeInExpo:\"cubic-bezier(.95,.05,.795,.035)\",easeOutExpo:\"cubic-bezier(.19,1,.22,1)\",easeInOutExpo:\"cubic-bezier(1,0,0,1)\",easeInQuad:\"cubic-bezier(.55,.085,.68,.53)\",easeOutQuad:\"cubic-bezier(.25,.46,.45,.94)\",easeInOutQuad:\"cubic-bezier(.455,.03,.515,.955)\",easeInQuart:\"cubic-bezier(.895,.03,.685,.22)\",easeOutQuart:\"cubic-bezier(.165,.84,.44,1)\",easeInOutQuart:\"cubic-bezier(.77,0,.175,1)\",easeInQuint:\"cubic-bezier(.755,.05,.855,.06)\",easeOutQuint:\"cubic-bezier(.23,1,.32,1)\",easeInOutQuint:\"cubic-bezier(.86,0,.07,1)\",easeInSine:\"cubic-bezier(.47,0,.745,.715)\",easeOutSine:\"cubic-bezier(.39,.575,.565,1)\",easeInOutSine:\"cubic-bezier(.445,.05,.55,.95)\",easeInBack:\"cubic-bezier(.6,-.28,.735,.045)\",easeOutBack:\"cubic-bezier(.175, .885,.32,1.275)\",easeInOutBack:\"cubic-bezier(.68,-.55,.265,1.55)\"};m[d]&&(d=m[d]),g.off(jQuery.CSS.transitionEnd+\".\"+f.id);var n=jQuery.CSS.getProp(a),p={};jQuery.extend(p,a),p[jQuery.CSS.sfx+\"transition-property\"]=n,p[jQuery.CSS.sfx+\"transition-duration\"]=b+\"ms\",p[jQuery.CSS.sfx+\"transition-delay\"]=c+\"ms\",p[jQuery.CSS.sfx+\"transition-timing-function\"]=d,setTimeout(function(){g.one(jQuery.CSS.transitionEnd+\".\"+f.id,o),g.css(p)},1),f.timeout=setTimeout(function(){return f.called||!e?(f.called=!1,f.CSSAIsRunning=!1,void 0):(g.css(jQuery.CSS.sfx+\"transition\",\"\"),e.apply(f),f.CSSAIsRunning=!1,\"function\"==typeof f.CSSqueue&&(f.CSSqueue(),f.CSSqueue=null),void 0)},b+c+10)}})}},jQuery.fn.CSSAnimate=jQuery.CSS.animate,jQuery.normalizeCss=jQuery.CSS.normalizeCss,jQuery.fn.css3=function(a){return this.each(function(){var b=jQuery(this),c=jQuery.normalizeCss(a);b.css(c)})};\n;/*\n * ******************************************************************************\n *  jquery.mb.components\n *  file: jquery.mb.browser.min.js\n *\n *  Copyright (c) 2001-2014. Matteo Bicocchi (Pupunzi);\n *  Open lab srl, Firenze - Italy\n *  email: matteo@open-lab.com\n *  site: \thttp://pupunzi.com\n *  blog:\thttp://pupunzi.open-lab.com\n * \thttp://open-lab.com\n *\n *  Licences: MIT, GPL\n *  http://www.opensource.org/licenses/mit-license.php\n *  http://www.gnu.org/licenses/gpl.html\n *\n *  last modified: 26/03/14 21.43\n *  *****************************************************************************\n */\n\nvar nAgt=navigator.userAgent;if(!jQuery.browser){jQuery.browser={},jQuery.browser.mozilla=!1,jQuery.browser.webkit=!1,jQuery.browser.opera=!1,jQuery.browser.safari=!1,jQuery.browser.chrome=!1,jQuery.browser.msie=!1,jQuery.browser.ua=nAgt,jQuery.browser.name=navigator.appName,jQuery.browser.fullVersion=\"\"+parseFloat(navigator.appVersion),jQuery.browser.majorVersion=parseInt(navigator.appVersion,10);var nameOffset,verOffset,ix;if(-1!=(verOffset=nAgt.indexOf(\"Opera\")))jQuery.browser.opera=!0,jQuery.browser.name=\"Opera\",jQuery.browser.fullVersion=nAgt.substring(verOffset+6),-1!=(verOffset=nAgt.indexOf(\"Version\"))&&(jQuery.browser.fullVersion=nAgt.substring(verOffset+8));else if(-1!=(verOffset=nAgt.indexOf(\"OPR\")))jQuery.browser.opera=!0,jQuery.browser.name=\"Opera\",jQuery.browser.fullVersion=nAgt.substring(verOffset+4);else if(-1!=(verOffset=nAgt.indexOf(\"MSIE\")))jQuery.browser.msie=!0,jQuery.browser.name=\"Microsoft Internet Explorer\",jQuery.browser.fullVersion=nAgt.substring(verOffset+5);else if(-1!=nAgt.indexOf(\"Trident\")){jQuery.browser.msie=!0,jQuery.browser.name=\"Microsoft Internet Explorer\";var start=nAgt.indexOf(\"rv:\")+3,end=start+4;jQuery.browser.fullVersion=nAgt.substring(start,end)}else-1!=(verOffset=nAgt.indexOf(\"Chrome\"))?(jQuery.browser.webkit=!0,jQuery.browser.chrome=!0,jQuery.browser.name=\"Chrome\",jQuery.browser.fullVersion=nAgt.substring(verOffset+7)):-1!=(verOffset=nAgt.indexOf(\"Safari\"))?(jQuery.browser.webkit=!0,jQuery.browser.safari=!0,jQuery.browser.name=\"Safari\",jQuery.browser.fullVersion=nAgt.substring(verOffset+7),-1!=(verOffset=nAgt.indexOf(\"Version\"))&&(jQuery.browser.fullVersion=nAgt.substring(verOffset+8))):-1!=(verOffset=nAgt.indexOf(\"AppleWebkit\"))?(jQuery.browser.webkit=!0,jQuery.browser.name=\"Safari\",jQuery.browser.fullVersion=nAgt.substring(verOffset+7),-1!=(verOffset=nAgt.indexOf(\"Version\"))&&(jQuery.browser.fullVersion=nAgt.substring(verOffset+8))):-1!=(verOffset=nAgt.indexOf(\"Firefox\"))?(jQuery.browser.mozilla=!0,jQuery.browser.name=\"Firefox\",jQuery.browser.fullVersion=nAgt.substring(verOffset+8)):(nameOffset=nAgt.lastIndexOf(\" \")+1)<(verOffset=nAgt.lastIndexOf(\"/\"))&&(jQuery.browser.name=nAgt.substring(nameOffset,verOffset),jQuery.browser.fullVersion=nAgt.substring(verOffset+1),jQuery.browser.name.toLowerCase()==jQuery.browser.name.toUpperCase()&&(jQuery.browser.name=navigator.appName));-1!=(ix=jQuery.browser.fullVersion.indexOf(\";\"))&&(jQuery.browser.fullVersion=jQuery.browser.fullVersion.substring(0,ix)),-1!=(ix=jQuery.browser.fullVersion.indexOf(\" \"))&&(jQuery.browser.fullVersion=jQuery.browser.fullVersion.substring(0,ix)),jQuery.browser.majorVersion=parseInt(\"\"+jQuery.browser.fullVersion,10),isNaN(jQuery.browser.majorVersion)&&(jQuery.browser.fullVersion=\"\"+parseFloat(navigator.appVersion),jQuery.browser.majorVersion=parseInt(navigator.appVersion,10)),jQuery.browser.version=jQuery.browser.majorVersion}jQuery.browser.android=/Android/i.test(nAgt),jQuery.browser.blackberry=/BlackBerry|BB|PlayBook/i.test(nAgt),jQuery.browser.ios=/iPhone|iPad|iPod|webOS/i.test(nAgt),jQuery.browser.operaMobile=/Opera Mini/i.test(nAgt),jQuery.browser.windowsMobile=/IEMobile|Windows Phone/i.test(nAgt),jQuery.browser.kindle=/Kindle|Silk/i.test(nAgt),jQuery.browser.mobile=jQuery.browser.android||jQuery.browser.blackberry||jQuery.browser.ios||jQuery.browser.windowsMobile||jQuery.browser.operaMobile||jQuery.browser.kindle,jQuery.isMobile=jQuery.browser.mobile,jQuery.isTablet=jQuery.browser.mobile&&jQuery(window).width()>765,jQuery.isAndroidDefault=jQuery.browser.android&&!/chrome/i.test(nAgt);\n;/*___________________________________________________________________________________________________________________________________________________\n _ jquery.mb.components                                                                                                                             _\n _                                                                                                                                                  _\n _ file: jquery.mb.simpleSlider.min.js                                                                                                              _\n _ last modified: 16/05/15 23.45                                                                                                                    _\n _                                                                                                                                                  _\n _ Open Lab s.r.l., Florence - Italy                                                                                                                _\n _                                                                                                                                                  _\n _ email: matteo@open-lab.com                                                                                                                       _\n _ site: http://pupunzi.com                                                                                                                         _\n _       http://open-lab.com                                                                                                                        _\n _ blog: http://pupunzi.open-lab.com                                                                                                                _\n _ Q&A:  http://jquery.pupunzi.com                                                                                                                  _\n _                                                                                                                                                  _\n _ Licences: MIT, GPL                                                                                                                               _\n _    http://www.opensource.org/licenses/mit-license.php                                                                                            _\n _    http://www.gnu.org/licenses/gpl.html                                                                                                          _\n _                                                                                                                                                  _\n _ Copyright (c) 2001-2015. Matteo Bicocchi (Pupunzi);                                                                                              _\n ___________________________________________________________________________________________________________________________________________________*/\n\n!function(a){/iphone|ipod|ipad|android|ie|blackberry|fennec/.test(navigator.userAgent.toLowerCase());var c=\"ontouchstart\"in window||window.navigator&&window.navigator.msPointerEnabled&&window.MSGesture||window.DocumentTouch&&document instanceof DocumentTouch||!1;a.simpleSlider={defaults:{initialval:0,scale:100,orientation:\"h\",readonly:!1,callback:!1},events:{start:c?\"touchstart\":\"mousedown\",end:c?\"touchend\":\"mouseup\",move:c?\"touchmove\":\"mousemove\"},init:function(b){return this.each(function(){var d=this,e=a(d);e.addClass(\"simpleSlider\"),d.opt={},a.extend(d.opt,a.simpleSlider.defaults,b),a.extend(d.opt,e.data());var f=\"h\"==d.opt.orientation?\"horizontal\":\"vertical\",g=a(\"<div/>\").addClass(\"level\").addClass(f);e.prepend(g),d.level=g,e.css({cursor:\"default\"}),\"auto\"==d.opt.scale&&(d.opt.scale=a(d).outerWidth()),e.updateSliderVal(),d.opt.readonly||(e.on(a.simpleSlider.events.start,function(a){c&&(a=a.changedTouches[0]),d.canSlide=!0,e.updateSliderVal(a),e.css({cursor:\"col-resize\"}),a.preventDefault(),a.stopPropagation()}),a(document).on(a.simpleSlider.events.move,function(b){c&&(b=b.changedTouches[0]),d.canSlide&&(a(document).css({cursor:\"default\"}),e.updateSliderVal(b),b.preventDefault(),b.stopPropagation())}).on(a.simpleSlider.events.end,function(){a(document).css({cursor:\"auto\"}),d.canSlide=!1,e.css({cursor:\"auto\"})}))})},updateSliderVal:function(b){function g(a,b){return Math.floor(100*a/b)}var c=this,d=c.get(0);d.opt.initialval=\"number\"==typeof d.opt.initialval?d.opt.initialval:d.opt.initialval(d);var e=a(d).outerWidth(),f=a(d).outerHeight();d.x=\"object\"==typeof b?b.clientX+document.body.scrollLeft-c.offset().left:\"number\"==typeof b?b*e/d.opt.scale:d.opt.initialval*e/d.opt.scale,d.y=\"object\"==typeof b?b.clientY+document.body.scrollTop-c.offset().top:\"number\"==typeof b?(d.opt.scale-d.opt.initialval-b)*f/d.opt.scale:d.opt.initialval*f/d.opt.scale,d.y=c.outerHeight()-d.y,d.scaleX=d.x*d.opt.scale/e,d.scaleY=d.y*d.opt.scale/f,d.outOfRangeX=d.scaleX>d.opt.scale?d.scaleX-d.opt.scale:d.scaleX<0?d.scaleX:0,d.outOfRangeY=d.scaleY>d.opt.scale?d.scaleY-d.opt.scale:d.scaleY<0?d.scaleY:0,d.outOfRange=\"h\"==d.opt.orientation?d.outOfRangeX:d.outOfRangeY,d.value=\"undefined\"!=typeof b?\"h\"==d.opt.orientation?d.x>=c.outerWidth()?d.opt.scale:d.x<=0?0:d.scaleX:d.y>=c.outerHeight()?d.opt.scale:d.y<=0?0:d.scaleY:\"h\"==d.opt.orientation?d.scaleX:d.scaleY,\"h\"==d.opt.orientation?d.level.width(g(d.x,e)+\"%\"):d.level.height(g(d.y,f)),\"function\"==typeof d.opt.callback&&d.opt.callback(d)}},a.fn.simpleSlider=a.simpleSlider.init,a.fn.updateSliderVal=a.simpleSlider.updateSliderVal}(jQuery);\n;/*___________________________________________________________________________________________________________________________________________________\n _ jquery.mb.components                                                                                                                             _\n _                                                                                                                                                  _\n _ file: jquery.mb.storage.min.js                                                                                                                   _\n _ last modified: 24/05/15 16.08                                                                                                                    _\n _                                                                                                                                                  _\n _ Open Lab s.r.l., Florence - Italy                                                                                                                _\n _                                                                                                                                                  _\n _ email: matteo@open-lab.com                                                                                                                       _\n _ site: http://pupunzi.com                                                                                                                         _\n _       http://open-lab.com                                                                                                                        _\n _ blog: http://pupunzi.open-lab.com                                                                                                                _\n _ Q&A:  http://jquery.pupunzi.com                                                                                                                  _\n _                                                                                                                                                  _\n _ Licences: MIT, GPL                                                                                                                               _\n _    http://www.opensource.org/licenses/mit-license.php                                                                                            _\n _    http://www.gnu.org/licenses/gpl.html                                                                                                          _\n _                                                                                                                                                  _\n _ Copyright (c) 2001-2015. Matteo Bicocchi (Pupunzi);                                                                                              _\n ___________________________________________________________________________________________________________________________________________________*/\n\n!function(a){a.mbCookie={set:function(a,b,c,d){b=JSON.stringify(b),c||(c=7),d=d?\"; domain=\"+d:\"\";var f,e=new Date;e.setTime(e.getTime()+1e3*60*60*24*c),f=\"; expires=\"+e.toGMTString(),document.cookie=a+\"=\"+b+f+\"; path=/\"+d},get:function(a){for(var b=a+\"=\",c=document.cookie.split(\";\"),d=0;d<c.length;d++){for(var e=c[d];\" \"==e.charAt(0);)e=e.substring(1,e.length);if(0==e.indexOf(b))return JSON.parse(e.substring(b.length,e.length))}return null},remove:function(b){a.mbCookie.set(b,\"\",-1)}},a.mbStorage={set:function(a,b){b=JSON.stringify(b),localStorage.setItem(a,b)},get:function(a){return localStorage[a]?JSON.parse(localStorage[a]):null},remove:function(a){a?localStorage.removeItem(a):localStorage.clear()}}}(jQuery);\n"

/***/ },
/* 13 */
/*!******************************************************************!*\
  !*** ./~/script-loader!./pixo/assets/flexibility/flexibility.js ***!
  \******************************************************************/
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(/*! !./~/script-loader/addScript.js */ 11)(__webpack_require__(/*! !./~/raw-loader!./pixo/assets/flexibility/flexibility.js */ 14)+"\n\n// SCRIPT-LOADER FOOTER\n//# sourceURL=script:///Users/admin/dev/pixo_dev/pixo/assets/flexibility/flexibility.js")

/***/ },
/* 14 */
/*!***************************************************************!*\
  !*** ./~/raw-loader!./pixo/assets/flexibility/flexibility.js ***!
  \***************************************************************/
/***/ function(module, exports) {

	module.exports = "!function(){window.flexibility={},Array.prototype.forEach||(Array.prototype.forEach=function(t){if(void 0===this||null===this)throw new TypeError(this+\"is not an object\");if(!(t instanceof Function))throw new TypeError(t+\" is not a function\");for(var e=Object(this),i=arguments[1],n=e instanceof String?e.split(\"\"):e,r=Math.max(Math.min(n.length,9007199254740991),0)||0,o=-1;++o<r;)o in n&&t.call(i,n[o],o,e)}),function(t,e){\"function\"==typeof define&&define.amd?define([],e):\"object\"==typeof exports?module.exports=e():t.computeLayout=e()}(flexibility,function(){var t=function(){function t(e){if((!e.layout||e.isDirty)&&(e.layout={width:void 0,height:void 0,top:0,left:0,right:0,bottom:0}),e.style||(e.style={}),e.children||(e.children=[]),e.style.measure&&e.children&&e.children.length)throw new Error(\"Using custom measure function is supported only for leaf nodes.\");return e.children.forEach(t),e}function e(t){return void 0===t}function i(t){return t===q||t===G}function n(t){return t===U||t===Z}function r(t,e){if(void 0!==t.style.marginStart&&i(e))return t.style.marginStart;var n=null;switch(e){case\"row\":n=t.style.marginLeft;break;case\"row-reverse\":n=t.style.marginRight;break;case\"column\":n=t.style.marginTop;break;case\"column-reverse\":n=t.style.marginBottom}return void 0!==n?n:void 0!==t.style.margin?t.style.margin:0}function o(t,e){if(void 0!==t.style.marginEnd&&i(e))return t.style.marginEnd;var n=null;switch(e){case\"row\":n=t.style.marginRight;break;case\"row-reverse\":n=t.style.marginLeft;break;case\"column\":n=t.style.marginBottom;break;case\"column-reverse\":n=t.style.marginTop}return null!=n?n:void 0!==t.style.margin?t.style.margin:0}function l(t,e){if(void 0!==t.style.paddingStart&&t.style.paddingStart>=0&&i(e))return t.style.paddingStart;var n=null;switch(e){case\"row\":n=t.style.paddingLeft;break;case\"row-reverse\":n=t.style.paddingRight;break;case\"column\":n=t.style.paddingTop;break;case\"column-reverse\":n=t.style.paddingBottom}return null!=n&&n>=0?n:void 0!==t.style.padding&&t.style.padding>=0?t.style.padding:0}function a(t,e){if(void 0!==t.style.paddingEnd&&t.style.paddingEnd>=0&&i(e))return t.style.paddingEnd;var n=null;switch(e){case\"row\":n=t.style.paddingRight;break;case\"row-reverse\":n=t.style.paddingLeft;break;case\"column\":n=t.style.paddingBottom;break;case\"column-reverse\":n=t.style.paddingTop}return null!=n&&n>=0?n:void 0!==t.style.padding&&t.style.padding>=0?t.style.padding:0}function d(t,e){if(void 0!==t.style.borderStartWidth&&t.style.borderStartWidth>=0&&i(e))return t.style.borderStartWidth;var n=null;switch(e){case\"row\":n=t.style.borderLeftWidth;break;case\"row-reverse\":n=t.style.borderRightWidth;break;case\"column\":n=t.style.borderTopWidth;break;case\"column-reverse\":n=t.style.borderBottomWidth}return null!=n&&n>=0?n:void 0!==t.style.borderWidth&&t.style.borderWidth>=0?t.style.borderWidth:0}function s(t,e){if(void 0!==t.style.borderEndWidth&&t.style.borderEndWidth>=0&&i(e))return t.style.borderEndWidth;var n=null;switch(e){case\"row\":n=t.style.borderRightWidth;break;case\"row-reverse\":n=t.style.borderLeftWidth;break;case\"column\":n=t.style.borderBottomWidth;break;case\"column-reverse\":n=t.style.borderTopWidth}return null!=n&&n>=0?n:void 0!==t.style.borderWidth&&t.style.borderWidth>=0?t.style.borderWidth:0}function u(t,e){return l(t,e)+d(t,e)}function y(t,e){return a(t,e)+s(t,e)}function c(t,e){return d(t,e)+s(t,e)}function f(t,e){return r(t,e)+o(t,e)}function h(t,e){return u(t,e)+y(t,e)}function m(t){return t.style.justifyContent?t.style.justifyContent:\"flex-start\"}function v(t){return t.style.alignContent?t.style.alignContent:\"flex-start\"}function p(t,e){return e.style.alignSelf?e.style.alignSelf:t.style.alignItems?t.style.alignItems:\"stretch\"}function x(t,e){if(e===N){if(t===q)return G;if(t===G)return q}return t}function g(t,e){var i;return i=t.style.direction?t.style.direction:M,i===M&&(i=void 0===e?A:e),i}function b(t){return t.style.flexDirection?t.style.flexDirection:U}function w(t,e){return n(t)?x(q,e):U}function W(t){return t.style.position?t.style.position:\"relative\"}function L(t){return W(t)===tt&&t.style.flex>0}function E(t){return\"wrap\"===t.style.flexWrap}function S(t,e){return t.layout[ot[e]]+f(t,e)}function k(t,e){return void 0!==t.style[ot[e]]&&t.style[ot[e]]>=0}function C(t,e){return void 0!==t.style[e]}function T(t){return void 0!==t.style.measure}function $(t,e){return void 0!==t.style[e]?t.style[e]:0}function H(t,e,i){var n={row:t.style.minWidth,\"row-reverse\":t.style.minWidth,column:t.style.minHeight,\"column-reverse\":t.style.minHeight}[e],r={row:t.style.maxWidth,\"row-reverse\":t.style.maxWidth,column:t.style.maxHeight,\"column-reverse\":t.style.maxHeight}[e],o=i;return void 0!==r&&r>=0&&o>r&&(o=r),void 0!==n&&n>=0&&n>o&&(o=n),o}function z(t,e){return t>e?t:e}function B(t,e){void 0===t.layout[ot[e]]&&k(t,e)&&(t.layout[ot[e]]=z(H(t,e,t.style[ot[e]]),h(t,e)))}function D(t,e,i){e.layout[nt[i]]=t.layout[ot[i]]-e.layout[ot[i]]-e.layout[rt[i]]}function I(t,e){return void 0!==t.style[it[e]]?$(t,it[e]):-$(t,nt[e])}function R(t,n,l,a){var s=g(t,a),R=x(b(t),s),M=w(R,s),A=x(q,s);B(t,R),B(t,M),t.layout.direction=s,t.layout[it[R]]+=r(t,R)+I(t,R),t.layout[nt[R]]+=o(t,R)+I(t,R),t.layout[it[M]]+=r(t,M)+I(t,M),t.layout[nt[M]]+=o(t,M)+I(t,M);var N=t.children.length,lt=h(t,A),at=h(t,U);if(T(t)){var dt=!e(t.layout[ot[A]]),st=F;st=k(t,A)?t.style.width:dt?t.layout[ot[A]]:n-f(t,A),st-=lt;var ut=F;ut=k(t,U)?t.style.height:e(t.layout[ot[U]])?l-f(t,A):t.layout[ot[U]],ut-=h(t,U);var yt=!k(t,A)&&!dt,ct=!k(t,U)&&e(t.layout[ot[U]]);if(yt||ct){var ft=t.style.measure(st,ut);yt&&(t.layout.width=ft.width+lt),ct&&(t.layout.height=ft.height+at)}if(0===N)return}var ht,mt,vt,pt,xt=E(t),gt=m(t),bt=u(t,R),wt=u(t,M),Wt=h(t,R),Lt=h(t,M),Et=!e(t.layout[ot[R]]),St=!e(t.layout[ot[M]]),kt=i(R),Ct=null,Tt=null,$t=F;Et&&($t=t.layout[ot[R]]-Wt);for(var Ht=0,zt=0,Bt=0,Dt=0,It=0,Rt=0;N>zt;){var jt,Ft,Mt=0,At=0,Nt=0,qt=0,Gt=Et&&gt===O||!Et&&gt!==_,Ut=Gt?N:Ht,Zt=!0,Ot=N,_t=null,Jt=null,Kt=bt,Pt=0;for(ht=Ht;N>ht;++ht){vt=t.children[ht],vt.lineIndex=Rt,vt.nextAbsoluteChild=null,vt.nextFlexChild=null;var Qt=p(t,vt);if(Qt===Y&&W(vt)===tt&&St&&!k(vt,M))vt.layout[ot[M]]=z(H(vt,M,t.layout[ot[M]]-Lt-f(vt,M)),h(vt,M));else if(W(vt)===et)for(null===Ct&&(Ct=vt),null!==Tt&&(Tt.nextAbsoluteChild=vt),Tt=vt,mt=0;2>mt;mt++)pt=0!==mt?q:U,!e(t.layout[ot[pt]])&&!k(vt,pt)&&C(vt,it[pt])&&C(vt,nt[pt])&&(vt.layout[ot[pt]]=z(H(vt,pt,t.layout[ot[pt]]-h(t,pt)-f(vt,pt)-$(vt,it[pt])-$(vt,nt[pt])),h(vt,pt)));var Vt=0;if(Et&&L(vt)?(At++,Nt+=vt.style.flex,null===_t&&(_t=vt),null!==Jt&&(Jt.nextFlexChild=vt),Jt=vt,Vt=h(vt,R)+f(vt,R)):(jt=F,Ft=F,kt?Ft=k(t,U)?t.layout[ot[U]]-at:l-f(t,U)-at:jt=k(t,A)?t.layout[ot[A]]-lt:n-f(t,A)-lt,0===Bt&&j(vt,jt,Ft,s),W(vt)===tt&&(qt++,Vt=S(vt,R))),xt&&Et&&Mt+Vt>$t&&ht!==Ht){qt--,Bt=1;break}Gt&&(W(vt)!==tt||L(vt))&&(Gt=!1,Ut=ht),Zt&&(W(vt)!==tt||Qt!==Y&&Qt!==Q||e(vt.layout[ot[M]]))&&(Zt=!1,Ot=ht),Gt&&(vt.layout[rt[R]]+=Kt,Et&&D(t,vt,R),Kt+=S(vt,R),Pt=z(Pt,H(vt,M,S(vt,M)))),Zt&&(vt.layout[rt[M]]+=Dt+wt,St&&D(t,vt,M)),Bt=0,Mt+=Vt,zt=ht+1}var Xt=0,Yt=0,te=0;if(te=Et?$t-Mt:z(Mt,0)-Mt,0!==At){var ee,ie,ne=te/Nt;for(Jt=_t;null!==Jt;)ee=ne*Jt.style.flex+h(Jt,R),ie=H(Jt,R,ee),ee!==ie&&(te-=ie,Nt-=Jt.style.flex),Jt=Jt.nextFlexChild;for(ne=te/Nt,0>ne&&(ne=0),Jt=_t;null!==Jt;)Jt.layout[ot[R]]=H(Jt,R,ne*Jt.style.flex+h(Jt,R)),jt=F,k(t,A)?jt=t.layout[ot[A]]-lt:kt||(jt=n-f(t,A)-lt),Ft=F,k(t,U)?Ft=t.layout[ot[U]]-at:kt&&(Ft=l-f(t,U)-at),j(Jt,jt,Ft,s),vt=Jt,Jt=Jt.nextFlexChild,vt.nextFlexChild=null}else gt!==O&&(gt===_?Xt=te/2:gt===J?Xt=te:gt===K?(te=z(te,0),Yt=At+qt-1!==0?te/(At+qt-1):0):gt===P&&(Yt=te/(At+qt),Xt=Yt/2));for(Kt+=Xt,ht=Ut;zt>ht;++ht)vt=t.children[ht],W(vt)===et&&C(vt,it[R])?vt.layout[rt[R]]=$(vt,it[R])+d(t,R)+r(vt,R):(vt.layout[rt[R]]+=Kt,Et&&D(t,vt,R),W(vt)===tt&&(Kt+=Yt+S(vt,R),Pt=z(Pt,H(vt,M,S(vt,M)))));var re=t.layout[ot[M]];for(St||(re=z(H(t,M,Pt+Lt),Lt)),ht=Ot;zt>ht;++ht)if(vt=t.children[ht],W(vt)===et&&C(vt,it[M]))vt.layout[rt[M]]=$(vt,it[M])+d(t,M)+r(vt,M);else{var oe=wt;if(W(vt)===tt){var Qt=p(t,vt);if(Qt===Y)e(vt.layout[ot[M]])&&(vt.layout[ot[M]]=z(H(vt,M,re-Lt-f(vt,M)),h(vt,M)));else if(Qt!==Q){var le=re-Lt-S(vt,M);oe+=Qt===V?le/2:le}}vt.layout[rt[M]]+=Dt+oe,St&&D(t,vt,M)}Dt+=Pt,It=z(It,Kt),Rt+=1,Ht=zt}if(Rt>1&&St){var ae=t.layout[ot[M]]-Lt,de=ae-Dt,se=0,ue=wt,ye=v(t);ye===X?ue+=de:ye===V?ue+=de/2:ye===Y&&ae>Dt&&(se=de/Rt);var ce=0;for(ht=0;Rt>ht;++ht){var fe=ce,he=0;for(mt=fe;N>mt;++mt)if(vt=t.children[mt],W(vt)===tt){if(vt.lineIndex!==ht)break;e(vt.layout[ot[M]])||(he=z(he,vt.layout[ot[M]]+f(vt,M)))}for(ce=mt,he+=se,mt=fe;ce>mt;++mt)if(vt=t.children[mt],W(vt)===tt){var me=p(t,vt);if(me===Q)vt.layout[rt[M]]=ue+r(vt,M);else if(me===X)vt.layout[rt[M]]=ue+he-o(vt,M)-vt.layout[ot[M]];else if(me===V){var ve=vt.layout[ot[M]];vt.layout[rt[M]]=ue+(he-ve)/2}else me===Y&&(vt.layout[rt[M]]=ue+r(vt,M))}ue+=he}}var pe=!1,xe=!1;if(Et||(t.layout[ot[R]]=z(H(t,R,It+y(t,R)),Wt),(R===G||R===Z)&&(pe=!0)),St||(t.layout[ot[M]]=z(H(t,M,Dt+Lt),Lt),(M===G||M===Z)&&(xe=!0)),pe||xe)for(ht=0;N>ht;++ht)vt=t.children[ht],pe&&D(t,vt,R),xe&&D(t,vt,M);for(Tt=Ct;null!==Tt;){for(mt=0;2>mt;mt++)pt=0!==mt?q:U,!e(t.layout[ot[pt]])&&!k(Tt,pt)&&C(Tt,it[pt])&&C(Tt,nt[pt])&&(Tt.layout[ot[pt]]=z(H(Tt,pt,t.layout[ot[pt]]-c(t,pt)-f(Tt,pt)-$(Tt,it[pt])-$(Tt,nt[pt])),h(Tt,pt))),C(Tt,nt[pt])&&!C(Tt,it[pt])&&(Tt.layout[it[pt]]=t.layout[ot[pt]]-Tt.layout[ot[pt]]-$(Tt,nt[pt]));vt=Tt,Tt=Tt.nextAbsoluteChild,vt.nextAbsoluteChild=null}}function j(t,e,i,n){t.shouldUpdate=!0;var r=t.style.direction||A,o=!t.isDirty&&t.lastLayout&&t.lastLayout.requestedHeight===t.layout.height&&t.lastLayout.requestedWidth===t.layout.width&&t.lastLayout.parentMaxWidth===e&&t.lastLayout.parentMaxHeight===i&&t.lastLayout.direction===r;o?(t.layout.width=t.lastLayout.width,t.layout.height=t.lastLayout.height,t.layout.top=t.lastLayout.top,t.layout.left=t.lastLayout.left):(t.lastLayout||(t.lastLayout={}),t.lastLayout.requestedWidth=t.layout.width,t.lastLayout.requestedHeight=t.layout.height,t.lastLayout.parentMaxWidth=e,t.lastLayout.parentMaxHeight=i,t.lastLayout.direction=r,t.children.forEach(function(t){t.layout.width=void 0,t.layout.height=void 0,t.layout.top=0,t.layout.left=0}),R(t,e,i,n),t.lastLayout.width=t.layout.width,t.lastLayout.height=t.layout.height,t.lastLayout.top=t.layout.top,t.lastLayout.left=t.layout.left)}var F,M=\"inherit\",A=\"ltr\",N=\"rtl\",q=\"row\",G=\"row-reverse\",U=\"column\",Z=\"column-reverse\",O=\"flex-start\",_=\"center\",J=\"flex-end\",K=\"space-between\",P=\"space-around\",Q=\"flex-start\",V=\"center\",X=\"flex-end\",Y=\"stretch\",tt=\"relative\",et=\"absolute\",it={row:\"left\",\"row-reverse\":\"right\",column:\"top\",\"column-reverse\":\"bottom\"},nt={row:\"right\",\"row-reverse\":\"left\",column:\"bottom\",\"column-reverse\":\"top\"},rt={row:\"left\",\"row-reverse\":\"right\",column:\"top\",\"column-reverse\":\"bottom\"},ot={row:\"width\",\"row-reverse\":\"width\",column:\"height\",\"column-reverse\":\"height\"};return{layoutNodeImpl:R,computeLayout:j,fillNodes:t}}();return\"object\"==typeof exports&&(module.exports=t),function(e){t.fillNodes(e),t.computeLayout(e)}}),!window.addEventListener&&window.attachEvent&&function(){Window.prototype.addEventListener=HTMLDocument.prototype.addEventListener=Element.prototype.addEventListener=function(t,e){this.attachEvent(\"on\"+t,e)},Window.prototype.removeEventListener=HTMLDocument.prototype.removeEventListener=Element.prototype.removeEventListener=function(t,e){this.detachEvent(\"on\"+t,e)}}(),flexibility.detect=function(){var t=document.createElement(\"p\");try{return t.style.display=\"flex\",\"flex\"===t.style.display}catch(e){return!1}},!flexibility.detect()&&document.attachEvent&&document.documentElement.currentStyle&&document.attachEvent(\"onreadystatechange\",function(){flexibility.onresize({target:document.documentElement})}),flexibility.init=function(t){var e=t.onlayoutcomplete;return e||(e=t.onlayoutcomplete={node:t,style:{},children:[]}),e.style.display=t.currentStyle[\"-js-display\"]||t.currentStyle.display,e};var t,e=1e3,i=15,n=document.documentElement,r=0,o=0;flexibility.onresize=function(l){if(n.clientWidth!==r||n.clientHeight!==o){r=n.clientWidth,o=n.clientHeight,clearTimeout(t),window.removeEventListener(\"resize\",flexibility.onresize);var a=l.target&&1===l.target.nodeType?l.target:document.documentElement;flexibility.walk(a),t=setTimeout(function(){window.addEventListener(\"resize\",flexibility.onresize)},e/i)}};var l={alignContent:{initial:\"stretch\",valid:/^(flex-start|flex-end|center|space-between|space-around|stretch)/},alignItems:{initial:\"stretch\",valid:/^(flex-start|flex-end|center|baseline|stretch)$/},boxSizing:{initial:\"content-box\",valid:/^(border-box|content-box)$/},flexDirection:{initial:\"row\",valid:/^(row|row-reverse|column|column-reverse)$/},flexWrap:{initial:\"nowrap\",valid:/^(nowrap|wrap|wrap-reverse)$/},justifyContent:{initial:\"flex-start\",valid:/^(flex-start|flex-end|center|space-between|space-around)$/}};flexibility.updateFlexContainerCache=function(t){var e=t.style,i=t.node.currentStyle,n=t.node.style,r={};(i[\"flex-flow\"]||n[\"flex-flow\"]||\"\").replace(/^(row|row-reverse|column|column-reverse)\\s+(nowrap|wrap|wrap-reverse)$/i,function(t,e,i){r.flexDirection=e,r.flexWrap=i});for(var o in l){var a=o.replace(/[A-Z]/g,\"-$&\").toLowerCase(),d=l[o],s=i[a]||n[a];e[o]=d.valid.test(s)?s:r[o]||d.initial}};var a={alignSelf:{initial:\"auto\",valid:/^(auto|flex-start|flex-end|center|baseline|stretch)$/},boxSizing:{initial:\"content-box\",valid:/^(border-box|content-box)$/},flexBasis:{initial:\"auto\",valid:/^((?:[-+]?0|[-+]?[0-9]*\\.?[0-9]+(?:%|ch|cm|em|ex|in|mm|pc|pt|px|rem|vh|vmax|vmin|vw))|auto|fill|max-content|min-content|fit-content|content)$/},flexGrow:{initial:0,valid:/^\\+?(0|[1-9][0-9]*)$/},flexShrink:{initial:0,valid:/^\\+?(0|[1-9][0-9]*)$/},order:{initial:0,valid:/^([-+]?[0-9]+)$/}};flexibility.updateFlexItemCache=function(t){var e=t.style,i=t.node.currentStyle,n=t.node.style,r={};(i.flex||n.flex||\"\").replace(/^\\+?(0|[1-9][0-9]*)/,function(t){r.flexGrow=t});for(var o in a){var l=o.replace(/[A-Z]/g,\"-$&\").toLowerCase(),d=a[o],s=i[l]||n[l];e[o]=d.valid.test(s)?s:r[o]||d.initial,\"number\"==typeof d.initial&&(e[o]=parseFloat(e[o]))}};var d=\"border:0 solid;clip:rect(0 0 0 0);display:inline-block;font:0/0 serif;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;overflow:hidden;padding:0;position:absolute;width:1em;\",s={medium:4,none:0,thick:6,thin:2},u={borderBottomWidth:0,borderLeftWidth:0,borderRightWidth:0,borderTopWidth:0,height:0,paddingBottom:0,paddingLeft:0,paddingRight:0,paddingTop:0,marginBottom:0,marginLeft:0,marginRight:0,marginTop:0,maxHeight:0,maxWidth:0,minHeight:0,minWidth:0,width:0},y=/^([-+]?0|[-+]?[0-9]*\\.?[0-9]+)/,c=100;flexibility.updateLengthCache=function(t){var e,i,n,r=t.node,o=t.style,l=r.parentNode,a=document.createElement(\"_\"),f=a.runtimeStyle,h=r.currentStyle;f.cssText=d+\"font-size:\"+h.fontSize,l.insertBefore(a,r.nextSibling),o.fontSize=a.offsetWidth,f.fontSize=o.fontSize+\"px\";for(var m in u){var v=h[m];y.test(v)||\"auto\"===v&&!/(width|height)/i.test(m)?/%$/.test(v)?(/^(bottom|height|top)$/.test(m)?(i||(i=l.offsetHeight),n=i):(e||(e=l.offsetWidth),n=e),o[m]=parseFloat(v)*n/c):(f.width=v,o[m]=a.offsetWidth):/^border/.test(m)&&v in s?o[m]=s[v]:delete o[m]}l.removeChild(a),\"none\"===h.borderTopStyle&&(o.borderTopWidth=0),\"none\"===h.borderRightStyle&&(o.borderRightWidth=0),\"none\"===h.borderBottomStyle&&(o.borderBottomWidth=0),\"none\"===h.borderLeftStyle&&(o.borderLeftWidth=0),o.width||o.minWidth||(/flex/.test(o.display)?o.width=r.offsetWidth:o.minWidth=r.offsetWidth),o.height||o.minHeight||/flex/.test(o.display)||(o.minHeight=r.offsetHeight)},flexibility.walk=function(t){var e=flexibility.init(t),i=e.style,n=i.display;if(\"none\"===n)return{};var r=n.match(/^(inline)?flex$/);if(r&&(flexibility.updateFlexContainerCache(e),t.runtimeStyle.cssText=\"display:\"+(r[1]?\"inline-block\":\"block\"),e.children=[]),Array.prototype.forEach.call(t.childNodes,function(t,n){if(1===t.nodeType){var o=flexibility.walk(t),l=o.style;o.index=n,r&&(flexibility.updateFlexItemCache(o),\"auto\"===l.alignSelf&&(l.alignSelf=i.alignItems),l.flex=l.flexGrow,t.runtimeStyle.cssText=\"display:inline-block\",e.children.push(o))}}),r){e.children.forEach(function(t){flexibility.updateLengthCache(t)}),e.children.sort(function(t,e){return t.style.order-e.style.order||t.index-e.index}),/-reverse$/.test(i.flexDirection)&&(e.children.reverse(),i.flexDirection=i.flexDirection.replace(/-reverse$/,\"\"),\"flex-start\"===i.justifyContent?i.justifyContent=\"flex-end\":\"flex-end\"===i.justifyContent&&(i.justifyContent=\"flex-start\")),flexibility.updateLengthCache(e),delete e.lastLayout,delete e.layout;var o=i.borderTopWidth,l=i.borderBottomWidth;i.borderTopWidth=0,i.borderBottomWidth=0,i.borderLeftWidth=0,\"column\"===i.flexDirection&&(i.width-=i.borderRightWidth),flexibility.computeLayout(e),t.runtimeStyle.cssText=\"box-sizing:border-box;display:block;position:relative;width:\"+(e.layout.width+i.borderRightWidth)+\"px;height:\"+(e.layout.height+o+l)+\"px\";var a=[],d=1,s=\"column\"===i.flexDirection?\"width\":\"height\";e.children.forEach(function(t){a[t.lineIndex]=Math.max(a[t.lineIndex]||0,t.layout[s]),d=Math.max(d,t.lineIndex+1)}),e.children.forEach(function(t){var e=t.layout;\"stretch\"===t.style.alignSelf&&(e[s]=a[t.lineIndex]),t.node.runtimeStyle.cssText=\"box-sizing:border-box;display:block;position:absolute;margin:0;width:\"+e.width+\"px;height:\"+e.height+\"px;top:\"+e.top+\"px;left:\"+e.left+\"px\"})}return e}}();"

/***/ },
/* 15 */
/*!*********************************!*\
  !*** isotope (bower component) ***!
  \*********************************/
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(/*! ./js/isotope.js */ 16);

/***/ },
/* 16 */
/*!*******************************************!*\
  !*** ./pixo/assets/isotope/js/isotope.js ***!
  \*******************************************/
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Isotope v2.2.2
	 *
	 * Licensed GPLv3 for open source use
	 * or Isotope Commercial License for commercial use
	 *
	 * http://isotope.metafizzy.co
	 * Copyright 2015 Metafizzy
	 */
	
	( function( window, factory ) {
	  'use strict';
	  // universal module definition
	
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(/*! outlayer/outlayer */ 23),
	        __webpack_require__(/*! get-size/get-size */ 17),
	        __webpack_require__(/*! matches-selector/matches-selector */ 19),
	        __webpack_require__(/*! fizzy-ui-utils/utils */ 20),
	        __webpack_require__(/*! ./item */ 31),
	        __webpack_require__(/*! ./layout-mode */ 26),
	        // include default layout modes
	        __webpack_require__(/*! ./layout-modes/masonry */ 27),
	        __webpack_require__(/*! ./layout-modes/fit-rows */ 29),
	        __webpack_require__(/*! ./layout-modes/vertical */ 30)
	      ], __WEBPACK_AMD_DEFINE_RESULT__ = function( Outlayer, getSize, matchesSelector, utils, Item, LayoutMode ) {
	        return factory( window, Outlayer, getSize, matchesSelector, utils, Item, LayoutMode );
	      }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof exports == 'object' ) {
	    // CommonJS
	    module.exports = factory(
	      window,
	      require('outlayer'),
	      require('get-size'),
	      require('desandro-matches-selector'),
	      require('fizzy-ui-utils'),
	      require('./item'),
	      require('./layout-mode'),
	      // include default layout modes
	      require('./layout-modes/masonry'),
	      require('./layout-modes/fit-rows'),
	      require('./layout-modes/vertical')
	    );
	  } else {
	    // browser global
	    window.Isotope = factory(
	      window,
	      window.Outlayer,
	      window.getSize,
	      window.matchesSelector,
	      window.fizzyUIUtils,
	      window.Isotope.Item,
	      window.Isotope.LayoutMode
	    );
	  }
	
	}( window, function factory( window, Outlayer, getSize, matchesSelector, utils,
	  Item, LayoutMode ) {
	
	'use strict';
	
	// -------------------------- vars -------------------------- //
	
	var jQuery = window.jQuery;
	
	// -------------------------- helpers -------------------------- //
	
	var trim = String.prototype.trim ?
	  function( str ) {
	    return str.trim();
	  } :
	  function( str ) {
	    return str.replace( /^\s+|\s+$/g, '' );
	  };
	
	var docElem = document.documentElement;
	
	var getText = docElem.textContent ?
	  function( elem ) {
	    return elem.textContent;
	  } :
	  function( elem ) {
	    return elem.innerText;
	  };
	
	// -------------------------- isotopeDefinition -------------------------- //
	
	  // create an Outlayer layout class
	  var Isotope = Outlayer.create( 'isotope', {
	    layoutMode: "masonry",
	    isJQueryFiltering: true,
	    sortAscending: true
	  });
	
	  Isotope.Item = Item;
	  Isotope.LayoutMode = LayoutMode;
	
	  Isotope.prototype._create = function() {
	    this.itemGUID = 0;
	    // functions that sort items
	    this._sorters = {};
	    this._getSorters();
	    // call super
	    Outlayer.prototype._create.call( this );
	
	    // create layout modes
	    this.modes = {};
	    // start filteredItems with all items
	    this.filteredItems = this.items;
	    // keep of track of sortBys
	    this.sortHistory = [ 'original-order' ];
	    // create from registered layout modes
	    for ( var name in LayoutMode.modes ) {
	      this._initLayoutMode( name );
	    }
	  };
	
	  Isotope.prototype.reloadItems = function() {
	    // reset item ID counter
	    this.itemGUID = 0;
	    // call super
	    Outlayer.prototype.reloadItems.call( this );
	  };
	
	  Isotope.prototype._itemize = function() {
	    var items = Outlayer.prototype._itemize.apply( this, arguments );
	    // assign ID for original-order
	    for ( var i=0, len = items.length; i < len; i++ ) {
	      var item = items[i];
	      item.id = this.itemGUID++;
	    }
	    this._updateItemsSortData( items );
	    return items;
	  };
	
	
	  // -------------------------- layout -------------------------- //
	
	  Isotope.prototype._initLayoutMode = function( name ) {
	    var Mode = LayoutMode.modes[ name ];
	    // set mode options
	    // HACK extend initial options, back-fill in default options
	    var initialOpts = this.options[ name ] || {};
	    this.options[ name ] = Mode.options ?
	      utils.extend( Mode.options, initialOpts ) : initialOpts;
	    // init layout mode instance
	    this.modes[ name ] = new Mode( this );
	  };
	
	
	  Isotope.prototype.layout = function() {
	    // if first time doing layout, do all magic
	    if ( !this._isLayoutInited && this.options.isInitLayout ) {
	      this.arrange();
	      return;
	    }
	    this._layout();
	  };
	
	  // private method to be used in layout() & magic()
	  Isotope.prototype._layout = function() {
	    // don't animate first layout
	    var isInstant = this._getIsInstant();
	    // layout flow
	    this._resetLayout();
	    this._manageStamps();
	    this.layoutItems( this.filteredItems, isInstant );
	
	    // flag for initalized
	    this._isLayoutInited = true;
	  };
	
	  // filter + sort + layout
	  Isotope.prototype.arrange = function( opts ) {
	    // set any options pass
	    this.option( opts );
	    this._getIsInstant();
	    // filter, sort, and layout
	
	    // filter
	    var filtered = this._filter( this.items );
	    this.filteredItems = filtered.matches;
	
	    var _this = this;
	    function hideReveal() {
	      _this.reveal( filtered.needReveal );
	      _this.hide( filtered.needHide );
	    }
	
	    this._bindArrangeComplete();
	
	    if ( this._isInstant ) {
	      this._noTransition( hideReveal );
	    } else {
	      hideReveal();
	    }
	
	    this._sort();
	    this._layout();
	  };
	  // alias to _init for main plugin method
	  Isotope.prototype._init = Isotope.prototype.arrange;
	
	  // HACK
	  // Don't animate/transition first layout
	  // Or don't animate/transition other layouts
	  Isotope.prototype._getIsInstant = function() {
	    var isInstant = this.options.isLayoutInstant !== undefined ?
	      this.options.isLayoutInstant : !this._isLayoutInited;
	    this._isInstant = isInstant;
	    return isInstant;
	  };
	
	  // listen for layoutComplete, hideComplete and revealComplete
	  // to trigger arrangeComplete
	  Isotope.prototype._bindArrangeComplete = function() {
	    // listen for 3 events to trigger arrangeComplete
	    var isLayoutComplete, isHideComplete, isRevealComplete;
	    var _this = this;
	    function arrangeParallelCallback() {
	      if ( isLayoutComplete && isHideComplete && isRevealComplete ) {
	        _this.dispatchEvent( 'arrangeComplete', null, [ _this.filteredItems ] );
	      }
	    }
	    this.once( 'layoutComplete', function() {
	      isLayoutComplete = true;
	      arrangeParallelCallback();
	    });
	    this.once( 'hideComplete', function() {
	      isHideComplete = true;
	      arrangeParallelCallback();
	    });
	    this.once( 'revealComplete', function() {
	      isRevealComplete = true;
	      arrangeParallelCallback();
	    });
	  };
	
	  // -------------------------- filter -------------------------- //
	
	  Isotope.prototype._filter = function( items ) {
	    var filter = this.options.filter;
	    filter = filter || '*';
	    var matches = [];
	    var hiddenMatched = [];
	    var visibleUnmatched = [];
	
	    var test = this._getFilterTest( filter );
	
	    // test each item
	    for ( var i=0, len = items.length; i < len; i++ ) {
	      var item = items[i];
	      if ( item.isIgnored ) {
	        continue;
	      }
	      // add item to either matched or unmatched group
	      var isMatched = test( item );
	      // item.isFilterMatched = isMatched;
	      // add to matches if its a match
	      if ( isMatched ) {
	        matches.push( item );
	      }
	      // add to additional group if item needs to be hidden or revealed
	      if ( isMatched && item.isHidden ) {
	        hiddenMatched.push( item );
	      } else if ( !isMatched && !item.isHidden ) {
	        visibleUnmatched.push( item );
	      }
	    }
	
	    // return collections of items to be manipulated
	    return {
	      matches: matches,
	      needReveal: hiddenMatched,
	      needHide: visibleUnmatched
	    };
	  };
	
	  // get a jQuery, function, or a matchesSelector test given the filter
	  Isotope.prototype._getFilterTest = function( filter ) {
	    if ( jQuery && this.options.isJQueryFiltering ) {
	      // use jQuery
	      return function( item ) {
	        return jQuery( item.element ).is( filter );
	      };
	    }
	    if ( typeof filter == 'function' ) {
	      // use filter as function
	      return function( item ) {
	        return filter( item.element );
	      };
	    }
	    // default, use filter as selector string
	    return function( item ) {
	      return matchesSelector( item.element, filter );
	    };
	  };
	
	  // -------------------------- sorting -------------------------- //
	
	  /**
	   * @params {Array} elems
	   * @public
	   */
	  Isotope.prototype.updateSortData = function( elems ) {
	    // get items
	    var items;
	    if ( elems ) {
	      elems = utils.makeArray( elems );
	      items = this.getItems( elems );
	    } else {
	      // update all items if no elems provided
	      items = this.items;
	    }
	
	    this._getSorters();
	    this._updateItemsSortData( items );
	  };
	
	  Isotope.prototype._getSorters = function() {
	    var getSortData = this.options.getSortData;
	    for ( var key in getSortData ) {
	      var sorter = getSortData[ key ];
	      this._sorters[ key ] = mungeSorter( sorter );
	    }
	  };
	
	  /**
	   * @params {Array} items - of Isotope.Items
	   * @private
	   */
	  Isotope.prototype._updateItemsSortData = function( items ) {
	    // do not update if no items
	    var len = items && items.length;
	
	    for ( var i=0; len && i < len; i++ ) {
	      var item = items[i];
	      item.updateSortData();
	    }
	  };
	
	  // ----- munge sorter ----- //
	
	  // encapsulate this, as we just need mungeSorter
	  // other functions in here are just for munging
	  var mungeSorter = ( function() {
	    // add a magic layer to sorters for convienent shorthands
	    // `.foo-bar` will use the text of .foo-bar querySelector
	    // `[foo-bar]` will use attribute
	    // you can also add parser
	    // `.foo-bar parseInt` will parse that as a number
	    function mungeSorter( sorter ) {
	      // if not a string, return function or whatever it is
	      if ( typeof sorter != 'string' ) {
	        return sorter;
	      }
	      // parse the sorter string
	      var args = trim( sorter ).split(' ');
	      var query = args[0];
	      // check if query looks like [an-attribute]
	      var attrMatch = query.match( /^\[(.+)\]$/ );
	      var attr = attrMatch && attrMatch[1];
	      var getValue = getValueGetter( attr, query );
	      // use second argument as a parser
	      var parser = Isotope.sortDataParsers[ args[1] ];
	      // parse the value, if there was a parser
	      sorter = parser ? function( elem ) {
	        return elem && parser( getValue( elem ) );
	      } :
	      // otherwise just return value
	      function( elem ) {
	        return elem && getValue( elem );
	      };
	
	      return sorter;
	    }
	
	    // get an attribute getter, or get text of the querySelector
	    function getValueGetter( attr, query ) {
	      var getValue;
	      // if query looks like [foo-bar], get attribute
	      if ( attr ) {
	        getValue = function( elem ) {
	          return elem.getAttribute( attr );
	        };
	      } else {
	        // otherwise, assume its a querySelector, and get its text
	        getValue = function( elem ) {
	          var child = elem.querySelector( query );
	          return child && getText( child );
	        };
	      }
	      return getValue;
	    }
	
	    return mungeSorter;
	  })();
	
	  // parsers used in getSortData shortcut strings
	  Isotope.sortDataParsers = {
	    'parseInt': function( val ) {
	      return parseInt( val, 10 );
	    },
	    'parseFloat': function( val ) {
	      return parseFloat( val );
	    }
	  };
	
	  // ----- sort method ----- //
	
	  // sort filteredItem order
	  Isotope.prototype._sort = function() {
	    var sortByOpt = this.options.sortBy;
	    if ( !sortByOpt ) {
	      return;
	    }
	    // concat all sortBy and sortHistory
	    var sortBys = [].concat.apply( sortByOpt, this.sortHistory );
	    // sort magic
	    var itemSorter = getItemSorter( sortBys, this.options.sortAscending );
	    this.filteredItems.sort( itemSorter );
	    // keep track of sortBy History
	    if ( sortByOpt != this.sortHistory[0] ) {
	      // add to front, oldest goes in last
	      this.sortHistory.unshift( sortByOpt );
	    }
	  };
	
	  // returns a function used for sorting
	  function getItemSorter( sortBys, sortAsc ) {
	    return function sorter( itemA, itemB ) {
	      // cycle through all sortKeys
	      for ( var i = 0, len = sortBys.length; i < len; i++ ) {
	        var sortBy = sortBys[i];
	        var a = itemA.sortData[ sortBy ];
	        var b = itemB.sortData[ sortBy ];
	        if ( a > b || a < b ) {
	          // if sortAsc is an object, use the value given the sortBy key
	          var isAscending = sortAsc[ sortBy ] !== undefined ? sortAsc[ sortBy ] : sortAsc;
	          var direction = isAscending ? 1 : -1;
	          return ( a > b ? 1 : -1 ) * direction;
	        }
	      }
	      return 0;
	    };
	  }
	
	  // -------------------------- methods -------------------------- //
	
	  // get layout mode
	  Isotope.prototype._mode = function() {
	    var layoutMode = this.options.layoutMode;
	    var mode = this.modes[ layoutMode ];
	    if ( !mode ) {
	      // TODO console.error
	      throw new Error( 'No layout mode: ' + layoutMode );
	    }
	    // HACK sync mode's options
	    // any options set after init for layout mode need to be synced
	    mode.options = this.options[ layoutMode ];
	    return mode;
	  };
	
	  Isotope.prototype._resetLayout = function() {
	    // trigger original reset layout
	    Outlayer.prototype._resetLayout.call( this );
	    this._mode()._resetLayout();
	  };
	
	  Isotope.prototype._getItemLayoutPosition = function( item  ) {
	    return this._mode()._getItemLayoutPosition( item );
	  };
	
	  Isotope.prototype._manageStamp = function( stamp ) {
	    this._mode()._manageStamp( stamp );
	  };
	
	  Isotope.prototype._getContainerSize = function() {
	    return this._mode()._getContainerSize();
	  };
	
	  Isotope.prototype.needsResizeLayout = function() {
	    return this._mode().needsResizeLayout();
	  };
	
	  // -------------------------- adding & removing -------------------------- //
	
	  // HEADS UP overwrites default Outlayer appended
	  Isotope.prototype.appended = function( elems ) {
	    var items = this.addItems( elems );
	    if ( !items.length ) {
	      return;
	    }
	    // filter, layout, reveal new items
	    var filteredItems = this._filterRevealAdded( items );
	    // add to filteredItems
	    this.filteredItems = this.filteredItems.concat( filteredItems );
	  };
	
	  // HEADS UP overwrites default Outlayer prepended
	  Isotope.prototype.prepended = function( elems ) {
	    var items = this._itemize( elems );
	    if ( !items.length ) {
	      return;
	    }
	    // start new layout
	    this._resetLayout();
	    this._manageStamps();
	    // filter, layout, reveal new items
	    var filteredItems = this._filterRevealAdded( items );
	    // layout previous items
	    this.layoutItems( this.filteredItems );
	    // add to items and filteredItems
	    this.filteredItems = filteredItems.concat( this.filteredItems );
	    this.items = items.concat( this.items );
	  };
	
	  Isotope.prototype._filterRevealAdded = function( items ) {
	    var filtered = this._filter( items );
	    this.hide( filtered.needHide );
	    // reveal all new items
	    this.reveal( filtered.matches );
	    // layout new items, no transition
	    this.layoutItems( filtered.matches, true );
	    return filtered.matches;
	  };
	
	  /**
	   * Filter, sort, and layout newly-appended item elements
	   * @param {Array or NodeList or Element} elems
	   */
	  Isotope.prototype.insert = function( elems ) {
	    var items = this.addItems( elems );
	    if ( !items.length ) {
	      return;
	    }
	    // append item elements
	    var i, item;
	    var len = items.length;
	    for ( i=0; i < len; i++ ) {
	      item = items[i];
	      this.element.appendChild( item.element );
	    }
	    // filter new stuff
	    var filteredInsertItems = this._filter( items ).matches;
	    // set flag
	    for ( i=0; i < len; i++ ) {
	      items[i].isLayoutInstant = true;
	    }
	    this.arrange();
	    // reset flag
	    for ( i=0; i < len; i++ ) {
	      delete items[i].isLayoutInstant;
	    }
	    this.reveal( filteredInsertItems );
	  };
	
	  var _remove = Isotope.prototype.remove;
	  Isotope.prototype.remove = function( elems ) {
	    elems = utils.makeArray( elems );
	    var removeItems = this.getItems( elems );
	    // do regular thing
	    _remove.call( this, elems );
	    // bail if no items to remove
	    var len = removeItems && removeItems.length;
	    if ( !len ) {
	      return;
	    }
	    // remove elems from filteredItems
	    for ( var i=0; i < len; i++ ) {
	      var item = removeItems[i];
	      // remove item from collection
	      utils.removeFrom( this.filteredItems, item );
	    }
	  };
	
	  Isotope.prototype.shuffle = function() {
	    // update random sortData
	    for ( var i=0, len = this.items.length; i < len; i++ ) {
	      var item = this.items[i];
	      item.sortData.random = Math.random();
	    }
	    this.options.sortBy = 'random';
	    this._sort();
	    this._layout();
	  };
	
	  /**
	   * trigger fn without transition
	   * kind of hacky to have this in the first place
	   * @param {Function} fn
	   * @returns ret
	   * @private
	   */
	  Isotope.prototype._noTransition = function( fn ) {
	    // save transitionDuration before disabling
	    var transitionDuration = this.options.transitionDuration;
	    // disable transition
	    this.options.transitionDuration = 0;
	    // do it
	    var returnValue = fn.call( this );
	    // re-enable transition for reveal
	    this.options.transitionDuration = transitionDuration;
	    return returnValue;
	  };
	
	  // ----- helper methods ----- //
	
	  /**
	   * getter method for getting filtered item elements
	   * @returns {Array} elems - collection of item elements
	   */
	  Isotope.prototype.getFilteredItemElements = function() {
	    var elems = [];
	    for ( var i=0, len = this.filteredItems.length; i < len; i++ ) {
	      elems.push( this.filteredItems[i].element );
	    }
	    return elems;
	  };
	
	  // -----  ----- //
	
	  return Isotope;
	
	}));


/***/ },
/* 17 */
/*!******************************************!*\
  !*** ./pixo/assets/get-size/get-size.js ***!
  \******************************************/
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * getSize v1.2.2
	 * measure size of elements
	 * MIT license
	 */
	
	/*jshint browser: true, strict: true, undef: true, unused: true */
	/*global define: false, exports: false, require: false, module: false, console: false */
	
	( function( window, undefined ) {
	
	'use strict';
	
	// -------------------------- helpers -------------------------- //
	
	// get a number from a string, not a percentage
	function getStyleSize( value ) {
	  var num = parseFloat( value );
	  // not a percent like '100%', and a number
	  var isValid = value.indexOf('%') === -1 && !isNaN( num );
	  return isValid && num;
	}
	
	function noop() {}
	
	var logError = typeof console === 'undefined' ? noop :
	  function( message ) {
	    console.error( message );
	  };
	
	// -------------------------- measurements -------------------------- //
	
	var measurements = [
	  'paddingLeft',
	  'paddingRight',
	  'paddingTop',
	  'paddingBottom',
	  'marginLeft',
	  'marginRight',
	  'marginTop',
	  'marginBottom',
	  'borderLeftWidth',
	  'borderRightWidth',
	  'borderTopWidth',
	  'borderBottomWidth'
	];
	
	function getZeroSize() {
	  var size = {
	    width: 0,
	    height: 0,
	    innerWidth: 0,
	    innerHeight: 0,
	    outerWidth: 0,
	    outerHeight: 0
	  };
	  for ( var i=0, len = measurements.length; i < len; i++ ) {
	    var measurement = measurements[i];
	    size[ measurement ] = 0;
	  }
	  return size;
	}
	
	
	
	function defineGetSize( getStyleProperty ) {
	
	// -------------------------- setup -------------------------- //
	
	var isSetup = false;
	
	var getStyle, boxSizingProp, isBoxSizeOuter;
	
	/**
	 * setup vars and functions
	 * do it on initial getSize(), rather than on script load
	 * For Firefox bug https://bugzilla.mozilla.org/show_bug.cgi?id=548397
	 */
	function setup() {
	  // setup once
	  if ( isSetup ) {
	    return;
	  }
	  isSetup = true;
	
	  var getComputedStyle = window.getComputedStyle;
	  getStyle = ( function() {
	    var getStyleFn = getComputedStyle ?
	      function( elem ) {
	        return getComputedStyle( elem, null );
	      } :
	      function( elem ) {
	        return elem.currentStyle;
	      };
	
	      return function getStyle( elem ) {
	        var style = getStyleFn( elem );
	        if ( !style ) {
	          logError( 'Style returned ' + style +
	            '. Are you running this code in a hidden iframe on Firefox? ' +
	            'See http://bit.ly/getsizebug1' );
	        }
	        return style;
	      };
	  })();
	
	  // -------------------------- box sizing -------------------------- //
	
	  boxSizingProp = getStyleProperty('boxSizing');
	
	  /**
	   * WebKit measures the outer-width on style.width on border-box elems
	   * IE & Firefox measures the inner-width
	   */
	  if ( boxSizingProp ) {
	    var div = document.createElement('div');
	    div.style.width = '200px';
	    div.style.padding = '1px 2px 3px 4px';
	    div.style.borderStyle = 'solid';
	    div.style.borderWidth = '1px 2px 3px 4px';
	    div.style[ boxSizingProp ] = 'border-box';
	
	    var body = document.body || document.documentElement;
	    body.appendChild( div );
	    var style = getStyle( div );
	
	    isBoxSizeOuter = getStyleSize( style.width ) === 200;
	    body.removeChild( div );
	  }
	
	}
	
	// -------------------------- getSize -------------------------- //
	
	function getSize( elem ) {
	  setup();
	
	  // use querySeletor if elem is string
	  if ( typeof elem === 'string' ) {
	    elem = document.querySelector( elem );
	  }
	
	  // do not proceed on non-objects
	  if ( !elem || typeof elem !== 'object' || !elem.nodeType ) {
	    return;
	  }
	
	  var style = getStyle( elem );
	
	  // if hidden, everything is 0
	  if ( style.display === 'none' ) {
	    return getZeroSize();
	  }
	
	  var size = {};
	  size.width = elem.offsetWidth;
	  size.height = elem.offsetHeight;
	
	  var isBorderBox = size.isBorderBox = !!( boxSizingProp &&
	    style[ boxSizingProp ] && style[ boxSizingProp ] === 'border-box' );
	
	  // get all measurements
	  for ( var i=0, len = measurements.length; i < len; i++ ) {
	    var measurement = measurements[i];
	    var value = style[ measurement ];
	    value = mungeNonPixel( elem, value );
	    var num = parseFloat( value );
	    // any 'auto', 'medium' value will be 0
	    size[ measurement ] = !isNaN( num ) ? num : 0;
	  }
	
	  var paddingWidth = size.paddingLeft + size.paddingRight;
	  var paddingHeight = size.paddingTop + size.paddingBottom;
	  var marginWidth = size.marginLeft + size.marginRight;
	  var marginHeight = size.marginTop + size.marginBottom;
	  var borderWidth = size.borderLeftWidth + size.borderRightWidth;
	  var borderHeight = size.borderTopWidth + size.borderBottomWidth;
	
	  var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;
	
	  // overwrite width and height if we can get it from style
	  var styleWidth = getStyleSize( style.width );
	  if ( styleWidth !== false ) {
	    size.width = styleWidth +
	      // add padding and border unless it's already including it
	      ( isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth );
	  }
	
	  var styleHeight = getStyleSize( style.height );
	  if ( styleHeight !== false ) {
	    size.height = styleHeight +
	      // add padding and border unless it's already including it
	      ( isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight );
	  }
	
	  size.innerWidth = size.width - ( paddingWidth + borderWidth );
	  size.innerHeight = size.height - ( paddingHeight + borderHeight );
	
	  size.outerWidth = size.width + marginWidth;
	  size.outerHeight = size.height + marginHeight;
	
	  return size;
	}
	
	// IE8 returns percent values, not pixels
	// taken from jQuery's curCSS
	function mungeNonPixel( elem, value ) {
	  // IE8 and has percent value
	  if ( window.getComputedStyle || value.indexOf('%') === -1 ) {
	    return value;
	  }
	  var style = elem.style;
	  // Remember the original values
	  var left = style.left;
	  var rs = elem.runtimeStyle;
	  var rsLeft = rs && rs.left;
	
	  // Put in the new values to get a computed value out
	  if ( rsLeft ) {
	    rs.left = elem.currentStyle.left;
	  }
	  style.left = value;
	  value = style.pixelLeft;
	
	  // Revert the changed values
	  style.left = left;
	  if ( rsLeft ) {
	    rs.left = rsLeft;
	  }
	
	  return value;
	}
	
	return getSize;
	
	}
	
	// transport
	if ( true ) {
	  // AMD for RequireJS
	  !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(/*! get-style-property/get-style-property */ 18) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (defineGetSize), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if ( typeof exports === 'object' ) {
	  // CommonJS for Component
	  module.exports = defineGetSize( require('desandro-get-style-property') );
	} else {
	  // browser global
	  window.getSize = defineGetSize( window.getStyleProperty );
	}
	
	})( window );


/***/ },
/* 18 */
/*!**************************************************************!*\
  !*** ./pixo/assets/get-style-property/get-style-property.js ***!
  \**************************************************************/
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * getStyleProperty v1.0.4
	 * original by kangax
	 * http://perfectionkills.com/feature-testing-css-properties/
	 * MIT license
	 */
	
	/*jshint browser: true, strict: true, undef: true */
	/*global define: false, exports: false, module: false */
	
	( function( window ) {
	
	'use strict';
	
	var prefixes = 'Webkit Moz ms Ms O'.split(' ');
	var docElemStyle = document.documentElement.style;
	
	function getStyleProperty( propName ) {
	  if ( !propName ) {
	    return;
	  }
	
	  // test standard property first
	  if ( typeof docElemStyle[ propName ] === 'string' ) {
	    return propName;
	  }
	
	  // capitalize
	  propName = propName.charAt(0).toUpperCase() + propName.slice(1);
	
	  // test vendor specific properties
	  var prefixed;
	  for ( var i=0, len = prefixes.length; i < len; i++ ) {
	    prefixed = prefixes[i] + propName;
	    if ( typeof docElemStyle[ prefixed ] === 'string' ) {
	      return prefixed;
	    }
	  }
	}
	
	// transport
	if ( true ) {
	  // AMD
	  !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    return getStyleProperty;
	  }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if ( typeof exports === 'object' ) {
	  // CommonJS for Component
	  module.exports = getStyleProperty;
	} else {
	  // browser global
	  window.getStyleProperty = getStyleProperty;
	}
	
	})( window );


/***/ },
/* 19 */
/*!**********************************************************!*\
  !*** ./pixo/assets/matches-selector/matches-selector.js ***!
  \**********************************************************/
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * matchesSelector v1.0.3
	 * matchesSelector( element, '.selector' )
	 * MIT license
	 */
	
	/*jshint browser: true, strict: true, undef: true, unused: true */
	/*global define: false, module: false */
	
	( function( ElemProto ) {
	
	  'use strict';
	
	  var matchesMethod = ( function() {
	    // check for the standard method name first
	    if ( ElemProto.matches ) {
	      return 'matches';
	    }
	    // check un-prefixed
	    if ( ElemProto.matchesSelector ) {
	      return 'matchesSelector';
	    }
	    // check vendor prefixes
	    var prefixes = [ 'webkit', 'moz', 'ms', 'o' ];
	
	    for ( var i=0, len = prefixes.length; i < len; i++ ) {
	      var prefix = prefixes[i];
	      var method = prefix + 'MatchesSelector';
	      if ( ElemProto[ method ] ) {
	        return method;
	      }
	    }
	  })();
	
	  // ----- match ----- //
	
	  function match( elem, selector ) {
	    return elem[ matchesMethod ]( selector );
	  }
	
	  // ----- appendToFragment ----- //
	
	  function checkParent( elem ) {
	    // not needed if already has parent
	    if ( elem.parentNode ) {
	      return;
	    }
	    var fragment = document.createDocumentFragment();
	    fragment.appendChild( elem );
	  }
	
	  // ----- query ----- //
	
	  // fall back to using QSA
	  // thx @jonathantneal https://gist.github.com/3062955
	  function query( elem, selector ) {
	    // append to fragment if no parent
	    checkParent( elem );
	
	    // match elem with all selected elems of parent
	    var elems = elem.parentNode.querySelectorAll( selector );
	    for ( var i=0, len = elems.length; i < len; i++ ) {
	      // return true if match
	      if ( elems[i] === elem ) {
	        return true;
	      }
	    }
	    // otherwise return false
	    return false;
	  }
	
	  // ----- matchChild ----- //
	
	  function matchChild( elem, selector ) {
	    checkParent( elem );
	    return match( elem, selector );
	  }
	
	  // ----- matchesSelector ----- //
	
	  var matchesSelector;
	
	  if ( matchesMethod ) {
	    // IE9 supports matchesSelector, but doesn't work on orphaned elems
	    // check for that
	    var div = document.createElement('div');
	    var supportsOrphans = match( div, 'div' );
	    matchesSelector = supportsOrphans ? match : matchChild;
	  } else {
	    matchesSelector = query;
	  }
	
	  // transport
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return matchesSelector;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof exports === 'object' ) {
	    module.exports = matchesSelector;
	  }
	  else {
	    // browser global
	    window.matchesSelector = matchesSelector;
	  }
	
	})( Element.prototype );


/***/ },
/* 20 */
/*!*********************************************!*\
  !*** ./pixo/assets/fizzy-ui-utils/utils.js ***!
  \*********************************************/
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Fizzy UI utils v1.0.1
	 * MIT license
	 */
	
	/*jshint browser: true, undef: true, unused: true, strict: true */
	
	( function( window, factory ) {
	  /*global define: false, module: false, require: false */
	  'use strict';
	  // universal module definition
	
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	      __webpack_require__(/*! doc-ready/doc-ready */ 21),
	      __webpack_require__(/*! matches-selector/matches-selector */ 19)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( docReady, matchesSelector ) {
	      return factory( window, docReady, matchesSelector );
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof exports == 'object' ) {
	    // CommonJS
	    module.exports = factory(
	      window,
	      require('doc-ready'),
	      require('desandro-matches-selector')
	    );
	  } else {
	    // browser global
	    window.fizzyUIUtils = factory(
	      window,
	      window.docReady,
	      window.matchesSelector
	    );
	  }
	
	}( window, function factory( window, docReady, matchesSelector ) {
	
	'use strict';
	
	var utils = {};
	
	// ----- extend ----- //
	
	// extends objects
	utils.extend = function( a, b ) {
	  for ( var prop in b ) {
	    a[ prop ] = b[ prop ];
	  }
	  return a;
	};
	
	// ----- modulo ----- //
	
	utils.modulo = function( num, div ) {
	  return ( ( num % div ) + div ) % div;
	};
	
	// ----- isArray ----- //
	  
	var objToString = Object.prototype.toString;
	utils.isArray = function( obj ) {
	  return objToString.call( obj ) == '[object Array]';
	};
	
	// ----- makeArray ----- //
	
	// turn element or nodeList into an array
	utils.makeArray = function( obj ) {
	  var ary = [];
	  if ( utils.isArray( obj ) ) {
	    // use object if already an array
	    ary = obj;
	  } else if ( obj && typeof obj.length == 'number' ) {
	    // convert nodeList to array
	    for ( var i=0, len = obj.length; i < len; i++ ) {
	      ary.push( obj[i] );
	    }
	  } else {
	    // array of single index
	    ary.push( obj );
	  }
	  return ary;
	};
	
	// ----- indexOf ----- //
	
	// index of helper cause IE8
	utils.indexOf = Array.prototype.indexOf ? function( ary, obj ) {
	    return ary.indexOf( obj );
	  } : function( ary, obj ) {
	    for ( var i=0, len = ary.length; i < len; i++ ) {
	      if ( ary[i] === obj ) {
	        return i;
	      }
	    }
	    return -1;
	  };
	
	// ----- removeFrom ----- //
	
	utils.removeFrom = function( ary, obj ) {
	  var index = utils.indexOf( ary, obj );
	  if ( index != -1 ) {
	    ary.splice( index, 1 );
	  }
	};
	
	// ----- isElement ----- //
	
	// http://stackoverflow.com/a/384380/182183
	utils.isElement = ( typeof HTMLElement == 'function' || typeof HTMLElement == 'object' ) ?
	  function isElementDOM2( obj ) {
	    return obj instanceof HTMLElement;
	  } :
	  function isElementQuirky( obj ) {
	    return obj && typeof obj == 'object' &&
	      obj.nodeType == 1 && typeof obj.nodeName == 'string';
	  };
	
	// ----- setText ----- //
	
	utils.setText = ( function() {
	  var setTextProperty;
	  function setText( elem, text ) {
	    // only check setTextProperty once
	    setTextProperty = setTextProperty || ( document.documentElement.textContent !== undefined ? 'textContent' : 'innerText' );
	    elem[ setTextProperty ] = text;
	  }
	  return setText;
	})();
	
	// ----- getParent ----- //
	
	utils.getParent = function( elem, selector ) {
	  while ( elem != document.body ) {
	    elem = elem.parentNode;
	    if ( matchesSelector( elem, selector ) ) {
	      return elem;
	    }
	  }
	};
	
	// ----- getQueryElement ----- //
	
	// use element as selector string
	utils.getQueryElement = function( elem ) {
	  if ( typeof elem == 'string' ) {
	    return document.querySelector( elem );
	  }
	  return elem;
	};
	
	// ----- handleEvent ----- //
	
	// enable .ontype to trigger from .addEventListener( elem, 'type' )
	utils.handleEvent = function( event ) {
	  var method = 'on' + event.type;
	  if ( this[ method ] ) {
	    this[ method ]( event );
	  }
	};
	
	// ----- filterFindElements ----- //
	
	utils.filterFindElements = function( elems, selector ) {
	  // make array of elems
	  elems = utils.makeArray( elems );
	  var ffElems = [];
	
	  for ( var i=0, len = elems.length; i < len; i++ ) {
	    var elem = elems[i];
	    // check that elem is an actual element
	    if ( !utils.isElement( elem ) ) {
	      continue;
	    }
	    // filter & find items if we have a selector
	    if ( selector ) {
	      // filter siblings
	      if ( matchesSelector( elem, selector ) ) {
	        ffElems.push( elem );
	      }
	      // find children
	      var childElems = elem.querySelectorAll( selector );
	      // concat childElems to filterFound array
	      for ( var j=0, jLen = childElems.length; j < jLen; j++ ) {
	        ffElems.push( childElems[j] );
	      }
	    } else {
	      ffElems.push( elem );
	    }
	  }
	
	  return ffElems;
	};
	
	// ----- debounceMethod ----- //
	
	utils.debounceMethod = function( _class, methodName, threshold ) {
	  // original method
	  var method = _class.prototype[ methodName ];
	  var timeoutName = methodName + 'Timeout';
	
	  _class.prototype[ methodName ] = function() {
	    var timeout = this[ timeoutName ];
	    if ( timeout ) {
	      clearTimeout( timeout );
	    }
	    var args = arguments;
	
	    var _this = this;
	    this[ timeoutName ] = setTimeout( function() {
	      method.apply( _this, args );
	      delete _this[ timeoutName ];
	    }, threshold || 100 );
	  };
	};
	
	// ----- htmlInit ----- //
	
	// http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
	utils.toDashed = function( str ) {
	  return str.replace( /(.)([A-Z])/g, function( match, $1, $2 ) {
	    return $1 + '-' + $2;
	  }).toLowerCase();
	};
	
	var console = window.console;
	/**
	 * allow user to initialize classes via .js-namespace class
	 * htmlInit( Widget, 'widgetName' )
	 * options are parsed from data-namespace-option attribute
	 */
	utils.htmlInit = function( WidgetClass, namespace ) {
	  docReady( function() {
	    var dashedNamespace = utils.toDashed( namespace );
	    var elems = document.querySelectorAll( '.js-' + dashedNamespace );
	    var dataAttr = 'data-' + dashedNamespace + '-options';
	
	    for ( var i=0, len = elems.length; i < len; i++ ) {
	      var elem = elems[i];
	      var attr = elem.getAttribute( dataAttr );
	      var options;
	      try {
	        options = attr && JSON.parse( attr );
	      } catch ( error ) {
	        // log error, do not initialize
	        if ( console ) {
	          console.error( 'Error parsing ' + dataAttr + ' on ' +
	            elem.nodeName.toLowerCase() + ( elem.id ? '#' + elem.id : '' ) + ': ' +
	            error );
	        }
	        continue;
	      }
	      // initialize
	      var instance = new WidgetClass( elem, options );
	      // make available via $().data('layoutname')
	      var jQuery = window.jQuery;
	      if ( jQuery ) {
	        jQuery.data( elem, namespace, instance );
	      }
	    }
	  });
	};
	
	// -----  ----- //
	
	return utils;
	
	}));


/***/ },
/* 21 */
/*!********************************************!*\
  !*** ./pixo/assets/doc-ready/doc-ready.js ***!
  \********************************************/
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * docReady v1.0.4
	 * Cross browser DOMContentLoaded event emitter
	 * MIT license
	 */
	
	/*jshint browser: true, strict: true, undef: true, unused: true*/
	/*global define: false, require: false, module: false */
	
	( function( window ) {
	
	'use strict';
	
	var document = window.document;
	// collection of functions to be triggered on ready
	var queue = [];
	
	function docReady( fn ) {
	  // throw out non-functions
	  if ( typeof fn !== 'function' ) {
	    return;
	  }
	
	  if ( docReady.isReady ) {
	    // ready now, hit it
	    fn();
	  } else {
	    // queue function when ready
	    queue.push( fn );
	  }
	}
	
	docReady.isReady = false;
	
	// triggered on various doc ready events
	function onReady( event ) {
	  // bail if already triggered or IE8 document is not ready just yet
	  var isIE8NotReady = event.type === 'readystatechange' && document.readyState !== 'complete';
	  if ( docReady.isReady || isIE8NotReady ) {
	    return;
	  }
	
	  trigger();
	}
	
	function trigger() {
	  docReady.isReady = true;
	  // process queue
	  for ( var i=0, len = queue.length; i < len; i++ ) {
	    var fn = queue[i];
	    fn();
	  }
	}
	
	function defineDocReady( eventie ) {
	  // trigger ready if page is ready
	  if ( document.readyState === 'complete' ) {
	    trigger();
	  } else {
	    // listen for events
	    eventie.bind( document, 'DOMContentLoaded', onReady );
	    eventie.bind( document, 'readystatechange', onReady );
	    eventie.bind( window, 'load', onReady );
	  }
	
	  return docReady;
	}
	
	// transport
	if ( true ) {
	  // AMD
	  !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(/*! eventie/eventie */ 22) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (defineDocReady), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if ( typeof exports === 'object' ) {
	  module.exports = defineDocReady( require('eventie') );
	} else {
	  // browser global
	  window.docReady = defineDocReady( window.eventie );
	}
	
	})( window );


/***/ },
/* 22 */
/*!****************************************!*\
  !*** ./pixo/assets/eventie/eventie.js ***!
  \****************************************/
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * eventie v1.0.6
	 * event binding helper
	 *   eventie.bind( elem, 'click', myFn )
	 *   eventie.unbind( elem, 'click', myFn )
	 * MIT license
	 */
	
	/*jshint browser: true, undef: true, unused: true */
	/*global define: false, module: false */
	
	( function( window ) {
	
	'use strict';
	
	var docElem = document.documentElement;
	
	var bind = function() {};
	
	function getIEEvent( obj ) {
	  var event = window.event;
	  // add event.target
	  event.target = event.target || event.srcElement || obj;
	  return event;
	}
	
	if ( docElem.addEventListener ) {
	  bind = function( obj, type, fn ) {
	    obj.addEventListener( type, fn, false );
	  };
	} else if ( docElem.attachEvent ) {
	  bind = function( obj, type, fn ) {
	    obj[ type + fn ] = fn.handleEvent ?
	      function() {
	        var event = getIEEvent( obj );
	        fn.handleEvent.call( fn, event );
	      } :
	      function() {
	        var event = getIEEvent( obj );
	        fn.call( obj, event );
	      };
	    obj.attachEvent( "on" + type, obj[ type + fn ] );
	  };
	}
	
	var unbind = function() {};
	
	if ( docElem.removeEventListener ) {
	  unbind = function( obj, type, fn ) {
	    obj.removeEventListener( type, fn, false );
	  };
	} else if ( docElem.detachEvent ) {
	  unbind = function( obj, type, fn ) {
	    obj.detachEvent( "on" + type, obj[ type + fn ] );
	    try {
	      delete obj[ type + fn ];
	    } catch ( err ) {
	      // can't delete window object properties
	      obj[ type + fn ] = undefined;
	    }
	  };
	}
	
	var eventie = {
	  bind: bind,
	  unbind: unbind
	};
	
	// ----- module definition ----- //
	
	if ( true ) {
	  // AMD
	  !(__WEBPACK_AMD_DEFINE_FACTORY__ = (eventie), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if ( typeof exports === 'object' ) {
	  // CommonJS
	  module.exports = eventie;
	} else {
	  // browser global
	  window.eventie = eventie;
	}
	
	})( window );


/***/ },
/* 23 */
/*!******************************************!*\
  !*** ./pixo/assets/outlayer/outlayer.js ***!
  \******************************************/
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Outlayer v1.4.2
	 * the brains and guts of a layout library
	 * MIT license
	 */
	
	( function( window, factory ) {
	  'use strict';
	  // universal module definition
	
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(/*! eventie/eventie */ 22),
	        __webpack_require__(/*! eventEmitter/EventEmitter */ 24),
	        __webpack_require__(/*! get-size/get-size */ 17),
	        __webpack_require__(/*! fizzy-ui-utils/utils */ 20),
	        __webpack_require__(/*! ./item */ 25)
	      ], __WEBPACK_AMD_DEFINE_RESULT__ = function( eventie, EventEmitter, getSize, utils, Item ) {
	        return factory( window, eventie, EventEmitter, getSize, utils, Item);
	      }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof exports == 'object' ) {
	    // CommonJS
	    module.exports = factory(
	      window,
	      require('eventie'),
	      require('wolfy87-eventemitter'),
	      require('get-size'),
	      require('fizzy-ui-utils'),
	      require('./item')
	    );
	  } else {
	    // browser global
	    window.Outlayer = factory(
	      window,
	      window.eventie,
	      window.EventEmitter,
	      window.getSize,
	      window.fizzyUIUtils,
	      window.Outlayer.Item
	    );
	  }
	
	}( window, function factory( window, eventie, EventEmitter, getSize, utils, Item ) {
	'use strict';
	
	// ----- vars ----- //
	
	var console = window.console;
	var jQuery = window.jQuery;
	var noop = function() {};
	
	// -------------------------- Outlayer -------------------------- //
	
	// globally unique identifiers
	var GUID = 0;
	// internal store of all Outlayer intances
	var instances = {};
	
	
	/**
	 * @param {Element, String} element
	 * @param {Object} options
	 * @constructor
	 */
	function Outlayer( element, options ) {
	  var queryElement = utils.getQueryElement( element );
	  if ( !queryElement ) {
	    if ( console ) {
	      console.error( 'Bad element for ' + this.constructor.namespace +
	        ': ' + ( queryElement || element ) );
	    }
	    return;
	  }
	  this.element = queryElement;
	  // add jQuery
	  if ( jQuery ) {
	    this.$element = jQuery( this.element );
	  }
	
	  // options
	  this.options = utils.extend( {}, this.constructor.defaults );
	  this.option( options );
	
	  // add id for Outlayer.getFromElement
	  var id = ++GUID;
	  this.element.outlayerGUID = id; // expando
	  instances[ id ] = this; // associate via id
	
	  // kick it off
	  this._create();
	
	  if ( this.options.isInitLayout ) {
	    this.layout();
	  }
	}
	
	// settings are for internal use only
	Outlayer.namespace = 'outlayer';
	Outlayer.Item = Item;
	
	// default options
	Outlayer.defaults = {
	  containerStyle: {
	    position: 'relative'
	  },
	  isInitLayout: true,
	  isOriginLeft: true,
	  isOriginTop: true,
	  isResizeBound: true,
	  isResizingContainer: true,
	  // item options
	  transitionDuration: '0.4s',
	  hiddenStyle: {
	    opacity: 0,
	    transform: 'scale(0.001)'
	  },
	  visibleStyle: {
	    opacity: 1,
	    transform: 'scale(1)'
	  }
	};
	
	// inherit EventEmitter
	utils.extend( Outlayer.prototype, EventEmitter.prototype );
	
	/**
	 * set options
	 * @param {Object} opts
	 */
	Outlayer.prototype.option = function( opts ) {
	  utils.extend( this.options, opts );
	};
	
	Outlayer.prototype._create = function() {
	  // get items from children
	  this.reloadItems();
	  // elements that affect layout, but are not laid out
	  this.stamps = [];
	  this.stamp( this.options.stamp );
	  // set container style
	  utils.extend( this.element.style, this.options.containerStyle );
	
	  // bind resize method
	  if ( this.options.isResizeBound ) {
	    this.bindResize();
	  }
	};
	
	// goes through all children again and gets bricks in proper order
	Outlayer.prototype.reloadItems = function() {
	  // collection of item elements
	  this.items = this._itemize( this.element.children );
	};
	
	
	/**
	 * turn elements into Outlayer.Items to be used in layout
	 * @param {Array or NodeList or HTMLElement} elems
	 * @returns {Array} items - collection of new Outlayer Items
	 */
	Outlayer.prototype._itemize = function( elems ) {
	
	  var itemElems = this._filterFindItemElements( elems );
	  var Item = this.constructor.Item;
	
	  // create new Outlayer Items for collection
	  var items = [];
	  for ( var i=0, len = itemElems.length; i < len; i++ ) {
	    var elem = itemElems[i];
	    var item = new Item( elem, this );
	    items.push( item );
	  }
	
	  return items;
	};
	
	/**
	 * get item elements to be used in layout
	 * @param {Array or NodeList or HTMLElement} elems
	 * @returns {Array} items - item elements
	 */
	Outlayer.prototype._filterFindItemElements = function( elems ) {
	  return utils.filterFindElements( elems, this.options.itemSelector );
	};
	
	/**
	 * getter method for getting item elements
	 * @returns {Array} elems - collection of item elements
	 */
	Outlayer.prototype.getItemElements = function() {
	  var elems = [];
	  for ( var i=0, len = this.items.length; i < len; i++ ) {
	    elems.push( this.items[i].element );
	  }
	  return elems;
	};
	
	// ----- init & layout ----- //
	
	/**
	 * lays out all items
	 */
	Outlayer.prototype.layout = function() {
	  this._resetLayout();
	  this._manageStamps();
	
	  // don't animate first layout
	  var isInstant = this.options.isLayoutInstant !== undefined ?
	    this.options.isLayoutInstant : !this._isLayoutInited;
	  this.layoutItems( this.items, isInstant );
	
	  // flag for initalized
	  this._isLayoutInited = true;
	};
	
	// _init is alias for layout
	Outlayer.prototype._init = Outlayer.prototype.layout;
	
	/**
	 * logic before any new layout
	 */
	Outlayer.prototype._resetLayout = function() {
	  this.getSize();
	};
	
	
	Outlayer.prototype.getSize = function() {
	  this.size = getSize( this.element );
	};
	
	/**
	 * get measurement from option, for columnWidth, rowHeight, gutter
	 * if option is String -> get element from selector string, & get size of element
	 * if option is Element -> get size of element
	 * else use option as a number
	 *
	 * @param {String} measurement
	 * @param {String} size - width or height
	 * @private
	 */
	Outlayer.prototype._getMeasurement = function( measurement, size ) {
	  var option = this.options[ measurement ];
	  var elem;
	  if ( !option ) {
	    // default to 0
	    this[ measurement ] = 0;
	  } else {
	    // use option as an element
	    if ( typeof option === 'string' ) {
	      elem = this.element.querySelector( option );
	    } else if ( utils.isElement( option ) ) {
	      elem = option;
	    }
	    // use size of element, if element
	    this[ measurement ] = elem ? getSize( elem )[ size ] : option;
	  }
	};
	
	/**
	 * layout a collection of item elements
	 * @api public
	 */
	Outlayer.prototype.layoutItems = function( items, isInstant ) {
	  items = this._getItemsForLayout( items );
	
	  this._layoutItems( items, isInstant );
	
	  this._postLayout();
	};
	
	/**
	 * get the items to be laid out
	 * you may want to skip over some items
	 * @param {Array} items
	 * @returns {Array} items
	 */
	Outlayer.prototype._getItemsForLayout = function( items ) {
	  var layoutItems = [];
	  for ( var i=0, len = items.length; i < len; i++ ) {
	    var item = items[i];
	    if ( !item.isIgnored ) {
	      layoutItems.push( item );
	    }
	  }
	  return layoutItems;
	};
	
	/**
	 * layout items
	 * @param {Array} items
	 * @param {Boolean} isInstant
	 */
	Outlayer.prototype._layoutItems = function( items, isInstant ) {
	  this._emitCompleteOnItems( 'layout', items );
	
	  if ( !items || !items.length ) {
	    // no items, emit event with empty array
	    return;
	  }
	
	  var queue = [];
	
	  for ( var i=0, len = items.length; i < len; i++ ) {
	    var item = items[i];
	    // get x/y object from method
	    var position = this._getItemLayoutPosition( item );
	    // enqueue
	    position.item = item;
	    position.isInstant = isInstant || item.isLayoutInstant;
	    queue.push( position );
	  }
	
	  this._processLayoutQueue( queue );
	};
	
	/**
	 * get item layout position
	 * @param {Outlayer.Item} item
	 * @returns {Object} x and y position
	 */
	Outlayer.prototype._getItemLayoutPosition = function( /* item */ ) {
	  return {
	    x: 0,
	    y: 0
	  };
	};
	
	/**
	 * iterate over array and position each item
	 * Reason being - separating this logic prevents 'layout invalidation'
	 * thx @paul_irish
	 * @param {Array} queue
	 */
	Outlayer.prototype._processLayoutQueue = function( queue ) {
	  for ( var i=0, len = queue.length; i < len; i++ ) {
	    var obj = queue[i];
	    this._positionItem( obj.item, obj.x, obj.y, obj.isInstant );
	  }
	};
	
	/**
	 * Sets position of item in DOM
	 * @param {Outlayer.Item} item
	 * @param {Number} x - horizontal position
	 * @param {Number} y - vertical position
	 * @param {Boolean} isInstant - disables transitions
	 */
	Outlayer.prototype._positionItem = function( item, x, y, isInstant ) {
	  if ( isInstant ) {
	    // if not transition, just set CSS
	    item.goTo( x, y );
	  } else {
	    item.moveTo( x, y );
	  }
	};
	
	/**
	 * Any logic you want to do after each layout,
	 * i.e. size the container
	 */
	Outlayer.prototype._postLayout = function() {
	  this.resizeContainer();
	};
	
	Outlayer.prototype.resizeContainer = function() {
	  if ( !this.options.isResizingContainer ) {
	    return;
	  }
	  var size = this._getContainerSize();
	  if ( size ) {
	    this._setContainerMeasure( size.width, true );
	    this._setContainerMeasure( size.height, false );
	  }
	};
	
	/**
	 * Sets width or height of container if returned
	 * @returns {Object} size
	 *   @param {Number} width
	 *   @param {Number} height
	 */
	Outlayer.prototype._getContainerSize = noop;
	
	/**
	 * @param {Number} measure - size of width or height
	 * @param {Boolean} isWidth
	 */
	Outlayer.prototype._setContainerMeasure = function( measure, isWidth ) {
	  if ( measure === undefined ) {
	    return;
	  }
	
	  var elemSize = this.size;
	  // add padding and border width if border box
	  if ( elemSize.isBorderBox ) {
	    measure += isWidth ? elemSize.paddingLeft + elemSize.paddingRight +
	      elemSize.borderLeftWidth + elemSize.borderRightWidth :
	      elemSize.paddingBottom + elemSize.paddingTop +
	      elemSize.borderTopWidth + elemSize.borderBottomWidth;
	  }
	
	  measure = Math.max( measure, 0 );
	  this.element.style[ isWidth ? 'width' : 'height' ] = measure + 'px';
	};
	
	/**
	 * emit eventComplete on a collection of items events
	 * @param {String} eventName
	 * @param {Array} items - Outlayer.Items
	 */
	Outlayer.prototype._emitCompleteOnItems = function( eventName, items ) {
	  var _this = this;
	  function onComplete() {
	    _this.dispatchEvent( eventName + 'Complete', null, [ items ] );
	  }
	
	  var count = items.length;
	  if ( !items || !count ) {
	    onComplete();
	    return;
	  }
	
	  var doneCount = 0;
	  function tick() {
	    doneCount++;
	    if ( doneCount === count ) {
	      onComplete();
	    }
	  }
	
	  // bind callback
	  for ( var i=0, len = items.length; i < len; i++ ) {
	    var item = items[i];
	    item.once( eventName, tick );
	  }
	};
	
	/**
	 * emits events via eventEmitter and jQuery events
	 * @param {String} type - name of event
	 * @param {Event} event - original event
	 * @param {Array} args - extra arguments
	 */
	Outlayer.prototype.dispatchEvent = function( type, event, args ) {
	  // add original event to arguments
	  var emitArgs = event ? [ event ].concat( args ) : args;
	  this.emitEvent( type, emitArgs );
	
	  if ( jQuery ) {
	    // set this.$element
	    this.$element = this.$element || jQuery( this.element );
	    if ( event ) {
	      // create jQuery event
	      var $event = jQuery.Event( event );
	      $event.type = type;
	      this.$element.trigger( $event, args );
	    } else {
	      // just trigger with type if no event available
	      this.$element.trigger( type, args );
	    }
	  }
	};
	
	// -------------------------- ignore & stamps -------------------------- //
	
	
	/**
	 * keep item in collection, but do not lay it out
	 * ignored items do not get skipped in layout
	 * @param {Element} elem
	 */
	Outlayer.prototype.ignore = function( elem ) {
	  var item = this.getItem( elem );
	  if ( item ) {
	    item.isIgnored = true;
	  }
	};
	
	/**
	 * return item to layout collection
	 * @param {Element} elem
	 */
	Outlayer.prototype.unignore = function( elem ) {
	  var item = this.getItem( elem );
	  if ( item ) {
	    delete item.isIgnored;
	  }
	};
	
	/**
	 * adds elements to stamps
	 * @param {NodeList, Array, Element, or String} elems
	 */
	Outlayer.prototype.stamp = function( elems ) {
	  elems = this._find( elems );
	  if ( !elems ) {
	    return;
	  }
	
	  this.stamps = this.stamps.concat( elems );
	  // ignore
	  for ( var i=0, len = elems.length; i < len; i++ ) {
	    var elem = elems[i];
	    this.ignore( elem );
	  }
	};
	
	/**
	 * removes elements to stamps
	 * @param {NodeList, Array, or Element} elems
	 */
	Outlayer.prototype.unstamp = function( elems ) {
	  elems = this._find( elems );
	  if ( !elems ){
	    return;
	  }
	
	  for ( var i=0, len = elems.length; i < len; i++ ) {
	    var elem = elems[i];
	    // filter out removed stamp elements
	    utils.removeFrom( this.stamps, elem );
	    this.unignore( elem );
	  }
	
	};
	
	/**
	 * finds child elements
	 * @param {NodeList, Array, Element, or String} elems
	 * @returns {Array} elems
	 */
	Outlayer.prototype._find = function( elems ) {
	  if ( !elems ) {
	    return;
	  }
	  // if string, use argument as selector string
	  if ( typeof elems === 'string' ) {
	    elems = this.element.querySelectorAll( elems );
	  }
	  elems = utils.makeArray( elems );
	  return elems;
	};
	
	Outlayer.prototype._manageStamps = function() {
	  if ( !this.stamps || !this.stamps.length ) {
	    return;
	  }
	
	  this._getBoundingRect();
	
	  for ( var i=0, len = this.stamps.length; i < len; i++ ) {
	    var stamp = this.stamps[i];
	    this._manageStamp( stamp );
	  }
	};
	
	// update boundingLeft / Top
	Outlayer.prototype._getBoundingRect = function() {
	  // get bounding rect for container element
	  var boundingRect = this.element.getBoundingClientRect();
	  var size = this.size;
	  this._boundingRect = {
	    left: boundingRect.left + size.paddingLeft + size.borderLeftWidth,
	    top: boundingRect.top + size.paddingTop + size.borderTopWidth,
	    right: boundingRect.right - ( size.paddingRight + size.borderRightWidth ),
	    bottom: boundingRect.bottom - ( size.paddingBottom + size.borderBottomWidth )
	  };
	};
	
	/**
	 * @param {Element} stamp
	**/
	Outlayer.prototype._manageStamp = noop;
	
	/**
	 * get x/y position of element relative to container element
	 * @param {Element} elem
	 * @returns {Object} offset - has left, top, right, bottom
	 */
	Outlayer.prototype._getElementOffset = function( elem ) {
	  var boundingRect = elem.getBoundingClientRect();
	  var thisRect = this._boundingRect;
	  var size = getSize( elem );
	  var offset = {
	    left: boundingRect.left - thisRect.left - size.marginLeft,
	    top: boundingRect.top - thisRect.top - size.marginTop,
	    right: thisRect.right - boundingRect.right - size.marginRight,
	    bottom: thisRect.bottom - boundingRect.bottom - size.marginBottom
	  };
	  return offset;
	};
	
	// -------------------------- resize -------------------------- //
	
	// enable event handlers for listeners
	// i.e. resize -> onresize
	Outlayer.prototype.handleEvent = function( event ) {
	  var method = 'on' + event.type;
	  if ( this[ method ] ) {
	    this[ method ]( event );
	  }
	};
	
	/**
	 * Bind layout to window resizing
	 */
	Outlayer.prototype.bindResize = function() {
	  // bind just one listener
	  if ( this.isResizeBound ) {
	    return;
	  }
	  eventie.bind( window, 'resize', this );
	  this.isResizeBound = true;
	};
	
	/**
	 * Unbind layout to window resizing
	 */
	Outlayer.prototype.unbindResize = function() {
	  if ( this.isResizeBound ) {
	    eventie.unbind( window, 'resize', this );
	  }
	  this.isResizeBound = false;
	};
	
	// original debounce by John Hann
	// http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
	
	// this fires every resize
	Outlayer.prototype.onresize = function() {
	  if ( this.resizeTimeout ) {
	    clearTimeout( this.resizeTimeout );
	  }
	
	  var _this = this;
	  function delayed() {
	    _this.resize();
	    delete _this.resizeTimeout;
	  }
	
	  this.resizeTimeout = setTimeout( delayed, 100 );
	};
	
	// debounced, layout on resize
	Outlayer.prototype.resize = function() {
	  // don't trigger if size did not change
	  // or if resize was unbound. See #9
	  if ( !this.isResizeBound || !this.needsResizeLayout() ) {
	    return;
	  }
	
	  this.layout();
	};
	
	/**
	 * check if layout is needed post layout
	 * @returns Boolean
	 */
	Outlayer.prototype.needsResizeLayout = function() {
	  var size = getSize( this.element );
	  // check that this.size and size are there
	  // IE8 triggers resize on body size change, so they might not be
	  var hasSizes = this.size && size;
	  return hasSizes && size.innerWidth !== this.size.innerWidth;
	};
	
	// -------------------------- methods -------------------------- //
	
	/**
	 * add items to Outlayer instance
	 * @param {Array or NodeList or Element} elems
	 * @returns {Array} items - Outlayer.Items
	**/
	Outlayer.prototype.addItems = function( elems ) {
	  var items = this._itemize( elems );
	  // add items to collection
	  if ( items.length ) {
	    this.items = this.items.concat( items );
	  }
	  return items;
	};
	
	/**
	 * Layout newly-appended item elements
	 * @param {Array or NodeList or Element} elems
	 */
	Outlayer.prototype.appended = function( elems ) {
	  var items = this.addItems( elems );
	  if ( !items.length ) {
	    return;
	  }
	  // layout and reveal just the new items
	  this.layoutItems( items, true );
	  this.reveal( items );
	};
	
	/**
	 * Layout prepended elements
	 * @param {Array or NodeList or Element} elems
	 */
	Outlayer.prototype.prepended = function( elems ) {
	  var items = this._itemize( elems );
	  if ( !items.length ) {
	    return;
	  }
	  // add items to beginning of collection
	  var previousItems = this.items.slice(0);
	  this.items = items.concat( previousItems );
	  // start new layout
	  this._resetLayout();
	  this._manageStamps();
	  // layout new stuff without transition
	  this.layoutItems( items, true );
	  this.reveal( items );
	  // layout previous items
	  this.layoutItems( previousItems );
	};
	
	/**
	 * reveal a collection of items
	 * @param {Array of Outlayer.Items} items
	 */
	Outlayer.prototype.reveal = function( items ) {
	  this._emitCompleteOnItems( 'reveal', items );
	
	  var len = items && items.length;
	  for ( var i=0; len && i < len; i++ ) {
	    var item = items[i];
	    item.reveal();
	  }
	};
	
	/**
	 * hide a collection of items
	 * @param {Array of Outlayer.Items} items
	 */
	Outlayer.prototype.hide = function( items ) {
	  this._emitCompleteOnItems( 'hide', items );
	
	  var len = items && items.length;
	  for ( var i=0; len && i < len; i++ ) {
	    var item = items[i];
	    item.hide();
	  }
	};
	
	/**
	 * reveal item elements
	 * @param {Array}, {Element}, {NodeList} items
	 */
	Outlayer.prototype.revealItemElements = function( elems ) {
	  var items = this.getItems( elems );
	  this.reveal( items );
	};
	
	/**
	 * hide item elements
	 * @param {Array}, {Element}, {NodeList} items
	 */
	Outlayer.prototype.hideItemElements = function( elems ) {
	  var items = this.getItems( elems );
	  this.hide( items );
	};
	
	/**
	 * get Outlayer.Item, given an Element
	 * @param {Element} elem
	 * @param {Function} callback
	 * @returns {Outlayer.Item} item
	 */
	Outlayer.prototype.getItem = function( elem ) {
	  // loop through items to get the one that matches
	  for ( var i=0, len = this.items.length; i < len; i++ ) {
	    var item = this.items[i];
	    if ( item.element === elem ) {
	      // return item
	      return item;
	    }
	  }
	};
	
	/**
	 * get collection of Outlayer.Items, given Elements
	 * @param {Array} elems
	 * @returns {Array} items - Outlayer.Items
	 */
	Outlayer.prototype.getItems = function( elems ) {
	  elems = utils.makeArray( elems );
	  var items = [];
	  for ( var i=0, len = elems.length; i < len; i++ ) {
	    var elem = elems[i];
	    var item = this.getItem( elem );
	    if ( item ) {
	      items.push( item );
	    }
	  }
	
	  return items;
	};
	
	/**
	 * remove element(s) from instance and DOM
	 * @param {Array or NodeList or Element} elems
	 */
	Outlayer.prototype.remove = function( elems ) {
	  var removeItems = this.getItems( elems );
	
	  this._emitCompleteOnItems( 'remove', removeItems );
	
	  // bail if no items to remove
	  if ( !removeItems || !removeItems.length ) {
	    return;
	  }
	
	  for ( var i=0, len = removeItems.length; i < len; i++ ) {
	    var item = removeItems[i];
	    item.remove();
	    // remove item from collection
	    utils.removeFrom( this.items, item );
	  }
	};
	
	// ----- destroy ----- //
	
	// remove and disable Outlayer instance
	Outlayer.prototype.destroy = function() {
	  // clean up dynamic styles
	  var style = this.element.style;
	  style.height = '';
	  style.position = '';
	  style.width = '';
	  // destroy items
	  for ( var i=0, len = this.items.length; i < len; i++ ) {
	    var item = this.items[i];
	    item.destroy();
	  }
	
	  this.unbindResize();
	
	  var id = this.element.outlayerGUID;
	  delete instances[ id ]; // remove reference to instance by id
	  delete this.element.outlayerGUID;
	  // remove data for jQuery
	  if ( jQuery ) {
	    jQuery.removeData( this.element, this.constructor.namespace );
	  }
	
	};
	
	// -------------------------- data -------------------------- //
	
	/**
	 * get Outlayer instance from element
	 * @param {Element} elem
	 * @returns {Outlayer}
	 */
	Outlayer.data = function( elem ) {
	  elem = utils.getQueryElement( elem );
	  var id = elem && elem.outlayerGUID;
	  return id && instances[ id ];
	};
	
	
	// -------------------------- create Outlayer class -------------------------- //
	
	/**
	 * create a layout class
	 * @param {String} namespace
	 */
	Outlayer.create = function( namespace, options ) {
	  // sub-class Outlayer
	  function Layout() {
	    Outlayer.apply( this, arguments );
	  }
	  // inherit Outlayer prototype, use Object.create if there
	  if ( Object.create ) {
	    Layout.prototype = Object.create( Outlayer.prototype );
	  } else {
	    utils.extend( Layout.prototype, Outlayer.prototype );
	  }
	  // set contructor, used for namespace and Item
	  Layout.prototype.constructor = Layout;
	
	  Layout.defaults = utils.extend( {}, Outlayer.defaults );
	  // apply new options
	  utils.extend( Layout.defaults, options );
	  // keep prototype.settings for backwards compatibility (Packery v1.2.0)
	  Layout.prototype.settings = {};
	
	  Layout.namespace = namespace;
	
	  Layout.data = Outlayer.data;
	
	  // sub-class Item
	  Layout.Item = function LayoutItem() {
	    Item.apply( this, arguments );
	  };
	
	  Layout.Item.prototype = new Item();
	
	  // -------------------------- declarative -------------------------- //
	
	  utils.htmlInit( Layout, namespace );
	
	  // -------------------------- jQuery bridge -------------------------- //
	
	  // make into jQuery plugin
	  if ( jQuery && jQuery.bridget ) {
	    jQuery.bridget( namespace, Layout );
	  }
	
	  return Layout;
	};
	
	// ----- fin ----- //
	
	// back in global
	Outlayer.Item = Item;
	
	return Outlayer;
	
	}));
	


/***/ },
/* 24 */
/*!**************************************************!*\
  !*** ./pixo/assets/eventEmitter/EventEmitter.js ***!
  \**************************************************/
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * EventEmitter v4.2.11 - git.io/ee
	 * Unlicense - http://unlicense.org/
	 * Oliver Caldwell - http://oli.me.uk/
	 * @preserve
	 */
	
	;(function () {
	    'use strict';
	
	    /**
	     * Class for managing events.
	     * Can be extended to provide event functionality in other classes.
	     *
	     * @class EventEmitter Manages event registering and emitting.
	     */
	    function EventEmitter() {}
	
	    // Shortcuts to improve speed and size
	    var proto = EventEmitter.prototype;
	    var exports = this;
	    var originalGlobalValue = exports.EventEmitter;
	
	    /**
	     * Finds the index of the listener for the event in its storage array.
	     *
	     * @param {Function[]} listeners Array of listeners to search through.
	     * @param {Function} listener Method to look for.
	     * @return {Number} Index of the specified listener, -1 if not found
	     * @api private
	     */
	    function indexOfListener(listeners, listener) {
	        var i = listeners.length;
	        while (i--) {
	            if (listeners[i].listener === listener) {
	                return i;
	            }
	        }
	
	        return -1;
	    }
	
	    /**
	     * Alias a method while keeping the context correct, to allow for overwriting of target method.
	     *
	     * @param {String} name The name of the target method.
	     * @return {Function} The aliased method
	     * @api private
	     */
	    function alias(name) {
	        return function aliasClosure() {
	            return this[name].apply(this, arguments);
	        };
	    }
	
	    /**
	     * Returns the listener array for the specified event.
	     * Will initialise the event object and listener arrays if required.
	     * Will return an object if you use a regex search. The object contains keys for each matched event. So /ba[rz]/ might return an object containing bar and baz. But only if you have either defined them with defineEvent or added some listeners to them.
	     * Each property in the object response is an array of listener functions.
	     *
	     * @param {String|RegExp} evt Name of the event to return the listeners from.
	     * @return {Function[]|Object} All listener functions for the event.
	     */
	    proto.getListeners = function getListeners(evt) {
	        var events = this._getEvents();
	        var response;
	        var key;
	
	        // Return a concatenated array of all matching events if
	        // the selector is a regular expression.
	        if (evt instanceof RegExp) {
	            response = {};
	            for (key in events) {
	                if (events.hasOwnProperty(key) && evt.test(key)) {
	                    response[key] = events[key];
	                }
	            }
	        }
	        else {
	            response = events[evt] || (events[evt] = []);
	        }
	
	        return response;
	    };
	
	    /**
	     * Takes a list of listener objects and flattens it into a list of listener functions.
	     *
	     * @param {Object[]} listeners Raw listener objects.
	     * @return {Function[]} Just the listener functions.
	     */
	    proto.flattenListeners = function flattenListeners(listeners) {
	        var flatListeners = [];
	        var i;
	
	        for (i = 0; i < listeners.length; i += 1) {
	            flatListeners.push(listeners[i].listener);
	        }
	
	        return flatListeners;
	    };
	
	    /**
	     * Fetches the requested listeners via getListeners but will always return the results inside an object. This is mainly for internal use but others may find it useful.
	     *
	     * @param {String|RegExp} evt Name of the event to return the listeners from.
	     * @return {Object} All listener functions for an event in an object.
	     */
	    proto.getListenersAsObject = function getListenersAsObject(evt) {
	        var listeners = this.getListeners(evt);
	        var response;
	
	        if (listeners instanceof Array) {
	            response = {};
	            response[evt] = listeners;
	        }
	
	        return response || listeners;
	    };
	
	    /**
	     * Adds a listener function to the specified event.
	     * The listener will not be added if it is a duplicate.
	     * If the listener returns true then it will be removed after it is called.
	     * If you pass a regular expression as the event name then the listener will be added to all events that match it.
	     *
	     * @param {String|RegExp} evt Name of the event to attach the listener to.
	     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.addListener = function addListener(evt, listener) {
	        var listeners = this.getListenersAsObject(evt);
	        var listenerIsWrapped = typeof listener === 'object';
	        var key;
	
	        for (key in listeners) {
	            if (listeners.hasOwnProperty(key) && indexOfListener(listeners[key], listener) === -1) {
	                listeners[key].push(listenerIsWrapped ? listener : {
	                    listener: listener,
	                    once: false
	                });
	            }
	        }
	
	        return this;
	    };
	
	    /**
	     * Alias of addListener
	     */
	    proto.on = alias('addListener');
	
	    /**
	     * Semi-alias of addListener. It will add a listener that will be
	     * automatically removed after its first execution.
	     *
	     * @param {String|RegExp} evt Name of the event to attach the listener to.
	     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.addOnceListener = function addOnceListener(evt, listener) {
	        return this.addListener(evt, {
	            listener: listener,
	            once: true
	        });
	    };
	
	    /**
	     * Alias of addOnceListener.
	     */
	    proto.once = alias('addOnceListener');
	
	    /**
	     * Defines an event name. This is required if you want to use a regex to add a listener to multiple events at once. If you don't do this then how do you expect it to know what event to add to? Should it just add to every possible match for a regex? No. That is scary and bad.
	     * You need to tell it what event names should be matched by a regex.
	     *
	     * @param {String} evt Name of the event to create.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.defineEvent = function defineEvent(evt) {
	        this.getListeners(evt);
	        return this;
	    };
	
	    /**
	     * Uses defineEvent to define multiple events.
	     *
	     * @param {String[]} evts An array of event names to define.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.defineEvents = function defineEvents(evts) {
	        for (var i = 0; i < evts.length; i += 1) {
	            this.defineEvent(evts[i]);
	        }
	        return this;
	    };
	
	    /**
	     * Removes a listener function from the specified event.
	     * When passed a regular expression as the event name, it will remove the listener from all events that match it.
	     *
	     * @param {String|RegExp} evt Name of the event to remove the listener from.
	     * @param {Function} listener Method to remove from the event.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.removeListener = function removeListener(evt, listener) {
	        var listeners = this.getListenersAsObject(evt);
	        var index;
	        var key;
	
	        for (key in listeners) {
	            if (listeners.hasOwnProperty(key)) {
	                index = indexOfListener(listeners[key], listener);
	
	                if (index !== -1) {
	                    listeners[key].splice(index, 1);
	                }
	            }
	        }
	
	        return this;
	    };
	
	    /**
	     * Alias of removeListener
	     */
	    proto.off = alias('removeListener');
	
	    /**
	     * Adds listeners in bulk using the manipulateListeners method.
	     * If you pass an object as the second argument you can add to multiple events at once. The object should contain key value pairs of events and listeners or listener arrays. You can also pass it an event name and an array of listeners to be added.
	     * You can also pass it a regular expression to add the array of listeners to all events that match it.
	     * Yeah, this function does quite a bit. That's probably a bad thing.
	     *
	     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add to multiple events at once.
	     * @param {Function[]} [listeners] An optional array of listener functions to add.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.addListeners = function addListeners(evt, listeners) {
	        // Pass through to manipulateListeners
	        return this.manipulateListeners(false, evt, listeners);
	    };
	
	    /**
	     * Removes listeners in bulk using the manipulateListeners method.
	     * If you pass an object as the second argument you can remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
	     * You can also pass it an event name and an array of listeners to be removed.
	     * You can also pass it a regular expression to remove the listeners from all events that match it.
	     *
	     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to remove from multiple events at once.
	     * @param {Function[]} [listeners] An optional array of listener functions to remove.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.removeListeners = function removeListeners(evt, listeners) {
	        // Pass through to manipulateListeners
	        return this.manipulateListeners(true, evt, listeners);
	    };
	
	    /**
	     * Edits listeners in bulk. The addListeners and removeListeners methods both use this to do their job. You should really use those instead, this is a little lower level.
	     * The first argument will determine if the listeners are removed (true) or added (false).
	     * If you pass an object as the second argument you can add/remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
	     * You can also pass it an event name and an array of listeners to be added/removed.
	     * You can also pass it a regular expression to manipulate the listeners of all events that match it.
	     *
	     * @param {Boolean} remove True if you want to remove listeners, false if you want to add.
	     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add/remove from multiple events at once.
	     * @param {Function[]} [listeners] An optional array of listener functions to add/remove.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.manipulateListeners = function manipulateListeners(remove, evt, listeners) {
	        var i;
	        var value;
	        var single = remove ? this.removeListener : this.addListener;
	        var multiple = remove ? this.removeListeners : this.addListeners;
	
	        // If evt is an object then pass each of its properties to this method
	        if (typeof evt === 'object' && !(evt instanceof RegExp)) {
	            for (i in evt) {
	                if (evt.hasOwnProperty(i) && (value = evt[i])) {
	                    // Pass the single listener straight through to the singular method
	                    if (typeof value === 'function') {
	                        single.call(this, i, value);
	                    }
	                    else {
	                        // Otherwise pass back to the multiple function
	                        multiple.call(this, i, value);
	                    }
	                }
	            }
	        }
	        else {
	            // So evt must be a string
	            // And listeners must be an array of listeners
	            // Loop over it and pass each one to the multiple method
	            i = listeners.length;
	            while (i--) {
	                single.call(this, evt, listeners[i]);
	            }
	        }
	
	        return this;
	    };
	
	    /**
	     * Removes all listeners from a specified event.
	     * If you do not specify an event then all listeners will be removed.
	     * That means every event will be emptied.
	     * You can also pass a regex to remove all events that match it.
	     *
	     * @param {String|RegExp} [evt] Optional name of the event to remove all listeners for. Will remove from every event if not passed.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.removeEvent = function removeEvent(evt) {
	        var type = typeof evt;
	        var events = this._getEvents();
	        var key;
	
	        // Remove different things depending on the state of evt
	        if (type === 'string') {
	            // Remove all listeners for the specified event
	            delete events[evt];
	        }
	        else if (evt instanceof RegExp) {
	            // Remove all events matching the regex.
	            for (key in events) {
	                if (events.hasOwnProperty(key) && evt.test(key)) {
	                    delete events[key];
	                }
	            }
	        }
	        else {
	            // Remove all listeners in all events
	            delete this._events;
	        }
	
	        return this;
	    };
	
	    /**
	     * Alias of removeEvent.
	     *
	     * Added to mirror the node API.
	     */
	    proto.removeAllListeners = alias('removeEvent');
	
	    /**
	     * Emits an event of your choice.
	     * When emitted, every listener attached to that event will be executed.
	     * If you pass the optional argument array then those arguments will be passed to every listener upon execution.
	     * Because it uses `apply`, your array of arguments will be passed as if you wrote them out separately.
	     * So they will not arrive within the array on the other side, they will be separate.
	     * You can also pass a regular expression to emit to all events that match it.
	     *
	     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
	     * @param {Array} [args] Optional array of arguments to be passed to each listener.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.emitEvent = function emitEvent(evt, args) {
	        var listenersMap = this.getListenersAsObject(evt);
	        var listeners;
	        var listener;
	        var i;
	        var key;
	        var response;
	
	        for (key in listenersMap) {
	            if (listenersMap.hasOwnProperty(key)) {
	                listeners = listenersMap[key].slice(0);
	                i = listeners.length;
	
	                while (i--) {
	                    // If the listener returns true then it shall be removed from the event
	                    // The function is executed either with a basic call or an apply if there is an args array
	                    listener = listeners[i];
	
	                    if (listener.once === true) {
	                        this.removeListener(evt, listener.listener);
	                    }
	
	                    response = listener.listener.apply(this, args || []);
	
	                    if (response === this._getOnceReturnValue()) {
	                        this.removeListener(evt, listener.listener);
	                    }
	                }
	            }
	        }
	
	        return this;
	    };
	
	    /**
	     * Alias of emitEvent
	     */
	    proto.trigger = alias('emitEvent');
	
	    /**
	     * Subtly different from emitEvent in that it will pass its arguments on to the listeners, as opposed to taking a single array of arguments to pass on.
	     * As with emitEvent, you can pass a regex in place of the event name to emit to all events that match it.
	     *
	     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
	     * @param {...*} Optional additional arguments to be passed to each listener.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.emit = function emit(evt) {
	        var args = Array.prototype.slice.call(arguments, 1);
	        return this.emitEvent(evt, args);
	    };
	
	    /**
	     * Sets the current value to check against when executing listeners. If a
	     * listeners return value matches the one set here then it will be removed
	     * after execution. This value defaults to true.
	     *
	     * @param {*} value The new value to check for when executing listeners.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.setOnceReturnValue = function setOnceReturnValue(value) {
	        this._onceReturnValue = value;
	        return this;
	    };
	
	    /**
	     * Fetches the current value to check against when executing listeners. If
	     * the listeners return value matches this one then it should be removed
	     * automatically. It will return true by default.
	     *
	     * @return {*|Boolean} The current value to check for or the default, true.
	     * @api private
	     */
	    proto._getOnceReturnValue = function _getOnceReturnValue() {
	        if (this.hasOwnProperty('_onceReturnValue')) {
	            return this._onceReturnValue;
	        }
	        else {
	            return true;
	        }
	    };
	
	    /**
	     * Fetches the events object and creates one if required.
	     *
	     * @return {Object} The events storage object.
	     * @api private
	     */
	    proto._getEvents = function _getEvents() {
	        return this._events || (this._events = {});
	    };
	
	    /**
	     * Reverts the global {@link EventEmitter} to its previous value and returns a reference to this version.
	     *
	     * @return {Function} Non conflicting EventEmitter class.
	     */
	    EventEmitter.noConflict = function noConflict() {
	        exports.EventEmitter = originalGlobalValue;
	        return EventEmitter;
	    };
	
	    // Expose the class either via AMD, CommonJS or the global object
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	            return EventEmitter;
	        }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    else if (typeof module === 'object' && module.exports){
	        module.exports = EventEmitter;
	    }
	    else {
	        exports.EventEmitter = EventEmitter;
	    }
	}.call(this));


/***/ },
/* 25 */
/*!**************************************!*\
  !*** ./pixo/assets/outlayer/item.js ***!
  \**************************************/
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Outlayer Item
	 */
	
	( function( window, factory ) {
	  'use strict';
	  // universal module definition
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(/*! eventEmitter/EventEmitter */ 24),
	        __webpack_require__(/*! get-size/get-size */ 17),
	        __webpack_require__(/*! get-style-property/get-style-property */ 18),
	        __webpack_require__(/*! fizzy-ui-utils/utils */ 20)
	      ], __WEBPACK_AMD_DEFINE_RESULT__ = function( EventEmitter, getSize, getStyleProperty, utils ) {
	        return factory( window, EventEmitter, getSize, getStyleProperty, utils );
	      }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // CommonJS
	    module.exports = factory(
	      window,
	      require('wolfy87-eventemitter'),
	      require('get-size'),
	      require('desandro-get-style-property'),
	      require('fizzy-ui-utils')
	    );
	  } else {
	    // browser global
	    window.Outlayer = {};
	    window.Outlayer.Item = factory(
	      window,
	      window.EventEmitter,
	      window.getSize,
	      window.getStyleProperty,
	      window.fizzyUIUtils
	    );
	  }
	
	}( window, function factory( window, EventEmitter, getSize, getStyleProperty, utils ) {
	'use strict';
	
	// ----- helpers ----- //
	
	var getComputedStyle = window.getComputedStyle;
	var getStyle = getComputedStyle ?
	  function( elem ) {
	    return getComputedStyle( elem, null );
	  } :
	  function( elem ) {
	    return elem.currentStyle;
	  };
	
	
	function isEmptyObj( obj ) {
	  for ( var prop in obj ) {
	    return false;
	  }
	  prop = null;
	  return true;
	}
	
	// -------------------------- CSS3 support -------------------------- //
	
	var transitionProperty = getStyleProperty('transition');
	var transformProperty = getStyleProperty('transform');
	var supportsCSS3 = transitionProperty && transformProperty;
	var is3d = !!getStyleProperty('perspective');
	
	var transitionEndEvent = {
	  WebkitTransition: 'webkitTransitionEnd',
	  MozTransition: 'transitionend',
	  OTransition: 'otransitionend',
	  transition: 'transitionend'
	}[ transitionProperty ];
	
	// properties that could have vendor prefix
	var prefixableProperties = [
	  'transform',
	  'transition',
	  'transitionDuration',
	  'transitionProperty'
	];
	
	// cache all vendor properties
	var vendorProperties = ( function() {
	  var cache = {};
	  for ( var i=0, len = prefixableProperties.length; i < len; i++ ) {
	    var prop = prefixableProperties[i];
	    var supportedProp = getStyleProperty( prop );
	    if ( supportedProp && supportedProp !== prop ) {
	      cache[ prop ] = supportedProp;
	    }
	  }
	  return cache;
	})();
	
	// -------------------------- Item -------------------------- //
	
	function Item( element, layout ) {
	  if ( !element ) {
	    return;
	  }
	
	  this.element = element;
	  // parent layout class, i.e. Masonry, Isotope, or Packery
	  this.layout = layout;
	  this.position = {
	    x: 0,
	    y: 0
	  };
	
	  this._create();
	}
	
	// inherit EventEmitter
	utils.extend( Item.prototype, EventEmitter.prototype );
	
	Item.prototype._create = function() {
	  // transition objects
	  this._transn = {
	    ingProperties: {},
	    clean: {},
	    onEnd: {}
	  };
	
	  this.css({
	    position: 'absolute'
	  });
	};
	
	// trigger specified handler for event type
	Item.prototype.handleEvent = function( event ) {
	  var method = 'on' + event.type;
	  if ( this[ method ] ) {
	    this[ method ]( event );
	  }
	};
	
	Item.prototype.getSize = function() {
	  this.size = getSize( this.element );
	};
	
	/**
	 * apply CSS styles to element
	 * @param {Object} style
	 */
	Item.prototype.css = function( style ) {
	  var elemStyle = this.element.style;
	
	  for ( var prop in style ) {
	    // use vendor property if available
	    var supportedProp = vendorProperties[ prop ] || prop;
	    elemStyle[ supportedProp ] = style[ prop ];
	  }
	};
	
	 // measure position, and sets it
	Item.prototype.getPosition = function() {
	  var style = getStyle( this.element );
	  var layoutOptions = this.layout.options;
	  var isOriginLeft = layoutOptions.isOriginLeft;
	  var isOriginTop = layoutOptions.isOriginTop;
	  var xValue = style[ isOriginLeft ? 'left' : 'right' ];
	  var yValue = style[ isOriginTop ? 'top' : 'bottom' ];
	  // convert percent to pixels
	  var layoutSize = this.layout.size;
	  var x = xValue.indexOf('%') != -1 ?
	    ( parseFloat( xValue ) / 100 ) * layoutSize.width : parseInt( xValue, 10 );
	  var y = yValue.indexOf('%') != -1 ?
	    ( parseFloat( yValue ) / 100 ) * layoutSize.height : parseInt( yValue, 10 );
	
	  // clean up 'auto' or other non-integer values
	  x = isNaN( x ) ? 0 : x;
	  y = isNaN( y ) ? 0 : y;
	  // remove padding from measurement
	  x -= isOriginLeft ? layoutSize.paddingLeft : layoutSize.paddingRight;
	  y -= isOriginTop ? layoutSize.paddingTop : layoutSize.paddingBottom;
	
	  this.position.x = x;
	  this.position.y = y;
	};
	
	// set settled position, apply padding
	Item.prototype.layoutPosition = function() {
	  var layoutSize = this.layout.size;
	  var layoutOptions = this.layout.options;
	  var style = {};
	
	  // x
	  var xPadding = layoutOptions.isOriginLeft ? 'paddingLeft' : 'paddingRight';
	  var xProperty = layoutOptions.isOriginLeft ? 'left' : 'right';
	  var xResetProperty = layoutOptions.isOriginLeft ? 'right' : 'left';
	
	  var x = this.position.x + layoutSize[ xPadding ];
	  // set in percentage or pixels
	  style[ xProperty ] = this.getXValue( x );
	  // reset other property
	  style[ xResetProperty ] = '';
	
	  // y
	  var yPadding = layoutOptions.isOriginTop ? 'paddingTop' : 'paddingBottom';
	  var yProperty = layoutOptions.isOriginTop ? 'top' : 'bottom';
	  var yResetProperty = layoutOptions.isOriginTop ? 'bottom' : 'top';
	
	  var y = this.position.y + layoutSize[ yPadding ];
	  // set in percentage or pixels
	  style[ yProperty ] = this.getYValue( y );
	  // reset other property
	  style[ yResetProperty ] = '';
	
	  this.css( style );
	  this.emitEvent( 'layout', [ this ] );
	};
	
	Item.prototype.getXValue = function( x ) {
	  var layoutOptions = this.layout.options;
	  return layoutOptions.percentPosition && !layoutOptions.isHorizontal ?
	    ( ( x / this.layout.size.width ) * 100 ) + '%' : x + 'px';
	};
	
	Item.prototype.getYValue = function( y ) {
	  var layoutOptions = this.layout.options;
	  return layoutOptions.percentPosition && layoutOptions.isHorizontal ?
	    ( ( y / this.layout.size.height ) * 100 ) + '%' : y + 'px';
	};
	
	
	Item.prototype._transitionTo = function( x, y ) {
	  this.getPosition();
	  // get current x & y from top/left
	  var curX = this.position.x;
	  var curY = this.position.y;
	
	  var compareX = parseInt( x, 10 );
	  var compareY = parseInt( y, 10 );
	  var didNotMove = compareX === this.position.x && compareY === this.position.y;
	
	  // save end position
	  this.setPosition( x, y );
	
	  // if did not move and not transitioning, just go to layout
	  if ( didNotMove && !this.isTransitioning ) {
	    this.layoutPosition();
	    return;
	  }
	
	  var transX = x - curX;
	  var transY = y - curY;
	  var transitionStyle = {};
	  transitionStyle.transform = this.getTranslate( transX, transY );
	
	  this.transition({
	    to: transitionStyle,
	    onTransitionEnd: {
	      transform: this.layoutPosition
	    },
	    isCleaning: true
	  });
	};
	
	Item.prototype.getTranslate = function( x, y ) {
	  // flip cooridinates if origin on right or bottom
	  var layoutOptions = this.layout.options;
	  x = layoutOptions.isOriginLeft ? x : -x;
	  y = layoutOptions.isOriginTop ? y : -y;
	
	  if ( is3d ) {
	    return 'translate3d(' + x + 'px, ' + y + 'px, 0)';
	  }
	
	  return 'translate(' + x + 'px, ' + y + 'px)';
	};
	
	// non transition + transform support
	Item.prototype.goTo = function( x, y ) {
	  this.setPosition( x, y );
	  this.layoutPosition();
	};
	
	// use transition and transforms if supported
	Item.prototype.moveTo = supportsCSS3 ?
	  Item.prototype._transitionTo : Item.prototype.goTo;
	
	Item.prototype.setPosition = function( x, y ) {
	  this.position.x = parseInt( x, 10 );
	  this.position.y = parseInt( y, 10 );
	};
	
	// ----- transition ----- //
	
	/**
	 * @param {Object} style - CSS
	 * @param {Function} onTransitionEnd
	 */
	
	// non transition, just trigger callback
	Item.prototype._nonTransition = function( args ) {
	  this.css( args.to );
	  if ( args.isCleaning ) {
	    this._removeStyles( args.to );
	  }
	  for ( var prop in args.onTransitionEnd ) {
	    args.onTransitionEnd[ prop ].call( this );
	  }
	};
	
	/**
	 * proper transition
	 * @param {Object} args - arguments
	 *   @param {Object} to - style to transition to
	 *   @param {Object} from - style to start transition from
	 *   @param {Boolean} isCleaning - removes transition styles after transition
	 *   @param {Function} onTransitionEnd - callback
	 */
	Item.prototype._transition = function( args ) {
	  // redirect to nonTransition if no transition duration
	  if ( !parseFloat( this.layout.options.transitionDuration ) ) {
	    this._nonTransition( args );
	    return;
	  }
	
	  var _transition = this._transn;
	  // keep track of onTransitionEnd callback by css property
	  for ( var prop in args.onTransitionEnd ) {
	    _transition.onEnd[ prop ] = args.onTransitionEnd[ prop ];
	  }
	  // keep track of properties that are transitioning
	  for ( prop in args.to ) {
	    _transition.ingProperties[ prop ] = true;
	    // keep track of properties to clean up when transition is done
	    if ( args.isCleaning ) {
	      _transition.clean[ prop ] = true;
	    }
	  }
	
	  // set from styles
	  if ( args.from ) {
	    this.css( args.from );
	    // force redraw. http://blog.alexmaccaw.com/css-transitions
	    var h = this.element.offsetHeight;
	    // hack for JSHint to hush about unused var
	    h = null;
	  }
	  // enable transition
	  this.enableTransition( args.to );
	  // set styles that are transitioning
	  this.css( args.to );
	
	  this.isTransitioning = true;
	
	};
	
	// dash before all cap letters, including first for
	// WebkitTransform => -webkit-transform
	function toDashedAll( str ) {
	  return str.replace( /([A-Z])/g, function( $1 ) {
	    return '-' + $1.toLowerCase();
	  });
	}
	
	var transitionProps = 'opacity,' +
	  toDashedAll( vendorProperties.transform || 'transform' );
	
	Item.prototype.enableTransition = function(/* style */) {
	  // HACK changing transitionProperty during a transition
	  // will cause transition to jump
	  if ( this.isTransitioning ) {
	    return;
	  }
	
	  // make `transition: foo, bar, baz` from style object
	  // HACK un-comment this when enableTransition can work
	  // while a transition is happening
	  // var transitionValues = [];
	  // for ( var prop in style ) {
	  //   // dash-ify camelCased properties like WebkitTransition
	  //   prop = vendorProperties[ prop ] || prop;
	  //   transitionValues.push( toDashedAll( prop ) );
	  // }
	  // enable transition styles
	  this.css({
	    transitionProperty: transitionProps,
	    transitionDuration: this.layout.options.transitionDuration
	  });
	  // listen for transition end event
	  this.element.addEventListener( transitionEndEvent, this, false );
	};
	
	Item.prototype.transition = Item.prototype[ transitionProperty ? '_transition' : '_nonTransition' ];
	
	// ----- events ----- //
	
	Item.prototype.onwebkitTransitionEnd = function( event ) {
	  this.ontransitionend( event );
	};
	
	Item.prototype.onotransitionend = function( event ) {
	  this.ontransitionend( event );
	};
	
	// properties that I munge to make my life easier
	var dashedVendorProperties = {
	  '-webkit-transform': 'transform',
	  '-moz-transform': 'transform',
	  '-o-transform': 'transform'
	};
	
	Item.prototype.ontransitionend = function( event ) {
	  // disregard bubbled events from children
	  if ( event.target !== this.element ) {
	    return;
	  }
	  var _transition = this._transn;
	  // get property name of transitioned property, convert to prefix-free
	  var propertyName = dashedVendorProperties[ event.propertyName ] || event.propertyName;
	
	  // remove property that has completed transitioning
	  delete _transition.ingProperties[ propertyName ];
	  // check if any properties are still transitioning
	  if ( isEmptyObj( _transition.ingProperties ) ) {
	    // all properties have completed transitioning
	    this.disableTransition();
	  }
	  // clean style
	  if ( propertyName in _transition.clean ) {
	    // clean up style
	    this.element.style[ event.propertyName ] = '';
	    delete _transition.clean[ propertyName ];
	  }
	  // trigger onTransitionEnd callback
	  if ( propertyName in _transition.onEnd ) {
	    var onTransitionEnd = _transition.onEnd[ propertyName ];
	    onTransitionEnd.call( this );
	    delete _transition.onEnd[ propertyName ];
	  }
	
	  this.emitEvent( 'transitionEnd', [ this ] );
	};
	
	Item.prototype.disableTransition = function() {
	  this.removeTransitionStyles();
	  this.element.removeEventListener( transitionEndEvent, this, false );
	  this.isTransitioning = false;
	};
	
	/**
	 * removes style property from element
	 * @param {Object} style
	**/
	Item.prototype._removeStyles = function( style ) {
	  // clean up transition styles
	  var cleanStyle = {};
	  for ( var prop in style ) {
	    cleanStyle[ prop ] = '';
	  }
	  this.css( cleanStyle );
	};
	
	var cleanTransitionStyle = {
	  transitionProperty: '',
	  transitionDuration: ''
	};
	
	Item.prototype.removeTransitionStyles = function() {
	  // remove transition
	  this.css( cleanTransitionStyle );
	};
	
	// ----- show/hide/remove ----- //
	
	// remove element from DOM
	Item.prototype.removeElem = function() {
	  this.element.parentNode.removeChild( this.element );
	  // remove display: none
	  this.css({ display: '' });
	  this.emitEvent( 'remove', [ this ] );
	};
	
	Item.prototype.remove = function() {
	  // just remove element if no transition support or no transition
	  if ( !transitionProperty || !parseFloat( this.layout.options.transitionDuration ) ) {
	    this.removeElem();
	    return;
	  }
	
	  // start transition
	  var _this = this;
	  this.once( 'transitionEnd', function() {
	    _this.removeElem();
	  });
	  this.hide();
	};
	
	Item.prototype.reveal = function() {
	  delete this.isHidden;
	  // remove display: none
	  this.css({ display: '' });
	
	  var options = this.layout.options;
	
	  var onTransitionEnd = {};
	  var transitionEndProperty = this.getHideRevealTransitionEndProperty('visibleStyle');
	  onTransitionEnd[ transitionEndProperty ] = this.onRevealTransitionEnd;
	
	  this.transition({
	    from: options.hiddenStyle,
	    to: options.visibleStyle,
	    isCleaning: true,
	    onTransitionEnd: onTransitionEnd
	  });
	};
	
	Item.prototype.onRevealTransitionEnd = function() {
	  // check if still visible
	  // during transition, item may have been hidden
	  if ( !this.isHidden ) {
	    this.emitEvent('reveal');
	  }
	};
	
	/**
	 * get style property use for hide/reveal transition end
	 * @param {String} styleProperty - hiddenStyle/visibleStyle
	 * @returns {String}
	 */
	Item.prototype.getHideRevealTransitionEndProperty = function( styleProperty ) {
	  var optionStyle = this.layout.options[ styleProperty ];
	  // use opacity
	  if ( optionStyle.opacity ) {
	    return 'opacity';
	  }
	  // get first property
	  for ( var prop in optionStyle ) {
	    return prop;
	  }
	};
	
	Item.prototype.hide = function() {
	  // set flag
	  this.isHidden = true;
	  // remove display: none
	  this.css({ display: '' });
	
	  var options = this.layout.options;
	
	  var onTransitionEnd = {};
	  var transitionEndProperty = this.getHideRevealTransitionEndProperty('hiddenStyle');
	  onTransitionEnd[ transitionEndProperty ] = this.onHideTransitionEnd;
	
	  this.transition({
	    from: options.visibleStyle,
	    to: options.hiddenStyle,
	    // keep hidden stuff hidden
	    isCleaning: true,
	    onTransitionEnd: onTransitionEnd
	  });
	};
	
	Item.prototype.onHideTransitionEnd = function() {
	  // check if still hidden
	  // during transition, item may have been un-hidden
	  if ( this.isHidden ) {
	    this.css({ display: 'none' });
	    this.emitEvent('hide');
	  }
	};
	
	Item.prototype.destroy = function() {
	  this.css({
	    position: '',
	    left: '',
	    right: '',
	    top: '',
	    bottom: '',
	    transition: '',
	    transform: ''
	  });
	};
	
	return Item;
	
	}));


/***/ },
/* 26 */
/*!***********************************************!*\
  !*** ./pixo/assets/isotope/js/layout-mode.js ***!
  \***********************************************/
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Isotope LayoutMode
	 */
	
	( function( window, factory ) {
	  'use strict';
	  // universal module definition
	
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(/*! get-size/get-size */ 17),
	        __webpack_require__(/*! outlayer/outlayer */ 23)
	      ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof exports == 'object' ) {
	    // CommonJS
	    module.exports = factory(
	      require('get-size'),
	      require('outlayer')
	    );
	  } else {
	    // browser global
	    window.Isotope = window.Isotope || {};
	    window.Isotope.LayoutMode = factory(
	      window.getSize,
	      window.Outlayer
	    );
	  }
	
	}( window, function factory( getSize, Outlayer ) {
	  'use strict';
	
	  // layout mode class
	  function LayoutMode( isotope ) {
	    this.isotope = isotope;
	    // link properties
	    if ( isotope ) {
	      this.options = isotope.options[ this.namespace ];
	      this.element = isotope.element;
	      this.items = isotope.filteredItems;
	      this.size = isotope.size;
	    }
	  }
	
	  /**
	   * some methods should just defer to default Outlayer method
	   * and reference the Isotope instance as `this`
	  **/
	  ( function() {
	    var facadeMethods = [
	      '_resetLayout',
	      '_getItemLayoutPosition',
	      '_manageStamp',
	      '_getContainerSize',
	      '_getElementOffset',
	      'needsResizeLayout'
	    ];
	
	    for ( var i=0, len = facadeMethods.length; i < len; i++ ) {
	      var methodName = facadeMethods[i];
	      LayoutMode.prototype[ methodName ] = getOutlayerMethod( methodName );
	    }
	
	    function getOutlayerMethod( methodName ) {
	      return function() {
	        return Outlayer.prototype[ methodName ].apply( this.isotope, arguments );
	      };
	    }
	  })();
	
	  // -----  ----- //
	
	  // for horizontal layout modes, check vertical size
	  LayoutMode.prototype.needsVerticalResizeLayout = function() {
	    // don't trigger if size did not change
	    var size = getSize( this.isotope.element );
	    // check that this.size and size are there
	    // IE8 triggers resize on body size change, so they might not be
	    var hasSizes = this.isotope.size && size;
	    return hasSizes && size.innerHeight != this.isotope.size.innerHeight;
	  };
	
	  // ----- measurements ----- //
	
	  LayoutMode.prototype._getMeasurement = function() {
	    this.isotope._getMeasurement.apply( this, arguments );
	  };
	
	  LayoutMode.prototype.getColumnWidth = function() {
	    this.getSegmentSize( 'column', 'Width' );
	  };
	
	  LayoutMode.prototype.getRowHeight = function() {
	    this.getSegmentSize( 'row', 'Height' );
	  };
	
	  /**
	   * get columnWidth or rowHeight
	   * segment: 'column' or 'row'
	   * size 'Width' or 'Height'
	  **/
	  LayoutMode.prototype.getSegmentSize = function( segment, size ) {
	    var segmentName = segment + size;
	    var outerSize = 'outer' + size;
	    // columnWidth / outerWidth // rowHeight / outerHeight
	    this._getMeasurement( segmentName, outerSize );
	    // got rowHeight or columnWidth, we can chill
	    if ( this[ segmentName ] ) {
	      return;
	    }
	    // fall back to item of first element
	    var firstItemSize = this.getFirstItemSize();
	    this[ segmentName ] = firstItemSize && firstItemSize[ outerSize ] ||
	      // or size of container
	      this.isotope.size[ 'inner' + size ];
	  };
	
	  LayoutMode.prototype.getFirstItemSize = function() {
	    var firstItem = this.isotope.filteredItems[0];
	    return firstItem && firstItem.element && getSize( firstItem.element );
	  };
	
	  // ----- methods that should reference isotope ----- //
	
	  LayoutMode.prototype.layout = function() {
	    this.isotope.layout.apply( this.isotope, arguments );
	  };
	
	  LayoutMode.prototype.getSize = function() {
	    this.isotope.getSize();
	    this.size = this.isotope.size;
	  };
	
	  // -------------------------- create -------------------------- //
	
	  LayoutMode.modes = {};
	
	  LayoutMode.create = function( namespace, options ) {
	
	    function Mode() {
	      LayoutMode.apply( this, arguments );
	    }
	
	    Mode.prototype = new LayoutMode();
	
	    // default options
	    if ( options ) {
	      Mode.options = options;
	    }
	
	    Mode.prototype.namespace = namespace;
	    // register in Isotope
	    LayoutMode.modes[ namespace ] = Mode;
	
	    return Mode;
	  };
	
	  return LayoutMode;
	
	}));


/***/ },
/* 27 */
/*!********************************************************!*\
  !*** ./pixo/assets/isotope/js/layout-modes/masonry.js ***!
  \********************************************************/
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Masonry layout mode
	 * sub-classes Masonry
	 * http://masonry.desandro.com
	 */
	
	( function( window, factory ) {
	  'use strict';
	  // universal module definition
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(/*! ../layout-mode */ 26),
	        __webpack_require__(/*! masonry/masonry */ 28)
	      ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof exports == 'object' ) {
	    // CommonJS
	    module.exports = factory(
	      require('../layout-mode'),
	      require('masonry-layout')
	    );
	  } else {
	    // browser global
	    factory(
	      window.Isotope.LayoutMode,
	      window.Masonry
	    );
	  }
	
	}( window, function factory( LayoutMode, Masonry ) {
	'use strict';
	
	// -------------------------- helpers -------------------------- //
	
	// extend objects
	function extend( a, b ) {
	  for ( var prop in b ) {
	    a[ prop ] = b[ prop ];
	  }
	  return a;
	}
	
	// -------------------------- masonryDefinition -------------------------- //
	
	  // create an Outlayer layout class
	  var MasonryMode = LayoutMode.create('masonry');
	
	  // save on to these methods
	  var _getElementOffset = MasonryMode.prototype._getElementOffset;
	  var layout = MasonryMode.prototype.layout;
	  var _getMeasurement = MasonryMode.prototype._getMeasurement;
	
	  // sub-class Masonry
	  extend( MasonryMode.prototype, Masonry.prototype );
	
	  // set back, as it was overwritten by Masonry
	  MasonryMode.prototype._getElementOffset = _getElementOffset;
	  MasonryMode.prototype.layout = layout;
	  MasonryMode.prototype._getMeasurement = _getMeasurement;
	
	  var measureColumns = MasonryMode.prototype.measureColumns;
	  MasonryMode.prototype.measureColumns = function() {
	    // set items, used if measuring first item
	    this.items = this.isotope.filteredItems;
	    measureColumns.call( this );
	  };
	
	  // HACK copy over isOriginLeft/Top options
	  var _manageStamp = MasonryMode.prototype._manageStamp;
	  MasonryMode.prototype._manageStamp = function() {
	    this.options.isOriginLeft = this.isotope.options.isOriginLeft;
	    this.options.isOriginTop = this.isotope.options.isOriginTop;
	    _manageStamp.apply( this, arguments );
	  };
	
	  return MasonryMode;
	
	}));


/***/ },
/* 28 */
/*!****************************************!*\
  !*** ./pixo/assets/masonry/masonry.js ***!
  \****************************************/
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Masonry v3.3.2
	 * Cascading grid layout library
	 * http://masonry.desandro.com
	 * MIT License
	 * by David DeSandro
	 */
	
	( function( window, factory ) {
	  'use strict';
	  // universal module definition
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(/*! outlayer/outlayer */ 23),
	        __webpack_require__(/*! get-size/get-size */ 17),
	        __webpack_require__(/*! fizzy-ui-utils/utils */ 20)
	      ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof exports === 'object' ) {
	    // CommonJS
	    module.exports = factory(
	      require('outlayer'),
	      require('get-size'),
	      require('fizzy-ui-utils')
	    );
	  } else {
	    // browser global
	    window.Masonry = factory(
	      window.Outlayer,
	      window.getSize,
	      window.fizzyUIUtils
	    );
	  }
	
	}( window, function factory( Outlayer, getSize, utils ) {
	
	'use strict';
	
	// -------------------------- masonryDefinition -------------------------- //
	
	  // create an Outlayer layout class
	  var Masonry = Outlayer.create('masonry');
	
	  Masonry.prototype._resetLayout = function() {
	    this.getSize();
	    this._getMeasurement( 'columnWidth', 'outerWidth' );
	    this._getMeasurement( 'gutter', 'outerWidth' );
	    this.measureColumns();
	
	    // reset column Y
	    var i = this.cols;
	    this.colYs = [];
	    while (i--) {
	      this.colYs.push( 0 );
	    }
	
	    this.maxY = 0;
	  };
	
	  Masonry.prototype.measureColumns = function() {
	    this.getContainerWidth();
	    // if columnWidth is 0, default to outerWidth of first item
	    if ( !this.columnWidth ) {
	      var firstItem = this.items[0];
	      var firstItemElem = firstItem && firstItem.element;
	      // columnWidth fall back to item of first element
	      this.columnWidth = firstItemElem && getSize( firstItemElem ).outerWidth ||
	        // if first elem has no width, default to size of container
	        this.containerWidth;
	    }
	
	    var columnWidth = this.columnWidth += this.gutter;
	
	    // calculate columns
	    var containerWidth = this.containerWidth + this.gutter;
	    var cols = containerWidth / columnWidth;
	    // fix rounding errors, typically with gutters
	    var excess = columnWidth - containerWidth % columnWidth;
	    // if overshoot is less than a pixel, round up, otherwise floor it
	    var mathMethod = excess && excess < 1 ? 'round' : 'floor';
	    cols = Math[ mathMethod ]( cols );
	    this.cols = Math.max( cols, 1 );
	  };
	
	  Masonry.prototype.getContainerWidth = function() {
	    // container is parent if fit width
	    var container = this.options.isFitWidth ? this.element.parentNode : this.element;
	    // check that this.size and size are there
	    // IE8 triggers resize on body size change, so they might not be
	    var size = getSize( container );
	    this.containerWidth = size && size.innerWidth;
	  };
	
	  Masonry.prototype._getItemLayoutPosition = function( item ) {
	    item.getSize();
	    // how many columns does this brick span
	    var remainder = item.size.outerWidth % this.columnWidth;
	    var mathMethod = remainder && remainder < 1 ? 'round' : 'ceil';
	    // round if off by 1 pixel, otherwise use ceil
	    var colSpan = Math[ mathMethod ]( item.size.outerWidth / this.columnWidth );
	    colSpan = Math.min( colSpan, this.cols );
	
	    var colGroup = this._getColGroup( colSpan );
	    // get the minimum Y value from the columns
	    var minimumY = Math.min.apply( Math, colGroup );
	    var shortColIndex = utils.indexOf( colGroup, minimumY );
	
	    // position the brick
	    var position = {
	      x: this.columnWidth * shortColIndex,
	      y: minimumY
	    };
	
	    // apply setHeight to necessary columns
	    var setHeight = minimumY + item.size.outerHeight;
	    var setSpan = this.cols + 1 - colGroup.length;
	    for ( var i = 0; i < setSpan; i++ ) {
	      this.colYs[ shortColIndex + i ] = setHeight;
	    }
	
	    return position;
	  };
	
	  /**
	   * @param {Number} colSpan - number of columns the element spans
	   * @returns {Array} colGroup
	   */
	  Masonry.prototype._getColGroup = function( colSpan ) {
	    if ( colSpan < 2 ) {
	      // if brick spans only one column, use all the column Ys
	      return this.colYs;
	    }
	
	    var colGroup = [];
	    // how many different places could this brick fit horizontally
	    var groupCount = this.cols + 1 - colSpan;
	    // for each group potential horizontal position
	    for ( var i = 0; i < groupCount; i++ ) {
	      // make an array of colY values for that one group
	      var groupColYs = this.colYs.slice( i, i + colSpan );
	      // and get the max value of the array
	      colGroup[i] = Math.max.apply( Math, groupColYs );
	    }
	    return colGroup;
	  };
	
	  Masonry.prototype._manageStamp = function( stamp ) {
	    var stampSize = getSize( stamp );
	    var offset = this._getElementOffset( stamp );
	    // get the columns that this stamp affects
	    var firstX = this.options.isOriginLeft ? offset.left : offset.right;
	    var lastX = firstX + stampSize.outerWidth;
	    var firstCol = Math.floor( firstX / this.columnWidth );
	    firstCol = Math.max( 0, firstCol );
	    var lastCol = Math.floor( lastX / this.columnWidth );
	    // lastCol should not go over if multiple of columnWidth #425
	    lastCol -= lastX % this.columnWidth ? 0 : 1;
	    lastCol = Math.min( this.cols - 1, lastCol );
	    // set colYs to bottom of the stamp
	    var stampMaxY = ( this.options.isOriginTop ? offset.top : offset.bottom ) +
	      stampSize.outerHeight;
	    for ( var i = firstCol; i <= lastCol; i++ ) {
	      this.colYs[i] = Math.max( stampMaxY, this.colYs[i] );
	    }
	  };
	
	  Masonry.prototype._getContainerSize = function() {
	    this.maxY = Math.max.apply( Math, this.colYs );
	    var size = {
	      height: this.maxY
	    };
	
	    if ( this.options.isFitWidth ) {
	      size.width = this._getContainerFitWidth();
	    }
	
	    return size;
	  };
	
	  Masonry.prototype._getContainerFitWidth = function() {
	    var unusedCols = 0;
	    // count unused columns
	    var i = this.cols;
	    while ( --i ) {
	      if ( this.colYs[i] !== 0 ) {
	        break;
	      }
	      unusedCols++;
	    }
	    // fit container to columns that have been used
	    return ( this.cols - unusedCols ) * this.columnWidth - this.gutter;
	  };
	
	  Masonry.prototype.needsResizeLayout = function() {
	    var previousWidth = this.containerWidth;
	    this.getContainerWidth();
	    return previousWidth !== this.containerWidth;
	  };
	
	  return Masonry;
	
	}));


/***/ },
/* 29 */
/*!*********************************************************!*\
  !*** ./pixo/assets/isotope/js/layout-modes/fit-rows.js ***!
  \*********************************************************/
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * fitRows layout mode
	 */
	
	( function( window, factory ) {
	  'use strict';
	  // universal module definition
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(/*! ../layout-mode */ 26)
	      ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof exports == 'object' ) {
	    // CommonJS
	    module.exports = factory(
	      require('../layout-mode')
	    );
	  } else {
	    // browser global
	    factory(
	      window.Isotope.LayoutMode
	    );
	  }
	
	}( window, function factory( LayoutMode ) {
	'use strict';
	
	var FitRows = LayoutMode.create('fitRows');
	
	FitRows.prototype._resetLayout = function() {
	  this.x = 0;
	  this.y = 0;
	  this.maxY = 0;
	  this._getMeasurement( 'gutter', 'outerWidth' );
	};
	
	FitRows.prototype._getItemLayoutPosition = function( item ) {
	  item.getSize();
	
	  var itemWidth = item.size.outerWidth + this.gutter;
	  // if this element cannot fit in the current row
	  var containerWidth = this.isotope.size.innerWidth + this.gutter;
	  if ( this.x !== 0 && itemWidth + this.x > containerWidth ) {
	    this.x = 0;
	    this.y = this.maxY;
	  }
	
	  var position = {
	    x: this.x,
	    y: this.y
	  };
	
	  this.maxY = Math.max( this.maxY, this.y + item.size.outerHeight );
	  this.x += itemWidth;
	
	  return position;
	};
	
	FitRows.prototype._getContainerSize = function() {
	  return { height: this.maxY };
	};
	
	return FitRows;
	
	}));


/***/ },
/* 30 */
/*!*********************************************************!*\
  !*** ./pixo/assets/isotope/js/layout-modes/vertical.js ***!
  \*********************************************************/
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * vertical layout mode
	 */
	
	( function( window, factory ) {
	  'use strict';
	  // universal module definition
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(/*! ../layout-mode */ 26)
	      ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof exports == 'object' ) {
	    // CommonJS
	    module.exports = factory(
	      require('../layout-mode')
	    );
	  } else {
	    // browser global
	    factory(
	      window.Isotope.LayoutMode
	    );
	  }
	
	}( window, function factory( LayoutMode ) {
	'use strict';
	
	var Vertical = LayoutMode.create( 'vertical', {
	  horizontalAlignment: 0
	});
	
	Vertical.prototype._resetLayout = function() {
	  this.y = 0;
	};
	
	Vertical.prototype._getItemLayoutPosition = function( item ) {
	  item.getSize();
	  var x = ( this.isotope.size.innerWidth - item.size.outerWidth ) *
	    this.options.horizontalAlignment;
	  var y = this.y;
	  this.y += item.size.outerHeight;
	  return { x: x, y: y };
	};
	
	Vertical.prototype._getContainerSize = function() {
	  return { height: this.y };
	};
	
	return Vertical;
	
	}));


/***/ },
/* 31 */
/*!****************************************!*\
  !*** ./pixo/assets/isotope/js/item.js ***!
  \****************************************/
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Isotope Item
	**/
	
	( function( window, factory ) {
	'use strict';
	  // universal module definition
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(/*! outlayer/outlayer */ 23)
	      ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof exports == 'object' ) {
	    // CommonJS
	    module.exports = factory(
	      require('outlayer')
	    );
	  } else {
	    // browser global
	    window.Isotope = window.Isotope || {};
	    window.Isotope.Item = factory(
	      window.Outlayer
	    );
	  }
	
	}( window, function factory( Outlayer ) {
	'use strict';
	
	// -------------------------- Item -------------------------- //
	
	// sub-class Outlayer Item
	function Item() {
	  Outlayer.Item.apply( this, arguments );
	}
	
	Item.prototype = new Outlayer.Item();
	
	Item.prototype._create = function() {
	  // assign id, used for original-order sorting
	  this.id = this.layout.itemGUID++;
	  Outlayer.Item.prototype._create.call( this );
	  this.sortData = {};
	};
	
	Item.prototype.updateSortData = function() {
	  if ( this.isIgnored ) {
	    return;
	  }
	  // default sorters
	  this.sortData.id = this.id;
	  // for backward compatibility
	  this.sortData['original-order'] = this.id;
	  this.sortData.random = Math.random();
	  // go thru getSortData obj and apply the sorters
	  var getSortData = this.layout.options.getSortData;
	  var sorters = this.layout._sorters;
	  for ( var key in getSortData ) {
	    var sorter = sorters[ key ];
	    this.sortData[ key ] = sorter( this.element, this );
	  }
	};
	
	var _destroy = Item.prototype.destroy;
	Item.prototype.destroy = function() {
	  // call super
	  _destroy.apply( this, arguments );
	  // reset display, #741
	  this.css({
	    display: ''
	  });
	};
	
	return Item;
	
	}));


/***/ },
/* 32 */
/*!****************************************!*\
  !*** jquery-bridget (bower component) ***!
  \****************************************/
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(/*! ./jquery-bridget.js */ 33);

/***/ },
/* 33 */
/*!***********************************************************!*\
  !*** ./bower_components/jquery-bridget/jquery-bridget.js ***!
  \***********************************************************/
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Bridget makes jQuery widgets
	 * v2.0.0
	 * MIT license
	 */
	
	/* jshint browser: true, strict: true, undef: true, unused: true */
	
	( function( window, factory ) {
	  'use strict';
	  /* globals define: false, module: false, require: false */
	
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(/*! jquery */ 2) ], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	      factory( window, jQuery );
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory(
	      window,
	      require('jquery')
	    );
	  } else {
	    // browser global
	    window.jQueryBridget = factory(
	      window,
	      window.jQuery
	    );
	  }
	
	}( window, function factory( window, jQuery ) {
	'use strict';
	
	// ----- utils ----- //
	
	var arraySlice = Array.prototype.slice;
	
	// helper function for logging errors
	// $.error breaks jQuery chaining
	var console = window.console;
	var logError = typeof console == 'undefined' ? function() {} :
	  function( message ) {
	    console.error( message );
	  };
	
	// ----- jQueryBridget ----- //
	
	function jQueryBridget( namespace, PluginClass, $ ) {
	  $ = $ || jQuery || window.jQuery;
	  if ( !$ ) {
	    return;
	  }
	
	  // add option method -> $().plugin('option', {...})
	  if ( !PluginClass.prototype.option ) {
	    // option setter
	    PluginClass.prototype.option = function( opts ) {
	      // bail out if not an object
	      if ( !$.isPlainObject( opts ) ){
	        return;
	      }
	      this.options = $.extend( true, this.options, opts );
	    };
	  }
	
	  // make jQuery plugin
	  $.fn[ namespace ] = function( arg0 /*, arg1 */ ) {
	    if ( typeof arg0 == 'string' ) {
	      // method call $().plugin( 'methodName', { options } )
	      // shift arguments by 1
	      var args = arraySlice.call( arguments, 1 );
	      return methodCall( this, arg0, args );
	    }
	    // just $().plugin({ options })
	    plainCall( this, arg0 );
	    return this;
	  };
	
	  // $().plugin('methodName')
	  function methodCall( $elems, methodName, args ) {
	    var returnValue;
	    var pluginMethodStr = '$().' + namespace + '("' + methodName + '")';
	
	    $elems.each( function( i, elem ) {
	      // get instance
	      var instance = $.data( elem, namespace );
	      if ( !instance ) {
	        logError( namespace + ' not initialized. Cannot call methods, i.e. ' +
	          pluginMethodStr );
	        return;
	      }
	
	      var method = instance[ methodName ];
	      if ( !method || methodName.charAt(0) == '_' ) {
	        logError( pluginMethodStr + ' is not a valid method' );
	        return;
	      }
	
	      // apply method, get return value
	      var value = method.apply( instance, args );
	      // set return value if value is returned, use only first value
	      returnValue = returnValue === undefined ? value : returnValue;
	    });
	
	    return returnValue !== undefined ? returnValue : $elems;
	  }
	
	  function plainCall( $elems, options ) {
	    $elems.each( function( i, elem ) {
	      var instance = $.data( elem, namespace );
	      if ( instance ) {
	        // set options & init
	        instance.option( options );
	        instance._init();
	      } else {
	        // initialize new instance
	        instance = new PluginClass( elem, options );
	        $.data( elem, namespace, instance );
	      }
	    });
	  }
	
	  updateJQuery( $ );
	
	}
	
	// ----- updateJQuery ----- //
	
	// set $.bridget for v1 backwards compatibility
	function updateJQuery( $ ) {
	  if ( !$ || ( $ && $.bridget ) ) {
	    return;
	  }
	  $.bridget = jQueryBridget;
	}
	
	updateJQuery( jQuery || window.jQuery );
	
	// -----  ----- //
	
	return jQueryBridget;
	
	}));


/***/ },
/* 34 */
/*!*********************************!*\
  !*** fitVids (bower component) ***!
  \*********************************/
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(/*! ././jquery.fitvids.js */ 35);

/***/ },
/* 35 */
/*!****************************************************!*\
  !*** ./bower_components/fitVids/jquery.fitvids.js ***!
  \****************************************************/
/***/ function(module, exports) {

	/*jshint browser:true */
	/*!
	* FitVids 1.1
	*
	* Copyright 2013, Chris Coyier - http://css-tricks.com + Dave Rupert - http://daverupert.com
	* Credit to Thierry Koblentz - http://www.alistapart.com/articles/creating-intrinsic-ratios-for-video/
	* Released under the WTFPL license - http://sam.zoy.org/wtfpl/
	*
	*/
	
	;(function( $ ){
	
	  'use strict';
	
	  $.fn.fitVids = function( options ) {
	    var settings = {
	      customSelector: null,
	      ignore: null
	    };
	
	    if(!document.getElementById('fit-vids-style')) {
	      // appendStyles: https://github.com/toddmotto/fluidvids/blob/master/dist/fluidvids.js
	      var head = document.head || document.getElementsByTagName('head')[0];
	      var css = '.fluid-width-video-wrapper{width:100%;position:relative;padding:0;}.fluid-width-video-wrapper iframe,.fluid-width-video-wrapper object,.fluid-width-video-wrapper embed {position:absolute;top:0;left:0;width:100%;height:100%;}';
	      var div = document.createElement("div");
	      div.innerHTML = '<p>x</p><style id="fit-vids-style">' + css + '</style>';
	      head.appendChild(div.childNodes[1]);
	    }
	
	    if ( options ) {
	      $.extend( settings, options );
	    }
	
	    return this.each(function(){
	      var selectors = [
	        'iframe[src*="player.vimeo.com"]',
	        'iframe[src*="youtube.com"]',
	        'iframe[src*="youtube-nocookie.com"]',
	        'iframe[src*="kickstarter.com"][src*="video.html"]',
	        'object',
	        'embed'
	      ];
	
	      if (settings.customSelector) {
	        selectors.push(settings.customSelector);
	      }
	
	      var ignoreList = '.fitvidsignore';
	
	      if(settings.ignore) {
	        ignoreList = ignoreList + ', ' + settings.ignore;
	      }
	
	      var $allVideos = $(this).find(selectors.join(','));
	      $allVideos = $allVideos.not('object object'); // SwfObj conflict patch
	      $allVideos = $allVideos.not(ignoreList); // Disable FitVids on this video.
	
	      $allVideos.each(function(count){
	        var $this = $(this);
	        if($this.parents(ignoreList).length > 0) {
	          return; // Disable FitVids on this video.
	        }
	        if (this.tagName.toLowerCase() === 'embed' && $this.parent('object').length || $this.parent('.fluid-width-video-wrapper').length) { return; }
	        if ((!$this.css('height') && !$this.css('width')) && (isNaN($this.attr('height')) || isNaN($this.attr('width'))))
	        {
	          $this.attr('height', 9);
	          $this.attr('width', 16);
	        }
	        var height = ( this.tagName.toLowerCase() === 'object' || ($this.attr('height') && !isNaN(parseInt($this.attr('height'), 10))) ) ? parseInt($this.attr('height'), 10) : $this.height(),
	            width = !isNaN(parseInt($this.attr('width'), 10)) ? parseInt($this.attr('width'), 10) : $this.width(),
	            aspectRatio = height / width;
	        if(!$this.attr('id')){
	          var videoID = 'fitvid' + count;
	          $this.attr('id', videoID);
	        }
	        $this.wrap('<div class="fluid-width-video-wrapper"></div>').parent('.fluid-width-video-wrapper').css('padding-top', (aspectRatio * 100)+'%');
	        $this.removeAttr('height').removeAttr('width');
	      });
	    });
	  };
	// Works with either jQuery or Zepto
	})( window.jQuery || window.Zepto );


/***/ },
/* 36 */
/*!*************************************!*\
  !*** prettyphoto (bower component) ***!
  \*************************************/
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(/*! ./js/jquery.prettyPhoto.js */ 37);
	__webpack_require__(/*! ./css/prettyPhoto.css */ 38);

/***/ },
/* 37 */
/*!***************************************************************!*\
  !*** ./bower_components/prettyphoto/js/jquery.prettyPhoto.js ***!
  \***************************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ------------------------------------------------------------------------
		Class: prettyPhoto
		Use: Lightbox clone for jQuery
		Author: Stephane Caron (http://www.no-margin-for-errors.com)
		Version: 3.1.5
	------------------------------------------------------------------------- */
	(function($) {
		$.prettyPhoto = {version: '3.1.5'};
		
		$.fn.prettyPhoto = function(pp_settings) {
			pp_settings = jQuery.extend({
				hook: 'rel', /* the attribute tag to use for prettyPhoto hooks. default: 'rel'. For HTML5, use "data-rel" or similar. */
				animation_speed: 'fast', /* fast/slow/normal */
				ajaxcallback: function() {},
				slideshow: 5000, /* false OR interval time in ms */
				autoplay_slideshow: false, /* true/false */
				opacity: 0.80, /* Value between 0 and 1 */
				show_title: true, /* true/false */
				allow_resize: true, /* Resize the photos bigger than viewport. true/false */
				allow_expand: true, /* Allow the user to expand a resized image. true/false */
				default_width: 500,
				default_height: 344,
				counter_separator_label: '/', /* The separator for the gallery counter 1 "of" 2 */
				theme: 'pp_default', /* light_rounded / dark_rounded / light_square / dark_square / facebook */
				horizontal_padding: 20, /* The padding on each side of the picture */
				hideflash: false, /* Hides all the flash object on a page, set to TRUE if flash appears over prettyPhoto */
				wmode: 'opaque', /* Set the flash wmode attribute */
				autoplay: true, /* Automatically start videos: True/False */
				modal: false, /* If set to true, only the close button will close the window */
				deeplinking: true, /* Allow prettyPhoto to update the url to enable deeplinking. */
				overlay_gallery: true, /* If set to true, a gallery will overlay the fullscreen image on mouse over */
				overlay_gallery_max: 30, /* Maximum number of pictures in the overlay gallery */
				keyboard_shortcuts: true, /* Set to false if you open forms inside prettyPhoto */
				changepicturecallback: function(){}, /* Called everytime an item is shown/changed */
				callback: function(){}, /* Called when prettyPhoto is closed */
				ie6_fallback: true,
				markup: '<div class="pp_pic_holder"> \
							<div class="ppt">&nbsp;</div> \
							<div class="pp_top"> \
								<div class="pp_left"></div> \
								<div class="pp_middle"></div> \
								<div class="pp_right"></div> \
							</div> \
							<div class="pp_content_container"> \
								<div class="pp_left"> \
								<div class="pp_right"> \
									<div class="pp_content"> \
										<div class="pp_loaderIcon"></div> \
										<div class="pp_fade"> \
											<a href="#" class="pp_expand" title="Expand the image">Expand</a> \
											<div class="pp_hoverContainer"> \
												<a class="pp_next" href="#">next</a> \
												<a class="pp_previous" href="#">previous</a> \
											</div> \
											<div id="pp_full_res"></div> \
											<div class="pp_details"> \
												<div class="pp_nav"> \
													<a href="#" class="pp_arrow_previous">Previous</a> \
													<p class="currentTextHolder">0/0</p> \
													<a href="#" class="pp_arrow_next">Next</a> \
												</div> \
												<p class="pp_description"></p> \
												<div class="pp_social">{pp_social}</div> \
												<a class="pp_close" href="#">Close</a> \
											</div> \
										</div> \
									</div> \
								</div> \
								</div> \
							</div> \
							<div class="pp_bottom"> \
								<div class="pp_left"></div> \
								<div class="pp_middle"></div> \
								<div class="pp_right"></div> \
							</div> \
						</div> \
						<div class="pp_overlay"></div>',
				gallery_markup: '<div class="pp_gallery"> \
									<a href="#" class="pp_arrow_previous">Previous</a> \
									<div> \
										<ul> \
											{gallery} \
										</ul> \
									</div> \
									<a href="#" class="pp_arrow_next">Next</a> \
								</div>',
				image_markup: '<img id="fullResImage" src="{path}" />',
				flash_markup: '<object classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" width="{width}" height="{height}"><param name="wmode" value="{wmode}" /><param name="allowfullscreen" value="true" /><param name="allowscriptaccess" value="always" /><param name="movie" value="{path}" /><embed src="{path}" type="application/x-shockwave-flash" allowfullscreen="true" allowscriptaccess="always" width="{width}" height="{height}" wmode="{wmode}"></embed></object>',
				quicktime_markup: '<object classid="clsid:02BF25D5-8C17-4B23-BC80-D3488ABDDC6B" codebase="http://www.apple.com/qtactivex/qtplugin.cab" height="{height}" width="{width}"><param name="src" value="{path}"><param name="autoplay" value="{autoplay}"><param name="type" value="video/quicktime"><embed src="{path}" height="{height}" width="{width}" autoplay="{autoplay}" type="video/quicktime" pluginspage="http://www.apple.com/quicktime/download/"></embed></object>',
				iframe_markup: '<iframe src ="{path}" width="{width}" height="{height}" frameborder="no"></iframe>',
				inline_markup: '<div class="pp_inline">{content}</div>',
				custom_markup: '',
				social_tools: '<div class="twitter"><a href="http://twitter.com/share" class="twitter-share-button" data-count="none">Tweet</a><script type="text/javascript" src="http://platform.twitter.com/widgets.js"></script></div><div class="facebook"><iframe src="//www.facebook.com/plugins/like.php?locale=en_US&href={location_href}&amp;layout=button_count&amp;show_faces=true&amp;width=500&amp;action=like&amp;font&amp;colorscheme=light&amp;height=23" scrolling="no" frameborder="0" style="border:none; overflow:hidden; width:500px; height:23px;" allowTransparency="true"></iframe></div>' /* html or false to disable */
			}, pp_settings);
			
			// Global variables accessible only by prettyPhoto
			var matchedObjects = this, percentBased = false, pp_dimensions, pp_open,
			
			// prettyPhoto container specific
			pp_contentHeight, pp_contentWidth, pp_containerHeight, pp_containerWidth,
			
			// Window size
			windowHeight = $(window).height(), windowWidth = $(window).width(),
	
			// Global elements
			pp_slideshow;
			
			doresize = true, scroll_pos = _get_scroll();
		
			// Window/Keyboard events
			$(window).unbind('resize.prettyphoto').bind('resize.prettyphoto',function(){ _center_overlay(); _resize_overlay(); });
			
			if(pp_settings.keyboard_shortcuts) {
				$(document).unbind('keydown.prettyphoto').bind('keydown.prettyphoto',function(e){
					if(typeof $pp_pic_holder != 'undefined'){
						if($pp_pic_holder.is(':visible')){
							switch(e.keyCode){
								case 37:
									$.prettyPhoto.changePage('previous');
									e.preventDefault();
									break;
								case 39:
									$.prettyPhoto.changePage('next');
									e.preventDefault();
									break;
								case 27:
									if(!settings.modal)
									$.prettyPhoto.close();
									e.preventDefault();
									break;
							};
							// return false;
						};
					};
				});
			};
			
			/**
			* Initialize prettyPhoto.
			*/
			$.prettyPhoto.initialize = function() {
				
				settings = pp_settings;
				
				if(settings.theme == 'pp_default') settings.horizontal_padding = 16;
				
				// Find out if the picture is part of a set
				theRel = $(this).attr(settings.hook);
				galleryRegExp = /\[(?:.*)\]/;
				isSet = (galleryRegExp.exec(theRel)) ? true : false;
				
				// Put the SRCs, TITLEs, ALTs into an array.
				pp_images = (isSet) ? jQuery.map(matchedObjects, function(n, i){ if($(n).attr(settings.hook).indexOf(theRel) != -1) return $(n).attr('href'); }) : $.makeArray($(this).attr('href'));
				pp_titles = (isSet) ? jQuery.map(matchedObjects, function(n, i){ if($(n).attr(settings.hook).indexOf(theRel) != -1) return ($(n).find('img').attr('alt')) ? $(n).find('img').attr('alt') : ""; }) : $.makeArray($(this).find('img').attr('alt'));
				pp_descriptions = (isSet) ? jQuery.map(matchedObjects, function(n, i){ if($(n).attr(settings.hook).indexOf(theRel) != -1) return ($(n).attr('title')) ? $(n).attr('title') : ""; }) : $.makeArray($(this).attr('title'));
				
				if(pp_images.length > settings.overlay_gallery_max) settings.overlay_gallery = false;
				
				set_position = jQuery.inArray($(this).attr('href'), pp_images); // Define where in the array the clicked item is positionned
				rel_index = (isSet) ? set_position : $("a["+settings.hook+"^='"+theRel+"']").index($(this));
				
				_build_overlay(this); // Build the overlay {this} being the caller
				
				if(settings.allow_resize)
					$(window).bind('scroll.prettyphoto',function(){ _center_overlay(); });
				
				
				$.prettyPhoto.open();
				
				return false;
			}
	
	
			/**
			* Opens the prettyPhoto modal box.
			* @param image {String,Array} Full path to the image to be open, can also be an array containing full images paths.
			* @param title {String,Array} The title to be displayed with the picture, can also be an array containing all the titles.
			* @param description {String,Array} The description to be displayed with the picture, can also be an array containing all the descriptions.
			*/
			$.prettyPhoto.open = function(event) {
				if(typeof settings == "undefined"){ // Means it's an API call, need to manually get the settings and set the variables
					settings = pp_settings;
					pp_images = $.makeArray(arguments[0]);
					pp_titles = (arguments[1]) ? $.makeArray(arguments[1]) : $.makeArray("");
					pp_descriptions = (arguments[2]) ? $.makeArray(arguments[2]) : $.makeArray("");
					isSet = (pp_images.length > 1) ? true : false;
					set_position = (arguments[3])? arguments[3]: 0;
					_build_overlay(event.target); // Build the overlay {this} being the caller
				}
				
				if(settings.hideflash) $('object,embed,iframe[src*=youtube],iframe[src*=vimeo]').css('visibility','hidden'); // Hide the flash
	
				_checkPosition($(pp_images).size()); // Hide the next/previous links if on first or last images.
			
				$('.pp_loaderIcon').show();
			
				if(settings.deeplinking)
					setHashtag();
			
				// Rebuild Facebook Like Button with updated href
				if(settings.social_tools){
					facebook_like_link = settings.social_tools.replace('{location_href}', encodeURIComponent(location.href)); 
					$pp_pic_holder.find('.pp_social').html(facebook_like_link);
				}
				
				// Fade the content in
				if($ppt.is(':hidden')) $ppt.css('opacity',0).show();
				$pp_overlay.show().fadeTo(settings.animation_speed,settings.opacity);
	
				// Display the current position
				$pp_pic_holder.find('.currentTextHolder').text((set_position+1) + settings.counter_separator_label + $(pp_images).size());
	
				// Set the description
				if(typeof pp_descriptions[set_position] != 'undefined' && pp_descriptions[set_position] != ""){
					$pp_pic_holder.find('.pp_description').show().html(unescape(pp_descriptions[set_position]));
				}else{
					$pp_pic_holder.find('.pp_description').hide();
				}
				
				// Get the dimensions
				movie_width = ( parseFloat(getParam('width',pp_images[set_position])) ) ? getParam('width',pp_images[set_position]) : settings.default_width.toString();
				movie_height = ( parseFloat(getParam('height',pp_images[set_position])) ) ? getParam('height',pp_images[set_position]) : settings.default_height.toString();
				
				// If the size is % based, calculate according to window dimensions
				percentBased=false;
				if(movie_height.indexOf('%') != -1) { movie_height = parseFloat(($(window).height() * parseFloat(movie_height) / 100) - 150); percentBased = true; }
				if(movie_width.indexOf('%') != -1) { movie_width = parseFloat(($(window).width() * parseFloat(movie_width) / 100) - 150); percentBased = true; }
				
				// Fade the holder
				$pp_pic_holder.fadeIn(function(){
					// Set the title
					(settings.show_title && pp_titles[set_position] != "" && typeof pp_titles[set_position] != "undefined") ? $ppt.html(unescape(pp_titles[set_position])) : $ppt.html('&nbsp;');
					
					imgPreloader = "";
					skipInjection = false;
					
					// Inject the proper content
					switch(_getFileType(pp_images[set_position])){
						case 'image':
							imgPreloader = new Image();
	
							// Preload the neighbour images
							nextImage = new Image();
							if(isSet && set_position < $(pp_images).size() -1) nextImage.src = pp_images[set_position + 1];
							prevImage = new Image();
							if(isSet && pp_images[set_position - 1]) prevImage.src = pp_images[set_position - 1];
	
							$pp_pic_holder.find('#pp_full_res')[0].innerHTML = settings.image_markup.replace(/{path}/g,pp_images[set_position]);
	
							imgPreloader.onload = function(){
								// Fit item to viewport
								pp_dimensions = _fitToViewport(imgPreloader.width,imgPreloader.height);
	
								_showContent();
							};
	
							imgPreloader.onerror = function(){
								alert('Image cannot be loaded. Make sure the path is correct and image exist.');
								$.prettyPhoto.close();
							};
						
							imgPreloader.src = pp_images[set_position];
						break;
					
						case 'youtube':
							pp_dimensions = _fitToViewport(movie_width,movie_height); // Fit item to viewport
							
							// Regular youtube link
							movie_id = getParam('v',pp_images[set_position]);
							
							// youtu.be link
							if(movie_id == ""){
								movie_id = pp_images[set_position].split('youtu.be/');
								movie_id = movie_id[1];
								if(movie_id.indexOf('?') > 0)
									movie_id = movie_id.substr(0,movie_id.indexOf('?')); // Strip anything after the ?
	
								if(movie_id.indexOf('&') > 0)
									movie_id = movie_id.substr(0,movie_id.indexOf('&')); // Strip anything after the &
							}
	
							movie = 'http://www.youtube.com/embed/'+movie_id;
							(getParam('rel',pp_images[set_position])) ? movie+="?rel="+getParam('rel',pp_images[set_position]) : movie+="?rel=1";
								
							if(settings.autoplay) movie += "&autoplay=1";
						
							toInject = settings.iframe_markup.replace(/{width}/g,pp_dimensions['width']).replace(/{height}/g,pp_dimensions['height']).replace(/{wmode}/g,settings.wmode).replace(/{path}/g,movie);
						break;
					
						case 'vimeo':
							pp_dimensions = _fitToViewport(movie_width,movie_height); // Fit item to viewport
						
							movie_id = pp_images[set_position];
							var regExp = /http(s?):\/\/(www\.)?vimeo.com\/(\d+)/;
							var match = movie_id.match(regExp);
							
							movie = 'http://player.vimeo.com/video/'+ match[3] +'?title=0&amp;byline=0&amp;portrait=0';
							if(settings.autoplay) movie += "&autoplay=1;";
					
							vimeo_width = pp_dimensions['width'] + '/embed/?moog_width='+ pp_dimensions['width'];
					
							toInject = settings.iframe_markup.replace(/{width}/g,vimeo_width).replace(/{height}/g,pp_dimensions['height']).replace(/{path}/g,movie);
						break;
					
						case 'quicktime':
							pp_dimensions = _fitToViewport(movie_width,movie_height); // Fit item to viewport
							pp_dimensions['height']+=15; pp_dimensions['contentHeight']+=15; pp_dimensions['containerHeight']+=15; // Add space for the control bar
					
							toInject = settings.quicktime_markup.replace(/{width}/g,pp_dimensions['width']).replace(/{height}/g,pp_dimensions['height']).replace(/{wmode}/g,settings.wmode).replace(/{path}/g,pp_images[set_position]).replace(/{autoplay}/g,settings.autoplay);
						break;
					
						case 'flash':
							pp_dimensions = _fitToViewport(movie_width,movie_height); // Fit item to viewport
						
							flash_vars = pp_images[set_position];
							flash_vars = flash_vars.substring(pp_images[set_position].indexOf('flashvars') + 10,pp_images[set_position].length);
	
							filename = pp_images[set_position];
							filename = filename.substring(0,filename.indexOf('?'));
						
							toInject =  settings.flash_markup.replace(/{width}/g,pp_dimensions['width']).replace(/{height}/g,pp_dimensions['height']).replace(/{wmode}/g,settings.wmode).replace(/{path}/g,filename+'?'+flash_vars);
						break;
					
						case 'iframe':
							pp_dimensions = _fitToViewport(movie_width,movie_height); // Fit item to viewport
					
							frame_url = pp_images[set_position];
							frame_url = frame_url.substr(0,frame_url.indexOf('iframe')-1);
	
							toInject = settings.iframe_markup.replace(/{width}/g,pp_dimensions['width']).replace(/{height}/g,pp_dimensions['height']).replace(/{path}/g,frame_url);
						break;
						
						case 'ajax':
							doresize = false; // Make sure the dimensions are not resized.
							pp_dimensions = _fitToViewport(movie_width,movie_height);
							doresize = true; // Reset the dimensions
						
							skipInjection = true;
							$.get(pp_images[set_position],function(responseHTML){
								toInject = settings.inline_markup.replace(/{content}/g,responseHTML);
								$pp_pic_holder.find('#pp_full_res')[0].innerHTML = toInject;
								_showContent();
							});
							
						break;
						
						case 'custom':
							pp_dimensions = _fitToViewport(movie_width,movie_height); // Fit item to viewport
						
							toInject = settings.custom_markup;
						break;
					
						case 'inline':
							// to get the item height clone it, apply default width, wrap it in the prettyPhoto containers , then delete
							myClone = $(pp_images[set_position]).clone().append('<br clear="all" />').css({'width':settings.default_width}).wrapInner('<div id="pp_full_res"><div class="pp_inline"></div></div>').appendTo($('body')).show();
							doresize = false; // Make sure the dimensions are not resized.
							pp_dimensions = _fitToViewport($(myClone).width(),$(myClone).height());
							doresize = true; // Reset the dimensions
							$(myClone).remove();
							toInject = settings.inline_markup.replace(/{content}/g,$(pp_images[set_position]).html());
						break;
					};
	
					if(!imgPreloader && !skipInjection){
						$pp_pic_holder.find('#pp_full_res')[0].innerHTML = toInject;
					
						// Show content
						_showContent();
					};
				});
	
				return false;
			};
	
		
			/**
			* Change page in the prettyPhoto modal box
			* @param direction {String} Direction of the paging, previous or next.
			*/
			$.prettyPhoto.changePage = function(direction){
				currentGalleryPage = 0;
				
				if(direction == 'previous') {
					set_position--;
					if (set_position < 0) set_position = $(pp_images).size()-1;
				}else if(direction == 'next'){
					set_position++;
					if(set_position > $(pp_images).size()-1) set_position = 0;
				}else{
					set_position=direction;
				};
				
				rel_index = set_position;
	
				if(!doresize) doresize = true; // Allow the resizing of the images
				if(settings.allow_expand) {
					$('.pp_contract').removeClass('pp_contract').addClass('pp_expand');
				}
	
				_hideContent(function(){ $.prettyPhoto.open(); });
			};
	
	
			/**
			* Change gallery page in the prettyPhoto modal box
			* @param direction {String} Direction of the paging, previous or next.
			*/
			$.prettyPhoto.changeGalleryPage = function(direction){
				if(direction=='next'){
					currentGalleryPage ++;
	
					if(currentGalleryPage > totalPage) currentGalleryPage = 0;
				}else if(direction=='previous'){
					currentGalleryPage --;
	
					if(currentGalleryPage < 0) currentGalleryPage = totalPage;
				}else{
					currentGalleryPage = direction;
				};
				
				slide_speed = (direction == 'next' || direction == 'previous') ? settings.animation_speed : 0;
	
				slide_to = currentGalleryPage * (itemsPerPage * itemWidth);
	
				$pp_gallery.find('ul').animate({left:-slide_to},slide_speed);
			};
	
	
			/**
			* Start the slideshow...
			*/
			$.prettyPhoto.startSlideshow = function(){
				if(typeof pp_slideshow == 'undefined'){
					$pp_pic_holder.find('.pp_play').unbind('click').removeClass('pp_play').addClass('pp_pause').click(function(){
						$.prettyPhoto.stopSlideshow();
						return false;
					});
					pp_slideshow = setInterval($.prettyPhoto.startSlideshow,settings.slideshow);
				}else{
					$.prettyPhoto.changePage('next');	
				};
			}
	
	
			/**
			* Stop the slideshow...
			*/
			$.prettyPhoto.stopSlideshow = function(){
				$pp_pic_holder.find('.pp_pause').unbind('click').removeClass('pp_pause').addClass('pp_play').click(function(){
					$.prettyPhoto.startSlideshow();
					return false;
				});
				clearInterval(pp_slideshow);
				pp_slideshow=undefined;
			}
	
	
			/**
			* Closes prettyPhoto.
			*/
			$.prettyPhoto.close = function(){
				if($pp_overlay.is(":animated")) return;
				
				$.prettyPhoto.stopSlideshow();
				
				$pp_pic_holder.stop().find('object,embed').css('visibility','hidden');
				
				$('div.pp_pic_holder,div.ppt,.pp_fade').fadeOut(settings.animation_speed,function(){ $(this).remove(); });
				
				$pp_overlay.fadeOut(settings.animation_speed, function(){
					
					if(settings.hideflash) $('object,embed,iframe[src*=youtube],iframe[src*=vimeo]').css('visibility','visible'); // Show the flash
					
					$(this).remove(); // No more need for the prettyPhoto markup
					
					$(window).unbind('scroll.prettyphoto');
					
					clearHashtag();
					
					settings.callback();
					
					doresize = true;
					
					pp_open = false;
					
					delete settings;
				});
			};
		
			/**
			* Set the proper sizes on the containers and animate the content in.
			*/
			function _showContent(){
				$('.pp_loaderIcon').hide();
	
				// Calculate the opened top position of the pic holder
				projectedTop = scroll_pos['scrollTop'] + ((windowHeight/2) - (pp_dimensions['containerHeight']/2));
				if(projectedTop < 0) projectedTop = 0;
	
				$ppt.fadeTo(settings.animation_speed,1);
	
				// Resize the content holder
				$pp_pic_holder.find('.pp_content')
					.animate({
						height:pp_dimensions['contentHeight'],
						width:pp_dimensions['contentWidth']
					},settings.animation_speed);
				
				// Resize picture the holder
				$pp_pic_holder.animate({
					'top': projectedTop,
					'left': ((windowWidth/2) - (pp_dimensions['containerWidth']/2) < 0) ? 0 : (windowWidth/2) - (pp_dimensions['containerWidth']/2),
					width:pp_dimensions['containerWidth']
				},settings.animation_speed,function(){
					$pp_pic_holder.find('.pp_hoverContainer,#fullResImage').height(pp_dimensions['height']).width(pp_dimensions['width']);
	
					$pp_pic_holder.find('.pp_fade').fadeIn(settings.animation_speed); // Fade the new content
	
					// Show the nav
					if(isSet && _getFileType(pp_images[set_position])=="image") { $pp_pic_holder.find('.pp_hoverContainer').show(); }else{ $pp_pic_holder.find('.pp_hoverContainer').hide(); }
				
					if(settings.allow_expand) {
						if(pp_dimensions['resized']){ // Fade the resizing link if the image is resized
							$('a.pp_expand,a.pp_contract').show();
						}else{
							$('a.pp_expand').hide();
						}
					}
					
					if(settings.autoplay_slideshow && !pp_slideshow && !pp_open) $.prettyPhoto.startSlideshow();
					
					settings.changepicturecallback(); // Callback!
					
					pp_open = true;
				});
				
				_insert_gallery();
				pp_settings.ajaxcallback();
			};
			
			/**
			* Hide the content...DUH!
			*/
			function _hideContent(callback){
				// Fade out the current picture
				$pp_pic_holder.find('#pp_full_res object,#pp_full_res embed').css('visibility','hidden');
				$pp_pic_holder.find('.pp_fade').fadeOut(settings.animation_speed,function(){
					$('.pp_loaderIcon').show();
					
					callback();
				});
			};
		
			/**
			* Check the item position in the gallery array, hide or show the navigation links
			* @param setCount {integer} The total number of items in the set
			*/
			function _checkPosition(setCount){
				(setCount > 1) ? $('.pp_nav').show() : $('.pp_nav').hide(); // Hide the bottom nav if it's not a set.
			};
		
			/**
			* Resize the item dimensions if it's bigger than the viewport
			* @param width {integer} Width of the item to be opened
			* @param height {integer} Height of the item to be opened
			* @return An array containin the "fitted" dimensions
			*/
			function _fitToViewport(width,height){
				resized = false;
	
				_getDimensions(width,height);
				
				// Define them in case there's no resize needed
				imageWidth = width, imageHeight = height;
	
				if( ((pp_containerWidth > windowWidth) || (pp_containerHeight > windowHeight)) && doresize && settings.allow_resize && !percentBased) {
					resized = true, fitting = false;
				
					while (!fitting){
						if((pp_containerWidth > windowWidth)){
							imageWidth = (windowWidth - 200);
							imageHeight = (height/width) * imageWidth;
						}else if((pp_containerHeight > windowHeight)){
							imageHeight = (windowHeight - 200);
							imageWidth = (width/height) * imageHeight;
						}else{
							fitting = true;
						};
	
						pp_containerHeight = imageHeight, pp_containerWidth = imageWidth;
					};
				
	
					
					if((pp_containerWidth > windowWidth) || (pp_containerHeight > windowHeight)){
						_fitToViewport(pp_containerWidth,pp_containerHeight)
					};
					
					_getDimensions(imageWidth,imageHeight);
				};
				
				return {
					width:Math.floor(imageWidth),
					height:Math.floor(imageHeight),
					containerHeight:Math.floor(pp_containerHeight),
					containerWidth:Math.floor(pp_containerWidth) + (settings.horizontal_padding * 2),
					contentHeight:Math.floor(pp_contentHeight),
					contentWidth:Math.floor(pp_contentWidth),
					resized:resized
				};
			};
			
			/**
			* Get the containers dimensions according to the item size
			* @param width {integer} Width of the item to be opened
			* @param height {integer} Height of the item to be opened
			*/
			function _getDimensions(width,height){
				width = parseFloat(width);
				height = parseFloat(height);
				
				// Get the details height, to do so, I need to clone it since it's invisible
				$pp_details = $pp_pic_holder.find('.pp_details');
				$pp_details.width(width);
				detailsHeight = parseFloat($pp_details.css('marginTop')) + parseFloat($pp_details.css('marginBottom'));
				
				$pp_details = $pp_details.clone().addClass(settings.theme).width(width).appendTo($('body')).css({
					'position':'absolute',
					'top':-10000
				});
				detailsHeight += $pp_details.height();
				detailsHeight = (detailsHeight <= 34) ? 36 : detailsHeight; // Min-height for the details
				$pp_details.remove();
				
				// Get the titles height, to do so, I need to clone it since it's invisible
				$pp_title = $pp_pic_holder.find('.ppt');
				$pp_title.width(width);
				titleHeight = parseFloat($pp_title.css('marginTop')) + parseFloat($pp_title.css('marginBottom'));
				$pp_title = $pp_title.clone().appendTo($('body')).css({
					'position':'absolute',
					'top':-10000
				});
				titleHeight += $pp_title.height();
				$pp_title.remove();
				
				// Get the container size, to resize the holder to the right dimensions
				pp_contentHeight = height + detailsHeight;
				pp_contentWidth = width;
				pp_containerHeight = pp_contentHeight + titleHeight + $pp_pic_holder.find('.pp_top').height() + $pp_pic_holder.find('.pp_bottom').height();
				pp_containerWidth = width;
			}
		
			function _getFileType(itemSrc){
				if (itemSrc.match(/youtube\.com\/watch/i) || itemSrc.match(/youtu\.be/i)) {
					return 'youtube';
				}else if (itemSrc.match(/vimeo\.com/i)) {
					return 'vimeo';
				}else if(itemSrc.match(/\b.mov\b/i)){ 
					return 'quicktime';
				}else if(itemSrc.match(/\b.swf\b/i)){
					return 'flash';
				}else if(itemSrc.match(/\biframe=true\b/i)){
					return 'iframe';
				}else if(itemSrc.match(/\bajax=true\b/i)){
					return 'ajax';
				}else if(itemSrc.match(/\bcustom=true\b/i)){
					return 'custom';
				}else if(itemSrc.substr(0,1) == '#'){
					return 'inline';
				}else{
					return 'image';
				};
			};
		
			function _center_overlay(){
				if(doresize && typeof $pp_pic_holder != 'undefined') {
					scroll_pos = _get_scroll();
					contentHeight = $pp_pic_holder.height(), contentwidth = $pp_pic_holder.width();
	
					projectedTop = (windowHeight/2) + scroll_pos['scrollTop'] - (contentHeight/2);
					if(projectedTop < 0) projectedTop = 0;
					
					if(contentHeight > windowHeight)
						return;
	
					$pp_pic_holder.css({
						'top': projectedTop,
						'left': (windowWidth/2) + scroll_pos['scrollLeft'] - (contentwidth/2)
					});
				};
			};
		
			function _get_scroll(){
				if (self.pageYOffset) {
					return {scrollTop:self.pageYOffset,scrollLeft:self.pageXOffset};
				} else if (document.documentElement && document.documentElement.scrollTop) { // Explorer 6 Strict
					return {scrollTop:document.documentElement.scrollTop,scrollLeft:document.documentElement.scrollLeft};
				} else if (document.body) {// all other Explorers
					return {scrollTop:document.body.scrollTop,scrollLeft:document.body.scrollLeft};
				};
			};
		
			function _resize_overlay() {
				windowHeight = $(window).height(), windowWidth = $(window).width();
				
				if(typeof $pp_overlay != "undefined") $pp_overlay.height($(document).height()).width(windowWidth);
			};
		
			function _insert_gallery(){
				if(isSet && settings.overlay_gallery && _getFileType(pp_images[set_position])=="image") {
					itemWidth = 52+5; // 52 beign the thumb width, 5 being the right margin.
					navWidth = (settings.theme == "facebook" || settings.theme == "pp_default") ? 50 : 30; // Define the arrow width depending on the theme
					
					itemsPerPage = Math.floor((pp_dimensions['containerWidth'] - 100 - navWidth) / itemWidth);
					itemsPerPage = (itemsPerPage < pp_images.length) ? itemsPerPage : pp_images.length;
					totalPage = Math.ceil(pp_images.length / itemsPerPage) - 1;
	
					// Hide the nav in the case there's no need for links
					if(totalPage == 0){
						navWidth = 0; // No nav means no width!
						$pp_gallery.find('.pp_arrow_next,.pp_arrow_previous').hide();
					}else{
						$pp_gallery.find('.pp_arrow_next,.pp_arrow_previous').show();
					};
	
					galleryWidth = itemsPerPage * itemWidth;
					fullGalleryWidth = pp_images.length * itemWidth;
					
					// Set the proper width to the gallery items
					$pp_gallery
						.css('margin-left',-((galleryWidth/2) + (navWidth/2)))
						.find('div:first').width(galleryWidth+5)
						.find('ul').width(fullGalleryWidth)
						.find('li.selected').removeClass('selected');
					
					goToPage = (Math.floor(set_position/itemsPerPage) < totalPage) ? Math.floor(set_position/itemsPerPage) : totalPage;
	
					$.prettyPhoto.changeGalleryPage(goToPage);
					
					$pp_gallery_li.filter(':eq('+set_position+')').addClass('selected');
				}else{
					$pp_pic_holder.find('.pp_content').unbind('mouseenter mouseleave');
					// $pp_gallery.hide();
				}
			}
		
			function _build_overlay(caller){
				// Inject Social Tool markup into General markup
				if(settings.social_tools)
					facebook_like_link = settings.social_tools.replace('{location_href}', encodeURIComponent(location.href)); 
	
				settings.markup = settings.markup.replace('{pp_social}',''); 
				
				$('body').append(settings.markup); // Inject the markup
				
				$pp_pic_holder = $('.pp_pic_holder') , $ppt = $('.ppt'), $pp_overlay = $('div.pp_overlay'); // Set my global selectors
				
				// Inject the inline gallery!
				if(isSet && settings.overlay_gallery) {
					currentGalleryPage = 0;
					toInject = "";
					for (var i=0; i < pp_images.length; i++) {
						if(!pp_images[i].match(/\b(jpg|jpeg|png|gif)\b/gi)){
							classname = 'default';
							img_src = '';
						}else{
							classname = '';
							img_src = pp_images[i];
						}
						toInject += "<li class='"+classname+"'><a href='#'><img src='" + img_src + "' width='50' alt='' /></a></li>";
					};
					
					toInject = settings.gallery_markup.replace(/{gallery}/g,toInject);
					
					$pp_pic_holder.find('#pp_full_res').after(toInject);
					
					$pp_gallery = $('.pp_pic_holder .pp_gallery'), $pp_gallery_li = $pp_gallery.find('li'); // Set the gallery selectors
					
					$pp_gallery.find('.pp_arrow_next').click(function(){
						$.prettyPhoto.changeGalleryPage('next');
						$.prettyPhoto.stopSlideshow();
						return false;
					});
					
					$pp_gallery.find('.pp_arrow_previous').click(function(){
						$.prettyPhoto.changeGalleryPage('previous');
						$.prettyPhoto.stopSlideshow();
						return false;
					});
					
					$pp_pic_holder.find('.pp_content').hover(
						function(){
							$pp_pic_holder.find('.pp_gallery:not(.disabled)').fadeIn();
						},
						function(){
							$pp_pic_holder.find('.pp_gallery:not(.disabled)').fadeOut();
						});
	
					itemWidth = 52+5; // 52 beign the thumb width, 5 being the right margin.
					$pp_gallery_li.each(function(i){
						$(this)
							.find('a')
							.click(function(){
								$.prettyPhoto.changePage(i);
								$.prettyPhoto.stopSlideshow();
								return false;
							});
					});
				};
				
				
				// Inject the play/pause if it's a slideshow
				if(settings.slideshow){
					$pp_pic_holder.find('.pp_nav').prepend('<a href="#" class="pp_play">Play</a>')
					$pp_pic_holder.find('.pp_nav .pp_play').click(function(){
						$.prettyPhoto.startSlideshow();
						return false;
					});
				}
				
				$pp_pic_holder.attr('class','pp_pic_holder ' + settings.theme); // Set the proper theme
				
				$pp_overlay
					.css({
						'opacity':0,
						'height':$(document).height(),
						'width':$(window).width()
						})
					.bind('click',function(){
						if(!settings.modal) $.prettyPhoto.close();
					});
	
				$('a.pp_close').bind('click',function(){ $.prettyPhoto.close(); return false; });
	
	
				if(settings.allow_expand) {
					$('a.pp_expand').bind('click',function(e){
						// Expand the image
						if($(this).hasClass('pp_expand')){
							$(this).removeClass('pp_expand').addClass('pp_contract');
							doresize = false;
						}else{
							$(this).removeClass('pp_contract').addClass('pp_expand');
							doresize = true;
						};
					
						_hideContent(function(){ $.prettyPhoto.open(); });
				
						return false;
					});
				}
			
				$pp_pic_holder.find('.pp_previous, .pp_nav .pp_arrow_previous').bind('click',function(){
					$.prettyPhoto.changePage('previous');
					$.prettyPhoto.stopSlideshow();
					return false;
				});
			
				$pp_pic_holder.find('.pp_next, .pp_nav .pp_arrow_next').bind('click',function(){
					$.prettyPhoto.changePage('next');
					$.prettyPhoto.stopSlideshow();
					return false;
				});
				
				_center_overlay(); // Center it
			};
	
			if(!pp_alreadyInitialized && getHashtag()){
				pp_alreadyInitialized = true;
				
				// Grab the rel index to trigger the click on the correct element
				hashIndex = getHashtag();
				hashRel = hashIndex;
				hashIndex = hashIndex.substring(hashIndex.indexOf('/')+1,hashIndex.length-1);
				hashRel = hashRel.substring(0,hashRel.indexOf('/'));
	
				// Little timeout to make sure all the prettyPhoto initialize scripts has been run.
				// Useful in the event the page contain several init scripts.
				setTimeout(function(){ $("a["+pp_settings.hook+"^='"+hashRel+"']:eq("+hashIndex+")").trigger('click'); },50);
			}
			
			return this.unbind('click.prettyphoto').bind('click.prettyphoto',$.prettyPhoto.initialize); // Return the jQuery object for chaining. The unbind method is used to avoid click conflict when the plugin is called more than once
		};
		
		function getHashtag(){
			var url = location.href;
			hashtag = (url.indexOf('#prettyPhoto') !== -1) ? decodeURI(url.substring(url.indexOf('#prettyPhoto')+1,url.length)) : false;
	
			return hashtag;
		};
		
		function setHashtag(){
			if(typeof theRel == 'undefined') return; // theRel is set on normal calls, it's impossible to deeplink using the API
			location.hash = theRel + '/'+rel_index+'/';
		};
		
		function clearHashtag(){
			if ( location.href.indexOf('#prettyPhoto') !== -1 ) location.hash = "prettyPhoto";
		}
		
		function getParam(name,url){
		  name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
		  var regexS = "[\\?&]"+name+"=([^&#]*)";
		  var regex = new RegExp( regexS );
		  var results = regex.exec( url );
		  return ( results == null ) ? "" : results[1];
		}
		
	})(jQuery);
	
	var pp_alreadyInitialized = false; // Used for the deep linking to make sure not to call the same function several times.
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 2)))

/***/ },
/* 38 */
/*!**********************************************************!*\
  !*** ./bower_components/prettyphoto/css/prettyPhoto.css ***!
  \**********************************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../~/css-loader!./prettyPhoto.css */ 39);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../~/style-loader/addStyles.js */ 43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./prettyPhoto.css", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./prettyPhoto.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 39 */
/*!*************************************************************************!*\
  !*** ./~/css-loader!./bower_components/prettyphoto/css/prettyPhoto.css ***!
  \*************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(/*! ./../../../~/css-loader/lib/css-base.js */ 40)();
	// imports
	
	
	// module
	exports.push([module.id, "div.pp_default .pp_bottom,div.pp_default .pp_bottom .pp_left,div.pp_default .pp_bottom .pp_middle,div.pp_default .pp_bottom .pp_right,div.pp_default .pp_top,div.pp_default .pp_top .pp_left,div.pp_default .pp_top .pp_middle,div.pp_default .pp_top .pp_right{height:13px}div.pp_default .pp_top .pp_left{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/default/sprite.png */ 41) + ") -78px -93px no-repeat}div.pp_default .pp_top .pp_middle{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/default/sprite_x.png */ 44) + ") 0 0 repeat-x}div.pp_default .pp_top .pp_right{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/default/sprite.png */ 41) + ") -112px -93px no-repeat}div.pp_default .pp_content .ppt{color:#f8f8f8}div.pp_default .pp_content_container .pp_left{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/default/sprite_y.png */ 46) + ") -7px 0 repeat-y;padding-left:13px}div.pp_default .pp_content_container .pp_right{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/default/sprite_y.png */ 46) + ") 100% 0 repeat-y;padding-right:13px}div.pp_default .pp_content{background-color:#fff}div.pp_default .pp_next:hover{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/default/sprite_next.png */ 48) + ") 100% no-repeat;cursor:pointer}div.pp_default .pp_previous:hover{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/default/sprite_prev.png */ 50) + ") 0 no-repeat;cursor:pointer}div.pp_default .pp_expand{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/default/sprite.png */ 41) + ") 0 -29px no-repeat;cursor:pointer;width:28px;height:28px}div.pp_default .pp_expand:hover{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/default/sprite.png */ 41) + ") 0 -56px no-repeat;cursor:pointer}div.pp_default .pp_contract{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/default/sprite.png */ 41) + ") 0 -84px no-repeat;cursor:pointer;width:28px;height:28px}div.pp_default .pp_contract:hover{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/default/sprite.png */ 41) + ") 0 -113px no-repeat;cursor:pointer}div.pp_default .pp_close{width:30px;height:30px;background:url(" + __webpack_require__(/*! ../images/prettyPhoto/default/sprite.png */ 41) + ") 2px 1px no-repeat;cursor:pointer}div.pp_default #pp_full_res .pp_inline{color:#000}div.pp_default .pp_gallery ul li a{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/default/default_thumb.png */ 52) + ") 50% #f8f8f8;border:1px solid #aaa}div.pp_default .pp_gallery ul li.selected a,div.pp_default .pp_gallery ul li a:hover{border-color:#fff}div.pp_default .pp_social{margin-top:7px}div.pp_default .pp_gallery a.pp_arrow_next,div.pp_default .pp_gallery a.pp_arrow_previous{position:static;left:auto}div.pp_default .pp_nav .pp_pause,div.pp_default .pp_nav .pp_play{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/default/sprite.png */ 41) + ") -51px 1px no-repeat;height:30px;width:30px}div.pp_default .pp_nav .pp_pause{background-position:-51px -29px}div.pp_default .pp_details{position:relative}div.pp_default a.pp_arrow_next,div.pp_default a.pp_arrow_previous{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/default/sprite.png */ 41) + ") -31px -3px no-repeat;height:20px;margin:4px 0 0;width:20px}div.pp_default a.pp_arrow_next{left:52px;background-position:-82px -3px}div.pp_default .pp_content_container .pp_details{margin-top:5px}div.pp_default .pp_nav{clear:none;height:30px;width:110px;position:relative}div.pp_default .pp_nav .currentTextHolder{font-family:Georgia;font-style:italic;color:#999;font-size:11px;left:75px;line-height:25px;margin:0;padding:0 0 0 10px;position:absolute;top:2px}div.pp_default .pp_arrow_next:hover,div.pp_default .pp_arrow_previous:hover,div.pp_default .pp_close:hover,div.pp_default .pp_nav .pp_pause:hover,div.pp_default .pp_nav .pp_play:hover{opacity:.7}div.pp_default .pp_description{font-size:11px;font-weight:700;line-height:14px;margin:5px 50px 5px 0}div.pp_default .pp_bottom .pp_left{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/default/sprite.png */ 41) + ") -78px -127px no-repeat}div.pp_default .pp_bottom .pp_middle{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/default/sprite_x.png */ 44) + ") 0 100% repeat-x}div.pp_default .pp_bottom .pp_right{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/default/sprite.png */ 41) + ") -112px -127px no-repeat}div.pp_default .pp_loaderIcon{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/default/loader.gif */ 54) + ") 50% no-repeat}div.light_rounded .pp_top .pp_left{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/light_rounded/sprite.png */ 56) + ") -88px -53px no-repeat}div.light_rounded .pp_top .pp_middle{background:#fff}div.light_rounded .pp_top .pp_right{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/light_rounded/sprite.png */ 56) + ") -110px -53px no-repeat}div.light_rounded .pp_content .ppt{color:#000}div.light_rounded .pp_content_container .pp_left,div.light_rounded .pp_content_container .pp_right{background:#fff}div.light_rounded .pp_content{background-color:#fff}div.light_rounded .pp_next:hover{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/light_rounded/btnNext.png */ 58) + ") 100% no-repeat;cursor:pointer}div.light_rounded .pp_previous:hover{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/light_rounded/btnPrevious.png */ 60) + ") 0 no-repeat;cursor:pointer}div.light_rounded .pp_expand{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/light_rounded/sprite.png */ 56) + ") -31px -26px no-repeat;cursor:pointer}div.light_rounded .pp_expand:hover{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/light_rounded/sprite.png */ 56) + ") -31px -47px no-repeat;cursor:pointer}div.light_rounded .pp_contract{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/light_rounded/sprite.png */ 56) + ") 0 -26px no-repeat;cursor:pointer}div.light_rounded .pp_contract:hover{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/light_rounded/sprite.png */ 56) + ") 0 -47px no-repeat;cursor:pointer}div.light_rounded .pp_close{width:75px;height:22px;background:url(" + __webpack_require__(/*! ../images/prettyPhoto/light_rounded/sprite.png */ 56) + ") -1px -1px no-repeat;cursor:pointer}div.light_rounded .pp_details{position:relative}div.light_rounded .pp_description{margin-right:85px}div.light_rounded #pp_full_res .pp_inline{color:#000}div.light_rounded .pp_gallery a.pp_arrow_next,div.light_rounded .pp_gallery a.pp_arrow_previous{margin-top:12px!important}div.light_rounded .pp_nav .pp_play{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/light_rounded/sprite.png */ 56) + ") -1px -100px no-repeat;height:15px;width:14px}div.light_rounded .pp_nav .pp_pause{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/light_rounded/sprite.png */ 56) + ") -24px -100px no-repeat;height:15px;width:14px}div.light_rounded .pp_arrow_previous{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/light_rounded/sprite.png */ 56) + ") 0 -71px no-repeat}div.light_rounded .pp_arrow_previous.disabled{background-position:0 -87px;cursor:default}div.light_rounded .pp_arrow_next{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/light_rounded/sprite.png */ 56) + ") -22px -71px no-repeat}div.light_rounded .pp_arrow_next.disabled{background-position:-22px -87px;cursor:default}div.light_rounded .pp_bottom .pp_left{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/light_rounded/sprite.png */ 56) + ") -88px -80px no-repeat}div.light_rounded .pp_bottom .pp_middle{background:#fff}div.light_rounded .pp_bottom .pp_right{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/light_rounded/sprite.png */ 56) + ") -110px -80px no-repeat}div.light_rounded .pp_loaderIcon{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/light_rounded/loader.gif */ 62) + ") 50% no-repeat}div.dark_rounded .pp_top .pp_left{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/dark_rounded/sprite.png */ 64) + ") -88px -53px no-repeat}div.dark_rounded .pp_top .pp_middle{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/dark_rounded/contentPattern.png */ 66) + ") 0 0 repeat}div.dark_rounded .pp_top .pp_right{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/dark_rounded/sprite.png */ 64) + ") -110px -53px no-repeat}div.dark_rounded .pp_content_container .pp_left{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/dark_rounded/contentPattern.png */ 66) + ") 0 0 repeat-y}div.dark_rounded .pp_content_container .pp_right{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/dark_rounded/contentPattern.png */ 66) + ") 100% 0 repeat-y}div.dark_rounded .pp_content{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/dark_rounded/contentPattern.png */ 66) + ") 0 0 repeat}div.dark_rounded .pp_next:hover{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/dark_rounded/btnNext.png */ 68) + ") 100% no-repeat;cursor:pointer}div.dark_rounded .pp_previous:hover{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/dark_rounded/btnPrevious.png */ 70) + ") 0 no-repeat;cursor:pointer}div.dark_rounded .pp_expand{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/dark_rounded/sprite.png */ 64) + ") -31px -26px no-repeat;cursor:pointer}div.dark_rounded .pp_expand:hover{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/dark_rounded/sprite.png */ 64) + ") -31px -47px no-repeat;cursor:pointer}div.dark_rounded .pp_contract{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/dark_rounded/sprite.png */ 64) + ") 0 -26px no-repeat;cursor:pointer}div.dark_rounded .pp_contract:hover{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/dark_rounded/sprite.png */ 64) + ") 0 -47px no-repeat;cursor:pointer}div.dark_rounded .pp_close{width:75px;height:22px;background:url(" + __webpack_require__(/*! ../images/prettyPhoto/dark_rounded/sprite.png */ 64) + ") -1px -1px no-repeat;cursor:pointer}div.dark_rounded .pp_details{position:relative}div.dark_rounded .pp_description{margin-right:85px}div.dark_rounded .currentTextHolder{color:#c4c4c4}div.dark_rounded #pp_full_res .pp_inline,div.dark_rounded .pp_description{color:#fff}div.dark_rounded .pp_gallery a.pp_arrow_next,div.dark_rounded .pp_gallery a.pp_arrow_previous{margin-top:12px!important}div.dark_rounded .pp_nav .pp_play{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/dark_rounded/sprite.png */ 64) + ") -1px -100px no-repeat;height:15px;width:14px}div.dark_rounded .pp_nav .pp_pause{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/dark_rounded/sprite.png */ 64) + ") -24px -100px no-repeat;height:15px;width:14px}div.dark_rounded .pp_arrow_previous{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/dark_rounded/sprite.png */ 64) + ") 0 -71px no-repeat}div.dark_rounded .pp_arrow_previous.disabled{background-position:0 -87px;cursor:default}div.dark_rounded .pp_arrow_next{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/dark_rounded/sprite.png */ 64) + ") -22px -71px no-repeat}div.dark_rounded .pp_arrow_next.disabled{background-position:-22px -87px;cursor:default}div.dark_rounded .pp_bottom .pp_left{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/dark_rounded/sprite.png */ 64) + ") -88px -80px no-repeat}div.dark_rounded .pp_bottom .pp_middle{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/dark_rounded/contentPattern.png */ 66) + ") 0 0 repeat}div.dark_rounded .pp_bottom .pp_right{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/dark_rounded/sprite.png */ 64) + ") -110px -80px no-repeat}div.dark_rounded .pp_loaderIcon{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/dark_rounded/loader.gif */ 72) + ") 50% no-repeat}div.dark_square .pp_content,div.dark_square .pp_left,div.dark_square .pp_middle,div.dark_square .pp_right{background:#000}div.dark_square .currentTextHolder{color:#c4c4c4}div.dark_square .pp_description{color:#fff}div.dark_square .pp_loaderIcon{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/dark_square/loader.gif */ 74) + ") 50% no-repeat}div.dark_square .pp_expand{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/dark_square/sprite.png */ 76) + ") -31px -26px no-repeat;cursor:pointer}div.dark_square .pp_expand:hover{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/dark_square/sprite.png */ 76) + ") -31px -47px no-repeat;cursor:pointer}div.dark_square .pp_contract{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/dark_square/sprite.png */ 76) + ") 0 -26px no-repeat;cursor:pointer}div.dark_square .pp_contract:hover{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/dark_square/sprite.png */ 76) + ") 0 -47px no-repeat;cursor:pointer}div.dark_square .pp_close{width:75px;height:22px;background:url(" + __webpack_require__(/*! ../images/prettyPhoto/dark_square/sprite.png */ 76) + ") -1px -1px no-repeat;cursor:pointer}div.dark_square .pp_details{position:relative}div.dark_square .pp_description{margin:0 85px 0 0}div.dark_square #pp_full_res .pp_inline{color:#fff}div.dark_square .pp_gallery a.pp_arrow_next,div.dark_square .pp_gallery a.pp_arrow_previous{margin-top:12px!important}div.dark_square .pp_nav{clear:none}div.dark_square .pp_nav .pp_play{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/dark_square/sprite.png */ 76) + ") -1px -100px no-repeat;height:15px;width:14px}div.dark_square .pp_nav .pp_pause{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/dark_square/sprite.png */ 76) + ") -24px -100px no-repeat;height:15px;width:14px}div.dark_square .pp_arrow_previous{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/dark_square/sprite.png */ 76) + ") 0 -71px no-repeat}div.dark_square .pp_arrow_previous.disabled{background-position:0 -87px;cursor:default}div.dark_square .pp_arrow_next{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/dark_square/sprite.png */ 76) + ") -22px -71px no-repeat}div.dark_square .pp_arrow_next.disabled{background-position:-22px -87px;cursor:default}div.dark_square .pp_next:hover{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/dark_square/btnNext.png */ 78) + ") 100% no-repeat;cursor:pointer}div.dark_square .pp_previous:hover{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/dark_square/btnPrevious.png */ 80) + ") 0 no-repeat;cursor:pointer}div.light_square .pp_content,div.light_square .pp_left,div.light_square .pp_middle,div.light_square .pp_right{background:#fff}div.light_square .pp_content .ppt{color:#000}div.light_square .pp_expand{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/light_square/sprite.png */ 82) + ") -31px -26px no-repeat;cursor:pointer}div.light_square .pp_expand:hover{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/light_square/sprite.png */ 82) + ") -31px -47px no-repeat;cursor:pointer}div.light_square .pp_contract{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/light_square/sprite.png */ 82) + ") 0 -26px no-repeat;cursor:pointer}div.light_square .pp_contract:hover{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/light_square/sprite.png */ 82) + ") 0 -47px no-repeat;cursor:pointer}div.light_square .pp_close{width:75px;height:22px;background:url(" + __webpack_require__(/*! ../images/prettyPhoto/light_square/sprite.png */ 82) + ") -1px -1px no-repeat;cursor:pointer}div.light_square .pp_details{position:relative}div.light_square .pp_description{margin-right:85px}div.light_square #pp_full_res .pp_inline{color:#000}div.light_square .pp_gallery a.pp_arrow_next,div.light_square .pp_gallery a.pp_arrow_previous{margin-top:12px!important}div.light_square .pp_nav .pp_play{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/light_square/sprite.png */ 82) + ") -1px -100px no-repeat;height:15px;width:14px}div.light_square .pp_nav .pp_pause{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/light_square/sprite.png */ 82) + ") -24px -100px no-repeat;height:15px;width:14px}div.light_square .pp_arrow_previous{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/light_square/sprite.png */ 82) + ") 0 -71px no-repeat}div.light_square .pp_arrow_previous.disabled{background-position:0 -87px;cursor:default}div.light_square .pp_arrow_next{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/light_square/sprite.png */ 82) + ") -22px -71px no-repeat}div.light_square .pp_arrow_next.disabled{background-position:-22px -87px;cursor:default}div.light_square .pp_next:hover{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/light_square/btnNext.png */ 84) + ") 100% no-repeat;cursor:pointer}div.light_square .pp_previous:hover{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/light_square/btnPrevious.png */ 86) + ") 0 no-repeat;cursor:pointer}div.light_square .pp_loaderIcon{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/light_rounded/loader.gif */ 62) + ") 50% no-repeat}div.facebook .pp_top .pp_left{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/facebook/sprite.png */ 88) + ") -88px -53px no-repeat}div.facebook .pp_top .pp_middle{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/facebook/contentPatternTop.png */ 90) + ") 0 0 repeat-x}div.facebook .pp_top .pp_right{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/facebook/sprite.png */ 88) + ") -110px -53px no-repeat}div.facebook .pp_content .ppt{color:#000}div.facebook .pp_content_container .pp_left{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/facebook/contentPatternLeft.png */ 92) + ") 0 0 repeat-y}div.facebook .pp_content_container .pp_right{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/facebook/contentPatternRight.png */ 94) + ") 100% 0 repeat-y}div.facebook .pp_content{background:#fff}div.facebook .pp_expand{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/facebook/sprite.png */ 88) + ") -31px -26px no-repeat;cursor:pointer}div.facebook .pp_expand:hover{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/facebook/sprite.png */ 88) + ") -31px -47px no-repeat;cursor:pointer}div.facebook .pp_contract{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/facebook/sprite.png */ 88) + ") 0 -26px no-repeat;cursor:pointer}div.facebook .pp_contract:hover{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/facebook/sprite.png */ 88) + ") 0 -47px no-repeat;cursor:pointer}div.facebook .pp_close{width:22px;height:22px;background:url(" + __webpack_require__(/*! ../images/prettyPhoto/facebook/sprite.png */ 88) + ") -1px -1px no-repeat;cursor:pointer}div.facebook .pp_details{position:relative}div.facebook .pp_description{margin:0 37px 0 0}div.facebook #pp_full_res .pp_inline{color:#000}div.facebook .pp_loaderIcon{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/facebook/loader.gif */ 96) + ") 50% no-repeat}div.facebook .pp_arrow_previous{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/facebook/sprite.png */ 88) + ") 0 -71px no-repeat;height:22px;margin-top:0;width:22px}div.facebook .pp_arrow_previous.disabled{background-position:0 -96px;cursor:default}div.facebook .pp_arrow_next{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/facebook/sprite.png */ 88) + ") -32px -71px no-repeat;height:22px;margin-top:0;width:22px}div.facebook .pp_arrow_next.disabled{background-position:-32px -96px;cursor:default}div.facebook .pp_nav{margin-top:0}div.facebook .pp_nav p{font-size:15px;padding:0 3px 0 4px}div.facebook .pp_nav .pp_play{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/facebook/sprite.png */ 88) + ") -1px -123px no-repeat;height:22px;width:22px}div.facebook .pp_nav .pp_pause{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/facebook/sprite.png */ 88) + ") -32px -123px no-repeat;height:22px;width:22px}div.facebook .pp_next:hover{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/facebook/btnNext.png */ 98) + ") 100% no-repeat;cursor:pointer}div.facebook .pp_previous:hover{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/facebook/btnPrevious.png */ 100) + ") 0 no-repeat;cursor:pointer}div.facebook .pp_bottom .pp_left{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/facebook/sprite.png */ 88) + ") -88px -80px no-repeat}div.facebook .pp_bottom .pp_middle{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/facebook/contentPatternBottom.png */ 102) + ") 0 0 repeat-x}div.facebook .pp_bottom .pp_right{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/facebook/sprite.png */ 88) + ") -110px -80px no-repeat}div.pp_pic_holder a:focus{outline:none}div.pp_overlay{background:#000;display:none;left:0;position:absolute;top:0;width:100%;z-index:9500}div.pp_pic_holder{display:none;position:absolute;width:100px;z-index:10000}.pp_top{height:20px;position:relative}* html .pp_top{padding:0 20px}.pp_top .pp_left{height:20px;left:0;position:absolute;width:20px}.pp_top .pp_middle{height:20px;left:20px;position:absolute;right:20px}* html .pp_top .pp_middle{left:0;position:static}.pp_top .pp_right{height:20px;left:auto;position:absolute;right:0;top:0;width:20px}.pp_content{height:40px;min-width:40px}* html .pp_content{width:40px}.pp_fade{display:none}.pp_content_container{position:relative;text-align:left;width:100%}.pp_content_container .pp_left{padding-left:20px}.pp_content_container .pp_right{padding-right:20px}.pp_content_container .pp_details{float:left;margin:10px 0 2px}.pp_description{display:none;margin:0}.pp_social{float:left;margin:0}.pp_social .facebook{float:left;margin-left:5px;width:55px;overflow:hidden}.pp_nav,.pp_social .twitter{float:left}.pp_nav{clear:right;margin:3px 10px 0 0}.pp_nav p{float:left;margin:2px 4px;white-space:nowrap}.pp_nav .pp_pause,.pp_nav .pp_play{float:left;margin-right:4px;text-indent:-10000px}a.pp_arrow_next,a.pp_arrow_previous{display:block;float:left;height:15px;margin-top:3px;overflow:hidden;text-indent:-10000px;width:14px}.pp_hoverContainer{position:absolute;top:0;width:100%;z-index:2000}.pp_gallery{display:none;left:50%;margin-top:-50px;position:absolute;z-index:10000}.pp_gallery div{float:left;overflow:hidden;position:relative}.pp_gallery ul{float:left;height:35px;margin:0 0 0 5px;padding:0;position:relative;white-space:nowrap}.pp_gallery ul a{border:1px solid #000;border:1px solid rgba(0,0,0,.5);display:block;float:left;height:33px;overflow:hidden}.pp_gallery li.selected a,.pp_gallery ul a:hover{border-color:#fff}.pp_gallery ul a img{border:0}.pp_gallery li{display:block;float:left;margin:0 5px 0 0;padding:0}.pp_gallery li.default a{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/facebook/default_thumbnail.gif */ 104) + ") 0 0 no-repeat;display:block;height:33px;width:50px}.pp_gallery li.default a img{display:none}.pp_gallery .pp_arrow_next,.pp_gallery .pp_arrow_previous{margin-top:7px!important}a.pp_next{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/light_rounded/btnNext.png */ 58) + ") 10000px 10000px no-repeat;float:right}a.pp_next,a.pp_previous{display:block;height:100%;text-indent:-10000px;width:49%}a.pp_previous{background:url(" + __webpack_require__(/*! ../images/prettyPhoto/light_rounded/btnNext.png */ 58) + ") 10000px 10000px no-repeat;float:left}a.pp_contract,a.pp_expand{cursor:pointer;display:none;height:20px;right:30px;top:10px;width:20px;z-index:20000}a.pp_close,a.pp_contract,a.pp_expand{position:absolute;text-indent:-10000px}a.pp_close{right:0;top:0;display:block;line-height:22px}.pp_bottom{height:20px;position:relative}* html .pp_bottom{padding:0 20px}.pp_bottom .pp_left{height:20px;left:0;position:absolute;width:20px}.pp_bottom .pp_middle{height:20px;left:20px;position:absolute;right:20px}* html .pp_bottom .pp_middle{left:0;position:static}.pp_bottom .pp_right{height:20px;left:auto;position:absolute;right:0;top:0;width:20px}.pp_loaderIcon{display:block;height:24px;left:50%;margin:-12px 0 0 -12px;position:absolute;top:50%;width:24px}#pp_full_res{line-height:1!important}#pp_full_res .pp_inline{text-align:left}#pp_full_res .pp_inline p{margin:0 0 15px}div.ppt{color:#fff;display:none;font-size:17px;margin:0 0 5px 15px;z-index:9999}", ""]);
	
	// exports


/***/ },
/* 40 */
/*!**************************************!*\
  !*** ./~/css-loader/lib/css-base.js ***!
  \**************************************/
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 41 */
/*!****************************************************************************!*\
  !*** ./bower_components/prettyphoto/images/prettyPhoto/default/sprite.png ***!
  \****************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../../~/url-loader!./sprite.png */ 42);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../../~/style-loader/addStyles.js */ 43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/url-loader/index.js!./sprite.png", function() {
				var newContent = require("!!./../../../../../node_modules/url-loader/index.js!./sprite.png");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 42 */
/*!*******************************************************************************************!*\
  !*** ./~/url-loader!./bower_components/prettyphoto/images/prettyPhoto/default/sprite.png ***!
  \*******************************************************************************************/
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIIAAACTCAYAAABCicHDAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowMTgwMTE3NDA3MjA2ODExOEJGMkY2QjUxMTM2ODA5MCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDoyNzU1MDMzMDNFODUxMUUwOEU2RjkzMTJFRjMxNEUwMiIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDoyNDI4M0NDNDNFODMxMUUwOEU2RjkzMTJFRjMxNEUwMiIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1IE1hY2ludG9zaCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjAzODAxMTc0MDcyMDY4MTE4QkYyRjZCNTExMzY4MDkwIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjAxODAxMTc0MDcyMDY4MTE4QkYyRjZCNTExMzY4MDkwIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+74JHSQAAFkpJREFUeNrsXQtwFUW67pMHhFcEYwQJmPAwIMiKYEnWMux6N5cVRR6JgAqkkEt8awQUEHzillKCBq+3fFwERVRKqQTCEosNcOWGLLBeJMYVxEh4BCTRBIlESAIk2f8bps+dzJmZMyfJzDkz6a+q6yQz03P67/n7///+p7/TnqKiImaEmpqa7lFRUWPCw8OnejyeBDp0NX1e0dTUVEp//0qfe6jk3njjjfnMISgoKDAlE533K9MNN9xgS5upPZbe36OnCGfPno3p1KnTkrCwsPuio6M7XXbZZSwyMlIq1EHs/PnzrLGxkdXW1kJZUKoaGhpeLi8vf2v8+PH1oagAhYWFLZapb9++9a5WhH379jU7MGLECM+ePXvGUuesu/LKK6OvuOIKRqNFaoi6MTjOP9GJ1dXVrLKysuTcuXN3Jicnl5hpwNdff90qAYYPH25KzraQqUuXLj4yUX85UhFkA9CVym9Q5jDeGSiyEiygDtsUHx8vdRiOY5RoNYTXw/mIiAgWGxvLevXqlUijbs/u3btTQsQQtJlM9fX1Kcr+snqU2oDu/I8ILgz5eM+uXbue7Nmz5ysxMTFSJwQqKK6//PLLYWp7lJWVbSJf/KfRo0fvDkTTyRSPodE4mcoIKtfToXC6Zp9c1pvx20olaGuZyGX+qXPnzrvN1t+7d6+hPEGOrWKonJA66ssvv+RB4R+7deu2bfDgweHosFYNQTKrMKnUcT+dOHFiWFpaWqXetdw1UQcnUgevpDaMJv/NKJiTCu4Fn11XV8fOnDmDdhaQmc7gZtrING/fvt0ymShmkGS66aabNK/fuXNnQPL4c6UWuQZY7W1e17By5coO1Og3SLhWdxhvdPfu3RmNxJ7kk5egH/WuhQmmThlNnbSHTPDoq6++miGI69Chg3SOLIT0N47hHK7BtaiD83rIyMiwVCZSAI/ewyErFLA8qBMEi9CT/xE2atQoz7333juNTOfvIGhbBjfUYTCpszZv3jxI77rTp08Poge1kTqlB0ywke/GOVyDa1EHdfUGsB0yabVz69atLZYHdW1WhF5eRUChRmT06NHD2+i2LKTxHciMz5a/S42wrl27ruzdu3cPmE8z5g/X4FrUQV29+5qR6YUXXmDHjx9vsUxJSUlhNsljFa7yNnzt2rW9aV59E0XFuoJjTr106VJGvrHZ8V9++YW98sor7OTJk7p1yUdijj5WS0AaASl0PhmBXCA+ENeiDuriHurzZmRC+fHHH9mTTz7J3nzzTUkWs4qgJ5NV8thiEWh6NIbMU7jR1W+99Rb79ddf2TPPPCM9dNmks9dee42dOnWKZWVl6daVg6Qha9as6asxaidjNMBvYuRqlf3797OXXnrJ5zjqoC7uoXogHjMyATDzAwYMkALWp59+mmVnZ0tBnD/oyGQoD+4PWfTkNJDHlhghgkbOEAQvRhr8+OOPs/fee4/Rtez5559nmZmZ7JNPPpHqUOzE7r//ft36OI77k68eSv8exSHecYR/I3OoWe/gwYNs/fr17NChQ9Jo0QLq4h5yxzUq7utXJuVsIC4ujl28eJFt27aNke9nFF+wlJQUwxGsIZOhPBhIGDDIS0yfPp1de+21ZuWxErHKPMLleMBGETiEfuCBB9i7774r/b9s2TLGo+EHH3yQkb80rI/0LQagPHtoUsQnfRDRK+t+//337KOPPpJGD/lN6Xv47EINeTbQR20RzMikdS8km4ANGzawzz//nE2bNk03hawhk6Y8HIhXAFjQJUuWsP79+0sKp1QIHXmsziNcehjUaI+/kYPzEBwNxyd/OGlpaX6VgD9E+RrlNNJD5rAOI1Htg/FAhg0b1swSaPlq2aR61NNTMzIZ9g59L6wEYowAZNKVR9kW3HvgwIHS/ZVpbiN5bMksUsNPX7hwwa8ZRUyAwBBaCwsBvPzyy5KroCjasC7uX19fX6VxvIKOR8PncmCEYBQeO3ZMGpVHjhzRtQhUFx13Qn3crExaQCB4++23s5EjR0r3x4M1K5OWPGr069dPun98fLwUjyjvryePhfD6sYja2tqD586dM+w0+LfnnntOMm9wBzNnzmSfffaZ9HBef/11NmfOHENlwP3Lysp+ULgFaZBTR/z9zJkziVyxALzoQYEvfeihh7wKoaUIaBfde4fqvsyMTGp07NiRJScns1tvvVWq99tvvxleryGTpjxaCoC6yCqalcdCeIUM++6773ZUVlY2GEXuCBR5NgyxAswbPrl5w/RLr+7Zs2fRqd/Nnz//qErAxp9//jlXb9qGEYeO4QqhdQ3q4h6qwKrJjExKxRo1ahRbuHChpAQYpShG9XRkMpQHMkAWyMStlUl5rES1VxHItJdRw/ZCOD3MmzdP6qyHH35Yigm4H8RsAbl+TCuNrAmN0HxZuGaKkJGRsZ0E311eXq7b6TCXcEvq46iDuriHquMazcgEDB48WJJt4sSJkjx4B2DGiujIZCgPZIAsenIayGMlTnldA174kSauoUaM6ty5s26wmJ6eLo0EaLPyONwEjmP0adUj83mBpoIf4nvU8RY8QVFR0WMUgH5BpRvSrWaATiWXUYO6uIfaIpiRCUDbYaaRMAsk+aMjk1XyWAnvy0BpDlRcXFxyyy233EmddqVWpAzhuTabOc6B5FNFRcUammKuRSyl4fuaduzYUU1WpYhczFia8kXB4hhl9eh+CCCrS0pKZi5atOgfcsf5DGN/MvHgLJAppgmZLJMH6fC2BL6X8GcqOVddddUlRSCNbEpKSjpMjZ9KWhyGKWJr3zFUVVVByys3b96cTpperWER+OhtzM/PP9GnT598emjXk8mNg3XBPfj6AVgcvAJGSpjK/+3atWsamX90Wp3e6LFDpry8vAYk1uyQxyJFuJlKPhTBg0zauHHjoBCdPvzww3nkN19AthBRdEsBU3fo0KG6AwcOTFywYEGBLKCm8924cSN8NL4fXxi1bNmyf6eG3Unf/7vIyMhh8rTsnzR6vyE/+tennnpqq3y/eqrbAP+ul8eyWibquybqO73vDlgencHitb5tCXk9wjwqr2G67tm0aZN0Yvz48ZHouPfff/8pmhU8PXDgwPCWvML96aef4EOrDx8+/B80rfybLKSugMjiAZMmTQqTYxbMvSLlzgxT+N8G2RTDdF6keo1yPaPmWCYT9VuD3G961QKSx19cYJEiTKPyMRQhQvEFaEztfffdtzwrK+sA+c53aXrYTTIbHv+JLsz90WHkQ0th6pYvX77fn5YrBczJyZGCrdTU1Iv89bgiw9Ykd1SjfJ3ZjrFEptzc3AYT39+oeMi68tgYGGrquDfNC9PMQWbWI2txFEXU8SkpKQsp2JlCPjYSETByCTCvfOk3ppFIvGA6ReUURer/TZ31XzSPrzajBDahTWWCO1Le3MA1tSkssghYQ1ksuQZumjnI1Hpk7YVJixo7dmzMbbfddmtsbGwqBTtxVBJoNHWjAOgkjbBTdXV1X9E0beurr776P/RZKyvA+SBrupYytFom7o5U/eVkRcALrhOSIhhcGyb7tQhFCVeYOG7eLqpKg40p0kDhWJms5jV4AhhNvLM86umSIsPWFAzhzPh7p8lku8m0iWkUaorgRVvL71RFCGMCAow1mz5qwh8b+quvvnI0G5qCQx+ZAmFDuwVBZUPb7RrsYEM7NkYIJhvaRkWwjQ3t2BhBsKHNy+RCNrSvIowcOdLLHL7mmmvC8R6/pcxhULjQ8eSLfx9sJWhrmchl/t6VisBXyGzfvv0PNAK89PHWTAmxADQuLq5Tx44dN2RnZ8cGSzirZDp27FisermbKyxCMNnQViGYbGhHKkKw2dBWuYRgsaEdm0dgKuawGhMmTGCcTIrVvbm5uc3O4e0domtAeY4DzGGajoENPZ/Z9yLKUCbg2WefZQcOHJCCweXLl0t0M6wCKi4uZgkJCRLfUo++xmVKSkqyUyZrO8wfcxiMIzBzKNhiH3/8cbNzOTk5bNCgQdI1KIGyoa2CGTY0qGcg02AWgb9xDAo9dOhQKafAj4WKTJYrglnmMPDoo49K6+wAzK/BBfAHAza0ZW7BjEzKFcbgSSo/+U/chJBM1iuCkjmsx9l78cUXJdYzVvaA8fTtt99KdDcs6EB2btGiRc3m4Go+n4I57AkFmfTyB1r5hBCRyZZZg5c5rFVAaQPAegY7GQX0bkTinA2NEYLr9O6hYg5bbhH8yaQVN6iPwSIY1bdZJlvyCIbTIHD0cB4de/fdd0ufUAZ0xF133eVlQ2tx+ZSdrMGGtgyBsqG1iK5ahJ1gymS5IiiZw0YFy7lhCZQj5+2335aoWv7q6rGhrYIZmZTgnActdxEqMlmuCErmsFaZPHmyFBhiOgVmECLmxx57TIoZoBTgPWKlL6yD3j102NCWwZ9MrY0RgiGT5Yrgjzl83XXXSWRXTMWQTAERFilbsHtB9YZiYE6O6WOAbGirYIoNrQRGt17cECIyWa8IZpjDmFsjOMTDR2AIn4pOzsjIkH4ACvR4PRiwoS0LEczIxKeKANYjqI8ZTR+DIJMtmUVTzGE+c8BvJXDcc889kiXQi7z9sKEtswhmZMLPAJWWlkoJJWQX0XblMfzwh5aVCJJM1k+1ECv179+/24oVKwoTExOHqqnc6CQlyOSaOgeAOfzDDz+spjgDdG8fgqeFC1MMZQKQA0EuAJYN/l7vmBp2yRQMi9B4+PDh2iNHjiyg6DmXYoFwJVkUgaAejM4hRXv8+PHKLVu2/IVd4vjZmZM3lEkOKKXi75iRTHl5eY133HGHO2YNYPRixpWZmfm/JOhLeLiYHbQGmGrSgwBzeMaqVavAv75os1y2yOS6hSkys7c+PT09a//+/X8pLi6GjzXMrBn9BExJSUn1oUOHpi1YsKCQ6fzwgw2wVCbqsyY3LUzxqP6Gq+iclZV1O00N24I5XGdkDWxYvGqJTLm5uV6Z8CreDTGCR6fjbGFD27SK2VY2tGsob8OHD7eNDW3ncnZmExvaddxHUgjLmcNB4D62WCZSAs3GukURdClvRUVFEiO4oqKia3R09J/JfE4B5Y1KX9DDaOQcRpKNPvdcuHBh08033/w3B2TZGhUP2hQbOicnp8nJD9j0YGpPlDdb5q2C8hbSlDehCP58ZjugvAmYGUx79+6V/uAbgNIc+9XWMIMwOuEqysrKaskyGG4A6na/67jMolspbwIBugY3Ut4EArTkKF988cVMGsGrSRGamWtkzWAteLDIf6VVialTp0rn+Q9cq9lO33zzzfmqqqrrx40bd1C4hhDOIzADehhWJnFgubrWO3oox9y5c3UfbpAobwKBugYjephSCbBvodYGoPPnz/dyH5QzCTfTw1ypCP7oYXjIYDVh/R+2qVNuAArWE17RgvqmVAYl3EgPc6UiGNHD8HDxJg6LVrFAFXkFHAOLGEqAgBAE2SeeeEK6DufaAz3MrbMGXXoY2Es8WYSFq3iPj7/xwKEEnPIG+rjyerfTw9yaRzC1ASiUBTMEvLuHQgAgv7RiA1CBUFIEs5Q3BIYrVqyQFmxwvPPOOxJNPtQobwItUAQz9DAeGCJXAAIsp7whLsBOsP74j26jh7lSEYzoYdgOD5/YtBtEESXlDRuA4hdHQAT54IMPvASR9kAPc6UiGNHDsKP5rFmz2COPPCLtlQwl4JQ3jHQow5AhQyQLgfgBG2qq4UZ6mBvhl/IGZZgyZQrLy8vT3QAUO51x6psycHQrPcyVFgEPiKzCOvLz+9U/IMWBhwxGD7cEvMCd4DgY08qHzwuST+QW1i5evPggE+nlkLcIuvQwdbZQi+K2detWzWuCTHkTCBBB3QBUvH0MrYSSWylvAoEogiIe8G6WWVpaOoMeZg2SRXy9or+CHAMFhtjwunTnzp23zZkzBzOFUNn7UcCfa9D433GUN4G2VwR+zFGUN4E2UAQ3UN4ELFQEhUKIzTLbQx7B38MoKCi4zGi7P741npO2+xPQsAhu4D4KtIEiuIH7KNCGeQTBfRSK4Obt/gTMKoLgPgp4LYLgPgqY3u6PZgKax7FoRU8Zgrjdn7URNgXHTi8+eQRmYmu8tLQ07y5uamD3N+zssm7dOs267YD7iERbPBWs8e/BQovah/4+TaWcyjGj/ve73R9+gR2LVJWzBPUqpgEDBrDU1NR2szWeAlFUkqlgiVZMCMoYJrfrOrmdUboXGnEfQYvHQzYDLGJNT0/37Sn3ch/RyaOoRDukvdFyezWVNULJfVRDvQwNr5zVUC9nU1+D+yq4j0eZexapxDtICZTKgHYf8VEEJfdRDaOd2wK5RsV9dIsi9HZwu30VIdCt8VoUsbiT+6g5xRozZkzMG2+8MYuC5CEUd8XY3SgKzE9VVFQcyMzMXJ2fn3/KbLtNcx9bU1zKffTxtTNmzIjLzs7+z379+iUHQwkAfC++H+2YNWtWXzPtlg6a4T62trQX7uPixYunR0ZGdguFtqAdCxcunG72+ghwHymQa0BWUZ1oAJcRmUa+C9qqVat8bjB79mzpNTR+IwGB4qeffqo2Ve2G+xgXF3dDSAUDvXubbo8h93HLli0sMTFR2t8RRQsJCQlSsgnn1bMMoD1xH2nAdA6l9tAgjgrEz3Huow9Hoaqqqtn00GgjTVyH65XnQIkT3EfnBDy63EcUbOHHlUEvs4jzuE59TnAfnQO/2/0B4DPiYWtxH/WOC+6jwyyC2e3+9PZ41DoeAtv9CQSqCIL7KCApguA+CgCejRs3ev+ZOHGi4D6a6bRL+ZY71cfr6uo2hVpbo6KitFYU/dVnRfqGDRuaHZg0aZLgPgpFaKYQgvvYjhRBl/KWk5MjcRpTU1NNb40ngkIH5xGwxMzfwJVHuQj6XJ5QMkRBQUF3QYJtx4pQWFjojwQ7QCbBjqipqXl43759AZNgBUIo7hEkWBEsNksoCRJs+4YgwQpcUgRBghXwWgRBghUwTYJtiTK4lQTrSkVgKhKs0RtGMKKV/2OPBn9vJUGC7dKly2wm9n0MbUXwR4LlZcKECV5GNC/Y6g/HjeqJDUAdogj+NgAF8BsIfGMONXActHmDeazYANQJimC0ASgKGNGDBg3yyR0op5ZgQuM6rfpiA1BnwJAEC6i5CkrSq5oJrUeIdSkJ1l2K4I8Ea8R2NsOEBsQGoA5QBCUJ1iqIDUAdoAhKEqwW8PtISDeD3wisX7/eew5bAgPgPcK9aHEjAbEBqAMUwYgEC4D/OHfu3GZmXjljUMYLWAKvRnsiwTp61mBEggXwcNVBoRp6SgC0JxIs9eO5UGoPuf0604rADEiwWmRYNQFWi/zaXkmw5eXlxaHUnpMnTxYFpAhGJFg1GVZ5TI/82l5JsEuXLv2IrEJNiFinGrQnEEXwkmBLS0sb4NP1LAN4jkb/KwsUxOUkWB95Vq9efTwtLe3xo0eP/p1mSaeD0Sh8L74f7UB7tDyGVj2xAWgLIAfVt7BLv7TqNEBBC32WqgkSbMtdsJvaLUiwLQemw2cc1uYzcrt9rZwgwbbYNQD4jSKn/AwvlOAfsptmggTbtorAA+4EKr3YpR/ADjUgwVMuW4JGvb4XJNjWK4Ij4aMIOTk5hhVSU1PFBqDtAJ5Q0kqB4EGsIxQQiiDw/4gQ5llAWAQBL/4lwACVKiuxRfKUhgAAAABJRU5ErkJggg=="

/***/ },
/* 43 */
/*!*************************************!*\
  !*** ./~/style-loader/addStyles.js ***!
  \*************************************/
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(true) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 44 */
/*!******************************************************************************!*\
  !*** ./bower_components/prettyphoto/images/prettyPhoto/default/sprite_x.png ***!
  \******************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../../~/url-loader!./sprite_x.png */ 45);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../../~/style-loader/addStyles.js */ 43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/url-loader/index.js!./sprite_x.png", function() {
				var newContent = require("!!./../../../../../node_modules/url-loader/index.js!./sprite_x.png");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 45 */
/*!*********************************************************************************************!*\
  !*** ./~/url-loader!./bower_components/prettyphoto/images/prettyPhoto/default/sprite_x.png ***!
  \*********************************************************************************************/
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIIAAAAvCAYAAAAvgRLNAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowMTgwMTE3NDA3MjA2ODExOEJGMkY2QjUxMTM2ODA5MCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo2RkQ3N0Q4RDNFNkIxMUUwOEU2RjkzMTJFRjMxNEUwMiIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo2RkQ3N0Q4QzNFNkIxMUUwOEU2RjkzMTJFRjMxNEUwMiIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1IE1hY2ludG9zaCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjAzODAxMTc0MDcyMDY4MTE4QkYyRjZCNTExMzY4MDkwIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjAxODAxMTc0MDcyMDY4MTE4QkYyRjZCNTExMzY4MDkwIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+wcubnwAAAHlJREFUeNrs3EERACAMA8FUIP6t9AcGqACGXQmZe6eSrPC9EgJCQAgIgVsI3b3NgBAQAkJACAgBISAEhIAQEAJCQAgIASEgBISAEBACQkAICAEhIASEgBAQAkJACAgBISAEhIAQEAJCQAg8GUK8qiEEhIAQEAKDI8AA1FuTlQtMVXIAAAAASUVORK5CYII="

/***/ },
/* 46 */
/*!******************************************************************************!*\
  !*** ./bower_components/prettyphoto/images/prettyPhoto/default/sprite_y.png ***!
  \******************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../../~/url-loader!./sprite_y.png */ 47);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../../~/style-loader/addStyles.js */ 43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/url-loader/index.js!./sprite_y.png", function() {
				var newContent = require("!!./../../../../../node_modules/url-loader/index.js!./sprite_y.png");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 47 */
/*!*********************************************************************************************!*\
  !*** ./~/url-loader!./bower_components/prettyphoto/images/prettyPhoto/default/sprite_y.png ***!
  \*********************************************************************************************/
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAACCCAYAAAD1/sBJAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowMTgwMTE3NDA3MjA2ODExOEJGMkY2QjUxMTM2ODA5MCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo2RkQ3N0Q5NTNFNkIxMUUwOEU2RjkzMTJFRjMxNEUwMiIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo2RkQ3N0Q5NDNFNkIxMUUwOEU2RjkzMTJFRjMxNEUwMiIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1IE1hY2ludG9zaCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjA1ODAxMTc0MDcyMDY4MTE4QkYyRjZCNTExMzY4MDkwIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjAxODAxMTc0MDcyMDY4MTE4QkYyRjZCNTExMzY4MDkwIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+IJNLSgAAALpJREFUeNrsz7ENgDAMAMGYysvBsLBcOiMKmigDRMp9YVl2dVFVbSwi/vUcf733uy1WZl6T8/ONme9oGwYNDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ29Vq8AAwDEjAwBf+xdvAAAAABJRU5ErkJggg=="

/***/ },
/* 48 */
/*!*********************************************************************************!*\
  !*** ./bower_components/prettyphoto/images/prettyPhoto/default/sprite_next.png ***!
  \*********************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../../~/url-loader!./sprite_next.png */ 49);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../../~/style-loader/addStyles.js */ 43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/url-loader/index.js!./sprite_next.png", function() {
				var newContent = require("!!./../../../../../node_modules/url-loader/index.js!./sprite_next.png");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 49 */
/*!************************************************************************************************!*\
  !*** ./~/url-loader!./bower_components/prettyphoto/images/prettyPhoto/default/sprite_next.png ***!
  \************************************************************************************************/
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAeCAYAAAA/xX6fAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowNzgwMTE3NDA3MjA2ODExOEJGMkY2QjUxMTM2ODA5MCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDoyNzU1MDMzODNFODUxMUUwOEU2RjkzMTJFRjMxNEUwMiIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDoyNzU1MDMzNzNFODUxMUUwOEU2RjkzMTJFRjMxNEUwMiIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1IE1hY2ludG9zaCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjA3ODAxMTc0MDcyMDY4MTE4QkYyRjZCNTExMzY4MDkwIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjA3ODAxMTc0MDcyMDY4MTE4QkYyRjZCNTExMzY4MDkwIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+GEY9uAAAAX5JREFUeNrslzFrwkAYht8kiqIhVTBTM7pGhEKWDPVfiP9AB5dOHbKl0EI2/4D/oXuQQrJkyNI9kK2gDg0EdTD27tDWUa13kx+8OS7Lc99378fdSbvdDiKjRD+bzeYwfyR6InoguufA25aOJs9Er5wTVCRaUpIhzcynP3iXVN6PLyJgx0BTlGkOwDvRQNyANPI8R5Ik/2/8U2KxWGA8HqNarcKyLIxGI74ZzmYzqKoK2rdRFGE6nfIF9no9KIqCZrMJTdMQx/FF0JOBuq7DcRzUajXIsox6vQ7f9zGZTPiZxjAMDIdDto+SJLExDEMGvrppflco/62RlrfRaLBScwGmaQrXdVGpVFAUBYO12222v1cHzudzeJ7HnLper1lWnU4Hg8GATx8GQYAsy5hDaSm73S76/T4/l9q2jVarhXK5DNM0L4LROBzAJ11sVqsVlsslc+ulcRbwdjydA/wWDfwUDXToJVUk8GMPFWqaN3rsEb0TfXHiFZLox8yPAAMA4GRx1RbQJygAAAAASUVORK5CYII="

/***/ },
/* 50 */
/*!*********************************************************************************!*\
  !*** ./bower_components/prettyphoto/images/prettyPhoto/default/sprite_prev.png ***!
  \*********************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../../~/url-loader!./sprite_prev.png */ 51);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../../~/style-loader/addStyles.js */ 43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/url-loader/index.js!./sprite_prev.png", function() {
				var newContent = require("!!./../../../../../node_modules/url-loader/index.js!./sprite_prev.png");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 51 */
/*!************************************************************************************************!*\
  !*** ./~/url-loader!./bower_components/prettyphoto/images/prettyPhoto/default/sprite_prev.png ***!
  \************************************************************************************************/
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAeCAYAAADdGWXmAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowNzgwMTE3NDA3MjA2ODExOEJGMkY2QjUxMTM2ODA5MCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpEM0IxQkE1RjNFODcxMUUwOEU2RjkzMTJFRjMxNEUwMiIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpEM0IxQkE1RTNFODcxMUUwOEU2RjkzMTJFRjMxNEUwMiIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1IE1hY2ludG9zaCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjA3ODAxMTc0MDcyMDY4MTE4QkYyRjZCNTExMzY4MDkwIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjA3ODAxMTc0MDcyMDY4MTE4QkYyRjZCNTExMzY4MDkwIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+GEjUPgAAAZBJREFUeNrsl79qwlAUxr+kAUEMEVGEhDyCUHBykSL4DM7BUV+gULcOnUoGMUPAl3B0Kv4BC4JjBsmgRKpDpvonSExvAi0d09R7odADH4QLlx/fPefcc8MFQQBWIXieR4PmEM2JnolewoVUKgXudDrRtnZP9MQK5hPdEdiYZ5CqG6LH8INnVBu3LGESSxj+Dsy2bRwOh581dRJQv9/HYDCAqqrodDooFAp0nJmmidFoBEmSsNlsMBwO6TjrdruwLAvZbBY8z0OWZdTr9evnzDAMLJdLXC4XnM9nkDsVrVYr9hHGdjadTjGbzZDJZKLj830f7XYbiqJcvxo5jkMul4MoilEFRpcqWaNS+pVKBaVSCa7rQhAEOI6DXq+H9XpNp880TUOtVsPxeESxWMRut4Ou69hut3SautFooFwuRw4/czeZTOg1dbPZRDqdxmKxwH6/R7Vajb038fBcrVbI5/MROE6QouJYTOov2P+I+W28s4TNWcHCp9wDK1gIGiee1DHijej1+/M7amqWPxYfAgwACS6Jy3cFed0AAAAASUVORK5CYII="

/***/ },
/* 52 */
/*!***********************************************************************************!*\
  !*** ./bower_components/prettyphoto/images/prettyPhoto/default/default_thumb.png ***!
  \***********************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../../~/url-loader!./default_thumb.png */ 53);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../../~/style-loader/addStyles.js */ 43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/url-loader/index.js!./default_thumb.png", function() {
				var newContent = require("!!./../../../../../node_modules/url-loader/index.js!./default_thumb.png");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 53 */
/*!**************************************************************************************************!*\
  !*** ./~/url-loader!./bower_components/prettyphoto/images/prettyPhoto/default/default_thumb.png ***!
  \**************************************************************************************************/
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 54 */
/*!****************************************************************************!*\
  !*** ./bower_components/prettyphoto/images/prettyPhoto/default/loader.gif ***!
  \****************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../../~/url-loader!./loader.gif */ 55);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../../~/style-loader/addStyles.js */ 43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/url-loader/index.js!./loader.gif", function() {
				var newContent = require("!!./../../../../../node_modules/url-loader/index.js!./loader.gif");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 55 */
/*!*******************************************************************************************!*\
  !*** ./~/url-loader!./bower_components/prettyphoto/images/prettyPhoto/default/loader.gif ***!
  \*******************************************************************************************/
/***/ function(module, exports) {

	module.exports = "data:image/gif;base64,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"

/***/ },
/* 56 */
/*!**********************************************************************************!*\
  !*** ./bower_components/prettyphoto/images/prettyPhoto/light_rounded/sprite.png ***!
  \**********************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../../~/url-loader!./sprite.png */ 57);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../../~/style-loader/addStyles.js */ 43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/url-loader/index.js!./sprite.png", function() {
				var newContent = require("!!./../../../../../node_modules/url-loader/index.js!./sprite.png");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 57 */
/*!*************************************************************************************************!*\
  !*** ./~/url-loader!./bower_components/prettyphoto/images/prettyPhoto/light_rounded/sprite.png ***!
  \*************************************************************************************************/
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 58 */
/*!***********************************************************************************!*\
  !*** ./bower_components/prettyphoto/images/prettyPhoto/light_rounded/btnNext.png ***!
  \***********************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../../~/url-loader!./btnNext.png */ 59);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../../~/style-loader/addStyles.js */ 43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/url-loader/index.js!./btnNext.png", function() {
				var newContent = require("!!./../../../../../node_modules/url-loader/index.js!./btnNext.png");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 59 */
/*!**************************************************************************************************!*\
  !*** ./~/url-loader!./bower_components/prettyphoto/images/prettyPhoto/light_rounded/btnNext.png ***!
  \**************************************************************************************************/
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAAWCAYAAABzCZQcAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABSVJREFUeNrMmMlLZEkQxqO03FcUFA+DCypoqQcRmlZccANRUTw4oIfpg3cv42UYET3YgtBHz/MHiApzcFxmxIMgOhe9KG6HHnBXxH2rqokvqCiyX1eVZV+qEpL3Kl9mvvxFfBGZr2xut5tsNhuNj4+Tj+Lg5418/ch9SvmajUZu+xoXF1cQFRXlio2NddrtdhfmCEFJ8Fzv3jPIrjcPDw/eRgbK4csnl8v1C9ccGIavUlEiIiKKXl9fxVgMTNHR0RQTE0ORkZEUYvj3QaMkJiaS0+msY8hf+dqqKgAYg3qB0I4K8JeXF1IDYDwbLFTgPwbtAR5jiA/4zfIVWLMoEK7wMLwP6NvbW4wXY8THx4c1uN2UNDwMYPWuetUEwG+rEdAX4AgR7Qu5hyu46cZPkLRYwiNnVEByshLp+ioAQz81EsBRoQCrgcLK05y5HZ6kJcnIXCxitKamRuBWVlZExmYxlQB4SBzQ8DSqNTzw/OnpSa4IH1TcQylq6OfnZ2nzeobbsC6sD8bFGBTMg3H+FIjwQ7Wuwe4Z0IgsbYVBwQLu7+8pPT2dqqqqBPzm5uabBRlZ3RvjWBAWh5ebModBMjIyRD2Xl5dScZ+Xl0fHx8d0cnJCZWVlMl6TJ+Y5ODig/Px8eY4xeAd+4xn6an5RJ6D94uJC3odnvuT90fSYuUXB4gDFBFgcwE2p4+X6MjWUZnY1hlkeHx+pqKiIWlpaqLe3l+7u7qRfQ0ODGBZAjY2NVFdXR7m5uWKMnJwcOjw8pMLCQurp6ZE+aWlp1NbWJgpISUmRvhUVFdTa2krFxcUyBuv0tQa7RwqleKgysEoFAAAHMBZWXV1Ns7Oz3/VVw8FQqGo4U15WY1RWVtLq6qrcY/uDslD29/dpYmJCgJKTkyk1NZWmpqaov7+fOjs7KTMzk87OzmhtbU12i+vrayopKaGuri7ph/dgHMLTyqOrydaFmN5Sj6vnAH51dSWx2tzcLG3az5zY9HygZDY/Py/5AvNZCzwMwL6+PqqvrxeJwpBzc3Mif0BPT0+LMeAIVI31hIQEUQI8DSUE3Kc1KfjNepxETC+pV3wVwELKmhzNMWqIyclJUU93d7fXWPA2ChLm9va2GATzYG2APj8/986FkAMY5kRc69q0r78tM0LP0tYM5wsYcQYLYhEzMzP+90Hj9BaoQJaLi4uUlZX13bPT01NaXl6m9fV12t3dFSAkVEh7b29PjNLR0SHKMzP9e/bpzUDQCoysC+CFhYXAk3qgrZlbtxJtS0pKos3NTUlm5taEAvnW1tZKciovLxcPt7e3i3QRswgNJCyHw+E9FCnDmw70yGqVB/0cLLC5Zfk7sPgCRsEOgAQE7wEacQgAZHTMj7adnR2RKNowBwyxtbUlz5aWliQEMH5jY4MKCgro6OhIlIDxaH8L2ob4Gh0dLeWJ/+QXZVtTPCzb1NQkEwUDjH761aWHDxNej6t4DzIrgPAbIBhn/jYNj3kwFvcYh/H6ZajzaOzrwchfiNk824xtbGxshO9/N19mggPmLWD9SNGTEO5D+Ln5Zky72Wp/MNisnqHNgpgLBlg9gitgg01oIfvgGB4ePuDU/4UX+q8v8GCBAavQYf+VNTIy4h4cHPyH97vfGPwvX9/S/mJYJW2Ch6uXrZ+WAHcNDQ39zZt+PyeKzwzxVeVqGkA/Ja3xq+Dh7GUzkX3zx+DAwAAII/laxttEA4N8YBAH9/vJc5j5jwHzuc2JPwfxxyBXdwg8/EN/DP4vwADzqyH4OmxBwwAAAABJRU5ErkJggg=="

/***/ },
/* 60 */
/*!***************************************************************************************!*\
  !*** ./bower_components/prettyphoto/images/prettyPhoto/light_rounded/btnPrevious.png ***!
  \***************************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../../~/url-loader!./btnPrevious.png */ 61);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../../~/style-loader/addStyles.js */ 43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/url-loader/index.js!./btnPrevious.png", function() {
				var newContent = require("!!./../../../../../node_modules/url-loader/index.js!./btnPrevious.png");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 61 */
/*!******************************************************************************************************!*\
  !*** ./~/url-loader!./bower_components/prettyphoto/images/prettyPhoto/light_rounded/btnPrevious.png ***!
  \******************************************************************************************************/
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAAWCAYAAABzCZQcAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABURJREFUeNrUWElLLFcUPj04j4gTiIqioLgQRAhOKE4YtwpZZJN/IARciQtXgsrDRVAUxUhw2ATcBSIJcSQoAU2MUdQ4NCpOOM9D534nfZpr5/Zrk8Cj34FL3aq6dep85zvDrbIPDQ1d0X+XMNfxmj6QPD4+Wu/v720PDw/Wp6cn6/PzsxXXX15e/lCHX9XxZ3Xth6ampiV17jTpsPT19TnpIxAFhhRYuru7IwWWnE4nX8OAWK1WHhaLBWNbXfrm9vb265aWlj89wVtGR0f9HjTAXlxc0NXVFYMFMLvdLgB5jThBsexeo5zwnYqId83NzT/Cb6LP+jEAPj09pcvLSz4PCAigwMBAndW/2VNHm83G97AGwJUDPlXzVsV2hY4VOUH+OhRLdH5+Tjc3N6/Y1QXgTOcAjrWK/fygoKAvGxsbMwS4XzN9fX3NAwLAwq5JwsPDKTg4mEFLfuMZlyNqoqOjv1BTG4LC7ukpCLyMsJKCgRdJ2AgDOEL0kMI1FBq5JwUGa6BH1mIO/Tji3MQg3g3AyFM8pzPpuRaAi4qK+N7ExATrlrV4P+xROj5XbH/b3t6+YDd5TVU9io+Pf+W5vb09zq2QkBBKS0tjowTU6uoqGw/lWVlZ/FJhBYDW19cpMzOTdcBheBb6IyMjaXNz082IZy6r9iQF6RUIqdiQiIgIBgxbT05OWL+JSHUtRa1Fbv9mBA22srOzGcDy8jLFxcVRTU0N9ff3szHV1dV0eHjIL0lJSeF7AwMD5HA4qLKykhnCXFiem5ujiooKmp2dpfn5edZRV1fH71pcXGSDPUU3Xj8CsDhBGBbAMzMz7uqtPwfHYa6c+wmC04oTzwEmxJu9vb3U1tbG84KCAm4bkMnJSerp6eH7kMTERHYWZGNjgzo7O9lJw8PDzNj29jbl5ubS8fExp0JsbCwtLCzwXAw02SAG60OkpKTkFWBJR9NaV5rkIDjtvooJPJ6cnMxzKJf8iomJoaSkJCouLubz3d1dd5imp6dTQ0MDnwPk1NQUM1xfX08JCQmUkZHB6xBFYWFhxveCMT2fdQAAV1tbS6oq09nZ2T8Am6q5y4HJDFqS3ltodXV18fHo6IiNDw0N5fPy8nIeEg1wiAiiYWVlhY0C+5LXEOQ2GEd6wGDoM9mgbTt97tRkl/ZGsfhsWa2tre4wRigJmyMjI9Td3c1z5BUMl6oNQKiiYHdtbY2fw72trS0qLCzkVEBog2VvLUgvYCYZGxtjsIi4srIyYzHUBboUkQ6vfVrf6UjbkGou4QaGdnZ2aHp6mnJycji/sImAIIRLS0spPz+f8vLyOHIAEAUN1RaytLTEncCb4D3vAw0ZHx9n4LDNF3BX61pGxBu1AhzCGSxFRUW5t31iCK4DCKo68gmsoYqnpqZy+0Koo/ojd9He4DTo3N/f57DHeoQt9HoTU+/2FGxN3wocupTNc8gI41cW8gO9GsaCDTFONhUYUC5hC4ZdLYHB6PmF6gyWcYSjsBaOQ6RI5TYJdAAU3qX3ZZMgeqqqqngdnCC7OI8NkkNF5mcqJc2bExgvYejpLQDV+6rsst4iKGwYbxHRq7dPX4xjnSdg0aXIGFGAf0djsJOfChwMB8lmw1d1lq8wE4FKvld7h2EEkF+DFoYAXJj+F21Jrwu/qBrz1eDg4AY6IHLar0HLh47kpbRFX+EuRRcMA3BHR8dPLsDoqU6/Bq0Dl74tX3jv+12kxIEcRkhrDD/K3xO7qs7/56feB/sxKCAV2/xjUIW6TYG3qOtW17Z1FX1Y3Zs7ODiYcBWtJ41hd3j8JcAAJ3IhvjEWLJYAAAAASUVORK5CYII="

/***/ },
/* 62 */
/*!**********************************************************************************!*\
  !*** ./bower_components/prettyphoto/images/prettyPhoto/light_rounded/loader.gif ***!
  \**********************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../../~/url-loader!./loader.gif */ 63);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../../~/style-loader/addStyles.js */ 43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/url-loader/index.js!./loader.gif", function() {
				var newContent = require("!!./../../../../../node_modules/url-loader/index.js!./loader.gif");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 63 */
/*!*************************************************************************************************!*\
  !*** ./~/url-loader!./bower_components/prettyphoto/images/prettyPhoto/light_rounded/loader.gif ***!
  \*************************************************************************************************/
/***/ function(module, exports) {

	module.exports = "data:image/gif;base64,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"

/***/ },
/* 64 */
/*!*********************************************************************************!*\
  !*** ./bower_components/prettyphoto/images/prettyPhoto/dark_rounded/sprite.png ***!
  \*********************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../../~/url-loader!./sprite.png */ 65);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../../~/style-loader/addStyles.js */ 43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/url-loader/index.js!./sprite.png", function() {
				var newContent = require("!!./../../../../../node_modules/url-loader/index.js!./sprite.png");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 65 */
/*!************************************************************************************************!*\
  !*** ./~/url-loader!./bower_components/prettyphoto/images/prettyPhoto/dark_rounded/sprite.png ***!
  \************************************************************************************************/
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIIAAAB3CAYAAADPXJhXAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAD45JREFUeNrsXW1sFMcZHpvDQCDm03wZgiEmicN3gEZ8xnwYlxYIKIEflZIgBfEDqUqlVCUVqmKq/kikJGp/UhFhIdEfpPmRKrRFIGNQiEkAtaKACRgwThwHrBgwEAwhpu8znrmMJ7N3u3u7d7d380qj29udfWd23mfer52bK3j48CGzZCm2fft2x4uTJ0+eQh/LqMyjMp3KhIDaHSg+76TjIQF2lO7ubnb//v3C77//vg/KDz/8UPDgwYMuUa2F6vyP6jRQObht27bTNTU1eTNLCuhhTQAoo4+NNDCv0KCUYQBliRpJAJDAAQJGAGAEgPh5+UyFhYW8FBQUoFyhspvq11LdS3mhEQwgqKSP12ngVmGwMDCxWCw+UFEDAQDQ1dXFAYBP/ZlwrGoN1CdwTKDzfygqKppNl965e/fuobwCAkBAg/EWDcaz+N63b9+48OWARQ0EJER2+/ZtDgL9meJqUTwbPkn4cQ1C2uAXVLdkwIABW3MdDDHNHEATPCtnDCjK5uDevXvszp07HATqM0mtoNbXgYG6QjvMpePX+/Xr10z8LucqENSpsRHmgKMjFov0Q0Gw8AOgDaQmkM9Es5s9+uijzClaGjRoEK+j3kO8ftmnT5+NOa8REB0Ix5A/vNuQUs46DDhmDw0W69+/P1e/+A6imcTPq+r6u+++4/dh5mHQUVAHwoPgUMAbfMAP9aSTp85YlbcOAvBHAR/UwflHHnmEPffcc/z+o0ePslu3bvXSDADBggULeN3Dhw/z54IZAT+q9wr15QPq2+lcNg3LEB14uRGD09nZyQW1ePFi/gkBXrhwgTU1NbG5c+fy69euXeMDjMHF9Rs3brA5c+awMWPGcCGcPXuW3zNkyBCuxseOHcuefPJJDo62tjZ2/vx5DoLy8nIOItwD4SAC+Oabb7hwTQDFPRKMknAPQDh8+HAu8E8++YT7DyBoCZzDc3z77be8rowmwI/6P4EAhVD6dC6bhnl4WC8OIQZ0xIgRbNOmTVyIECZ4vPjii6yjo4MtW7aMVVRUxFUzhAIQbNmyhYOkpaWFg2Tt2rVszZo1rLW1lQNgw4YNvC4AMHXqVFZW1oPPFStWcABNnDiRTZo0ibdt8l9U71/1BeQ5aAIIGgJfuHAhB6nUBBIEqCNDTKkdxee8XHcWp2NQpTedzDSg7vXr19lLL73EhVlbW8sGDx7MZ3djY2MvR1MKBLP9mWee4TN4x44d7ObNm3zW4Xx1dTUX7IQJPfmqPXv2cLPw+eefs/Hjx8dNQl1dHRcSZi/Ah5mt91XNeZieSYIBgsf9ixYtipswCQKpSSQQACbRh+m5DoQJctB0j9pEGKiSkhI2cOBAdvDgQS6UYcOG8XshXOlsqQR7PXr0aH4MlY6ZjnMXL17k52ASoFWefvpp9t5777Hm5mZ25swZdurUKT5jQUuWLGEzZ87kQAPgrl69mjBq0J9JChZmAwKHSUPfQdBWEgSqJlABRjwey4s8gm5TnUjaT+kr4DuEKgWAgZYCkdfUe3Cs3iNt8aeffsrvhUmZMmUKB0txcTFraGjgdSD4y5cv89kLjYS6Omhlf5I9E+qppgXHMGNuxyBXfYQrXrKGmJEQBAh2FmoefgHMBLQBvG0JBDhjuI4B/uqrr/j50tJSXre9vR0RS1xL4PjEiRNs165dbPPmzfz80KFD46bh3Llz3ME7fvw4v9/UZ5EijjuVTv2vrKzkWkxGKTjGOafQWWiWllwFQh88PNnKRfSQU70kjyAc2NRZs2axadOmceFjJq9evZrt27ePrVy5Mh7KjRo1itv6+vp6Nn/+fDZjxgwODDiHy5cv5wLGtXXr1rF58+bx7B76BcAcO3aMAwn3oX/wD8aNG8c/oc7hS5jMgpzx+jNJEIwcOZID4MCBA+zSpUvcP4GfA5MHR1a/DyEogaGOtNDfcxkIpXS8Us68ZCTjeMzwL774gjuAMhw8cuQIDxshRDiCGHA4ZSgIKyFYEIABHwP1UWCroRWg9nENgjh06BDnD6HDRIA/nErwAiG8BGhMzqwKhkQgQC4BpgTPkggMAgg7CQif5SIQ+NtHkVD6mAakzItWkHYVBYMuE0pQo9AQ0leQOX4IHsLENZlQQn2YExxDIHpyCoKWSShpv9X7dFUutRB4oV/4lM+E9quqqnj/JAhUAuBwHfVxHUCWZoHauUKHq3I1oRR/DU1gqKGBflMVXlRJhq0AAgCnPhPAAMHqIFDBgPslCCSICZh/JDC+mQ9RQy2hfjbNqFVR95yhMaBRoE3UBBNIFbCJdIBA4xCvfaRlavMhakAM30wf79KDfxb1l04yYsBzYDYDEH6eSaxZOE5AejeX3zz2AoIAQz0N4hs0eB+b3ttHVSugwAl1+0yoI8zBP4nP1rxbmCLBQP5CM82GkzQQkV6qJsEg31JCwHapmksgKGaihgDxAd64Ucmrxat03i5etZSfVGiHwJIFgqXePkJFRcVDk6OVaF2CuuBDp8bGRlcrXDLVriWfGkFd7q06YInqBuX1Z6LdvAWCOojyFa6+zEudqaZBV+/zKuh0t2vJAQjqQK9fvz7+HcemmYhjrC2U5+SxV2Go7RrWBzoe6+csCALUCHK27d27lwvWLaEu7vGjntV2gzAhllJ0FlU17AUMKgh0Hl60gqre9XYlf6fzujmxlAIQVJXrRRuoAoJgvNpqk6rXBZ0MEG4iDUseNIIcTF0ATmSq50cYJiFKjaS3Ic+pYLAACDh8DGJA/ahnp3Z1gZuAYX2E4Ii/a0BiJ1Gixuvs9pJQykS7lpIklFLVCn7vz1S7lgzhY1CmwYuaNrWrm4Nkx0GGoXkPhKDCL6/JnUTt6j5BopDWJpUCihrUmekUrzuFjcnqudUIeh9M/Lwmuyz5CB/dxOuJwshUzYuTiUjWH5tDCCGPIAViitcThXj4TPRiyE3IKe930ixO5/22a8nBR3ATr7uJ9/1kFoMQpNUKAeYREr3rdzvQYjscT3mEdLdrKUH4mEhtO9UxhW1+1yOks11LDj6CaRDdzMYwEkHpaNeSAxAylZq1KeEsA4JdvGrJLl61ZHYW7eJV6yz+ZEC9LiL16yzKRbN6fsLURhCpbUsOQAhKraaiEdwK1pRythohQB9BV79eXwf7XUSqCtDPolm7eDUE02ASSqK3j/q1IBavpqPddFIKvzZ/gspSBFdURrGerQSKlMmLjR2wsyi2FsAWtI1U6qic99N+LNFgOs1QkzD8CsK0aDbZ4tUc9w9eZT2bf48Vgnci/D/BAFFGUMEfsa2h8jUVbFX7vmeNYBJkMhWtvyb2OzMTLV516z/kiI+wSWiAEjySTx4AThnr2dBkmdAQOz1rBFUwXl8Hp5oryGNnb47QAo+z4LYpwKCOxHwl04A/KHufPk+4TijZxatpp5epvEFlMgtnr4pCwfsNAsLLrsLHZKYh2U/P/IShQS6ajSC9RqWKSv80tDVEaIehVP7iqBFM4RcEnMgMmK4HvXjVzTk/7WYJCKrTBAJJaKuagPCaIxCc0rhhLyJ1WjTrtt2ILmR9WWiCogy0jTarTGai0MneJluypgslKPWcqXbT6BiuSbMmMGmGNQSGOUYg6Kt+nOJ1p+NUFq+q2Uw3UYkKhogtXn1V2OtM0xDRl5/6CEHNML+LV1WNkEjlO12PgI+wSYSI2UKPk1bY9JM8QqLB9LqI1A94TJrAKdsZ0chhKcuu7QwLRZ929nIWkw2uXbyaskkoycJ+lZBWeLWXaTD9UbabRaSp/ropE+1mgPDuIBtVVoHom128mgbCW8SxWdy/saQVnrBb8KbHNyjK4v6hb0stEMKniij00QIhfBoVhT7Gw8fS0tLx9PEC68mBzxanT1LZT+XD1tbWL/20EBbfCNHAKPQxJoQFz3Erlee1Cj8XpZLqvE1Ca/AIglD4RoyKotDHQjFjdWE1aRVxbauo60UTmEDQlArfCFIUzC//y7MXNGHhj7ArDZWfF3Xd0gsGEDDBuyUFvpZCQmu18r0VgiJV3epQv9oDb2NdwbtStOWHr6WQgCAduHYBgstCYAUodDhGqT/bA2+17hiFHxNtVIo2vfK1lCH7FcT/Az+wQ539QDgpjvFSpJ4ct4nC2XuIosxaptR1Q2rddoUfE23Usx9fxJy0osg8EParzr4AQ6lD/f0eeO93iCZKBQhKffK1FBIQPqTykXLuMSEonT4Sdd2SzldSvWjDL9+oURT+R7m7UGT23taEVm4AwdtesoAOfHXenvlGkO5HoY8xIbQG0ti/FrM1sFRwWHwjRviR6oBs72NMm8F/FiUwCotvhAi/VB6R7X20bx/Dp8Yo9NECIXyqy3I/AX2rs0AIn7BxxddZ3L+va2pqzqvrEQazntU08OplWrmN9bwtbCRbf9NPK2HxjRjhNTv2LMi2NZoPRd+YXI+A18ALqDxlCPVQyqjOUa8eflh8I0jYvQQbV4zMsn61kzbgO6sUihmrC6tDuwHXFoi6XjSBCQQdqfCNuK+QTcmlbtEnToVCbavCgqquNdz4FPO2ELPCAAImeN9MgW9UCb8ouphF/blI2mCnCgQ109cJQZGq7nS4udxDQ+UOeYVOAYZOn3yjbiJuZEE/bjBts62Y4sDdESC4LgRWI1T8IPr4ragzxkNjat13iN9tBQzXiS/AgJ9bDfTIN8qEfYz+QQW/4s3UT+O70Ad9TyU34WMQdq2bWZK0m8qBDOUW0OYBAsFu/UJMhHLlYmZupJm6S8zYGgOjNg+Ntikq/3fyzTY0DR0PRVvsx6XebXkGBrmPUVUaNUOXAIHjHkrqquJiAYZiB2ZNHhpucogmigUIin3yzSUw7E2Tz4A29jqBQAIBufBzyrnBQlA6nWPe8uY6X0kbRRt++eaamXiLyoWQzGe34P2WyRz0Mg3I7CGpo4RyoGEGEBz1kgV04Kvz9sw3Rx1IlCB2XpUklxjWqSFiQiAIoX1JQvsXHTazAFPBYfHN4TzDTuZ+L2YnZzC1vZiFQI6JEhiFxTfHcw0ogezO7hkIlsKhFLbpP+9XqH7Ivoa2ZIFgyQLBkslHIM8eq4vbybFrCaMR4o+Fq1jJ+xtq467+3YohezTCzxDTk4C2UQlj6fVGKpuVcEj/bimLTAMA8CcBiF/ZobE+An6OtofA8BmVmXaIrLMIc/EfAsNOKqPtUNmoASnPC8J/sDY9z8NHRBMnycO/b4csP4GA9wSvU5lFIPi3Ha4czyM40F+p/J4A0GGHKT+BcJj1JHr+a4cnP4HQIjTA30Jop5L1/JfxbYfvlrIECLD/tWGle3XtYrVN9lFBHv8nsyUf4aMlCwRL+UD/F2AAZDs5F9dqVQcAAAAASUVORK5CYII="

/***/ },
/* 66 */
/*!*****************************************************************************************!*\
  !*** ./bower_components/prettyphoto/images/prettyPhoto/dark_rounded/contentPattern.png ***!
  \*****************************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../../~/url-loader!./contentPattern.png */ 67);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../../~/style-loader/addStyles.js */ 43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/url-loader/index.js!./contentPattern.png", function() {
				var newContent = require("!!./../../../../../node_modules/url-loader/index.js!./contentPattern.png");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 67 */
/*!********************************************************************************************************!*\
  !*** ./~/url-loader!./bower_components/prettyphoto/images/prettyPhoto/dark_rounded/contentPattern.png ***!
  \********************************************************************************************************/
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACRJREFUeNpiZGBg2M9ARcDEQGUwauCogaMGjho4auBQMRAgwAA63wDniG/BMgAAAABJRU5ErkJggg=="

/***/ },
/* 68 */
/*!**********************************************************************************!*\
  !*** ./bower_components/prettyphoto/images/prettyPhoto/dark_rounded/btnNext.png ***!
  \**********************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../../~/url-loader!./btnNext.png */ 69);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../../~/style-loader/addStyles.js */ 43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/url-loader/index.js!./btnNext.png", function() {
				var newContent = require("!!./../../../../../node_modules/url-loader/index.js!./btnNext.png");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 69 */
/*!*************************************************************************************************!*\
  !*** ./~/url-loader!./bower_components/prettyphoto/images/prettyPhoto/dark_rounded/btnNext.png ***!
  \*************************************************************************************************/
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAAWCAYAAABzCZQcAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABSVJREFUeNrMmMlLZEkQxqO03FcUFA+DCypoqQcRmlZccANRUTw4oIfpg3cv42UYET3YgtBHz/MHiApzcFxmxIMgOhe9KG6HHnBXxH2rqokvqCiyX1eVZV+qEpL3Kl9mvvxFfBGZr2xut5tsNhuNj4+Tj+Lg5418/ch9SvmajUZu+xoXF1cQFRXlio2NddrtdhfmCEFJ8Fzv3jPIrjcPDw/eRgbK4csnl8v1C9ccGIavUlEiIiKKXl9fxVgMTNHR0RQTE0ORkZEUYvj3QaMkJiaS0+msY8hf+dqqKgAYg3qB0I4K8JeXF1IDYDwbLFTgPwbtAR5jiA/4zfIVWLMoEK7wMLwP6NvbW4wXY8THx4c1uN2UNDwMYPWuetUEwG+rEdAX4AgR7Qu5hyu46cZPkLRYwiNnVEByshLp+ioAQz81EsBRoQCrgcLK05y5HZ6kJcnIXCxitKamRuBWVlZExmYxlQB4SBzQ8DSqNTzw/OnpSa4IH1TcQylq6OfnZ2nzeobbsC6sD8bFGBTMg3H+FIjwQ7Wuwe4Z0IgsbYVBwQLu7+8pPT2dqqqqBPzm5uabBRlZ3RvjWBAWh5ebModBMjIyRD2Xl5dScZ+Xl0fHx8d0cnJCZWVlMl6TJ+Y5ODig/Px8eY4xeAd+4xn6an5RJ6D94uJC3odnvuT90fSYuUXB4gDFBFgcwE2p4+X6MjWUZnY1hlkeHx+pqKiIWlpaqLe3l+7u7qRfQ0ODGBZAjY2NVFdXR7m5uWKMnJwcOjw8pMLCQurp6ZE+aWlp1NbWJgpISUmRvhUVFdTa2krFxcUyBuv0tQa7RwqleKgysEoFAAAHMBZWXV1Ns7Oz3/VVw8FQqGo4U15WY1RWVtLq6qrcY/uDslD29/dpYmJCgJKTkyk1NZWmpqaov7+fOjs7KTMzk87OzmhtbU12i+vrayopKaGuri7ph/dgHMLTyqOrydaFmN5Sj6vnAH51dSWx2tzcLG3az5zY9HygZDY/Py/5AvNZCzwMwL6+PqqvrxeJwpBzc3Mif0BPT0+LMeAIVI31hIQEUQI8DSUE3Kc1KfjNepxETC+pV3wVwELKmhzNMWqIyclJUU93d7fXWPA2ChLm9va2GATzYG2APj8/986FkAMY5kRc69q0r78tM0LP0tYM5wsYcQYLYhEzMzP+90Hj9BaoQJaLi4uUlZX13bPT01NaXl6m9fV12t3dFSAkVEh7b29PjNLR0SHKMzP9e/bpzUDQCoysC+CFhYXAk3qgrZlbtxJtS0pKos3NTUlm5taEAvnW1tZKciovLxcPt7e3i3QRswgNJCyHw+E9FCnDmw70yGqVB/0cLLC5Zfk7sPgCRsEOgAQE7wEacQgAZHTMj7adnR2RKNowBwyxtbUlz5aWliQEMH5jY4MKCgro6OhIlIDxaH8L2ob4Gh0dLeWJ/+QXZVtTPCzb1NQkEwUDjH761aWHDxNej6t4DzIrgPAbIBhn/jYNj3kwFvcYh/H6ZajzaOzrwchfiNk824xtbGxshO9/N19mggPmLWD9SNGTEO5D+Ln5Zky72Wp/MNisnqHNgpgLBlg9gitgg01oIfvgGB4ePuDU/4UX+q8v8GCBAavQYf+VNTIy4h4cHPyH97vfGPwvX9/S/mJYJW2Ch6uXrZ+WAHcNDQ39zZt+PyeKzwzxVeVqGkA/Ja3xq+Dh7GUzkX3zx+DAwAAII/laxttEA4N8YBAH9/vJc5j5jwHzuc2JPwfxxyBXdwg8/EN/DP4vwADzqyH4OmxBwwAAAABJRU5ErkJggg=="

/***/ },
/* 70 */
/*!**************************************************************************************!*\
  !*** ./bower_components/prettyphoto/images/prettyPhoto/dark_rounded/btnPrevious.png ***!
  \**************************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../../~/url-loader!./btnPrevious.png */ 71);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../../~/style-loader/addStyles.js */ 43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/url-loader/index.js!./btnPrevious.png", function() {
				var newContent = require("!!./../../../../../node_modules/url-loader/index.js!./btnPrevious.png");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 71 */
/*!*****************************************************************************************************!*\
  !*** ./~/url-loader!./bower_components/prettyphoto/images/prettyPhoto/dark_rounded/btnPrevious.png ***!
  \*****************************************************************************************************/
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAAWCAYAAABzCZQcAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABURJREFUeNrUWElLLFcUPj04j4gTiIqioLgQRAhOKE4YtwpZZJN/IARciQtXgsrDRVAUxUhw2ATcBSIJcSQoAU2MUdQ4NCpOOM9D534nfZpr5/Zrk8Cj34FL3aq6dep85zvDrbIPDQ1d0X+XMNfxmj6QPD4+Wu/v720PDw/Wp6cn6/PzsxXXX15e/lCHX9XxZ3Xth6ampiV17jTpsPT19TnpIxAFhhRYuru7IwWWnE4nX8OAWK1WHhaLBWNbXfrm9vb265aWlj89wVtGR0f9HjTAXlxc0NXVFYMFMLvdLgB5jThBsexeo5zwnYqId83NzT/Cb6LP+jEAPj09pcvLSz4PCAigwMBAndW/2VNHm83G97AGwJUDPlXzVsV2hY4VOUH+OhRLdH5+Tjc3N6/Y1QXgTOcAjrWK/fygoKAvGxsbMwS4XzN9fX3NAwLAwq5JwsPDKTg4mEFLfuMZlyNqoqOjv1BTG4LC7ukpCLyMsJKCgRdJ2AgDOEL0kMI1FBq5JwUGa6BH1mIO/Tji3MQg3g3AyFM8pzPpuRaAi4qK+N7ExATrlrV4P+xROj5XbH/b3t6+YDd5TVU9io+Pf+W5vb09zq2QkBBKS0tjowTU6uoqGw/lWVlZ/FJhBYDW19cpMzOTdcBheBb6IyMjaXNz082IZy6r9iQF6RUIqdiQiIgIBgxbT05OWL+JSHUtRa1Fbv9mBA22srOzGcDy8jLFxcVRTU0N9ff3szHV1dV0eHjIL0lJSeF7AwMD5HA4qLKykhnCXFiem5ujiooKmp2dpfn5edZRV1fH71pcXGSDPUU3Xj8CsDhBGBbAMzMz7uqtPwfHYa6c+wmC04oTzwEmxJu9vb3U1tbG84KCAm4bkMnJSerp6eH7kMTERHYWZGNjgzo7O9lJw8PDzNj29jbl5ubS8fExp0JsbCwtLCzwXAw02SAG60OkpKTkFWBJR9NaV5rkIDjtvooJPJ6cnMxzKJf8iomJoaSkJCouLubz3d1dd5imp6dTQ0MDnwPk1NQUM1xfX08JCQmUkZHB6xBFYWFhxveCMT2fdQAAV1tbS6oq09nZ2T8Am6q5y4HJDFqS3ltodXV18fHo6IiNDw0N5fPy8nIeEg1wiAiiYWVlhY0C+5LXEOQ2GEd6wGDoM9mgbTt97tRkl/ZGsfhsWa2tre4wRigJmyMjI9Td3c1z5BUMl6oNQKiiYHdtbY2fw72trS0qLCzkVEBog2VvLUgvYCYZGxtjsIi4srIyYzHUBboUkQ6vfVrf6UjbkGou4QaGdnZ2aHp6mnJycji/sImAIIRLS0spPz+f8vLyOHIAEAUN1RaytLTEncCb4D3vAw0ZHx9n4LDNF3BX61pGxBu1AhzCGSxFRUW5t31iCK4DCKo68gmsoYqnpqZy+0Koo/ojd9He4DTo3N/f57DHeoQt9HoTU+/2FGxN3wocupTNc8gI41cW8gO9GsaCDTFONhUYUC5hC4ZdLYHB6PmF6gyWcYSjsBaOQ6RI5TYJdAAU3qX3ZZMgeqqqqngdnCC7OI8NkkNF5mcqJc2bExgvYejpLQDV+6rsst4iKGwYbxHRq7dPX4xjnSdg0aXIGFGAf0djsJOfChwMB8lmw1d1lq8wE4FKvld7h2EEkF+DFoYAXJj+F21Jrwu/qBrz1eDg4AY6IHLar0HLh47kpbRFX+EuRRcMA3BHR8dPLsDoqU6/Bq0Dl74tX3jv+12kxIEcRkhrDD/K3xO7qs7/56feB/sxKCAV2/xjUIW6TYG3qOtW17Z1FX1Y3Zs7ODiYcBWtJ41hd3j8JcAAJ3IhvjEWLJYAAAAASUVORK5CYII="

/***/ },
/* 72 */
/*!*********************************************************************************!*\
  !*** ./bower_components/prettyphoto/images/prettyPhoto/dark_rounded/loader.gif ***!
  \*********************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../../~/url-loader!./loader.gif */ 73);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../../~/style-loader/addStyles.js */ 43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/url-loader/index.js!./loader.gif", function() {
				var newContent = require("!!./../../../../../node_modules/url-loader/index.js!./loader.gif");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 73 */
/*!************************************************************************************************!*\
  !*** ./~/url-loader!./bower_components/prettyphoto/images/prettyPhoto/dark_rounded/loader.gif ***!
  \************************************************************************************************/
/***/ function(module, exports) {

	module.exports = "data:image/gif;base64,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"

/***/ },
/* 74 */
/*!********************************************************************************!*\
  !*** ./bower_components/prettyphoto/images/prettyPhoto/dark_square/loader.gif ***!
  \********************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../../~/url-loader!./loader.gif */ 75);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../../~/style-loader/addStyles.js */ 43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/url-loader/index.js!./loader.gif", function() {
				var newContent = require("!!./../../../../../node_modules/url-loader/index.js!./loader.gif");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 75 */
/*!***********************************************************************************************!*\
  !*** ./~/url-loader!./bower_components/prettyphoto/images/prettyPhoto/dark_square/loader.gif ***!
  \***********************************************************************************************/
/***/ function(module, exports) {

	module.exports = "data:image/gif;base64,R0lGODlhGAAYAPQAADIyMv///1hYWDU1NUpKSnBwcENDQ4uLi11dXYCAgFBQUHd3d2NjYzs7O5+fn5KSkmpqaqqqqgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJBwAAACwAAAAAGAAYAAAFriAgjiQAQWVaDgr5POSgkoTDjFE0NoQ8iw8HQZQTDQjDn4jhSABhAAOhoTqSDg7qSUQwxEaEwwFhXHhHgzOA1xshxAnfTzotGRaHglJqkJcaVEqCgyoCBQkJBQKDDXQGDYaIioyOgYSXA36XIgYMBWRzXZoKBQUMmil0lgalLSIClgBpO0g+s26nUWddXyoEDIsACq5SsTMMDIECwUdJPw0Mzsu0qHYkw72bBmozIQAh+QQJBwAAACwAAAAAGAAYAAAFsCAgjiTAMGVaDgR5HKQwqKNxIKPjjFCk0KNXC6ATKSI7oAhxWIhezwhENTCQEoeGCdWIPEgzESGxEIgGBWstEW4QCGGAIJEoxGmGt5ZkgCRQQHkGd2CESoeIIwoMBQUMP4cNeQQGDYuNj4iSb5WJnmeGng0CDGaBlIQEJziHk3sABidDAHBgagButSKvAAoyuHuUYHgCkAZqebw0AgLBQyyzNKO3byNuoSS8x8OfwIchACH5BAkHAAAALAAAAAAYABgAAAW4ICCOJIAgZVoOBJkkpDKoo5EI43GMjNPSokXCINKJCI4HcCRIQEQvqIOhGhBHhUTDhGo4diOZyFAoKEQDxra2mAEgjghOpCgz3LTBIxJ5kgwMBShACREHZ1V4Kg1rS44pBAgMDAg/Sw0GBAQGDZGTlY+YmpyPpSQDiqYiDQoCliqZBqkGAgKIS5kEjQ21VwCyp76dBHiNvz+MR74AqSOdVwbQuo+abppo10ssjdkAnc0rf8vgl8YqIQAh+QQJBwAAACwAAAAAGAAYAAAFrCAgjiQgCGVaDgZZFCQxqKNRKGOSjMjR0qLXTyciHA7AkaLACMIAiwOC1iAxCrMToHHYjWQiA4NBEA0Q1RpWxHg4cMXxNDk4OBxNUkPAQAEXDgllKgMzQA1pSYopBgonCj9JEA8REQ8QjY+RQJOVl4ugoYssBJuMpYYjDQSliwasiQOwNakALKqsqbWvIohFm7V6rQAGP6+JQLlFg7KDQLKJrLjBKbvAor3IKiEAIfkECQcAAAAsAAAAABgAGAAABbUgII4koChlmhokw5DEoI4NQ4xFMQoJO4uuhignMiQWvxGBIQC+AJBEUyUcIRiyE6CR0CllW4HABxBURTUw4nC4FcWo5CDBRpQaCoF7VjgsyCUDYDMNZ0mHdwYEBAaGMwwHDg4HDA2KjI4qkJKUiJ6faJkiA4qAKQkRB3E0i6YpAw8RERAjA4tnBoMApCMQDhFTuySKoSKMJAq6rD4GzASiJYtgi6PUcs9Kew0xh7rNJMqIhYchACH5BAkHAAAALAAAAAAYABgAAAW0ICCOJEAQZZo2JIKQxqCOjWCMDDMqxT2LAgELkBMZCoXfyCBQiFwiRsGpku0EshNgUNAtrYPT0GQVNRBWwSKBMp98P24iISgNDAS4ipGA6JUpA2WAhDR4eWM/CAkHBwkIDYcGiTOLjY+FmZkNlCN3eUoLDmwlDW+AAwcODl5bYl8wCVYMDw5UWzBtnAANEQ8kBIM0oAAGPgcREIQnVloAChEOqARjzgAQEbczg8YkWJq8nSUhACH5BAkHAAAALAAAAAAYABgAAAWtICCOJGAYZZoOpKKQqDoORDMKwkgwtiwSBBYAJ2owGL5RgxBziQQMgkwoMkhNqAEDARPSaiMDFdDIiRSFQowMXE8Z6RdpYHWnEAWGPVkajPmARVZMPUkCBQkJBQINgwaFPoeJi4GVlQ2Qc3VJBQcLV0ptfAMJBwdcIl+FYjALQgimoGNWIhAQZA4HXSpLMQ8PIgkOSHxAQhERPw7ASTSFyCMMDqBTJL8tf3y2fCEAIfkECQcAAAAsAAAAABgAGAAABa8gII4k0DRlmg6kYZCoOg5EDBDEaAi2jLO3nEkgkMEIL4BLpBAkVy3hCTAQKGAznM0AFNFGBAbj2cA9jQixcGZAGgECBu/9HnTp+FGjjezJFAwFBQwKe2Z+KoCChHmNjVMqA21nKQwJEJRlbnUFCQlFXlpeCWcGBUACCwlrdw8RKGImBwktdyMQEQciB7oACwcIeA4RVwAODiIGvHQKERAjxyMIB5QlVSTLYLZ0sW8hACH5BAkHAAAALAAAAAAYABgAAAW0ICCOJNA0ZZoOpGGQrDoOBCoSxNgQsQzgMZyIlvOJdi+AS2SoyXrK4umWPM5wNiV0UDUIBNkdoepTfMkA7thIECiyRtUAGq8fm2O4jIBgMBA1eAZ6Knx+gHaJR4QwdCMKBxEJRggFDGgQEREPjjAMBQUKIwIRDhBDC2QNDDEKoEkDoiMHDigICGkJBS2dDA6TAAnAEAkCdQ8ORQcHTAkLcQQODLPMIgIJaCWxJMIkPIoAt3EhACH5BAkHAAAALAAAAAAYABgAAAWtICCOJNA0ZZoOpGGQrDoOBCoSxNgQsQzgMZyIlvOJdi+AS2SoyXrK4umWHM5wNiV0UN3xdLiqr+mENcWpM9TIbrsBkEck8oC0DQqBQGGIz+t3eXtob0ZTPgNrIwQJDgtGAgwCWSIMDg4HiiUIDAxFAAoODwxDBWINCEGdSTQkCQcoegADBaQ6MggHjwAFBZUFCm0HB0kJCUy9bAYHCCPGIwqmRq0jySMGmj6yRiEAIfkECQcAAAAsAAAAABgAGAAABbIgII4k0DRlmg6kYZCsOg4EKhLE2BCxDOAxnIiW84l2L4BLZKipBopW8XRLDkeCiAMyMvQAA+uON4JEIo+vqukkKQ6RhLHplVGN+LyKcXA4Dgx5DWwGDXx+gIKENnqNdzIDaiMECwcFRgQCCowiCAcHCZIlCgICVgSfCEMMnA0CXaU2YSQFoQAKUQMMqjoyAglcAAyBAAIMRUYLCUkFlybDeAYJryLNk6xGNCTQXY0juHghACH5BAkHAAAALAAAAAAYABgAAAWzICCOJNA0ZVoOAmkY5KCSSgSNBDE2hDyLjohClBMNij8RJHIQvZwEVOpIekRQJyJs5AMoHA+GMbE1lnm9EcPhOHRnhpwUl3AsknHDm5RN+v8qCAkHBwkIfw1xBAYNgoSGiIqMgJQifZUjBhAJYj95ewIJCQV7KYpzBAkLLQADCHOtOpY5PgNlAAykAEUsQ1wzCgWdCIdeArczBQVbDJ0NAqyeBb64nQAGArBTt8R8mLuyPyEAOwAAAAAAAAAAAA=="

/***/ },
/* 76 */
/*!********************************************************************************!*\
  !*** ./bower_components/prettyphoto/images/prettyPhoto/dark_square/sprite.png ***!
  \********************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../../~/url-loader!./sprite.png */ 77);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../../~/style-loader/addStyles.js */ 43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/url-loader/index.js!./sprite.png", function() {
				var newContent = require("!!./../../../../../node_modules/url-loader/index.js!./sprite.png");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 77 */
/*!***********************************************************************************************!*\
  !*** ./~/url-loader!./bower_components/prettyphoto/images/prettyPhoto/dark_square/sprite.png ***!
  \***********************************************************************************************/
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 78 */
/*!*********************************************************************************!*\
  !*** ./bower_components/prettyphoto/images/prettyPhoto/dark_square/btnNext.png ***!
  \*********************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../../~/url-loader!./btnNext.png */ 79);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../../~/style-loader/addStyles.js */ 43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/url-loader/index.js!./btnNext.png", function() {
				var newContent = require("!!./../../../../../node_modules/url-loader/index.js!./btnNext.png");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 79 */
/*!************************************************************************************************!*\
  !*** ./~/url-loader!./bower_components/prettyphoto/images/prettyPhoto/dark_square/btnNext.png ***!
  \************************************************************************************************/
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAAWCAYAAABzCZQcAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABSVJREFUeNrMmMlLZEkQxqO03FcUFA+DCypoqQcRmlZccANRUTw4oIfpg3cv42UYET3YgtBHz/MHiApzcFxmxIMgOhe9KG6HHnBXxH2rqokvqCiyX1eVZV+qEpL3Kl9mvvxFfBGZr2xut5tsNhuNj4+Tj+Lg5418/ch9SvmajUZu+xoXF1cQFRXlio2NddrtdhfmCEFJ8Fzv3jPIrjcPDw/eRgbK4csnl8v1C9ccGIavUlEiIiKKXl9fxVgMTNHR0RQTE0ORkZEUYvj3QaMkJiaS0+msY8hf+dqqKgAYg3qB0I4K8JeXF1IDYDwbLFTgPwbtAR5jiA/4zfIVWLMoEK7wMLwP6NvbW4wXY8THx4c1uN2UNDwMYPWuetUEwG+rEdAX4AgR7Qu5hyu46cZPkLRYwiNnVEByshLp+ioAQz81EsBRoQCrgcLK05y5HZ6kJcnIXCxitKamRuBWVlZExmYxlQB4SBzQ8DSqNTzw/OnpSa4IH1TcQylq6OfnZ2nzeobbsC6sD8bFGBTMg3H+FIjwQ7Wuwe4Z0IgsbYVBwQLu7+8pPT2dqqqqBPzm5uabBRlZ3RvjWBAWh5ebModBMjIyRD2Xl5dScZ+Xl0fHx8d0cnJCZWVlMl6TJ+Y5ODig/Px8eY4xeAd+4xn6an5RJ6D94uJC3odnvuT90fSYuUXB4gDFBFgcwE2p4+X6MjWUZnY1hlkeHx+pqKiIWlpaqLe3l+7u7qRfQ0ODGBZAjY2NVFdXR7m5uWKMnJwcOjw8pMLCQurp6ZE+aWlp1NbWJgpISUmRvhUVFdTa2krFxcUyBuv0tQa7RwqleKgysEoFAAAHMBZWXV1Ns7Oz3/VVw8FQqGo4U15WY1RWVtLq6qrcY/uDslD29/dpYmJCgJKTkyk1NZWmpqaov7+fOjs7KTMzk87OzmhtbU12i+vrayopKaGuri7ph/dgHMLTyqOrydaFmN5Sj6vnAH51dSWx2tzcLG3az5zY9HygZDY/Py/5AvNZCzwMwL6+PqqvrxeJwpBzc3Mif0BPT0+LMeAIVI31hIQEUQI8DSUE3Kc1KfjNepxETC+pV3wVwELKmhzNMWqIyclJUU93d7fXWPA2ChLm9va2GATzYG2APj8/986FkAMY5kRc69q0r78tM0LP0tYM5wsYcQYLYhEzMzP+90Hj9BaoQJaLi4uUlZX13bPT01NaXl6m9fV12t3dFSAkVEh7b29PjNLR0SHKMzP9e/bpzUDQCoysC+CFhYXAk3qgrZlbtxJtS0pKos3NTUlm5taEAvnW1tZKciovLxcPt7e3i3QRswgNJCyHw+E9FCnDmw70yGqVB/0cLLC5Zfk7sPgCRsEOgAQE7wEacQgAZHTMj7adnR2RKNowBwyxtbUlz5aWliQEMH5jY4MKCgro6OhIlIDxaH8L2ob4Gh0dLeWJ/+QXZVtTPCzb1NQkEwUDjH761aWHDxNej6t4DzIrgPAbIBhn/jYNj3kwFvcYh/H6ZajzaOzrwchfiNk824xtbGxshO9/N19mggPmLWD9SNGTEO5D+Ln5Zky72Wp/MNisnqHNgpgLBlg9gitgg01oIfvgGB4ePuDU/4UX+q8v8GCBAavQYf+VNTIy4h4cHPyH97vfGPwvX9/S/mJYJW2Ch6uXrZ+WAHcNDQ39zZt+PyeKzwzxVeVqGkA/Ja3xq+Dh7GUzkX3zx+DAwAAII/laxttEA4N8YBAH9/vJc5j5jwHzuc2JPwfxxyBXdwg8/EN/DP4vwADzqyH4OmxBwwAAAABJRU5ErkJggg=="

/***/ },
/* 80 */
/*!*************************************************************************************!*\
  !*** ./bower_components/prettyphoto/images/prettyPhoto/dark_square/btnPrevious.png ***!
  \*************************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../../~/url-loader!./btnPrevious.png */ 81);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../../~/style-loader/addStyles.js */ 43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/url-loader/index.js!./btnPrevious.png", function() {
				var newContent = require("!!./../../../../../node_modules/url-loader/index.js!./btnPrevious.png");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 81 */
/*!****************************************************************************************************!*\
  !*** ./~/url-loader!./bower_components/prettyphoto/images/prettyPhoto/dark_square/btnPrevious.png ***!
  \****************************************************************************************************/
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAAWCAYAAABzCZQcAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABURJREFUeNrUWElLLFcUPj04j4gTiIqioLgQRAhOKE4YtwpZZJN/IARciQtXgsrDRVAUxUhw2ATcBSIJcSQoAU2MUdQ4NCpOOM9D534nfZpr5/Zrk8Cj34FL3aq6dep85zvDrbIPDQ1d0X+XMNfxmj6QPD4+Wu/v720PDw/Wp6cn6/PzsxXXX15e/lCHX9XxZ3Xth6ampiV17jTpsPT19TnpIxAFhhRYuru7IwWWnE4nX8OAWK1WHhaLBWNbXfrm9vb265aWlj89wVtGR0f9HjTAXlxc0NXVFYMFMLvdLgB5jThBsexeo5zwnYqId83NzT/Cb6LP+jEAPj09pcvLSz4PCAigwMBAndW/2VNHm83G97AGwJUDPlXzVsV2hY4VOUH+OhRLdH5+Tjc3N6/Y1QXgTOcAjrWK/fygoKAvGxsbMwS4XzN9fX3NAwLAwq5JwsPDKTg4mEFLfuMZlyNqoqOjv1BTG4LC7ukpCLyMsJKCgRdJ2AgDOEL0kMI1FBq5JwUGa6BH1mIO/Tji3MQg3g3AyFM8pzPpuRaAi4qK+N7ExATrlrV4P+xROj5XbH/b3t6+YDd5TVU9io+Pf+W5vb09zq2QkBBKS0tjowTU6uoqGw/lWVlZ/FJhBYDW19cpMzOTdcBheBb6IyMjaXNz082IZy6r9iQF6RUIqdiQiIgIBgxbT05OWL+JSHUtRa1Fbv9mBA22srOzGcDy8jLFxcVRTU0N9ff3szHV1dV0eHjIL0lJSeF7AwMD5HA4qLKykhnCXFiem5ujiooKmp2dpfn5edZRV1fH71pcXGSDPUU3Xj8CsDhBGBbAMzMz7uqtPwfHYa6c+wmC04oTzwEmxJu9vb3U1tbG84KCAm4bkMnJSerp6eH7kMTERHYWZGNjgzo7O9lJw8PDzNj29jbl5ubS8fExp0JsbCwtLCzwXAw02SAG60OkpKTkFWBJR9NaV5rkIDjtvooJPJ6cnMxzKJf8iomJoaSkJCouLubz3d1dd5imp6dTQ0MDnwPk1NQUM1xfX08JCQmUkZHB6xBFYWFhxveCMT2fdQAAV1tbS6oq09nZ2T8Am6q5y4HJDFqS3ltodXV18fHo6IiNDw0N5fPy8nIeEg1wiAiiYWVlhY0C+5LXEOQ2GEd6wGDoM9mgbTt97tRkl/ZGsfhsWa2tre4wRigJmyMjI9Td3c1z5BUMl6oNQKiiYHdtbY2fw72trS0qLCzkVEBog2VvLUgvYCYZGxtjsIi4srIyYzHUBboUkQ6vfVrf6UjbkGou4QaGdnZ2aHp6mnJycji/sImAIIRLS0spPz+f8vLyOHIAEAUN1RaytLTEncCb4D3vAw0ZHx9n4LDNF3BX61pGxBu1AhzCGSxFRUW5t31iCK4DCKo68gmsoYqnpqZy+0Koo/ojd9He4DTo3N/f57DHeoQt9HoTU+/2FGxN3wocupTNc8gI41cW8gO9GsaCDTFONhUYUC5hC4ZdLYHB6PmF6gyWcYSjsBaOQ6RI5TYJdAAU3qX3ZZMgeqqqqngdnCC7OI8NkkNF5mcqJc2bExgvYejpLQDV+6rsst4iKGwYbxHRq7dPX4xjnSdg0aXIGFGAf0djsJOfChwMB8lmw1d1lq8wE4FKvld7h2EEkF+DFoYAXJj+F21Jrwu/qBrz1eDg4AY6IHLar0HLh47kpbRFX+EuRRcMA3BHR8dPLsDoqU6/Bq0Dl74tX3jv+12kxIEcRkhrDD/K3xO7qs7/56feB/sxKCAV2/xjUIW6TYG3qOtW17Z1FX1Y3Zs7ODiYcBWtJ41hd3j8JcAAJ3IhvjEWLJYAAAAASUVORK5CYII="

/***/ },
/* 82 */
/*!*********************************************************************************!*\
  !*** ./bower_components/prettyphoto/images/prettyPhoto/light_square/sprite.png ***!
  \*********************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../../~/url-loader!./sprite.png */ 83);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../../~/style-loader/addStyles.js */ 43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/url-loader/index.js!./sprite.png", function() {
				var newContent = require("!!./../../../../../node_modules/url-loader/index.js!./sprite.png");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 83 */
/*!************************************************************************************************!*\
  !*** ./~/url-loader!./bower_components/prettyphoto/images/prettyPhoto/light_square/sprite.png ***!
  \************************************************************************************************/
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 84 */
/*!**********************************************************************************!*\
  !*** ./bower_components/prettyphoto/images/prettyPhoto/light_square/btnNext.png ***!
  \**********************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../../~/url-loader!./btnNext.png */ 85);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../../~/style-loader/addStyles.js */ 43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/url-loader/index.js!./btnNext.png", function() {
				var newContent = require("!!./../../../../../node_modules/url-loader/index.js!./btnNext.png");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 85 */
/*!*************************************************************************************************!*\
  !*** ./~/url-loader!./bower_components/prettyphoto/images/prettyPhoto/light_square/btnNext.png ***!
  \*************************************************************************************************/
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAAWCAYAAABzCZQcAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABSVJREFUeNrMmMlLZEkQxqO03FcUFA+DCypoqQcRmlZccANRUTw4oIfpg3cv42UYET3YgtBHz/MHiApzcFxmxIMgOhe9KG6HHnBXxH2rqokvqCiyX1eVZV+qEpL3Kl9mvvxFfBGZr2xut5tsNhuNj4+Tj+Lg5418/ch9SvmajUZu+xoXF1cQFRXlio2NddrtdhfmCEFJ8Fzv3jPIrjcPDw/eRgbK4csnl8v1C9ccGIavUlEiIiKKXl9fxVgMTNHR0RQTE0ORkZEUYvj3QaMkJiaS0+msY8hf+dqqKgAYg3qB0I4K8JeXF1IDYDwbLFTgPwbtAR5jiA/4zfIVWLMoEK7wMLwP6NvbW4wXY8THx4c1uN2UNDwMYPWuetUEwG+rEdAX4AgR7Qu5hyu46cZPkLRYwiNnVEByshLp+ioAQz81EsBRoQCrgcLK05y5HZ6kJcnIXCxitKamRuBWVlZExmYxlQB4SBzQ8DSqNTzw/OnpSa4IH1TcQylq6OfnZ2nzeobbsC6sD8bFGBTMg3H+FIjwQ7Wuwe4Z0IgsbYVBwQLu7+8pPT2dqqqqBPzm5uabBRlZ3RvjWBAWh5ebModBMjIyRD2Xl5dScZ+Xl0fHx8d0cnJCZWVlMl6TJ+Y5ODig/Px8eY4xeAd+4xn6an5RJ6D94uJC3odnvuT90fSYuUXB4gDFBFgcwE2p4+X6MjWUZnY1hlkeHx+pqKiIWlpaqLe3l+7u7qRfQ0ODGBZAjY2NVFdXR7m5uWKMnJwcOjw8pMLCQurp6ZE+aWlp1NbWJgpISUmRvhUVFdTa2krFxcUyBuv0tQa7RwqleKgysEoFAAAHMBZWXV1Ns7Oz3/VVw8FQqGo4U15WY1RWVtLq6qrcY/uDslD29/dpYmJCgJKTkyk1NZWmpqaov7+fOjs7KTMzk87OzmhtbU12i+vrayopKaGuri7ph/dgHMLTyqOrydaFmN5Sj6vnAH51dSWx2tzcLG3az5zY9HygZDY/Py/5AvNZCzwMwL6+PqqvrxeJwpBzc3Mif0BPT0+LMeAIVI31hIQEUQI8DSUE3Kc1KfjNepxETC+pV3wVwELKmhzNMWqIyclJUU93d7fXWPA2ChLm9va2GATzYG2APj8/986FkAMY5kRc69q0r78tM0LP0tYM5wsYcQYLYhEzMzP+90Hj9BaoQJaLi4uUlZX13bPT01NaXl6m9fV12t3dFSAkVEh7b29PjNLR0SHKMzP9e/bpzUDQCoysC+CFhYXAk3qgrZlbtxJtS0pKos3NTUlm5taEAvnW1tZKciovLxcPt7e3i3QRswgNJCyHw+E9FCnDmw70yGqVB/0cLLC5Zfk7sPgCRsEOgAQE7wEacQgAZHTMj7adnR2RKNowBwyxtbUlz5aWliQEMH5jY4MKCgro6OhIlIDxaH8L2ob4Gh0dLeWJ/+QXZVtTPCzb1NQkEwUDjH761aWHDxNej6t4DzIrgPAbIBhn/jYNj3kwFvcYh/H6ZajzaOzrwchfiNk824xtbGxshO9/N19mggPmLWD9SNGTEO5D+Ln5Zky72Wp/MNisnqHNgpgLBlg9gitgg01oIfvgGB4ePuDU/4UX+q8v8GCBAavQYf+VNTIy4h4cHPyH97vfGPwvX9/S/mJYJW2Ch6uXrZ+WAHcNDQ39zZt+PyeKzwzxVeVqGkA/Ja3xq+Dh7GUzkX3zx+DAwAAII/laxttEA4N8YBAH9/vJc5j5jwHzuc2JPwfxxyBXdwg8/EN/DP4vwADzqyH4OmxBwwAAAABJRU5ErkJggg=="

/***/ },
/* 86 */
/*!**************************************************************************************!*\
  !*** ./bower_components/prettyphoto/images/prettyPhoto/light_square/btnPrevious.png ***!
  \**************************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../../~/url-loader!./btnPrevious.png */ 87);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../../~/style-loader/addStyles.js */ 43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/url-loader/index.js!./btnPrevious.png", function() {
				var newContent = require("!!./../../../../../node_modules/url-loader/index.js!./btnPrevious.png");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 87 */
/*!*****************************************************************************************************!*\
  !*** ./~/url-loader!./bower_components/prettyphoto/images/prettyPhoto/light_square/btnPrevious.png ***!
  \*****************************************************************************************************/
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAAWCAYAAABzCZQcAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABURJREFUeNrUWElLLFcUPj04j4gTiIqioLgQRAhOKE4YtwpZZJN/IARciQtXgsrDRVAUxUhw2ATcBSIJcSQoAU2MUdQ4NCpOOM9D534nfZpr5/Zrk8Cj34FL3aq6dep85zvDrbIPDQ1d0X+XMNfxmj6QPD4+Wu/v720PDw/Wp6cn6/PzsxXXX15e/lCHX9XxZ3Xth6ampiV17jTpsPT19TnpIxAFhhRYuru7IwWWnE4nX8OAWK1WHhaLBWNbXfrm9vb265aWlj89wVtGR0f9HjTAXlxc0NXVFYMFMLvdLgB5jThBsexeo5zwnYqId83NzT/Cb6LP+jEAPj09pcvLSz4PCAigwMBAndW/2VNHm83G97AGwJUDPlXzVsV2hY4VOUH+OhRLdH5+Tjc3N6/Y1QXgTOcAjrWK/fygoKAvGxsbMwS4XzN9fX3NAwLAwq5JwsPDKTg4mEFLfuMZlyNqoqOjv1BTG4LC7ukpCLyMsJKCgRdJ2AgDOEL0kMI1FBq5JwUGa6BH1mIO/Tji3MQg3g3AyFM8pzPpuRaAi4qK+N7ExATrlrV4P+xROj5XbH/b3t6+YDd5TVU9io+Pf+W5vb09zq2QkBBKS0tjowTU6uoqGw/lWVlZ/FJhBYDW19cpMzOTdcBheBb6IyMjaXNz082IZy6r9iQF6RUIqdiQiIgIBgxbT05OWL+JSHUtRa1Fbv9mBA22srOzGcDy8jLFxcVRTU0N9ff3szHV1dV0eHjIL0lJSeF7AwMD5HA4qLKykhnCXFiem5ujiooKmp2dpfn5edZRV1fH71pcXGSDPUU3Xj8CsDhBGBbAMzMz7uqtPwfHYa6c+wmC04oTzwEmxJu9vb3U1tbG84KCAm4bkMnJSerp6eH7kMTERHYWZGNjgzo7O9lJw8PDzNj29jbl5ubS8fExp0JsbCwtLCzwXAw02SAG60OkpKTkFWBJR9NaV5rkIDjtvooJPJ6cnMxzKJf8iomJoaSkJCouLubz3d1dd5imp6dTQ0MDnwPk1NQUM1xfX08JCQmUkZHB6xBFYWFhxveCMT2fdQAAV1tbS6oq09nZ2T8Am6q5y4HJDFqS3ltodXV18fHo6IiNDw0N5fPy8nIeEg1wiAiiYWVlhY0C+5LXEOQ2GEd6wGDoM9mgbTt97tRkl/ZGsfhsWa2tre4wRigJmyMjI9Td3c1z5BUMl6oNQKiiYHdtbY2fw72trS0qLCzkVEBog2VvLUgvYCYZGxtjsIi4srIyYzHUBboUkQ6vfVrf6UjbkGou4QaGdnZ2aHp6mnJycji/sImAIIRLS0spPz+f8vLyOHIAEAUN1RaytLTEncCb4D3vAw0ZHx9n4LDNF3BX61pGxBu1AhzCGSxFRUW5t31iCK4DCKo68gmsoYqnpqZy+0Koo/ojd9He4DTo3N/f57DHeoQt9HoTU+/2FGxN3wocupTNc8gI41cW8gO9GsaCDTFONhUYUC5hC4ZdLYHB6PmF6gyWcYSjsBaOQ6RI5TYJdAAU3qX3ZZMgeqqqqngdnCC7OI8NkkNF5mcqJc2bExgvYejpLQDV+6rsst4iKGwYbxHRq7dPX4xjnSdg0aXIGFGAf0djsJOfChwMB8lmw1d1lq8wE4FKvld7h2EEkF+DFoYAXJj+F21Jrwu/qBrz1eDg4AY6IHLar0HLh47kpbRFX+EuRRcMA3BHR8dPLsDoqU6/Bq0Dl74tX3jv+12kxIEcRkhrDD/K3xO7qs7/56feB/sxKCAV2/xjUIW6TYG3qOtW17Z1FX1Y3Zs7ODiYcBWtJ41hd3j8JcAAJ3IhvjEWLJYAAAAASUVORK5CYII="

/***/ },
/* 88 */
/*!*****************************************************************************!*\
  !*** ./bower_components/prettyphoto/images/prettyPhoto/facebook/sprite.png ***!
  \*****************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../../~/url-loader!./sprite.png */ 89);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../../~/style-loader/addStyles.js */ 43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/url-loader/index.js!./sprite.png", function() {
				var newContent = require("!!./../../../../../node_modules/url-loader/index.js!./sprite.png");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 89 */
/*!********************************************************************************************!*\
  !*** ./~/url-loader!./bower_components/prettyphoto/images/prettyPhoto/facebook/sprite.png ***!
  \********************************************************************************************/
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 90 */
/*!****************************************************************************************!*\
  !*** ./bower_components/prettyphoto/images/prettyPhoto/facebook/contentPatternTop.png ***!
  \****************************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../../~/url-loader!./contentPatternTop.png */ 91);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../../~/style-loader/addStyles.js */ 43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/url-loader/index.js!./contentPatternTop.png", function() {
				var newContent = require("!!./../../../../../node_modules/url-loader/index.js!./contentPatternTop.png");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 91 */
/*!*******************************************************************************************************!*\
  !*** ./~/url-loader!./bower_components/prettyphoto/images/prettyPhoto/facebook/contentPatternTop.png ***!
  \*******************************************************************************************************/
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADBJREFUeNpiZGBgaGCgImBioDIYNXDUwMFgIOOePXtOU9XA/0AwGimjBg43AwECDABqMQehO1Ts4gAAAABJRU5ErkJggg=="

/***/ },
/* 92 */
/*!*****************************************************************************************!*\
  !*** ./bower_components/prettyphoto/images/prettyPhoto/facebook/contentPatternLeft.png ***!
  \*****************************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../../~/url-loader!./contentPatternLeft.png */ 93);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../../~/style-loader/addStyles.js */ 43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/url-loader/index.js!./contentPatternLeft.png", function() {
				var newContent = require("!!./../../../../../node_modules/url-loader/index.js!./contentPatternLeft.png");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 93 */
/*!********************************************************************************************************!*\
  !*** ./~/url-loader!./bower_components/prettyphoto/images/prettyPhoto/facebook/contentPatternLeft.png ***!
  \********************************************************************************************************/
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACtJREFUeNpiZGBgaGAgEvz//7+ekBomBiqDUQNHDRw1cNTAUQOHioEAAQYAGcUEJOA4znwAAAAASUVORK5CYII="

/***/ },
/* 94 */
/*!******************************************************************************************!*\
  !*** ./bower_components/prettyphoto/images/prettyPhoto/facebook/contentPatternRight.png ***!
  \******************************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../../~/url-loader!./contentPatternRight.png */ 95);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../../~/style-loader/addStyles.js */ 43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/url-loader/index.js!./contentPatternRight.png", function() {
				var newContent = require("!!./../../../../../node_modules/url-loader/index.js!./contentPatternRight.png");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 95 */
/*!*********************************************************************************************************!*\
  !*** ./~/url-loader!./bower_components/prettyphoto/images/prettyPhoto/facebook/contentPatternRight.png ***!
  \*********************************************************************************************************/
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACpJREFUeNpi/A8EDAQAIyNjIwORgImBymDUwFEDRw0cNXDUwKFiIECAAQDh+ASoAGHc9gAAAABJRU5ErkJggg=="

/***/ },
/* 96 */
/*!*****************************************************************************!*\
  !*** ./bower_components/prettyphoto/images/prettyPhoto/facebook/loader.gif ***!
  \*****************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../../~/url-loader!./loader.gif */ 97);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../../~/style-loader/addStyles.js */ 43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/url-loader/index.js!./loader.gif", function() {
				var newContent = require("!!./../../../../../node_modules/url-loader/index.js!./loader.gif");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 97 */
/*!********************************************************************************************!*\
  !*** ./~/url-loader!./bower_components/prettyphoto/images/prettyPhoto/facebook/loader.gif ***!
  \********************************************************************************************/
/***/ function(module, exports) {

	module.exports = "data:image/gif;base64,R0lGODlhGAAYAPQAAP///3FxcePj4/v7++3t7dLS0vHx8b+/v+Dg4MfHx+jo6M7Oztvb2/f397Kysru7u9fX16qqqgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJBwAAACwAAAAAGAAYAAAFriAgjiQAQWVaDgr5POSgkoTDjFE0NoQ8iw8HQZQTDQjDn4jhSABhAAOhoTqSDg7qSUQwxEaEwwFhXHhHgzOA1xshxAnfTzotGRaHglJqkJcaVEqCgyoCBQkJBQKDDXQGDYaIioyOgYSXA36XIgYMBWRzXZoKBQUMmil0lgalLSIClgBpO0g+s26nUWddXyoEDIsACq5SsTMMDIECwUdJPw0Mzsu0qHYkw72bBmozIQAh+QQJBwAAACwAAAAAGAAYAAAFsCAgjiTAMGVaDgR5HKQwqKNxIKPjjFCk0KNXC6ATKSI7oAhxWIhezwhENTCQEoeGCdWIPEgzESGxEIgGBWstEW4QCGGAIJEoxGmGt5ZkgCRQQHkGd2CESoeIIwoMBQUMP4cNeQQGDYuNj4iSb5WJnmeGng0CDGaBlIQEJziHk3sABidDAHBgagButSKvAAoyuHuUYHgCkAZqebw0AgLBQyyzNKO3byNuoSS8x8OfwIchACH5BAkHAAAALAAAAAAYABgAAAW4ICCOJIAgZVoOBJkkpDKoo5EI43GMjNPSokXCINKJCI4HcCRIQEQvqIOhGhBHhUTDhGo4diOZyFAoKEQDxra2mAEgjghOpCgz3LTBIxJ5kgwMBShACREHZ1V4Kg1rS44pBAgMDAg/Sw0GBAQGDZGTlY+YmpyPpSQDiqYiDQoCliqZBqkGAgKIS5kEjQ21VwCyp76dBHiNvz+MR74AqSOdVwbQuo+abppo10ssjdkAnc0rf8vgl8YqIQAh+QQJBwAAACwAAAAAGAAYAAAFrCAgjiQgCGVaDgZZFCQxqKNRKGOSjMjR0qLXTyciHA7AkaLACMIAiwOC1iAxCrMToHHYjWQiA4NBEA0Q1RpWxHg4cMXxNDk4OBxNUkPAQAEXDgllKgMzQA1pSYopBgonCj9JEA8REQ8QjY+RQJOVl4ugoYssBJuMpYYjDQSliwasiQOwNakALKqsqbWvIohFm7V6rQAGP6+JQLlFg7KDQLKJrLjBKbvAor3IKiEAIfkECQcAAAAsAAAAABgAGAAABbUgII4koChlmhokw5DEoI4NQ4xFMQoJO4uuhignMiQWvxGBIQC+AJBEUyUcIRiyE6CR0CllW4HABxBURTUw4nC4FcWo5CDBRpQaCoF7VjgsyCUDYDMNZ0mHdwYEBAaGMwwHDg4HDA2KjI4qkJKUiJ6faJkiA4qAKQkRB3E0i6YpAw8RERAjA4tnBoMApCMQDhFTuySKoSKMJAq6rD4GzASiJYtgi6PUcs9Kew0xh7rNJMqIhYchACH5BAkHAAAALAAAAAAYABgAAAW0ICCOJEAQZZo2JIKQxqCOjWCMDDMqxT2LAgELkBMZCoXfyCBQiFwiRsGpku0EshNgUNAtrYPT0GQVNRBWwSKBMp98P24iISgNDAS4ipGA6JUpA2WAhDR4eWM/CAkHBwkIDYcGiTOLjY+FmZkNlCN3eUoLDmwlDW+AAwcODl5bYl8wCVYMDw5UWzBtnAANEQ8kBIM0oAAGPgcREIQnVloAChEOqARjzgAQEbczg8YkWJq8nSUhACH5BAkHAAAALAAAAAAYABgAAAWtICCOJGAYZZoOpKKQqDoORDMKwkgwtiwSBBYAJ2owGL5RgxBziQQMgkwoMkhNqAEDARPSaiMDFdDIiRSFQowMXE8Z6RdpYHWnEAWGPVkajPmARVZMPUkCBQkJBQINgwaFPoeJi4GVlQ2Qc3VJBQcLV0ptfAMJBwdcIl+FYjALQgimoGNWIhAQZA4HXSpLMQ8PIgkOSHxAQhERPw7ASTSFyCMMDqBTJL8tf3y2fCEAIfkECQcAAAAsAAAAABgAGAAABa8gII4k0DRlmg6kYZCoOg5EDBDEaAi2jLO3nEkgkMEIL4BLpBAkVy3hCTAQKGAznM0AFNFGBAbj2cA9jQixcGZAGgECBu/9HnTp+FGjjezJFAwFBQwKe2Z+KoCChHmNjVMqA21nKQwJEJRlbnUFCQlFXlpeCWcGBUACCwlrdw8RKGImBwktdyMQEQciB7oACwcIeA4RVwAODiIGvHQKERAjxyMIB5QlVSTLYLZ0sW8hACH5BAkHAAAALAAAAAAYABgAAAW0ICCOJNA0ZZoOpGGQrDoOBCoSxNgQsQzgMZyIlvOJdi+AS2SoyXrK4umWPM5wNiV0UDUIBNkdoepTfMkA7thIECiyRtUAGq8fm2O4jIBgMBA1eAZ6Knx+gHaJR4QwdCMKBxEJRggFDGgQEREPjjAMBQUKIwIRDhBDC2QNDDEKoEkDoiMHDigICGkJBS2dDA6TAAnAEAkCdQ8ORQcHTAkLcQQODLPMIgIJaCWxJMIkPIoAt3EhACH5BAkHAAAALAAAAAAYABgAAAWtICCOJNA0ZZoOpGGQrDoOBCoSxNgQsQzgMZyIlvOJdi+AS2SoyXrK4umWHM5wNiV0UN3xdLiqr+mENcWpM9TIbrsBkEck8oC0DQqBQGGIz+t3eXtob0ZTPgNrIwQJDgtGAgwCWSIMDg4HiiUIDAxFAAoODwxDBWINCEGdSTQkCQcoegADBaQ6MggHjwAFBZUFCm0HB0kJCUy9bAYHCCPGIwqmRq0jySMGmj6yRiEAIfkECQcAAAAsAAAAABgAGAAABbIgII4k0DRlmg6kYZCsOg4EKhLE2BCxDOAxnIiW84l2L4BLZKipBopW8XRLDkeCiAMyMvQAA+uON4JEIo+vqukkKQ6RhLHplVGN+LyKcXA4Dgx5DWwGDXx+gIKENnqNdzIDaiMECwcFRgQCCowiCAcHCZIlCgICVgSfCEMMnA0CXaU2YSQFoQAKUQMMqjoyAglcAAyBAAIMRUYLCUkFlybDeAYJryLNk6xGNCTQXY0juHghACH5BAkHAAAALAAAAAAYABgAAAWzICCOJNA0ZVoOAmkY5KCSSgSNBDE2hDyLjohClBMNij8RJHIQvZwEVOpIekRQJyJs5AMoHA+GMbE1lnm9EcPhOHRnhpwUl3AsknHDm5RN+v8qCAkHBwkIfw1xBAYNgoSGiIqMgJQifZUjBhAJYj95ewIJCQV7KYpzBAkLLQADCHOtOpY5PgNlAAykAEUsQ1wzCgWdCIdeArczBQVbDJ0NAqyeBb64nQAGArBTt8R8mLuyPyEAOwAAAAAAAAAAAA=="

/***/ },
/* 98 */
/*!******************************************************************************!*\
  !*** ./bower_components/prettyphoto/images/prettyPhoto/facebook/btnNext.png ***!
  \******************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../../~/url-loader!./btnNext.png */ 99);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../../~/style-loader/addStyles.js */ 43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/url-loader/index.js!./btnNext.png", function() {
				var newContent = require("!!./../../../../../node_modules/url-loader/index.js!./btnNext.png");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 99 */
/*!*********************************************************************************************!*\
  !*** ./~/url-loader!./bower_components/prettyphoto/images/prettyPhoto/facebook/btnNext.png ***!
  \*********************************************************************************************/
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADkAAAAvCAYAAABZl2IDAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAu9JREFUeNrcmj9oGlEcx9+ZSCTGCLGU2mqHDrEUC+2QobQgBJQuBTN0MDalrkFdHBQyhA4WxUgGwSEZbJvGDg6pSAlEGhBaMjpUSs3gIKZX0hptvSSmJl5/rzkhLRnu6r+794Xv8vD0ffid7/1+7/0odL5kYAP4BlgDvsSN9UpN8FdwGfwJnOfG/hLLsry+jDpn7AJ4CnwFiUc74DXw905A3gFPguVIfGqAN8Fb7UCawXeR+PUBnBYC2fqfGSUCiLh5GoU8gCEHwBYkLU1y8+YNiVfQUYlBjnHz5g05jqSpcSGQWolC6oRAjkgUclQIpKLTvx4KhW71AFLQwtNxOZ3O+4uLi7fFEvKu5aNut/uB3++/STSkTCajfD7flNfrNRAL2QKFaD50uVzXiIX8szqAwuGwzeFwXCUWEksulw9Go9Fpm83Wl/JtsJ2HoQqY5/tZhUIxtLy8PM0wzItUKrVLXCRbUiqVw6urqzMmk2mMWEgslUo1kkwmn0xMTKiJhcRSq9Wq9fX1x0ajcYRYSCyNRjO2sbExYzAYhomFxNJqtRfT6fQjnU43RCwkll6v1y4tLZmIhiwUCkW73b5JLGSxWNyB7SReqVSOiYSkaXrXYrHES6XSEZELT7lc3gPAlXw+f0DkFlKtVn+YzebnuVyOITIZqNVqjNVqfZnNZmuSSdApinp63vjh4aEPJ+Rnx/b39w9gFV3JZDJ7RJZa9Xr9COrJV72uPnoG2Wg0jmdnZ+OJRIImsmg+AXk8ntexWKxI5PFHs9lk5+bmEpFIpNDvrKorkCzLNgOBwFowGMwjEagrkAsLC28hih+RSIRvmn2oC1cFPdAveGOe8Y0kg6Spn0JeV1qikLQQyG2JQm4LgcTNQHsSA6xw8+YNeYJO+2OkpHfcvAVtITl0pglI5Nri5itoCzkLfA+MD5UGRAiHI5cBv0dcnx2JvXVvwN/+yaz+G7IV1evotFcG31tc7gPYF3yQwL2an1EbXZK/BRgAFzPpBTpJpB8AAAAASUVORK5CYII="

/***/ },
/* 100 */
/*!**********************************************************************************!*\
  !*** ./bower_components/prettyphoto/images/prettyPhoto/facebook/btnPrevious.png ***!
  \**********************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../../~/url-loader!./btnPrevious.png */ 101);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../../~/style-loader/addStyles.js */ 43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/url-loader/index.js!./btnPrevious.png", function() {
				var newContent = require("!!./../../../../../node_modules/url-loader/index.js!./btnPrevious.png");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 101 */
/*!*************************************************************************************************!*\
  !*** ./~/url-loader!./bower_components/prettyphoto/images/prettyPhoto/facebook/btnPrevious.png ***!
  \*************************************************************************************************/
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADkAAAAvCAYAAABZl2IDAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAt5JREFUeNrcmj9oWkEcx+9ppDXGCFpCbbRDh1iKhXbIUFoQCkoXwQwdrE3brEFdMkRwaQfBIOIgOLhY2qqDQyoOglKh0JIxQ6XUDA5iaklrtFVKUhPt78gbUkhLz+Tee/e+8F1uuPt93v3e/Xnvx41GI/Q/4jjupGYF2AK+BjaAL/JtQmkI/gJugz+Ca3zbn7GfAvICeAE8i6SjbfA6+NtZQN4C3wWrkPQ0AFfAG6eBtINvI+nrPbiMxnh/rIwAIj5OKymkEuxAbAm/UkoSSLyCTjMGqcdxk0DOITY1RwJpZBTSRAI5xSjkNAnkedrRRCKRGxS6VSqk8rhjsdhNr9d7j0bfkoAMhULX/X6/k1b/okOurq5aAoHAgkKh4GQJ6fP5rsAs3qcJKCrk0tLS5Wg06laCaI8lCqTb7Z5NJBIPVCrVhBDjkdxCnp7FgE6ncyabzT7WaDSTRIFy3DMmZtJms+nT6fQiKSAz6To/P6/L5/NPtFqt4CcnQSCtVutUsVh8pNPptGKsAdQhLRbLZKlUWjQYDHqxVnKqkCaT6Vy5XH5oNBpnxNyPqUImk0mb2WwW/YpGFdLj8VTq9XpD1pCdTucAto1Mo9HYli0kVrPZ3Hc4HJlWq7UjW0isWq32E0BfttvtXdlCYlWr1b7dbn/e7Xa/yxYSa3Nzs+dyuV70er2+kOMKfkD/1yF9b29vX61Wh2Vx1SoUCjtwn3yFoWSXrseVy+Vay8vLmcFgcCBbSKxUKtVYWVnJHoJkC4kVj8frwWAwNxwOR7KFxFpbW6uFw+F1WASHNPqfQBIRzOYHyFoqkCRbSAAJ8KuAgn6RpGsfsakfJJAtRiFbJJBbjEJukUDiYqBdxgA7OG4SSLxhVxiDfIPjJt0nq+hYEZDEtcHHO1axEn4wd8A2dFT2IjXhjHsLfof4Ojs51ta9Bn8d9zDwt2PhVXRU44M/Hl8SAewzuMun5id0QpXkbwEGAOy05C/ulRDiAAAAAElFTkSuQmCC"

/***/ },
/* 102 */
/*!*******************************************************************************************!*\
  !*** ./bower_components/prettyphoto/images/prettyPhoto/facebook/contentPatternBottom.png ***!
  \*******************************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../../~/url-loader!./contentPatternBottom.png */ 103);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../../~/style-loader/addStyles.js */ 43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/url-loader/index.js!./contentPatternBottom.png", function() {
				var newContent = require("!!./../../../../../node_modules/url-loader/index.js!./contentPatternBottom.png");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 103 */
/*!**********************************************************************************************************!*\
  !*** ./~/url-loader!./bower_components/prettyphoto/images/prettyPhoto/facebook/contentPatternBottom.png ***!
  \**********************************************************************************************************/
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADBJREFUeNpi/A8EDFQETAxUBqMGjhpIBmDZu3fvGWoayAjEDaORMmrgqIEEAECAAQC+aAeosx4HmQAAAABJRU5ErkJggg=="

/***/ },
/* 104 */
/*!****************************************************************************************!*\
  !*** ./bower_components/prettyphoto/images/prettyPhoto/facebook/default_thumbnail.gif ***!
  \****************************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../../~/url-loader!./default_thumbnail.gif */ 105);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../../~/style-loader/addStyles.js */ 43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/url-loader/index.js!./default_thumbnail.gif", function() {
				var newContent = require("!!./../../../../../node_modules/url-loader/index.js!./default_thumbnail.gif");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 105 */
/*!*******************************************************************************************************!*\
  !*** ./~/url-loader!./bower_components/prettyphoto/images/prettyPhoto/facebook/default_thumbnail.gif ***!
  \*******************************************************************************************************/
/***/ function(module, exports) {

	module.exports = "data:image/gif;base64,R0lGODlhMgAhAMQAAAAAAP///2lpaXt7ewkJCTAwMOHh4VpaWgYGBvPz8zMzMxgYGBISEiEhIZycnMnJyfDw8MDAwPb29khISJmZmdXV1XJych4eHgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAAAAAAALAAAAAAyACEAAAVgICCOZGmeaKqubOu+cCzPdG3feK7vfO//OcUFCBNIBgRiSxAIGA7KFbMZeBSiqCk14FhgS9ptYoD4isLUysR83gYgljIbEKYw5qNp5IrPP/slDUmAhIWGh4iJiouMjYghADs="

/***/ },
/* 106 */
/*!**************************************************************!*\
  !*** ./pixo/assets/jquery.mb.YTPlayer/jquery.mb.YTPlayer.js ***!
  \**************************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/*___________________________________________________________________________________________________________________________________________________
	 _ jquery.mb.components                                                                                                                             _
	 _                                                                                                                                                  _
	 _ file: jquery.mb.YTPlayer.src.js                                                                                                                  _
	 _ last modified: 05/01/16 17.43                                                                                                                    _
	 _                                                                                                                                                  _
	 _ Open Lab s.r.l., Florence - Italy                                                                                                                _
	 _                                                                                                                                                  _
	 _ email: matteo@open-lab.com                                                                                                                       _
	 _ site: http://pupunzi.com                                                                                                                         _
	 _       http://open-lab.com                                                                                                                        _
	 _ blog: http://pupunzi.open-lab.com                                                                                                                _
	 _ Q&A:  http://jquery.pupunzi.com                                                                                                                  _
	 _                                                                                                                                                  _
	 _ Licences: MIT, GPL                                                                                                                               _
	 _    http://www.opensource.org/licenses/mit-license.php                                                                                            _
	 _    http://www.gnu.org/licenses/gpl.html                                                                                                          _
	 _                                                                                                                                                  _
	 _ Copyright (c) 2001-2016. Matteo Bicocchi (Pupunzi);                                                                                              _
	 ___________________________________________________________________________________________________________________________________________________*/
	var ytp = ytp || {};
	
	function onYouTubeIframeAPIReady() {
		if( ytp.YTAPIReady ) return;
		ytp.YTAPIReady = true;
		jQuery( document ).trigger( "YTAPIReady" );
	}
	
	var getYTPVideoID = function( url ) {
		var videoID, playlistID;
		if( url.indexOf( "youtu.be" ) > 0 ) {
			videoID = url.substr( url.lastIndexOf( "/" ) + 1, url.length );
			playlistID = videoID.indexOf( "?list=" ) > 0 ? videoID.substr( videoID.lastIndexOf( "=" ), videoID.length ) : null;
			videoID = playlistID ? videoID.substr( 0, videoID.lastIndexOf( "?" ) ) : videoID;
		} else if( url.indexOf( "http" ) > -1 ) {
			//videoID = url.match( /([\/&]v\/([^&#]*))|([\\?&]v=([^&#]*))/ )[ 1 ];
			videoID = url.match( /[\\?&]v=([^&#]*)/ )[ 1 ];
			playlistID = url.indexOf( "list=" ) > 0 ? url.match( /[\\?&]list=([^&#]*)/ )[ 1 ] : null;
		} else {
			videoID = url.length > 15 ? null : url;
			playlistID = videoID ? null : url;
		}
		return {
			videoID: videoID,
			playlistID: playlistID
		};
	};
	
	( function( jQuery, ytp ) {
	
		jQuery.mbYTPlayer = {
			name: "jquery.mb.YTPlayer",
			version: "2.9.12",
			build: "5815",
			author: "Matteo Bicocchi",
			apiKey: "",
			defaults: {
				containment: "body",
				ratio: "auto", // "auto", "16/9", "4/3"
				videoURL: null,
				playlistURL: null,
				startAt: 0,
				stopAt: 0,
				autoPlay: true,
				vol: 50, // 1 to 100
				addRaster: false,
				opacity: 1,
				quality: "default", //or “small”, “medium”, “large”, “hd720”, “hd1080”, “highres”
				mute: false,
				loop: true,
				showControls: true,
				showAnnotations: false,
				showYTLogo: true,
				stopMovieOnBlur: true,
				realfullscreen: true,
				gaTrack: true,
				optimizeDisplay: true,
				onReady: function( player ) {}
			},
			/**
			 *  @fontface icons
			 *  */
			controls: {
				play: "P",
				pause: "p",
				mute: "M",
				unmute: "A",
				onlyYT: "O",
				showSite: "R",
				ytLogo: "Y"
			},
			locationProtocol: "https:",
			/**
			 *
			 * @param options
			 * @returns [players]
			 */
			buildPlayer: function( options ) {
				return this.each( function() {
					var YTPlayer = this;
					var $YTPlayer = jQuery( YTPlayer );
					YTPlayer.loop = 0;
					YTPlayer.opt = {};
					YTPlayer.state = {};
					YTPlayer.filtersEnabled = true;
					YTPlayer.filters = {
						grayscale: {
							value: 0,
							unit: "%"
						},
						hue_rotate: {
							value: 0,
							unit: "deg"
						},
						invert: {
							value: 0,
							unit: "%"
						},
						opacity: {
							value: 0,
							unit: "%"
						},
						saturate: {
							value: 0,
							unit: "%"
						},
						sepia: {
							value: 0,
							unit: "%"
						},
						brightness: {
							value: 0,
							unit: "%"
						},
						contrast: {
							value: 0,
							unit: "%"
						},
						blur: {
							value: 0,
							unit: "px"
						}
					};
					$YTPlayer.addClass( "mb_YTPlayer" );
					var property = $YTPlayer.data( "property" ) && typeof $YTPlayer.data( "property" ) == "string" ? eval( '(' + $YTPlayer.data( "property" ) + ')' ) : $YTPlayer.data( "property" );
					if( typeof property != "undefined" && typeof property.vol != "undefined" ) property.vol = property.vol === 0 ? property.vol = 1 : property.vol;
	
					jQuery.extend( YTPlayer.opt, jQuery.mbYTPlayer.defaults, options, property );
	
					if( !YTPlayer.hasChanged ) {
						YTPlayer.defaultOpt = {};
						//					jQuery.extend( YTPlayer.defaultOpt, jQuery.mbYTPlayer.defaults, options, property );
						jQuery.extend( YTPlayer.defaultOpt, jQuery.mbYTPlayer.defaults, options );
					}
	
					if( YTPlayer.opt.loop == "true" )
						YTPlayer.opt.loop = 9999;
	
					YTPlayer.isRetina = ( window.retina || window.devicePixelRatio > 1 );
					var isIframe = function() {
						var isIfr = false;
						try {
							if( self.location.href != top.location.href ) isIfr = true;
						} catch( e ) {
							isIfr = true;
						}
						return isIfr;
					};
					YTPlayer.canGoFullScreen = !( jQuery.browser.msie || jQuery.browser.opera || isIframe() );
					if( !YTPlayer.canGoFullScreen ) YTPlayer.opt.realfullscreen = false;
					if( !$YTPlayer.attr( "id" ) ) $YTPlayer.attr( "id", "video_" + new Date().getTime() );
					var playerID = "mbYTP_" + YTPlayer.id;
					YTPlayer.isAlone = false;
					YTPlayer.hasFocus = true;
					var videoID = this.opt.videoURL ? getYTPVideoID( this.opt.videoURL ).videoID : $YTPlayer.attr( "href" ) ? getYTPVideoID( $YTPlayer.attr( "href" ) ).videoID : false;
					var playlistID = this.opt.videoURL ? getYTPVideoID( this.opt.videoURL ).playlistID : $YTPlayer.attr( "href" ) ? getYTPVideoID( $YTPlayer.attr( "href" ) ).playlistID : false;
					YTPlayer.videoID = videoID;
					YTPlayer.playlistID = playlistID;
					YTPlayer.opt.showAnnotations = ( YTPlayer.opt.showAnnotations ) ? '0' : '3';
					var playerVars = {
						'autoplay': 0,
						'modestbranding': 1,
						'controls': 0,
						'showinfo': 0,
						'rel': 0,
						'enablejsapi': 1,
						'version': 3,
						'playerapiid': playerID,
						'origin': '*',
						'allowfullscreen': true,
						'wmode': 'transparent',
						'iv_load_policy': YTPlayer.opt.showAnnotations
					};
					if( document.createElement( 'video' ).canPlayType ) jQuery.extend( playerVars, {
						'html5': 1
					} );
					if( jQuery.browser.msie && jQuery.browser.version < 9 ) this.opt.opacity = 1;
					var playerBox = jQuery( "<div/>" ).attr( "id", playerID ).addClass( "playerBox" );
					var overlay = jQuery( "<div/>" ).css( {
						position: "absolute",
						top: 0,
						left: 0,
						width: "100%",
						height: "100%"
					} ).addClass( "YTPOverlay" );
					YTPlayer.isSelf = YTPlayer.opt.containment == "self";
					YTPlayer.defaultOpt.containment = YTPlayer.opt.containment = YTPlayer.opt.containment == "self" ? jQuery( this ) : jQuery( YTPlayer.opt.containment );
					YTPlayer.isBackground = YTPlayer.opt.containment.get( 0 ).tagName.toLowerCase() == "body";
					if( YTPlayer.isBackground && ytp.backgroundIsInited ) return;
					var isPlayer = YTPlayer.opt.containment.is( jQuery( this ) );
					YTPlayer.canPlayOnMobile = isPlayer && jQuery( this ).children().length === 0;
					if( !isPlayer ) {
						$YTPlayer.hide();
					} else {
						YTPlayer.isPlayer = true;
					}
	
					if( jQuery.browser.mobile && !YTPlayer.canPlayOnMobile ) {
						$YTPlayer.remove();
						return;
					}
	
					var wrapper = jQuery( "<div/>" ).addClass( "mbYTP_wrapper" ).attr( "id", "wrapper_" + playerID );
					wrapper.css( {
						position: "absolute",
						zIndex: 0,
						minWidth: "100%",
						minHeight: "100%",
						left: 0,
						top: 0,
						overflow: "hidden",
						opacity: 0
					} );
	
					playerBox.css( {
						position: "absolute",
						zIndex: 0,
						width: "100%",
						height: "100%",
						top: 0,
						left: 0,
						overflow: "hidden"
					} );
					wrapper.append( playerBox );
					YTPlayer.opt.containment.children().not( "script, style" ).each( function() {
						if( jQuery( this ).css( "position" ) == "static" ) jQuery( this ).css( "position", "relative" );
					} );
					if( YTPlayer.isBackground ) {
						jQuery( "body" ).css( {
							boxSizing: "border-box"
						} );
						wrapper.css( {
							position: "fixed",
							top: 0,
							left: 0,
							zIndex: 0
						} );
						$YTPlayer.hide();
					} else if( YTPlayer.opt.containment.css( "position" ) == "static" )
						YTPlayer.opt.containment.css( {
							position: "relative"
						} );
	
					YTPlayer.opt.containment.prepend( wrapper );
					YTPlayer.wrapper = wrapper;
					playerBox.css( {
						opacity: 1
					} );
	
					if( !jQuery.browser.mobile ) {
						playerBox.after( overlay );
						YTPlayer.overlay = overlay;
					}
	
					if( !YTPlayer.isBackground ) {
						overlay.on( "mouseenter", function() {
							if( YTPlayer.controlBar ) YTPlayer.controlBar.addClass( "visible" );
						} ).on( "mouseleave", function() {
							if( YTPlayer.controlBar ) YTPlayer.controlBar.removeClass( "visible" );
						} );
					}
					if( !ytp.YTAPIReady ) {
						jQuery( "#YTAPI" ).remove();
						var tag = jQuery( "<script></script>" ).attr( {
							"src": jQuery.mbYTPlayer.locationProtocol + "//www.youtube.com/iframe_api?v=" + jQuery.mbYTPlayer.version,
							"id": "YTAPI"
						} );
						jQuery( "head" ).prepend( tag );
					} else {
						setTimeout( function() {
							jQuery( document ).trigger( "YTAPIReady" );
						}, 100 )
					}
	
					jQuery( document ).on( "YTAPIReady", function() {
						if( ( YTPlayer.isBackground && ytp.backgroundIsInited ) || YTPlayer.isInit ) return;
						if( YTPlayer.isBackground ) {
							ytp.backgroundIsInited = true;
						}
	
						YTPlayer.opt.autoPlay = typeof YTPlayer.opt.autoPlay == "undefined" ? ( YTPlayer.isBackground ? true : false ) : YTPlayer.opt.autoPlay;
						YTPlayer.opt.vol = YTPlayer.opt.vol ? YTPlayer.opt.vol : 100;
						jQuery.mbYTPlayer.getDataFromAPI( YTPlayer );
						jQuery( YTPlayer ).on( "YTPChanged", function() {
							if( YTPlayer.isInit ) return;
							YTPlayer.isInit = true;
	
							//if is mobile && isPlayer fallback to the default YT player
							if( jQuery.browser.mobile && YTPlayer.canPlayOnMobile ) {
								// Try to adjust the player dimention
								if( YTPlayer.opt.containment.outerWidth() > jQuery( window ).width() ) {
									YTPlayer.opt.containment.css( {
										maxWidth: "100%"
									} );
									var h = YTPlayer.opt.containment.outerWidth() * .6;
									YTPlayer.opt.containment.css( {
										maxHeight: h
									} );
								}
								new YT.Player( playerID, {
									videoId: YTPlayer.videoID.toString(),
									height: '100%',
									width: '100%',
									events: {
										'onReady': function( event ) {
											YTPlayer.player = event.target;
											playerBox.css( {
												opacity: 1
											} );
											YTPlayer.wrapper.css( {
												opacity: 1
											} );
										}
									}
								} );
								return;
							}
	
							new YT.Player( playerID, {
								videoId: YTPlayer.videoID.toString(),
								playerVars: playerVars,
								events: {
									'onReady': function( event ) {
										YTPlayer.player = event.target;
										if( YTPlayer.isReady ) return;
										YTPlayer.isReady = YTPlayer.isPlayer && !YTPlayer.opt.autoPlay ? false : true;
										YTPlayer.playerEl = YTPlayer.player.getIframe();
	
										jQuery( YTPlayer.playerEl ).unselectable();
	
										$YTPlayer.optimizeDisplay();
										YTPlayer.videoID = videoID;
										jQuery( window ).off( "resize.YTP" ).on( "resize.YTP", function() {
											$YTPlayer.optimizeDisplay();
										} );
	
										jQuery.mbYTPlayer.checkForState( YTPlayer );
									},
									/**
									 *
									 * @param event
									 *
									 * -1 (unstarted)
									 * 0 (ended)
									 * 1 (playing)
									 * 2 (paused)
									 * 3 (buffering)
									 * 5 (video cued).
									 *
									 *
									 */
									'onStateChange': function( event ) {
										if( typeof event.target.getPlayerState != "function" ) return;
										var state = event.target.getPlayerState();
	
										if( YTPlayer.state == state ) return;
	
										if( YTPlayer.preventTrigger ) {
											YTPlayer.preventTrigger = false;
											return
										}
	
										YTPlayer.state = state;
	
										var eventType;
										switch( state ) {
											case -1: //----------------------------------------------- unstarted
												eventType = "YTPUnstarted";
												break;
											case 0: //------------------------------------------------ ended
												eventType = "YTPEnd";
												break;
											case 1: //------------------------------------------------ play
												eventType = "YTPPlay";
												if( YTPlayer.controlBar ) YTPlayer.controlBar.find( ".mb_YTPPlaypause" ).html( jQuery.mbYTPlayer.controls.pause );
	
												if( typeof _gaq != "undefined" && eval( YTPlayer.opt.gaTrack ) ) _gaq.push( [ '_trackEvent', 'YTPlayer', 'Play', ( YTPlayer.hasData ? YTPlayer.videoData.title : YTPlayer.videoID.toString() ) ] );
												if( typeof ga != "undefined" && eval( YTPlayer.opt.gaTrack ) ) ga( 'send', 'event', 'YTPlayer', 'play', ( YTPlayer.hasData ? YTPlayer.videoData.title : YTPlayer.videoID.toString() ) );
	
												break;
											case 2: //------------------------------------------------ pause
												eventType = "YTPPause";
												if( YTPlayer.controlBar ) YTPlayer.controlBar.find( ".mb_YTPPlaypause" ).html( jQuery.mbYTPlayer.controls.play );
												break;
											case 3: //------------------------------------------------ buffer
												YTPlayer.player.setPlaybackQuality( YTPlayer.opt.quality );
												eventType = "YTPBuffering";
												if( YTPlayer.controlBar ) YTPlayer.controlBar.find( ".mb_YTPPlaypause" ).html( jQuery.mbYTPlayer.controls.play );
												break;
											case 5: //------------------------------------------------ cued
												eventType = "YTPCued";
												break;
											default:
												break;
										}
										// Trigger state events
										var YTPEvent = jQuery.Event( eventType );
										YTPEvent.time = YTPlayer.player.time;
										if( YTPlayer.canTrigger ) jQuery( YTPlayer ).trigger( YTPEvent );
									},
									/**
									 *
									 * @param e
									 */
									'onPlaybackQualityChange': function( e ) {
										var quality = e.target.getPlaybackQuality();
										var YTPQualityChange = jQuery.Event( "YTPQualityChange" );
										YTPQualityChange.quality = quality;
										jQuery( YTPlayer ).trigger( YTPQualityChange );
									},
									/**
									 *
									 * @param err
									 */
									'onError': function( err ) {
										if( err.data == 150 ) {
											console.log( "Embedding this video is restricted by Youtube." );
											if( YTPlayer.isPlayList ) jQuery( YTPlayer ).playNext();
										}
										if( err.data == 2 && YTPlayer.isPlayList ) jQuery( YTPlayer ).playNext();
										if( typeof YTPlayer.opt.onError == "function" ) YTPlayer.opt.onError( $YTPlayer, err );
									}
								}
							} );
						} );
					} )
				} );
			},
			/**
			 *
			 * @param YTPlayer
			 */
			getDataFromAPI: function( YTPlayer ) {
				YTPlayer.videoData = jQuery.mbStorage.get( "YTPlayer_data_" + YTPlayer.videoID );
				jQuery( YTPlayer ).off( "YTPData.YTPlayer" ).on( "YTPData.YTPlayer", function() {
					if( YTPlayer.hasData ) {
	
						if( YTPlayer.isPlayer && !YTPlayer.opt.autoPlay ) {
							var bgndURL = YTPlayer.videoData.thumb_max || YTPlayer.videoData.thumb_high || YTPlayer.videoData.thumb_medium;
							YTPlayer.opt.containment.css( {
								background: "rgba(0,0,0,0.5) url(" + bgndURL + ") center center",
								backgroundSize: "cover"
							} );
							YTPlayer.opt.backgroundUrl = bgndURL;
						}
					}
				} );
	
				if( YTPlayer.videoData ) {
	
					setTimeout( function() {
						YTPlayer.opt.ratio = YTPlayer.opt.ratio == "auto" ? "16/9" : YTPlayer.opt.ratio;
						YTPlayer.dataReceived = true;
						jQuery( YTPlayer ).trigger( "YTPChanged" );
						var YTPData = jQuery.Event( "YTPData" );
						YTPData.prop = {};
						for( var x in YTPlayer.videoData ) YTPData.prop[ x ] = YTPlayer.videoData[ x ];
						jQuery( YTPlayer ).trigger( YTPData );
					}, 500 );
	
					YTPlayer.hasData = true;
				} else if( jQuery.mbYTPlayer.apiKey ) {
					// Get video info from API3 (needs api key)
					// snippet,player,contentDetails,statistics,status
					jQuery.getJSON( jQuery.mbYTPlayer.locationProtocol + "//www.googleapis.com/youtube/v3/videos?id=" + YTPlayer.videoID + "&key=" + jQuery.mbYTPlayer.apiKey + "&part=snippet", function( data ) {
						YTPlayer.dataReceived = true;
						jQuery( YTPlayer ).trigger( "YTPChanged" );
	
						function parseYTPlayer_data( data ) {
							YTPlayer.videoData = {};
							YTPlayer.videoData.id = YTPlayer.videoID;
							YTPlayer.videoData.channelTitle = data.channelTitle;
							YTPlayer.videoData.title = data.title;
							YTPlayer.videoData.description = data.description.length < 400 ? data.description : data.description.substring( 0, 400 ) + " ...";
							YTPlayer.videoData.aspectratio = YTPlayer.opt.ratio == "auto" ? "16/9" : YTPlayer.opt.ratio;
							YTPlayer.opt.ratio = YTPlayer.videoData.aspectratio;
							YTPlayer.videoData.thumb_max = data.thumbnails.maxres ? data.thumbnails.maxres.url : null;
							YTPlayer.videoData.thumb_high = data.thumbnails.high ? data.thumbnails.high.url : null;
							YTPlayer.videoData.thumb_medium = data.thumbnails.medium ? data.thumbnails.medium.url : null;
							jQuery.mbStorage.set( "YTPlayer_data_" + YTPlayer.videoID, YTPlayer.videoData );
						}
						parseYTPlayer_data( data.items[ 0 ].snippet );
						YTPlayer.hasData = true;
						var YTPData = jQuery.Event( "YTPData" );
						YTPData.prop = {};
						for( var x in YTPlayer.videoData ) YTPData.prop[ x ] = YTPlayer.videoData[ x ];
						jQuery( YTPlayer ).trigger( YTPData );
					} );
				} else {
					setTimeout( function() {
						jQuery( YTPlayer ).trigger( "YTPChanged" );
					}, 50 );
					if( YTPlayer.isPlayer && !YTPlayer.opt.autoPlay ) {
						var bgndURL = jQuery.mbYTPlayer.locationProtocol + "//i.ytimg.com/vi/" + YTPlayer.videoID + "/hqdefault.jpg";
						YTPlayer.opt.containment.css( {
							background: "rgba(0,0,0,0.5) url(" + bgndURL + ") center center",
							backgroundSize: "cover"
						} );
						YTPlayer.opt.backgroundUrl = bgndURL;
					}
					YTPlayer.videoData = null;
					YTPlayer.opt.ratio = YTPlayer.opt.ratio == "auto" ? "16/9" : YTPlayer.opt.ratio;
				}
				if( YTPlayer.isPlayer && !YTPlayer.opt.autoPlay ) {
					YTPlayer.loading = jQuery( "<div/>" ).addClass( "loading" ).html( "Loading" ).hide();
					jQuery( YTPlayer ).append( YTPlayer.loading );
					YTPlayer.loading.fadeIn();
				}
			},
			/**
			 *
			 */
			removeStoredData: function() {
				jQuery.mbStorage.remove();
			},
			/**
			 *
			 * @returns {*|YTPlayer.videoData}
			 */
			getVideoData: function() {
				var YTPlayer = this.get( 0 );
				return YTPlayer.videoData;
			},
			/**
			 *
			 * @returns {*|YTPlayer.videoID|boolean}
			 */
			getVideoID: function() {
				var YTPlayer = this.get( 0 );
				return YTPlayer.videoID || false;
			},
			/**
			 *
			 * @param quality
			 */
			setVideoQuality: function( quality ) {
				var YTPlayer = this.get( 0 );
				//if( !jQuery.browser.chrome )
				YTPlayer.player.setPlaybackQuality( quality );
			},
			/**
			 * @param videos
			 * @param shuffle
			 * @param callback
			 * @returns {jQuery.mbYTPlayer}
			 */
	
			playlist: function( videos, shuffle, callback ) {
				var $YTPlayer = this;
				var YTPlayer = $YTPlayer.get( 0 );
				YTPlayer.isPlayList = true;
				if( shuffle ) videos = jQuery.shuffle( videos );
				if( !YTPlayer.videoID ) {
					YTPlayer.videos = videos;
					YTPlayer.videoCounter = 0;
					YTPlayer.videoLength = videos.length;
					jQuery( YTPlayer ).data( "property", videos[ 0 ] );
					jQuery( YTPlayer ).mb_YTPlayer();
				}
				if( typeof callback == "function" ) jQuery( YTPlayer ).one( "YTPChanged", function() {
					callback( YTPlayer );
				} );
				jQuery( YTPlayer ).on( "YTPEnd", function() {
					jQuery( YTPlayer ).playNext();
				} );
				return $YTPlayer;
			},
			/**
			 *
			 * @returns {jQuery.mbYTPlayer}
			 */
			playNext: function() {
				var YTPlayer = this.get( 0 );
	
				if( YTPlayer.checkForStartAt ) {
					clearTimeout( YTPlayer.checkForStartAt );
					clearInterval( YTPlayer.getState );
				}
	
				YTPlayer.videoCounter++;
				if( YTPlayer.videoCounter >= YTPlayer.videoLength ) YTPlayer.videoCounter = 0;
				jQuery( YTPlayer ).changeMovie( YTPlayer.videos[ YTPlayer.videoCounter ] );
				return this;
			},
			/**
			 *
			 * @returns {jQuery.mbYTPlayer}
			 */
			playPrev: function() {
				var YTPlayer = this.get( 0 );
	
				if( YTPlayer.checkForStartAt ) {
					clearInterval( YTPlayer.checkForStartAt );
					clearInterval( YTPlayer.getState );
				}
	
				YTPlayer.videoCounter--;
				if( YTPlayer.videoCounter < 0 ) YTPlayer.videoCounter = YTPlayer.videoLength - 1;
				jQuery( YTPlayer ).changeMovie( YTPlayer.videos[ YTPlayer.videoCounter ] );
				return this;
			},
			/**
			 *
			 * @param opt
			 */
			changeMovie: function( opt ) {
	
				var YTPlayer = this.get( 0 );
				YTPlayer.opt.startAt = 0;
				YTPlayer.opt.stopAt = 0;
				YTPlayer.opt.mute = true;
				YTPlayer.hasData = false;
				YTPlayer.hasChanged = true;
				YTPlayer.player.loopTime = undefined;
	
				if( opt ) jQuery.extend( YTPlayer.opt, YTPlayer.defaultOpt, opt );
				YTPlayer.videoID = getYTPVideoID( YTPlayer.opt.videoURL ).videoID;
	
				if( YTPlayer.opt.loop == "true" )
					YTPlayer.opt.loop = 9999;
	
				jQuery( YTPlayer.playerEl ).CSSAnimate( {
					opacity: 0
				}, 200, function() {
	
					var YTPChangeMovie = jQuery.Event( "YTPChangeMovie" );
					YTPChangeMovie.time = YTPlayer.player.time;
					YTPChangeMovie.videoId = YTPlayer.videoID;
					jQuery( YTPlayer ).trigger( YTPChangeMovie );
	
					jQuery( YTPlayer ).YTPGetPlayer().cueVideoByUrl( encodeURI( jQuery.mbYTPlayer.locationProtocol + "//www.youtube.com/v/" + YTPlayer.videoID ), 1, YTPlayer.opt.quality );
					jQuery( YTPlayer ).optimizeDisplay();
	
					jQuery.mbYTPlayer.checkForState( YTPlayer );
					jQuery.mbYTPlayer.getDataFromAPI( YTPlayer );
					return this;
				} );
			},
			/**
			 *
			 * @returns {player}
			 */
			getPlayer: function() {
				return jQuery( this ).get( 0 ).player;
			},
	
			playerDestroy: function() {
				var YTPlayer = this.get( 0 );
				ytp.YTAPIReady = true;
				ytp.backgroundIsInited = false;
				YTPlayer.isInit = false;
				YTPlayer.videoID = null;
				var playerBox = YTPlayer.wrapper;
				playerBox.remove();
				jQuery( "#controlBar_" + YTPlayer.id ).remove();
				clearInterval( YTPlayer.checkForStartAt );
				clearInterval( YTPlayer.getState );
				return this;
			},
	
			/**
			 *
			 * @param real
			 * @returns {jQuery.mbYTPlayer}
			 */
			fullscreen: function( real ) {
				var YTPlayer = this.get( 0 );
				if( typeof real == "undefined" ) real = YTPlayer.opt.realfullscreen;
				real = eval( real );
				var controls = jQuery( "#controlBar_" + YTPlayer.id );
				var fullScreenBtn = controls.find( ".mb_OnlyYT" );
				var videoWrapper = YTPlayer.isSelf ? YTPlayer.opt.containment : YTPlayer.wrapper;
				//var videoWrapper = YTPlayer.wrapper;
				if( real ) {
					var fullscreenchange = jQuery.browser.mozilla ? "mozfullscreenchange" : jQuery.browser.webkit ? "webkitfullscreenchange" : "fullscreenchange";
					jQuery( document ).off( fullscreenchange ).on( fullscreenchange, function() {
						var isFullScreen = RunPrefixMethod( document, "IsFullScreen" ) || RunPrefixMethod( document, "FullScreen" );
						if( !isFullScreen ) {
							YTPlayer.isAlone = false;
							fullScreenBtn.html( jQuery.mbYTPlayer.controls.onlyYT );
							jQuery( YTPlayer ).YTPSetVideoQuality( YTPlayer.opt.quality );
							videoWrapper.removeClass( "YTPFullscreen" );
							videoWrapper.CSSAnimate( {
								opacity: YTPlayer.opt.opacity
							}, 500 );
							videoWrapper.css( {
								zIndex: 0
							} );
							if( YTPlayer.isBackground ) {
								jQuery( "body" ).after( controls );
							} else {
								YTPlayer.wrapper.before( controls );
							}
							jQuery( window ).resize();
							jQuery( YTPlayer ).trigger( "YTPFullScreenEnd" );
						} else {
							jQuery( YTPlayer ).YTPSetVideoQuality( "default" );
							jQuery( YTPlayer ).trigger( "YTPFullScreenStart" );
						}
					} );
				}
				if( !YTPlayer.isAlone ) {
					function hideMouse() {
						YTPlayer.overlay.css( {
							cursor: "none"
						} );
					}
					jQuery( document ).on( "mousemove.YTPlayer", function( e ) {
						YTPlayer.overlay.css( {
							cursor: "auto"
						} );
						clearTimeout( YTPlayer.hideCursor );
						if( !jQuery( e.target ).parents().is( ".mb_YTPBar" ) ) YTPlayer.hideCursor = setTimeout( hideMouse, 3000 );
					} );
					hideMouse();
					if( real ) {
						videoWrapper.css( {
							opacity: 0
						} );
						videoWrapper.addClass( "YTPFullscreen" );
						launchFullscreen( videoWrapper.get( 0 ) );
						setTimeout( function() {
							videoWrapper.CSSAnimate( {
								opacity: 1
							}, 1000 );
							YTPlayer.wrapper.append( controls );
							jQuery( YTPlayer ).optimizeDisplay();
							YTPlayer.player.seekTo( YTPlayer.player.getCurrentTime() + .1, true );
						}, 500 )
					} else videoWrapper.css( {
						zIndex: 10000
					} ).CSSAnimate( {
						opacity: 1
					}, 1000 );
					fullScreenBtn.html( jQuery.mbYTPlayer.controls.showSite );
					YTPlayer.isAlone = true;
				} else {
					jQuery( document ).off( "mousemove.YTPlayer" );
					YTPlayer.overlay.css( {
						cursor: "auto"
					} );
					if( real ) {
						cancelFullscreen();
					} else {
						videoWrapper.CSSAnimate( {
							opacity: YTPlayer.opt.opacity
						}, 500 );
						videoWrapper.css( {
							zIndex: 0
						} );
					}
					fullScreenBtn.html( jQuery.mbYTPlayer.controls.onlyYT );
					YTPlayer.isAlone = false;
				}
	
				function RunPrefixMethod( obj, method ) {
					var pfx = [ "webkit", "moz", "ms", "o", "" ];
					var p = 0,
						m, t;
					while( p < pfx.length && !obj[ m ] ) {
						m = method;
						if( pfx[ p ] == "" ) {
							m = m.substr( 0, 1 ).toLowerCase() + m.substr( 1 );
						}
						m = pfx[ p ] + m;
						t = typeof obj[ m ];
						if( t != "undefined" ) {
							pfx = [ pfx[ p ] ];
							return( t == "function" ? obj[ m ]() : obj[ m ] );
						}
						p++;
					}
				}
	
				function launchFullscreen( element ) {
					RunPrefixMethod( element, "RequestFullScreen" );
				}
	
				function cancelFullscreen() {
					if( RunPrefixMethod( document, "FullScreen" ) || RunPrefixMethod( document, "IsFullScreen" ) ) {
						RunPrefixMethod( document, "CancelFullScreen" );
					}
				}
				return this;
			},
			/**
			 *
			 * @returns {jQuery.mbYTPlayer}
			 */
			toggleLoops: function() {
				var YTPlayer = this.get( 0 );
				var data = YTPlayer.opt;
				if( data.loop == 1 ) {
					data.loop = 0;
				} else {
					if( data.startAt ) {
						YTPlayer.player.seekTo( data.startAt );
					} else {
						YTPlayer.player.playVideo();
					}
					data.loop = 1;
				}
				return this;
			},
			/**
			 *
			 * @returns {jQuery.mbYTPlayer}
			 */
			play: function() {
				var YTPlayer = this.get( 0 );
				if( !YTPlayer.isReady ) return;
	
				YTPlayer.player.playVideo();
				YTPlayer.wrapper.CSSAnimate( {
					opacity: YTPlayer.isAlone ? 1 : YTPlayer.opt.opacity
				}, 2000 );
	
				jQuery( YTPlayer.playerEl ).CSSAnimate( {
					opacity: 1
				}, 1000 );
	
				jQuery( YTPlayer ).css( "background-image", "none" );
				return this;
			},
			/**
			 *
			 * @param callback
			 * @returns {jQuery.mbYTPlayer}
			 */
			togglePlay: function( callback ) {
				var YTPlayer = this.get( 0 );
				if( YTPlayer.state == 1 ) this.YTPPause();
				else this.YTPPlay();
				if( typeof callback == "function" ) {
					callback( YTPlayer.state );
				}
				return this;
			},
			/**
			 *
			 * @returns {jQuery.mbYTPlayer}
			 */
			stop: function() {
				var YTPlayer = this.get( 0 );
				var controls = jQuery( "#controlBar_" + YTPlayer.id );
				var playBtn = controls.find( ".mb_YTPPlaypause" );
				playBtn.html( jQuery.mbYTPlayer.controls.play );
				YTPlayer.player.stopVideo();
				return this;
			},
			/**
			 *
			 * @returns {jQuery.mbYTPlayer}
			 */
			pause: function() {
				var YTPlayer = this.get( 0 );
				YTPlayer.player.pauseVideo();
				return this;
			},
			/**
			 *
			 * @param val
			 * @returns {jQuery.mbYTPlayer}
			 */
			seekTo: function( val ) {
				var YTPlayer = this.get( 0 );
				YTPlayer.player.seekTo( val, true );
				return this;
			},
			/**
			 *
			 * @param val
			 * @returns {jQuery.mbYTPlayer}
			 */
			setVolume: function( val ) {
				var YTPlayer = this.get( 0 );
				if( !val && !YTPlayer.opt.vol && YTPlayer.player.getVolume() == 0 ) jQuery( YTPlayer ).YTPUnmute();
				else if( ( !val && YTPlayer.player.getVolume() > 0 ) || ( val && YTPlayer.opt.vol == val ) ) {
					if( !YTPlayer.isMute ) jQuery( YTPlayer ).YTPMute();
					else jQuery( YTPlayer ).YTPUnmute();
				} else {
					YTPlayer.opt.vol = val;
					YTPlayer.player.setVolume( YTPlayer.opt.vol );
					if( YTPlayer.volumeBar && YTPlayer.volumeBar.length ) YTPlayer.volumeBar.updateSliderVal( val )
				}
				return this;
			},
			/**
			 *
			 * @returns {jQuery.mbYTPlayer}
			 */
			mute: function() {
				var YTPlayer = this.get( 0 );
				if( YTPlayer.isMute ) return;
				YTPlayer.player.mute();
				YTPlayer.isMute = true;
				YTPlayer.player.setVolume( 0 );
				if( YTPlayer.volumeBar && YTPlayer.volumeBar.length && YTPlayer.volumeBar.width() > 10 ) {
					YTPlayer.volumeBar.updateSliderVal( 0 );
				}
				var controls = jQuery( "#controlBar_" + YTPlayer.id );
				var muteBtn = controls.find( ".mb_YTPMuteUnmute" );
				muteBtn.html( jQuery.mbYTPlayer.controls.unmute );
				jQuery( YTPlayer ).addClass( "isMuted" );
				if( YTPlayer.volumeBar && YTPlayer.volumeBar.length ) YTPlayer.volumeBar.addClass( "muted" );
				var YTPEvent = jQuery.Event( "YTPMuted" );
				YTPEvent.time = YTPlayer.player.time;
				if( YTPlayer.canTrigger ) jQuery( YTPlayer ).trigger( YTPEvent );
				return this;
			},
			/**
			 *
			 * @returns {jQuery.mbYTPlayer}
			 */
			unmute: function() {
				var YTPlayer = this.get( 0 );
				if( !YTPlayer.isMute ) return;
				YTPlayer.player.unMute();
				YTPlayer.isMute = false;
				YTPlayer.player.setVolume( YTPlayer.opt.vol );
				if( YTPlayer.volumeBar && YTPlayer.volumeBar.length ) YTPlayer.volumeBar.updateSliderVal( YTPlayer.opt.vol > 10 ? YTPlayer.opt.vol : 10 );
				var controls = jQuery( "#controlBar_" + YTPlayer.id );
				var muteBtn = controls.find( ".mb_YTPMuteUnmute" );
				muteBtn.html( jQuery.mbYTPlayer.controls.mute );
				jQuery( YTPlayer ).removeClass( "isMuted" );
				if( YTPlayer.volumeBar && YTPlayer.volumeBar.length ) YTPlayer.volumeBar.removeClass( "muted" );
				var YTPEvent = jQuery.Event( "YTPUnmuted" );
				YTPEvent.time = YTPlayer.player.time;
				if( YTPlayer.canTrigger ) jQuery( YTPlayer ).trigger( YTPEvent );
				return this;
			},
			/**
			 *
			 * @param filter
			 * @param value
			 * @returns {jQuery.mbYTPlayer}
			 */
			applyFilter: function( filter, value ) {
				var YTPlayer = this.get( 0 );
				YTPlayer.filters[ filter ].value = value;
				if( YTPlayer.filtersEnabled ) this.YTPEnableFilters();
				return this;
			},
			/**
			 *
			 * @param filters
			 * @returns {jQuery.mbYTPlayer}
			 */
			applyFilters: function( filters ) {
				var YTPlayer = this.get( 0 );
				this.on( "YTPReady", function() {
					for( var key in filters ) {
						YTPlayer.filters[ key ].value = filters[ key ];
						jQuery( YTPlayer ).YTPApplyFilter( key, filters[ key ] );
					}
					jQuery( YTPlayer ).trigger( "YTPFiltersApplied" );
				} );
				return this;
			},
			/**
			 *
			 * @param filter
			 * @param value
			 * @returns {*}
			 */
			toggleFilter: function( filter, value ) {
				return this.each( function() {
					var YTPlayer = this;
					if( !YTPlayer.filters[ filter ].value ) YTPlayer.filters[ filter ].value = value;
					else YTPlayer.filters[ filter ].value = 0;
					if( YTPlayer.filtersEnabled ) jQuery( this ).YTPEnableFilters();
				} )
				return this;
			},
			/**
			 *
			 * @param callback
			 * @returns {*}
			 */
			toggleFilters: function( callback ) {
				return this.each( function() {
					var YTPlayer = this;
					if( YTPlayer.filtersEnabled ) {
						jQuery( YTPlayer ).trigger( "YTPDisableFilters" );
						jQuery( YTPlayer ).YTPDisableFilters();
					} else {
						jQuery( YTPlayer ).YTPEnableFilters();
						jQuery( YTPlayer ).trigger( "YTPEnableFilters" );
					}
					if( typeof callback == "function" ) callback( YTPlayer.filtersEnabled );
				} )
			},
			/**
			 *
			 * @returns {*}
			 */
			disableFilters: function() {
				return this.each( function() {
					var YTPlayer = this;
					var iframe = jQuery( YTPlayer.playerEl );
					iframe.css( "-webkit-filter", "" );
					iframe.css( "filter", "" );
					YTPlayer.filtersEnabled = false;
				} )
			},
			/**
			 *
			 * @returns {*}
			 */
			enableFilters: function() {
				return this.each( function() {
					var YTPlayer = this;
					var iframe = jQuery( YTPlayer.playerEl );
					var filterStyle = "";
					for( var key in YTPlayer.filters ) {
						if( YTPlayer.filters[ key ].value ) filterStyle += key.replace( "_", "-" ) + "(" + YTPlayer.filters[ key ].value + YTPlayer.filters[ key ].unit + ") ";
					}
					iframe.css( "-webkit-filter", filterStyle );
					iframe.css( "filter", filterStyle );
					YTPlayer.filtersEnabled = true;
				} )
				return this;
			},
			/**
			 *
			 * @param filter
			 * @param callback
			 * @returns {*}
			 */
			removeFilter: function( filter, callback ) {
				return this.each( function() {
					if( typeof filter == "function" ) {
						callback = filter;
						filter = null;
					}
					var YTPlayer = this;
					if( !filter )
						for( var key in YTPlayer.filters ) {
							jQuery( this ).YTPApplyFilter( key, 0 );
							if( typeof callback == "function" ) callback( key );
						} else {
							jQuery( this ).YTPApplyFilter( filter, 0 );
							if( typeof callback == "function" ) callback( filter );
						}
				} );
				return this;
			},
			/**
			 *
			 * @returns {{totalTime: number, currentTime: number}}
			 */
			manageProgress: function() {
				var YTPlayer = this.get( 0 );
				var controls = jQuery( "#controlBar_" + YTPlayer.id );
				var progressBar = controls.find( ".mb_YTPProgress" );
				var loadedBar = controls.find( ".mb_YTPLoaded" );
				var timeBar = controls.find( ".mb_YTPseekbar" );
				var totW = progressBar.outerWidth();
				var currentTime = Math.floor( YTPlayer.player.getCurrentTime() );
				var totalTime = Math.floor( YTPlayer.player.getDuration() );
				var timeW = ( currentTime * totW ) / totalTime;
				var startLeft = 0;
				var loadedW = YTPlayer.player.getVideoLoadedFraction() * 100;
				loadedBar.css( {
					left: startLeft,
					width: loadedW + "%"
				} );
				timeBar.css( {
					left: 0,
					width: timeW
				} );
				return {
					totalTime: totalTime,
					currentTime: currentTime
				};
			},
			/**
			 *
			 * @param YTPlayer
			 */
			buildControls: function( YTPlayer ) {
				var data = YTPlayer.opt;
				// @data.printUrl: is deprecated; use data.showYTLogo
				data.showYTLogo = data.showYTLogo || data.printUrl;
				if( jQuery( "#controlBar_" + YTPlayer.id ).length ) return;
				YTPlayer.controlBar = jQuery( "<span/>" ).attr( "id", "controlBar_" + YTPlayer.id ).addClass( "mb_YTPBar" ).css( {
					whiteSpace: "noWrap",
					position: YTPlayer.isBackground ? "fixed" : "absolute",
					zIndex: YTPlayer.isBackground ? 10000 : 1000
				} ).hide();
				var buttonBar = jQuery( "<div/>" ).addClass( "buttonBar" );
				/* play/pause button*/
				var playpause = jQuery( "<span>" + jQuery.mbYTPlayer.controls.play + "</span>" ).addClass( "mb_YTPPlaypause ytpicon" ).click( function() {
					if( YTPlayer.player.getPlayerState() == 1 ) jQuery( YTPlayer ).YTPPause();
					else jQuery( YTPlayer ).YTPPlay();
				} );
				/* mute/unmute button*/
				var MuteUnmute = jQuery( "<span>" + jQuery.mbYTPlayer.controls.mute + "</span>" ).addClass( "mb_YTPMuteUnmute ytpicon" ).click( function() {
					if( YTPlayer.player.getVolume() == 0 ) {
						jQuery( YTPlayer ).YTPUnmute();
					} else {
						jQuery( YTPlayer ).YTPMute();
					}
				} );
				/* volume bar*/
				var volumeBar = jQuery( "<div/>" ).addClass( "mb_YTPVolumeBar" ).css( {
					display: "inline-block"
				} );
				YTPlayer.volumeBar = volumeBar;
				/* time elapsed */
				var idx = jQuery( "<span/>" ).addClass( "mb_YTPTime" );
				var vURL = data.videoURL ? data.videoURL : "";
				if( vURL.indexOf( "http" ) < 0 ) vURL = jQuery.mbYTPlayer.locationProtocol + "//www.youtube.com/watch?v=" + data.videoURL;
				var movieUrl = jQuery( "<span/>" ).html( jQuery.mbYTPlayer.controls.ytLogo ).addClass( "mb_YTPUrl ytpicon" ).attr( "title", "view on YouTube" ).on( "click", function() {
					window.open( vURL, "viewOnYT" )
				} );
				var onlyVideo = jQuery( "<span/>" ).html( jQuery.mbYTPlayer.controls.onlyYT ).addClass( "mb_OnlyYT ytpicon" ).on( "click", function() {
					jQuery( YTPlayer ).YTPFullscreen( data.realfullscreen );
				} );
				var progressBar = jQuery( "<div/>" ).addClass( "mb_YTPProgress" ).css( "position", "absolute" ).click( function( e ) {
					timeBar.css( {
						width: ( e.clientX - timeBar.offset().left )
					} );
					YTPlayer.timeW = e.clientX - timeBar.offset().left;
					YTPlayer.controlBar.find( ".mb_YTPLoaded" ).css( {
						width: 0
					} );
					var totalTime = Math.floor( YTPlayer.player.getDuration() );
					YTPlayer.goto = ( timeBar.outerWidth() * totalTime ) / progressBar.outerWidth();
					YTPlayer.player.seekTo( parseFloat( YTPlayer.goto ), true );
					YTPlayer.controlBar.find( ".mb_YTPLoaded" ).css( {
						width: 0
					} );
				} );
				var loadedBar = jQuery( "<div/>" ).addClass( "mb_YTPLoaded" ).css( "position", "absolute" );
				var timeBar = jQuery( "<div/>" ).addClass( "mb_YTPseekbar" ).css( "position", "absolute" );
				progressBar.append( loadedBar ).append( timeBar );
				buttonBar.append( playpause ).append( MuteUnmute ).append( volumeBar ).append( idx );
				if( data.showYTLogo ) {
					buttonBar.append( movieUrl );
				}
				if( YTPlayer.isBackground || ( eval( YTPlayer.opt.realfullscreen ) && !YTPlayer.isBackground ) ) buttonBar.append( onlyVideo );
				YTPlayer.controlBar.append( buttonBar ).append( progressBar );
				if( !YTPlayer.isBackground ) {
					YTPlayer.controlBar.addClass( "inlinePlayer" );
					YTPlayer.wrapper.before( YTPlayer.controlBar );
				} else {
					jQuery( "body" ).after( YTPlayer.controlBar );
				}
				volumeBar.simpleSlider( {
					initialval: YTPlayer.opt.vol,
					scale: 100,
					orientation: "h",
					callback: function( el ) {
						if( el.value == 0 ) {
							jQuery( YTPlayer ).YTPMute();
						} else {
							jQuery( YTPlayer ).YTPUnmute();
						}
						YTPlayer.player.setVolume( el.value );
						if( !YTPlayer.isMute ) YTPlayer.opt.vol = el.value;
					}
				} );
			},
			/**
			 *
			 *
			 * */
			checkForState: function( YTPlayer ) {
				var interval = YTPlayer.opt.showControls ? 100 : 400;
				clearInterval( YTPlayer.getState );
				//Checking if player has been removed from scene
				if( !jQuery.contains( document, YTPlayer ) ) {
					jQuery( YTPlayer ).YTPPlayerDestroy();
					clearInterval( YTPlayer.getState );
					clearInterval( YTPlayer.checkForStartAt );
					return;
				}
	
				jQuery.mbYTPlayer.checkForStart( YTPlayer );
	
				YTPlayer.getState = setInterval( function() {
					var prog = jQuery( YTPlayer ).YTPManageProgress();
					var $YTPlayer = jQuery( YTPlayer );
					var data = YTPlayer.opt;
					var startAt = YTPlayer.opt.startAt ? YTPlayer.opt.startAt : 1;
					var stopAt = YTPlayer.opt.stopAt > YTPlayer.opt.startAt ? YTPlayer.opt.stopAt : 0;
					stopAt = stopAt < YTPlayer.player.getDuration() ? stopAt : 0;
					if( YTPlayer.player.time != prog.currentTime ) {
						var YTPEvent = jQuery.Event( "YTPTime" );
						YTPEvent.time = YTPlayer.player.time;
						jQuery( YTPlayer ).trigger( YTPEvent );
					}
					YTPlayer.player.time = prog.currentTime;
					if( YTPlayer.player.getVolume() == 0 ) $YTPlayer.addClass( "isMuted" );
					else $YTPlayer.removeClass( "isMuted" );
	
					if( YTPlayer.opt.showControls )
						if( prog.totalTime ) {
							YTPlayer.controlBar.find( ".mb_YTPTime" ).html( jQuery.mbYTPlayer.formatTime( prog.currentTime ) + " / " + jQuery.mbYTPlayer.formatTime( prog.totalTime ) );
						} else {
							YTPlayer.controlBar.find( ".mb_YTPTime" ).html( "-- : -- / -- : --" );
						}
	
	
					if( eval( YTPlayer.opt.stopMovieOnBlur ) )
						if( !document.hasFocus() ) {
							if( YTPlayer.state == 1 ) {
								YTPlayer.hasFocus = false;
								$YTPlayer.YTPPause();
							}
						} else if( document.hasFocus() && !YTPlayer.hasFocus && !( YTPlayer.state == -1 || YTPlayer.state == 0 ) ) {
	
						YTPlayer.hasFocus = true;
						$YTPlayer.YTPPlay();
					}
	
					if( YTPlayer.controlBar && YTPlayer.controlBar.outerWidth() <= 400 && !YTPlayer.isCompact ) {
						YTPlayer.controlBar.addClass( "compact" );
						YTPlayer.isCompact = true;
						if( !YTPlayer.isMute && YTPlayer.volumeBar ) YTPlayer.volumeBar.updateSliderVal( YTPlayer.opt.vol );
					} else if( YTPlayer.controlBar && YTPlayer.controlBar.outerWidth() > 400 && YTPlayer.isCompact ) {
						YTPlayer.controlBar.removeClass( "compact" );
						YTPlayer.isCompact = false;
						if( !YTPlayer.isMute && YTPlayer.volumeBar ) YTPlayer.volumeBar.updateSliderVal( YTPlayer.opt.vol );
					}
					if( YTPlayer.player.getPlayerState() == 1 && ( parseFloat( YTPlayer.player.getDuration() - 1.5 ) < YTPlayer.player.getCurrentTime() || ( stopAt > 0 && parseFloat( YTPlayer.player.getCurrentTime() ) > stopAt ) ) ) {
						if( YTPlayer.isEnded ) return;
						YTPlayer.isEnded = true;
						setTimeout( function() {
							YTPlayer.isEnded = false
						}, 1000 );
	
						if( YTPlayer.isPlayList ) {
	
							if( !data.loop || ( data.loop > 0 && YTPlayer.player.loopTime === data.loop - 1 ) ) {
	
								YTPlayer.player.loopTime = undefined;
								clearInterval( YTPlayer.getState );
								var YTPEnd = jQuery.Event( "YTPEnd" );
								YTPEnd.time = YTPlayer.player.time;
								jQuery( YTPlayer ).trigger( YTPEnd );
								YTPlayer.state = 0;
	
								return;
							}
	
						} else if( !data.loop || ( data.loop > 0 && YTPlayer.player.loopTime === data.loop - 1 ) ) {
	
							YTPlayer.player.loopTime = undefined;
							YTPlayer.preventTrigger = true;
							jQuery( YTPlayer ).YTPPause();
							YTPlayer.state = 0;
	
							YTPlayer.wrapper.CSSAnimate( {
								opacity: 0
							}, 500, function() {
	
								if( YTPlayer.controlBar )
									YTPlayer.controlBar.find( ".mb_YTPPlaypause" ).html( jQuery.mbYTPlayer.controls.play );
	
								var YTPEnd = jQuery.Event( "YTPEnd" );
								YTPEnd.time = YTPlayer.player.time;
								jQuery( YTPlayer ).trigger( YTPEnd );
	
								YTPlayer.player.seekTo( startAt, true );
								if( !YTPlayer.isBackground ) {
									YTPlayer.opt.containment.css( {
										background: "rgba(0,0,0,0.5) url(" + YTPlayer.opt.backgroundUrl + ") center center",
										backgroundSize: "cover"
									} );
								}
							} );
	
							return;
	
						}
	
						YTPlayer.player.loopTime = YTPlayer.player.loopTime ? ++YTPlayer.player.loopTime : 1;
						startAt = startAt || 1;
						YTPlayer.preventTrigger = true;
						jQuery( YTPlayer ).YTPPause();
						YTPlayer.player.seekTo( startAt, true );
						$YTPlayer.YTPPlay();
	
	
					}
				}, interval );
			},
			/**
			 *
			 * */
			checkForStart: function( YTPlayer ) {
				var $YTPlayer = jQuery( YTPlayer );
	
				//Checking if player has been removed from scene
				if( !jQuery.contains( document, YTPlayer ) ) {
					jQuery( YTPlayer ).YTPPlayerDestroy();
					return
				}
	
				/*
				 if( jQuery.browser.chrome )
				 YTPlayer.opt.quality = "default";
				 */
	
				YTPlayer.preventTrigger = true;
				jQuery( YTPlayer ).YTPPause();
	
				jQuery( YTPlayer ).muteYTPVolume();
				jQuery( "#controlBar_" + YTPlayer.id ).remove();
	
				if( YTPlayer.opt.showControls )
					jQuery.mbYTPlayer.buildControls( YTPlayer );
	
				if( YTPlayer.opt.addRaster ) {
	
					var classN = YTPlayer.opt.addRaster == "dot" ? "raster-dot" : "raster";
					YTPlayer.overlay.addClass( YTPlayer.isRetina ? classN + " retina" : classN );
	
				} else {
	
					YTPlayer.overlay.removeClass( function( index, classNames ) {
						// change the list into an array
						var current_classes = classNames.split( " " ),
							// array of classes which are to be removed
							classes_to_remove = [];
						jQuery.each( current_classes, function( index, class_name ) {
							// if the classname begins with bg add it to the classes_to_remove array
							if( /raster.*/.test( class_name ) ) {
								classes_to_remove.push( class_name );
							}
						} );
						classes_to_remove.push( "retina" );
						// turn the array back into a string
						return classes_to_remove.join( " " );
					} )
	
				}
	
				//console.time( "checkforStart" );
	
				var startAt = YTPlayer.opt.startAt ? YTPlayer.opt.startAt : 1;
				YTPlayer.player.playVideo();
				YTPlayer.player.seekTo( startAt, true );
	
				YTPlayer.checkForStartAt = setInterval( function() {
	
					jQuery( YTPlayer ).YTPMute();
	
					var canPlayVideo = YTPlayer.player.getVideoLoadedFraction() >= startAt / YTPlayer.player.getDuration();
	
					//console.debug( YTPlayer.player.getCurrentTime(), startAt, YTPlayer.player.getVideoLoadedFraction() );
	
					if( YTPlayer.player.getDuration() > 0 && YTPlayer.player.getCurrentTime() >= startAt && canPlayVideo ) {
	
						//YTPlayer.player.playVideo();
	
						//console.timeEnd( "checkforStart" );
	
						//	console.debug( "checkForStartAt:: checked ::  ", YTPlayer );
	
						clearInterval( YTPlayer.checkForStartAt );
	
						YTPlayer.isReady = true;
						if( typeof YTPlayer.opt.onReady == "function" )
							YTPlayer.opt.onReady( YTPlayer );
	
						var YTPready = jQuery.Event( "YTPReady" );
						YTPready.time = YTPlayer.player.time;
						jQuery( YTPlayer ).trigger( YTPready );
	
	
						YTPlayer.preventTrigger = true;
						jQuery( YTPlayer ).YTPPause();
	
						if( !YTPlayer.opt.mute ) jQuery( YTPlayer ).YTPUnmute();
						YTPlayer.canTrigger = true;
						if( YTPlayer.opt.autoPlay ) {
							$YTPlayer.YTPPlay();
	
							var YTPStart = jQuery.Event( "YTPStart" );
							YTPStart.time = YTPlayer.player.time;
							jQuery( YTPlayer ).trigger( YTPStart );
	
							$YTPlayer.css( "background-image", "none" );
							jQuery( YTPlayer.playerEl ).CSSAnimate( {
								opacity: 1
							}, 1000 );
							YTPlayer.wrapper.CSSAnimate( {
								opacity: YTPlayer.isAlone ? 1 : YTPlayer.opt.opacity
							}, 1000 );
						} else {
	
							$YTPlayer.YTPPause();
							//YTPlayer.player.pauseVideo();
							if( !YTPlayer.isPlayer ) {
								jQuery( YTPlayer.playerEl ).CSSAnimate( {
									opacity: 1
								}, 500 );
	
								YTPlayer.wrapper.CSSAnimate( {
									opacity: YTPlayer.isAlone ? 1 : YTPlayer.opt.opacity
								}, 500 );
							}
						}
	
						if( YTPlayer.isPlayer && !YTPlayer.opt.autoPlay ) {
							YTPlayer.loading.html( "Ready" );
							setTimeout( function() {
								YTPlayer.loading.fadeOut();
							}, 100 )
						}
						if( YTPlayer.controlBar ) YTPlayer.controlBar.slideDown( 1000 );
	
					} else if( jQuery.browser.safari ) {
						//YTPlayer.player.playVideo();
						//if( startAt >= 0 ) YTPlayer.player.seekTo( startAt, true );
					}
	
				}, 1 );
	
	
			},
			/**
			 *
			 * @param s
			 * @returns {string}
			 */
			formatTime: function( s ) {
				var min = Math.floor( s / 60 );
				var sec = Math.floor( s - ( 60 * min ) );
				return( min <= 9 ? "0" + min : min ) + " : " + ( sec <= 9 ? "0" + sec : sec );
			}
		};
		/**
		 *
		 * @returns {boolean}
		 */
		jQuery.fn.toggleVolume = function() {
			var YTPlayer = this.get( 0 );
			if( !YTPlayer ) return;
			if( YTPlayer.player.isMuted() ) {
				jQuery( YTPlayer ).YTPUnmute();
				return true;
			} else {
				jQuery( YTPlayer ).YTPMute();
				return false;
			}
		};
		/**
		 *
		 */
		jQuery.fn.optimizeDisplay = function() {
			var YTPlayer = this.get( 0 );
			var data = YTPlayer.opt;
			var playerBox = jQuery( YTPlayer.playerEl );
			var win = {};
			var el = YTPlayer.wrapper;
			win.width = el.outerWidth();
			win.height = el.outerHeight();
			var margin = 24;
			var overprint = 100;
			var vid = {};
			if( data.optimizeDisplay ) {
				vid.width = win.width + ( ( win.width * margin ) / 100 );
				vid.height = data.ratio == "16/9" ? Math.ceil( ( 9 * win.width ) / 16 ) : Math.ceil( ( 3 * win.width ) / 4 );
				vid.marginTop = -( ( vid.height - win.height ) / 2 );
				vid.marginLeft = -( ( win.width * ( margin / 2 ) ) / 100 );
				if( vid.height < win.height ) {
					vid.height = win.height + ( ( win.height * margin ) / 100 );
					vid.width = data.ratio == "16/9" ? Math.floor( ( 16 * win.height ) / 9 ) : Math.floor( ( 4 * win.height ) / 3 );
					vid.marginTop = -( ( win.height * ( margin / 2 ) ) / 100 );
					vid.marginLeft = -( ( vid.width - win.width ) / 2 );
				}
				vid.width += overprint;
				vid.height += overprint;
				vid.marginTop -= overprint / 2;
				vid.marginLeft -= overprint / 2;
			} else {
				vid.width = "100%";
				vid.height = "100%";
				vid.marginTop = 0;
				vid.marginLeft = 0;
			}
			playerBox.css( {
				width: vid.width,
				height: vid.height,
				marginTop: vid.marginTop,
				marginLeft: vid.marginLeft
			} );
		};
		/**
		 *
		 * @param arr
		 * @returns {Array|string|Blob|*}
		 *
		 */
		jQuery.shuffle = function( arr ) {
			var newArray = arr.slice();
			var len = newArray.length;
			var i = len;
			while( i-- ) {
				var p = parseInt( Math.random() * len );
				var t = newArray[ i ];
				newArray[ i ] = newArray[ p ];
				newArray[ p ] = t;
			}
			return newArray;
		};
	
		jQuery.fn.unselectable = function() {
			return this.each( function() {
				jQuery( this ).css( {
					"-moz-user-select": "none",
					"-webkit-user-select": "none",
					"user-select": "none"
				} ).attr( "unselectable", "on" );
			} );
		};
	
	
		/* Exposed public method */
		jQuery.fn.YTPlayer = jQuery.mbYTPlayer.buildPlayer;
		jQuery.fn.YTPGetPlayer = jQuery.mbYTPlayer.getPlayer;
		jQuery.fn.YTPGetVideoID = jQuery.mbYTPlayer.getVideoID;
		jQuery.fn.YTPChangeMovie = jQuery.mbYTPlayer.changeMovie;
		jQuery.fn.YTPPlayerDestroy = jQuery.mbYTPlayer.playerDestroy;
	
		jQuery.fn.YTPPlay = jQuery.mbYTPlayer.play;
		jQuery.fn.YTPTogglePlay = jQuery.mbYTPlayer.togglePlay;
		jQuery.fn.YTPStop = jQuery.mbYTPlayer.stop;
		jQuery.fn.YTPPause = jQuery.mbYTPlayer.pause;
		jQuery.fn.YTPSeekTo = jQuery.mbYTPlayer.seekTo;
	
		jQuery.fn.YTPlaylist = jQuery.mbYTPlayer.playlist;
		jQuery.fn.YTPPlayNext = jQuery.mbYTPlayer.playNext;
		jQuery.fn.YTPPlayPrev = jQuery.mbYTPlayer.playPrev;
	
		jQuery.fn.YTPMute = jQuery.mbYTPlayer.mute;
		jQuery.fn.YTPUnmute = jQuery.mbYTPlayer.unmute;
		jQuery.fn.YTPToggleVolume = jQuery.mbYTPlayer.toggleVolume;
		jQuery.fn.YTPSetVolume = jQuery.mbYTPlayer.setVolume;
	
		jQuery.fn.YTPGetVideoData = jQuery.mbYTPlayer.getVideoData;
		jQuery.fn.YTPFullscreen = jQuery.mbYTPlayer.fullscreen;
		jQuery.fn.YTPToggleLoops = jQuery.mbYTPlayer.toggleLoops;
		jQuery.fn.YTPSetVideoQuality = jQuery.mbYTPlayer.setVideoQuality;
		jQuery.fn.YTPManageProgress = jQuery.mbYTPlayer.manageProgress;
	
		jQuery.fn.YTPApplyFilter = jQuery.mbYTPlayer.applyFilter;
		jQuery.fn.YTPApplyFilters = jQuery.mbYTPlayer.applyFilters;
		jQuery.fn.YTPToggleFilter = jQuery.mbYTPlayer.toggleFilter;
		jQuery.fn.YTPToggleFilters = jQuery.mbYTPlayer.toggleFilters;
		jQuery.fn.YTPRemoveFilter = jQuery.mbYTPlayer.removeFilter;
		jQuery.fn.YTPDisableFilters = jQuery.mbYTPlayer.disableFilters;
		jQuery.fn.YTPEnableFilters = jQuery.mbYTPlayer.enableFilters;
	
	
		/**
		 *
		 * @deprecated
		 *
		 **/
		jQuery.fn.mb_YTPlayer = jQuery.mbYTPlayer.buildPlayer;
		jQuery.fn.playNext = jQuery.mbYTPlayer.playNext;
		jQuery.fn.playPrev = jQuery.mbYTPlayer.playPrev;
		jQuery.fn.changeMovie = jQuery.mbYTPlayer.changeMovie;
		jQuery.fn.getVideoID = jQuery.mbYTPlayer.getVideoID;
		jQuery.fn.getPlayer = jQuery.mbYTPlayer.getPlayer;
		jQuery.fn.playerDestroy = jQuery.mbYTPlayer.playerDestroy;
		jQuery.fn.fullscreen = jQuery.mbYTPlayer.fullscreen;
		jQuery.fn.buildYTPControls = jQuery.mbYTPlayer.buildControls;
		jQuery.fn.playYTP = jQuery.mbYTPlayer.play;
		jQuery.fn.toggleLoops = jQuery.mbYTPlayer.toggleLoops;
		jQuery.fn.stopYTP = jQuery.mbYTPlayer.stop;
		jQuery.fn.pauseYTP = jQuery.mbYTPlayer.pause;
		jQuery.fn.seekToYTP = jQuery.mbYTPlayer.seekTo;
		jQuery.fn.muteYTPVolume = jQuery.mbYTPlayer.mute;
		jQuery.fn.unmuteYTPVolume = jQuery.mbYTPlayer.unmute;
		jQuery.fn.setYTPVolume = jQuery.mbYTPlayer.setVolume;
		jQuery.fn.setVideoQuality = jQuery.mbYTPlayer.setVideoQuality;
		jQuery.fn.manageYTPProgress = jQuery.mbYTPlayer.manageProgress;
		jQuery.fn.YTPGetDataFromFeed = jQuery.mbYTPlayer.getVideoData;
	
	
	} )( jQuery, ytp );
	;
	/*
	 * ******************************************************************************
	 *  jquery.mb.components
	 *  file: jquery.mb.CSSAnimate.min.js
	 *
	 *  Copyright (c) 2001-2014. Matteo Bicocchi (Pupunzi);
	 *  Open lab srl, Firenze - Italy
	 *  email: matteo@open-lab.com
	 *  site: 	http://pupunzi.com
	 *  blog:	http://pupunzi.open-lab.com
	 * 	http://open-lab.com
	 *
	 *  Licences: MIT, GPL
	 *  http://www.opensource.org/licenses/mit-license.php
	 *  http://www.gnu.org/licenses/gpl.html
	 *
	 *  last modified: 26/03/14 21.40
	 *  *****************************************************************************
	 */
	
	function uncamel(a){return a.replace(/([A-Z])/g,function(a){return"-"+a.toLowerCase()})}function setUnit(a,b){return"string"!=typeof a||a.match(/^[\-0-9\.]+jQuery/)?""+a+b:a}function setFilter(a,b,c){var d=uncamel(b),e=jQuery.browser.mozilla?"":jQuery.CSS.sfx;a[e+"filter"]=a[e+"filter"]||"",c=setUnit(c>jQuery.CSS.filters[b].max?jQuery.CSS.filters[b].max:c,jQuery.CSS.filters[b].unit),a[e+"filter"]+=d+"("+c+") ",delete a[b]}jQuery.support.CSStransition=function(){var a=document.body||document.documentElement,b=a.style;return void 0!==b.transition||void 0!==b.WebkitTransition||void 0!==b.MozTransition||void 0!==b.MsTransition||void 0!==b.OTransition}(),jQuery.CSS={name:"mb.CSSAnimate",author:"Matteo Bicocchi",version:"2.0.0",transitionEnd:"transitionEnd",sfx:"",filters:{blur:{min:0,max:100,unit:"px"},brightness:{min:0,max:400,unit:"%"},contrast:{min:0,max:400,unit:"%"},grayscale:{min:0,max:100,unit:"%"},hueRotate:{min:0,max:360,unit:"deg"},invert:{min:0,max:100,unit:"%"},saturate:{min:0,max:400,unit:"%"},sepia:{min:0,max:100,unit:"%"}},normalizeCss:function(a){var b=jQuery.extend(!0,{},a);jQuery.browser.webkit||jQuery.browser.opera?jQuery.CSS.sfx="-webkit-":jQuery.browser.mozilla?jQuery.CSS.sfx="-moz-":jQuery.browser.msie&&(jQuery.CSS.sfx="-ms-");for(var c in b){"transform"===c&&(b[jQuery.CSS.sfx+"transform"]=b[c],delete b[c]),"transform-origin"===c&&(b[jQuery.CSS.sfx+"transform-origin"]=a[c],delete b[c]),"filter"!==c||jQuery.browser.mozilla||(b[jQuery.CSS.sfx+"filter"]=a[c],delete b[c]),"blur"===c&&setFilter(b,"blur",a[c]),"brightness"===c&&setFilter(b,"brightness",a[c]),"contrast"===c&&setFilter(b,"contrast",a[c]),"grayscale"===c&&setFilter(b,"grayscale",a[c]),"hueRotate"===c&&setFilter(b,"hueRotate",a[c]),"invert"===c&&setFilter(b,"invert",a[c]),"saturate"===c&&setFilter(b,"saturate",a[c]),"sepia"===c&&setFilter(b,"sepia",a[c]);var d="";"x"===c&&(d=jQuery.CSS.sfx+"transform",b[d]=b[d]||"",b[d]+=" translateX("+setUnit(a[c],"px")+")",delete b[c]),"y"===c&&(d=jQuery.CSS.sfx+"transform",b[d]=b[d]||"",b[d]+=" translateY("+setUnit(a[c],"px")+")",delete b[c]),"z"===c&&(d=jQuery.CSS.sfx+"transform",b[d]=b[d]||"",b[d]+=" translateZ("+setUnit(a[c],"px")+")",delete b[c]),"rotate"===c&&(d=jQuery.CSS.sfx+"transform",b[d]=b[d]||"",b[d]+=" rotate("+setUnit(a[c],"deg")+")",delete b[c]),"rotateX"===c&&(d=jQuery.CSS.sfx+"transform",b[d]=b[d]||"",b[d]+=" rotateX("+setUnit(a[c],"deg")+")",delete b[c]),"rotateY"===c&&(d=jQuery.CSS.sfx+"transform",b[d]=b[d]||"",b[d]+=" rotateY("+setUnit(a[c],"deg")+")",delete b[c]),"rotateZ"===c&&(d=jQuery.CSS.sfx+"transform",b[d]=b[d]||"",b[d]+=" rotateZ("+setUnit(a[c],"deg")+")",delete b[c]),"scale"===c&&(d=jQuery.CSS.sfx+"transform",b[d]=b[d]||"",b[d]+=" scale("+setUnit(a[c],"")+")",delete b[c]),"scaleX"===c&&(d=jQuery.CSS.sfx+"transform",b[d]=b[d]||"",b[d]+=" scaleX("+setUnit(a[c],"")+")",delete b[c]),"scaleY"===c&&(d=jQuery.CSS.sfx+"transform",b[d]=b[d]||"",b[d]+=" scaleY("+setUnit(a[c],"")+")",delete b[c]),"scaleZ"===c&&(d=jQuery.CSS.sfx+"transform",b[d]=b[d]||"",b[d]+=" scaleZ("+setUnit(a[c],"")+")",delete b[c]),"skew"===c&&(d=jQuery.CSS.sfx+"transform",b[d]=b[d]||"",b[d]+=" skew("+setUnit(a[c],"deg")+")",delete b[c]),"skewX"===c&&(d=jQuery.CSS.sfx+"transform",b[d]=b[d]||"",b[d]+=" skewX("+setUnit(a[c],"deg")+")",delete b[c]),"skewY"===c&&(d=jQuery.CSS.sfx+"transform",b[d]=b[d]||"",b[d]+=" skewY("+setUnit(a[c],"deg")+")",delete b[c]),"perspective"===c&&(d=jQuery.CSS.sfx+"transform",b[d]=b[d]||"",b[d]+=" perspective("+setUnit(a[c],"px")+")",delete b[c])}return b},getProp:function(a){var b=[];for(var c in a)b.indexOf(c)<0&&b.push(uncamel(c));return b.join(",")},animate:function(a,b,c,d,e){return this.each(function(){function o(){f.called=!0,f.CSSAIsRunning=!1,g.off(jQuery.CSS.transitionEnd+"."+f.id),clearTimeout(f.timeout),g.css(jQuery.CSS.sfx+"transition",""),"function"==typeof e&&e.apply(f),"function"==typeof f.CSSqueue&&(f.CSSqueue(),f.CSSqueue=null)}var f=this,g=jQuery(this);f.id=f.id||"CSSA_"+(new Date).getTime();var h=h||{type:"noEvent"};if(f.CSSAIsRunning&&f.eventType==h.type&&!jQuery.browser.msie&&jQuery.browser.version<=9)return f.CSSqueue=function(){g.CSSAnimate(a,b,c,d,e)},void 0;if(f.CSSqueue=null,f.eventType=h.type,0!==g.length&&a){if(a=jQuery.normalizeCss(a),f.CSSAIsRunning=!0,"function"==typeof b&&(e=b,b=jQuery.fx.speeds._default),"function"==typeof c&&(d=c,c=0),"string"==typeof c&&(e=c,c=0),"function"==typeof d&&(e=d,d="cubic-bezier(0.65,0.03,0.36,0.72)"),"string"==typeof b)for(var i in jQuery.fx.speeds){if(b==i){b=jQuery.fx.speeds[i];break}b=jQuery.fx.speeds._default}if(b||(b=jQuery.fx.speeds._default),"string"==typeof e&&(d=e,e=null),!jQuery.support.CSStransition){for(var j in a){if("transform"===j&&delete a[j],"filter"===j&&delete a[j],"transform-origin"===j&&delete a[j],"auto"===a[j]&&delete a[j],"x"===j){var k=a[j],l="left";a[l]=k,delete a[j]}if("y"===j){var k=a[j],l="top";a[l]=k,delete a[j]}("-ms-transform"===j||"-ms-filter"===j)&&delete a[j]}return g.delay(c).animate(a,b,e),void 0}var m={"default":"ease","in":"ease-in",out:"ease-out","in-out":"ease-in-out",snap:"cubic-bezier(0,1,.5,1)",easeOutCubic:"cubic-bezier(.215,.61,.355,1)",easeInOutCubic:"cubic-bezier(.645,.045,.355,1)",easeInCirc:"cubic-bezier(.6,.04,.98,.335)",easeOutCirc:"cubic-bezier(.075,.82,.165,1)",easeInOutCirc:"cubic-bezier(.785,.135,.15,.86)",easeInExpo:"cubic-bezier(.95,.05,.795,.035)",easeOutExpo:"cubic-bezier(.19,1,.22,1)",easeInOutExpo:"cubic-bezier(1,0,0,1)",easeInQuad:"cubic-bezier(.55,.085,.68,.53)",easeOutQuad:"cubic-bezier(.25,.46,.45,.94)",easeInOutQuad:"cubic-bezier(.455,.03,.515,.955)",easeInQuart:"cubic-bezier(.895,.03,.685,.22)",easeOutQuart:"cubic-bezier(.165,.84,.44,1)",easeInOutQuart:"cubic-bezier(.77,0,.175,1)",easeInQuint:"cubic-bezier(.755,.05,.855,.06)",easeOutQuint:"cubic-bezier(.23,1,.32,1)",easeInOutQuint:"cubic-bezier(.86,0,.07,1)",easeInSine:"cubic-bezier(.47,0,.745,.715)",easeOutSine:"cubic-bezier(.39,.575,.565,1)",easeInOutSine:"cubic-bezier(.445,.05,.55,.95)",easeInBack:"cubic-bezier(.6,-.28,.735,.045)",easeOutBack:"cubic-bezier(.175, .885,.32,1.275)",easeInOutBack:"cubic-bezier(.68,-.55,.265,1.55)"};m[d]&&(d=m[d]),g.off(jQuery.CSS.transitionEnd+"."+f.id);var n=jQuery.CSS.getProp(a),p={};jQuery.extend(p,a),p[jQuery.CSS.sfx+"transition-property"]=n,p[jQuery.CSS.sfx+"transition-duration"]=b+"ms",p[jQuery.CSS.sfx+"transition-delay"]=c+"ms",p[jQuery.CSS.sfx+"transition-timing-function"]=d,setTimeout(function(){g.one(jQuery.CSS.transitionEnd+"."+f.id,o),g.css(p)},1),f.timeout=setTimeout(function(){return f.called||!e?(f.called=!1,f.CSSAIsRunning=!1,void 0):(g.css(jQuery.CSS.sfx+"transition",""),e.apply(f),f.CSSAIsRunning=!1,"function"==typeof f.CSSqueue&&(f.CSSqueue(),f.CSSqueue=null),void 0)},b+c+10)}})}},jQuery.fn.CSSAnimate=jQuery.CSS.animate,jQuery.normalizeCss=jQuery.CSS.normalizeCss,jQuery.fn.css3=function(a){return this.each(function(){var b=jQuery(this),c=jQuery.normalizeCss(a);b.css(c)})};
	;/*
	 * ******************************************************************************
	 *  jquery.mb.components
	 *  file: jquery.mb.browser.min.js
	 *
	 *  Copyright (c) 2001-2014. Matteo Bicocchi (Pupunzi);
	 *  Open lab srl, Firenze - Italy
	 *  email: matteo@open-lab.com
	 *  site: 	http://pupunzi.com
	 *  blog:	http://pupunzi.open-lab.com
	 * 	http://open-lab.com
	 *
	 *  Licences: MIT, GPL
	 *  http://www.opensource.org/licenses/mit-license.php
	 *  http://www.gnu.org/licenses/gpl.html
	 *
	 *  last modified: 26/03/14 21.43
	 *  *****************************************************************************
	 */
	
	var nAgt=navigator.userAgent;if(!jQuery.browser){jQuery.browser={},jQuery.browser.mozilla=!1,jQuery.browser.webkit=!1,jQuery.browser.opera=!1,jQuery.browser.safari=!1,jQuery.browser.chrome=!1,jQuery.browser.msie=!1,jQuery.browser.ua=nAgt,jQuery.browser.name=navigator.appName,jQuery.browser.fullVersion=""+parseFloat(navigator.appVersion),jQuery.browser.majorVersion=parseInt(navigator.appVersion,10);var nameOffset,verOffset,ix;if(-1!=(verOffset=nAgt.indexOf("Opera")))jQuery.browser.opera=!0,jQuery.browser.name="Opera",jQuery.browser.fullVersion=nAgt.substring(verOffset+6),-1!=(verOffset=nAgt.indexOf("Version"))&&(jQuery.browser.fullVersion=nAgt.substring(verOffset+8));else if(-1!=(verOffset=nAgt.indexOf("OPR")))jQuery.browser.opera=!0,jQuery.browser.name="Opera",jQuery.browser.fullVersion=nAgt.substring(verOffset+4);else if(-1!=(verOffset=nAgt.indexOf("MSIE")))jQuery.browser.msie=!0,jQuery.browser.name="Microsoft Internet Explorer",jQuery.browser.fullVersion=nAgt.substring(verOffset+5);else if(-1!=nAgt.indexOf("Trident")){jQuery.browser.msie=!0,jQuery.browser.name="Microsoft Internet Explorer";var start=nAgt.indexOf("rv:")+3,end=start+4;jQuery.browser.fullVersion=nAgt.substring(start,end)}else-1!=(verOffset=nAgt.indexOf("Chrome"))?(jQuery.browser.webkit=!0,jQuery.browser.chrome=!0,jQuery.browser.name="Chrome",jQuery.browser.fullVersion=nAgt.substring(verOffset+7)):-1!=(verOffset=nAgt.indexOf("Safari"))?(jQuery.browser.webkit=!0,jQuery.browser.safari=!0,jQuery.browser.name="Safari",jQuery.browser.fullVersion=nAgt.substring(verOffset+7),-1!=(verOffset=nAgt.indexOf("Version"))&&(jQuery.browser.fullVersion=nAgt.substring(verOffset+8))):-1!=(verOffset=nAgt.indexOf("AppleWebkit"))?(jQuery.browser.webkit=!0,jQuery.browser.name="Safari",jQuery.browser.fullVersion=nAgt.substring(verOffset+7),-1!=(verOffset=nAgt.indexOf("Version"))&&(jQuery.browser.fullVersion=nAgt.substring(verOffset+8))):-1!=(verOffset=nAgt.indexOf("Firefox"))?(jQuery.browser.mozilla=!0,jQuery.browser.name="Firefox",jQuery.browser.fullVersion=nAgt.substring(verOffset+8)):(nameOffset=nAgt.lastIndexOf(" ")+1)<(verOffset=nAgt.lastIndexOf("/"))&&(jQuery.browser.name=nAgt.substring(nameOffset,verOffset),jQuery.browser.fullVersion=nAgt.substring(verOffset+1),jQuery.browser.name.toLowerCase()==jQuery.browser.name.toUpperCase()&&(jQuery.browser.name=navigator.appName));-1!=(ix=jQuery.browser.fullVersion.indexOf(";"))&&(jQuery.browser.fullVersion=jQuery.browser.fullVersion.substring(0,ix)),-1!=(ix=jQuery.browser.fullVersion.indexOf(" "))&&(jQuery.browser.fullVersion=jQuery.browser.fullVersion.substring(0,ix)),jQuery.browser.majorVersion=parseInt(""+jQuery.browser.fullVersion,10),isNaN(jQuery.browser.majorVersion)&&(jQuery.browser.fullVersion=""+parseFloat(navigator.appVersion),jQuery.browser.majorVersion=parseInt(navigator.appVersion,10)),jQuery.browser.version=jQuery.browser.majorVersion}jQuery.browser.android=/Android/i.test(nAgt),jQuery.browser.blackberry=/BlackBerry|BB|PlayBook/i.test(nAgt),jQuery.browser.ios=/iPhone|iPad|iPod|webOS/i.test(nAgt),jQuery.browser.operaMobile=/Opera Mini/i.test(nAgt),jQuery.browser.windowsMobile=/IEMobile|Windows Phone/i.test(nAgt),jQuery.browser.kindle=/Kindle|Silk/i.test(nAgt),jQuery.browser.mobile=jQuery.browser.android||jQuery.browser.blackberry||jQuery.browser.ios||jQuery.browser.windowsMobile||jQuery.browser.operaMobile||jQuery.browser.kindle,jQuery.isMobile=jQuery.browser.mobile,jQuery.isTablet=jQuery.browser.mobile&&jQuery(window).width()>765,jQuery.isAndroidDefault=jQuery.browser.android&&!/chrome/i.test(nAgt);
	;/*___________________________________________________________________________________________________________________________________________________
	 _ jquery.mb.components                                                                                                                             _
	 _                                                                                                                                                  _
	 _ file: jquery.mb.simpleSlider.min.js                                                                                                              _
	 _ last modified: 16/05/15 23.45                                                                                                                    _
	 _                                                                                                                                                  _
	 _ Open Lab s.r.l., Florence - Italy                                                                                                                _
	 _                                                                                                                                                  _
	 _ email: matteo@open-lab.com                                                                                                                       _
	 _ site: http://pupunzi.com                                                                                                                         _
	 _       http://open-lab.com                                                                                                                        _
	 _ blog: http://pupunzi.open-lab.com                                                                                                                _
	 _ Q&A:  http://jquery.pupunzi.com                                                                                                                  _
	 _                                                                                                                                                  _
	 _ Licences: MIT, GPL                                                                                                                               _
	 _    http://www.opensource.org/licenses/mit-license.php                                                                                            _
	 _    http://www.gnu.org/licenses/gpl.html                                                                                                          _
	 _                                                                                                                                                  _
	 _ Copyright (c) 2001-2015. Matteo Bicocchi (Pupunzi);                                                                                              _
	 ___________________________________________________________________________________________________________________________________________________*/
	
	!function(a){/iphone|ipod|ipad|android|ie|blackberry|fennec/.test(navigator.userAgent.toLowerCase());var c="ontouchstart"in window||window.navigator&&window.navigator.msPointerEnabled&&window.MSGesture||window.DocumentTouch&&document instanceof DocumentTouch||!1;a.simpleSlider={defaults:{initialval:0,scale:100,orientation:"h",readonly:!1,callback:!1},events:{start:c?"touchstart":"mousedown",end:c?"touchend":"mouseup",move:c?"touchmove":"mousemove"},init:function(b){return this.each(function(){var d=this,e=a(d);e.addClass("simpleSlider"),d.opt={},a.extend(d.opt,a.simpleSlider.defaults,b),a.extend(d.opt,e.data());var f="h"==d.opt.orientation?"horizontal":"vertical",g=a("<div/>").addClass("level").addClass(f);e.prepend(g),d.level=g,e.css({cursor:"default"}),"auto"==d.opt.scale&&(d.opt.scale=a(d).outerWidth()),e.updateSliderVal(),d.opt.readonly||(e.on(a.simpleSlider.events.start,function(a){c&&(a=a.changedTouches[0]),d.canSlide=!0,e.updateSliderVal(a),e.css({cursor:"col-resize"}),a.preventDefault(),a.stopPropagation()}),a(document).on(a.simpleSlider.events.move,function(b){c&&(b=b.changedTouches[0]),d.canSlide&&(a(document).css({cursor:"default"}),e.updateSliderVal(b),b.preventDefault(),b.stopPropagation())}).on(a.simpleSlider.events.end,function(){a(document).css({cursor:"auto"}),d.canSlide=!1,e.css({cursor:"auto"})}))})},updateSliderVal:function(b){function g(a,b){return Math.floor(100*a/b)}var c=this,d=c.get(0);d.opt.initialval="number"==typeof d.opt.initialval?d.opt.initialval:d.opt.initialval(d);var e=a(d).outerWidth(),f=a(d).outerHeight();d.x="object"==typeof b?b.clientX+document.body.scrollLeft-c.offset().left:"number"==typeof b?b*e/d.opt.scale:d.opt.initialval*e/d.opt.scale,d.y="object"==typeof b?b.clientY+document.body.scrollTop-c.offset().top:"number"==typeof b?(d.opt.scale-d.opt.initialval-b)*f/d.opt.scale:d.opt.initialval*f/d.opt.scale,d.y=c.outerHeight()-d.y,d.scaleX=d.x*d.opt.scale/e,d.scaleY=d.y*d.opt.scale/f,d.outOfRangeX=d.scaleX>d.opt.scale?d.scaleX-d.opt.scale:d.scaleX<0?d.scaleX:0,d.outOfRangeY=d.scaleY>d.opt.scale?d.scaleY-d.opt.scale:d.scaleY<0?d.scaleY:0,d.outOfRange="h"==d.opt.orientation?d.outOfRangeX:d.outOfRangeY,d.value="undefined"!=typeof b?"h"==d.opt.orientation?d.x>=c.outerWidth()?d.opt.scale:d.x<=0?0:d.scaleX:d.y>=c.outerHeight()?d.opt.scale:d.y<=0?0:d.scaleY:"h"==d.opt.orientation?d.scaleX:d.scaleY,"h"==d.opt.orientation?d.level.width(g(d.x,e)+"%"):d.level.height(g(d.y,f)),"function"==typeof d.opt.callback&&d.opt.callback(d)}},a.fn.simpleSlider=a.simpleSlider.init,a.fn.updateSliderVal=a.simpleSlider.updateSliderVal}(jQuery);
	;/*___________________________________________________________________________________________________________________________________________________
	 _ jquery.mb.components                                                                                                                             _
	 _                                                                                                                                                  _
	 _ file: jquery.mb.storage.min.js                                                                                                                   _
	 _ last modified: 24/05/15 16.08                                                                                                                    _
	 _                                                                                                                                                  _
	 _ Open Lab s.r.l., Florence - Italy                                                                                                                _
	 _                                                                                                                                                  _
	 _ email: matteo@open-lab.com                                                                                                                       _
	 _ site: http://pupunzi.com                                                                                                                         _
	 _       http://open-lab.com                                                                                                                        _
	 _ blog: http://pupunzi.open-lab.com                                                                                                                _
	 _ Q&A:  http://jquery.pupunzi.com                                                                                                                  _
	 _                                                                                                                                                  _
	 _ Licences: MIT, GPL                                                                                                                               _
	 _    http://www.opensource.org/licenses/mit-license.php                                                                                            _
	 _    http://www.gnu.org/licenses/gpl.html                                                                                                          _
	 _                                                                                                                                                  _
	 _ Copyright (c) 2001-2015. Matteo Bicocchi (Pupunzi);                                                                                              _
	 ___________________________________________________________________________________________________________________________________________________*/
	
	!function(a){a.mbCookie={set:function(a,b,c,d){b=JSON.stringify(b),c||(c=7),d=d?"; domain="+d:"";var f,e=new Date;e.setTime(e.getTime()+1e3*60*60*24*c),f="; expires="+e.toGMTString(),document.cookie=a+"="+b+f+"; path=/"+d},get:function(a){for(var b=a+"=",c=document.cookie.split(";"),d=0;d<c.length;d++){for(var e=c[d];" "==e.charAt(0);)e=e.substring(1,e.length);if(0==e.indexOf(b))return JSON.parse(e.substring(b.length,e.length))}return null},remove:function(b){a.mbCookie.set(b,"",-1)}},a.mbStorage={set:function(a,b){b=JSON.stringify(b),localStorage.setItem(a,b)},get:function(a){return localStorage[a]?JSON.parse(localStorage[a]):null},remove:function(a){a?localStorage.removeItem(a):localStorage.clear()}}}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 2)))

/***/ },
/* 107 */
/*!***********************************************************!*\
  !*** ./pixo/assets/matchheight/jquery.matchHeight-min.js ***!
  \***********************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/**
	* jquery.matchHeight-min.js master
	* http://brm.io/jquery-match-height/
	* License: MIT
	*/
	(function(c){var n=-1,f=-1,g=function(a){return parseFloat(a)||0},r=function(a){var b=null,d=[];c(a).each(function(){var a=c(this),k=a.offset().top-g(a.css("margin-top")),l=0<d.length?d[d.length-1]:null;null===l?d.push(a):1>=Math.floor(Math.abs(b-k))?d[d.length-1]=l.add(a):d.push(a);b=k});return d},p=function(a){var b={byRow:!0,property:"height",target:null,remove:!1};if("object"===typeof a)return c.extend(b,a);"boolean"===typeof a?b.byRow=a:"remove"===a&&(b.remove=!0);return b},b=c.fn.matchHeight=
	function(a){a=p(a);if(a.remove){var e=this;this.css(a.property,"");c.each(b._groups,function(a,b){b.elements=b.elements.not(e)});return this}if(1>=this.length&&!a.target)return this;b._groups.push({elements:this,options:a});b._apply(this,a);return this};b._groups=[];b._throttle=80;b._maintainScroll=!1;b._beforeUpdate=null;b._afterUpdate=null;b._apply=function(a,e){var d=p(e),h=c(a),k=[h],l=c(window).scrollTop(),f=c("html").outerHeight(!0),m=h.parents().filter(":hidden");m.each(function(){var a=c(this);
	a.data("style-cache",a.attr("style"))});m.css("display","block");d.byRow&&!d.target&&(h.each(function(){var a=c(this),b="inline-block"===a.css("display")?"inline-block":"block";a.data("style-cache",a.attr("style"));a.css({display:b,"padding-top":"0","padding-bottom":"0","margin-top":"0","margin-bottom":"0","border-top-width":"0","border-bottom-width":"0",height:"100px"})}),k=r(h),h.each(function(){var a=c(this);a.attr("style",a.data("style-cache")||"")}));c.each(k,function(a,b){var e=c(b),f=0;if(d.target)f=
	d.target.outerHeight(!1);else{if(d.byRow&&1>=e.length){e.css(d.property,"");return}e.each(function(){var a=c(this),b={display:"inline-block"===a.css("display")?"inline-block":"block"};b[d.property]="";a.css(b);a.outerHeight(!1)>f&&(f=a.outerHeight(!1));a.css("display","")})}e.each(function(){var a=c(this),b=0;d.target&&a.is(d.target)||("border-box"!==a.css("box-sizing")&&(b+=g(a.css("border-top-width"))+g(a.css("border-bottom-width")),b+=g(a.css("padding-top"))+g(a.css("padding-bottom"))),a.css(d.property,
	f-b))})});m.each(function(){var a=c(this);a.attr("style",a.data("style-cache")||null)});b._maintainScroll&&c(window).scrollTop(l/f*c("html").outerHeight(!0));return this};b._applyDataApi=function(){var a={};c("[data-match-height], [data-mh]").each(function(){var b=c(this),d=b.attr("data-mh")||b.attr("data-match-height");a[d]=d in a?a[d].add(b):b});c.each(a,function(){this.matchHeight(!0)})};var q=function(a){b._beforeUpdate&&b._beforeUpdate(a,b._groups);c.each(b._groups,function(){b._apply(this.elements,
	this.options)});b._afterUpdate&&b._afterUpdate(a,b._groups)};b._update=function(a,e){if(e&&"resize"===e.type){var d=c(window).width();if(d===n)return;n=d}a?-1===f&&(f=setTimeout(function(){q(e);f=-1},b._throttle)):q(e)};c(b._applyDataApi);c(window).bind("load",function(a){b._update(!1,a)});c(window).bind("resize orientationchange",function(a){b._update(!0,a)})})(jQuery);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 2)))

/***/ },
/* 108 */
/*!*****************************************************!*\
  !*** ./pixo/assets/bxslider/jquery.bxslider.min.js ***!
  \*****************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/**
	 * BxSlider v4.1.1 - Fully loaded, responsive content slider
	 * http://bxslider.com
	 *
	 * Copyright 2013, Steven Wanderski - http://stevenwanderski.com - http://bxcreative.com
	 * Written while drinking Belgian ales and listening to jazz
	 *
	 * Released under the MIT license - http://opensource.org/licenses/MIT
	 */
	!function(t){var e={},s={mode:"horizontal",slideSelector:"",infiniteLoop:!0,hideControlOnEnd:!1,speed:500,easing:null,slideMargin:0,startSlide:0,randomStart:!1,captions:!1,ticker:!1,tickerHover:!1,adaptiveHeight:!1,adaptiveHeightSpeed:500,video:!1,useCSS:!0,preloadImages:"visible",responsive:!0,touchEnabled:!0,swipeThreshold:50,oneToOneTouch:!0,preventDefaultSwipeX:!0,preventDefaultSwipeY:!1,pager:!0,pagerType:"full",pagerShortSeparator:" / ",pagerSelector:null,buildPager:null,pagerCustom:null,controls:!0,nextText:"Next",prevText:"Prev",nextSelector:null,prevSelector:null,autoControls:!1,startText:"Start",stopText:"Stop",autoControlsCombine:!1,autoControlsSelector:null,auto:!1,pause:4e3,autoStart:!0,autoDirection:"next",autoHover:!1,autoDelay:0,minSlides:1,maxSlides:1,moveSlides:0,slideWidth:0,onSliderLoad:function(){},onSlideBefore:function(){},onSlideAfter:function(){},onSlideNext:function(){},onSlidePrev:function(){}};t.fn.bxSlider=function(n){if(0==this.length)return this;if(this.length>1)return this.each(function(){t(this).bxSlider(n)}),this;var o={},r=this;e.el=this;var a=t(window).width(),l=t(window).height(),d=function(){o.settings=t.extend({},s,n),o.settings.slideWidth=parseInt(o.settings.slideWidth),o.children=r.children(o.settings.slideSelector),o.children.length<o.settings.minSlides&&(o.settings.minSlides=o.children.length),o.children.length<o.settings.maxSlides&&(o.settings.maxSlides=o.children.length),o.settings.randomStart&&(o.settings.startSlide=Math.floor(Math.random()*o.children.length)),o.active={index:o.settings.startSlide},o.carousel=o.settings.minSlides>1||o.settings.maxSlides>1,o.carousel&&(o.settings.preloadImages="all"),o.minThreshold=o.settings.minSlides*o.settings.slideWidth+(o.settings.minSlides-1)*o.settings.slideMargin,o.maxThreshold=o.settings.maxSlides*o.settings.slideWidth+(o.settings.maxSlides-1)*o.settings.slideMargin,o.working=!1,o.controls={},o.interval=null,o.animProp="vertical"==o.settings.mode?"top":"left",o.usingCSS=o.settings.useCSS&&"fade"!=o.settings.mode&&function(){var t=document.createElement("div"),e=["WebkitPerspective","MozPerspective","OPerspective","msPerspective"];for(var i in e)if(void 0!==t.style[e[i]])return o.cssPrefix=e[i].replace("Perspective","").toLowerCase(),o.animProp="-"+o.cssPrefix+"-transform",!0;return!1}(),"vertical"==o.settings.mode&&(o.settings.maxSlides=o.settings.minSlides),r.data("origStyle",r.attr("style")),r.children(o.settings.slideSelector).each(function(){t(this).data("origStyle",t(this).attr("style"))}),c()},c=function(){r.wrap('<div class="bx-wrapper"><div class="bx-viewport"></div></div>'),o.viewport=r.parent(),o.loader=t('<div class="bx-loading" />'),o.viewport.prepend(o.loader),r.css({width:"horizontal"==o.settings.mode?100*o.children.length+215+"%":"auto",position:"relative"}),o.usingCSS&&o.settings.easing?r.css("-"+o.cssPrefix+"-transition-timing-function",o.settings.easing):o.settings.easing||(o.settings.easing="swing"),f(),o.viewport.css({width:"100%",overflow:"hidden",position:"relative"}),o.viewport.parent().css({maxWidth:v()}),o.settings.pager||o.viewport.parent().css({margin:"0 auto 0px"}),o.children.css({"float":"horizontal"==o.settings.mode?"left":"none",listStyle:"none",position:"relative"}),o.children.css("width",u()),"horizontal"==o.settings.mode&&o.settings.slideMargin>0&&o.children.css("marginRight",o.settings.slideMargin),"vertical"==o.settings.mode&&o.settings.slideMargin>0&&o.children.css("marginBottom",o.settings.slideMargin),"fade"==o.settings.mode&&(o.children.css({position:"absolute",zIndex:0,display:"none"}),o.children.eq(o.settings.startSlide).css({zIndex:50,display:"block"})),o.controls.el=t('<div class="bx-controls" />'),o.settings.captions&&P(),o.active.last=o.settings.startSlide==x()-1,o.settings.video&&r.fitVids();var e=o.children.eq(o.settings.startSlide);"all"==o.settings.preloadImages&&(e=o.children),o.settings.ticker?o.settings.pager=!1:(o.settings.pager&&T(),o.settings.controls&&C(),o.settings.auto&&o.settings.autoControls&&E(),(o.settings.controls||o.settings.autoControls||o.settings.pager)&&o.viewport.after(o.controls.el)),g(e,h)},g=function(e,i){var s=e.find("img, iframe").length;if(0==s)return i(),void 0;var n=0;e.find("img, iframe").each(function(){t(this).one("load",function(){++n==s&&i()}).each(function(){this.complete&&t(this).load()})})},h=function(){if(o.settings.infiniteLoop&&"fade"!=o.settings.mode&&!o.settings.ticker){var e="vertical"==o.settings.mode?o.settings.minSlides:o.settings.maxSlides,i=o.children.slice(0,e).clone().addClass("bx-clone"),s=o.children.slice(-e).clone().addClass("bx-clone");r.append(i).prepend(s)}o.loader.remove(),S(),"vertical"==o.settings.mode&&(o.settings.adaptiveHeight=!0),o.viewport.height(p()),r.redrawSlider(),o.settings.onSliderLoad(o.active.index),o.initialized=!0,o.settings.responsive&&t(window).bind("resize",B),o.settings.auto&&o.settings.autoStart&&H(),o.settings.ticker&&L(),o.settings.pager&&I(o.settings.startSlide),o.settings.controls&&W(),o.settings.touchEnabled&&!o.settings.ticker&&O()},p=function(){var e=0,s=t();if("vertical"==o.settings.mode||o.settings.adaptiveHeight)if(o.carousel){var n=1==o.settings.moveSlides?o.active.index:o.active.index*m();for(s=o.children.eq(n),i=1;i<=o.settings.maxSlides-1;i++)s=n+i>=o.children.length?s.add(o.children.eq(i-1)):s.add(o.children.eq(n+i))}else s=o.children.eq(o.active.index);else s=o.children;return"vertical"==o.settings.mode?(s.each(function(){e+=t(this).outerHeight()}),o.settings.slideMargin>0&&(e+=o.settings.slideMargin*(o.settings.minSlides-1))):e=Math.max.apply(Math,s.map(function(){return t(this).outerHeight(!1)}).get()),e},v=function(){var t="100%";return o.settings.slideWidth>0&&(t="horizontal"==o.settings.mode?o.settings.maxSlides*o.settings.slideWidth+(o.settings.maxSlides-1)*o.settings.slideMargin:o.settings.slideWidth),t},u=function(){var t=o.settings.slideWidth,e=o.viewport.width();return 0==o.settings.slideWidth||o.settings.slideWidth>e&&!o.carousel||"vertical"==o.settings.mode?t=e:o.settings.maxSlides>1&&"horizontal"==o.settings.mode&&(e>o.maxThreshold||e<o.minThreshold&&(t=(e-o.settings.slideMargin*(o.settings.minSlides-1))/o.settings.minSlides)),t},f=function(){var t=1;if("horizontal"==o.settings.mode&&o.settings.slideWidth>0)if(o.viewport.width()<o.minThreshold)t=o.settings.minSlides;else if(o.viewport.width()>o.maxThreshold)t=o.settings.maxSlides;else{var e=o.children.first().width();t=Math.floor(o.viewport.width()/e)}else"vertical"==o.settings.mode&&(t=o.settings.minSlides);return t},x=function(){var t=0;if(o.settings.moveSlides>0)if(o.settings.infiniteLoop)t=o.children.length/m();else for(var e=0,i=0;e<o.children.length;)++t,e=i+f(),i+=o.settings.moveSlides<=f()?o.settings.moveSlides:f();else t=Math.ceil(o.children.length/f());return t},m=function(){return o.settings.moveSlides>0&&o.settings.moveSlides<=f()?o.settings.moveSlides:f()},S=function(){if(o.children.length>o.settings.maxSlides&&o.active.last&&!o.settings.infiniteLoop){if("horizontal"==o.settings.mode){var t=o.children.last(),e=t.position();b(-(e.left-(o.viewport.width()-t.width())),"reset",0)}else if("vertical"==o.settings.mode){var i=o.children.length-o.settings.minSlides,e=o.children.eq(i).position();b(-e.top,"reset",0)}}else{var e=o.children.eq(o.active.index*m()).position();o.active.index==x()-1&&(o.active.last=!0),void 0!=e&&("horizontal"==o.settings.mode?b(-e.left,"reset",0):"vertical"==o.settings.mode&&b(-e.top,"reset",0))}},b=function(t,e,i,s){if(o.usingCSS){var n="vertical"==o.settings.mode?"translate3d(0, "+t+"px, 0)":"translate3d("+t+"px, 0, 0)";r.css("-"+o.cssPrefix+"-transition-duration",i/1e3+"s"),"slide"==e?(r.css(o.animProp,n),r.bind("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd",function(){r.unbind("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd"),D()})):"reset"==e?r.css(o.animProp,n):"ticker"==e&&(r.css("-"+o.cssPrefix+"-transition-timing-function","linear"),r.css(o.animProp,n),r.bind("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd",function(){r.unbind("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd"),b(s.resetValue,"reset",0),N()}))}else{var a={};a[o.animProp]=t,"slide"==e?r.animate(a,i,o.settings.easing,function(){D()}):"reset"==e?r.css(o.animProp,t):"ticker"==e&&r.animate(a,speed,"linear",function(){b(s.resetValue,"reset",0),N()})}},w=function(){for(var e="",i=x(),s=0;i>s;s++){var n="";o.settings.buildPager&&t.isFunction(o.settings.buildPager)?(n=o.settings.buildPager(s),o.pagerEl.addClass("bx-custom-pager")):(n=s+1,o.pagerEl.addClass("bx-default-pager")),e+='<div class="bx-pager-item"><a href="" data-slide-index="'+s+'" class="bx-pager-link">'+n+"</a></div>"}o.pagerEl.html(e)},T=function(){o.settings.pagerCustom?o.pagerEl=t(o.settings.pagerCustom):(o.pagerEl=t('<div class="bx-pager" />'),o.settings.pagerSelector?t(o.settings.pagerSelector).html(o.pagerEl):o.controls.el.addClass("bx-has-pager").append(o.pagerEl),w()),o.pagerEl.delegate("a","click",q)},C=function(){o.controls.next=t('<a class="bx-next" href="">'+o.settings.nextText+"</a>"),o.controls.prev=t('<a class="bx-prev" href="">'+o.settings.prevText+"</a>"),o.controls.next.bind("click",y),o.controls.prev.bind("click",z),o.settings.nextSelector&&t(o.settings.nextSelector).append(o.controls.next),o.settings.prevSelector&&t(o.settings.prevSelector).append(o.controls.prev),o.settings.nextSelector||o.settings.prevSelector||(o.controls.directionEl=t('<div class="bx-controls-direction" />'),o.controls.directionEl.append(o.controls.prev).append(o.controls.next),o.controls.el.addClass("bx-has-controls-direction").append(o.controls.directionEl))},E=function(){o.controls.start=t('<div class="bx-controls-auto-item"><a class="bx-start" href="">'+o.settings.startText+"</a></div>"),o.controls.stop=t('<div class="bx-controls-auto-item"><a class="bx-stop" href="">'+o.settings.stopText+"</a></div>"),o.controls.autoEl=t('<div class="bx-controls-auto" />'),o.controls.autoEl.delegate(".bx-start","click",k),o.controls.autoEl.delegate(".bx-stop","click",M),o.settings.autoControlsCombine?o.controls.autoEl.append(o.controls.start):o.controls.autoEl.append(o.controls.start).append(o.controls.stop),o.settings.autoControlsSelector?t(o.settings.autoControlsSelector).html(o.controls.autoEl):o.controls.el.addClass("bx-has-controls-auto").append(o.controls.autoEl),A(o.settings.autoStart?"stop":"start")},P=function(){o.children.each(function(){var e=t(this).find("img:first").attr("title");void 0!=e&&(""+e).length&&t(this).append('<div class="bx-caption"><span>'+e+"</span></div>")})},y=function(t){o.settings.auto&&r.stopAuto(),r.goToNextSlide(),t.preventDefault()},z=function(t){o.settings.auto&&r.stopAuto(),r.goToPrevSlide(),t.preventDefault()},k=function(t){r.startAuto(),t.preventDefault()},M=function(t){r.stopAuto(),t.preventDefault()},q=function(e){o.settings.auto&&r.stopAuto();var i=t(e.currentTarget),s=parseInt(i.attr("data-slide-index"));s!=o.active.index&&r.goToSlide(s),e.preventDefault()},I=function(e){var i=o.children.length;return"short"==o.settings.pagerType?(o.settings.maxSlides>1&&(i=Math.ceil(o.children.length/o.settings.maxSlides)),o.pagerEl.html(e+1+o.settings.pagerShortSeparator+i),void 0):(o.pagerEl.find("a").removeClass("active"),o.pagerEl.each(function(i,s){t(s).find("a").eq(e).addClass("active")}),void 0)},D=function(){if(o.settings.infiniteLoop){var t="";0==o.active.index?t=o.children.eq(0).position():o.active.index==x()-1&&o.carousel?t=o.children.eq((x()-1)*m()).position():o.active.index==o.children.length-1&&(t=o.children.eq(o.children.length-1).position()),"horizontal"==o.settings.mode?b(-t.left,"reset",0):"vertical"==o.settings.mode&&b(-t.top,"reset",0)}o.working=!1,o.settings.onSlideAfter(o.children.eq(o.active.index),o.oldIndex,o.active.index)},A=function(t){o.settings.autoControlsCombine?o.controls.autoEl.html(o.controls[t]):(o.controls.autoEl.find("a").removeClass("active"),o.controls.autoEl.find("a:not(.bx-"+t+")").addClass("active"))},W=function(){1==x()?(o.controls.prev.addClass("disabled"),o.controls.next.addClass("disabled")):!o.settings.infiniteLoop&&o.settings.hideControlOnEnd&&(0==o.active.index?(o.controls.prev.addClass("disabled"),o.controls.next.removeClass("disabled")):o.active.index==x()-1?(o.controls.next.addClass("disabled"),o.controls.prev.removeClass("disabled")):(o.controls.prev.removeClass("disabled"),o.controls.next.removeClass("disabled")))},H=function(){o.settings.autoDelay>0?setTimeout(r.startAuto,o.settings.autoDelay):r.startAuto(),o.settings.autoHover&&r.hover(function(){o.interval&&(r.stopAuto(!0),o.autoPaused=!0)},function(){o.autoPaused&&(r.startAuto(!0),o.autoPaused=null)})},L=function(){var e=0;if("next"==o.settings.autoDirection)r.append(o.children.clone().addClass("bx-clone"));else{r.prepend(o.children.clone().addClass("bx-clone"));var i=o.children.first().position();e="horizontal"==o.settings.mode?-i.left:-i.top}b(e,"reset",0),o.settings.pager=!1,o.settings.controls=!1,o.settings.autoControls=!1,o.settings.tickerHover&&!o.usingCSS&&o.viewport.hover(function(){r.stop()},function(){var e=0;o.children.each(function(){e+="horizontal"==o.settings.mode?t(this).outerWidth(!0):t(this).outerHeight(!0)});var i=o.settings.speed/e,s="horizontal"==o.settings.mode?"left":"top",n=i*(e-Math.abs(parseInt(r.css(s))));N(n)}),N()},N=function(t){speed=t?t:o.settings.speed;var e={left:0,top:0},i={left:0,top:0};"next"==o.settings.autoDirection?e=r.find(".bx-clone").first().position():i=o.children.first().position();var s="horizontal"==o.settings.mode?-e.left:-e.top,n="horizontal"==o.settings.mode?-i.left:-i.top,a={resetValue:n};b(s,"ticker",speed,a)},O=function(){o.touch={start:{x:0,y:0},end:{x:0,y:0}},o.viewport.bind("touchstart",X)},X=function(t){if(o.working)t.preventDefault();else{o.touch.originalPos=r.position();var e=t.originalEvent;o.touch.start.x=e.changedTouches[0].pageX,o.touch.start.y=e.changedTouches[0].pageY,o.viewport.bind("touchmove",Y),o.viewport.bind("touchend",V)}},Y=function(t){var e=t.originalEvent,i=Math.abs(e.changedTouches[0].pageX-o.touch.start.x),s=Math.abs(e.changedTouches[0].pageY-o.touch.start.y);if(3*i>s&&o.settings.preventDefaultSwipeX?t.preventDefault():3*s>i&&o.settings.preventDefaultSwipeY&&t.preventDefault(),"fade"!=o.settings.mode&&o.settings.oneToOneTouch){var n=0;if("horizontal"==o.settings.mode){var r=e.changedTouches[0].pageX-o.touch.start.x;n=o.touch.originalPos.left+r}else{var r=e.changedTouches[0].pageY-o.touch.start.y;n=o.touch.originalPos.top+r}b(n,"reset",0)}},V=function(t){o.viewport.unbind("touchmove",Y);var e=t.originalEvent,i=0;if(o.touch.end.x=e.changedTouches[0].pageX,o.touch.end.y=e.changedTouches[0].pageY,"fade"==o.settings.mode){var s=Math.abs(o.touch.start.x-o.touch.end.x);s>=o.settings.swipeThreshold&&(o.touch.start.x>o.touch.end.x?r.goToNextSlide():r.goToPrevSlide(),r.stopAuto())}else{var s=0;"horizontal"==o.settings.mode?(s=o.touch.end.x-o.touch.start.x,i=o.touch.originalPos.left):(s=o.touch.end.y-o.touch.start.y,i=o.touch.originalPos.top),!o.settings.infiniteLoop&&(0==o.active.index&&s>0||o.active.last&&0>s)?b(i,"reset",200):Math.abs(s)>=o.settings.swipeThreshold?(0>s?r.goToNextSlide():r.goToPrevSlide(),r.stopAuto()):b(i,"reset",200)}o.viewport.unbind("touchend",V)},B=function(){var e=t(window).width(),i=t(window).height();(a!=e||l!=i)&&(a=e,l=i,r.redrawSlider())};return r.goToSlide=function(e,i){if(!o.working&&o.active.index!=e)if(o.working=!0,o.oldIndex=o.active.index,o.active.index=0>e?x()-1:e>=x()?0:e,o.settings.onSlideBefore(o.children.eq(o.active.index),o.oldIndex,o.active.index),"next"==i?o.settings.onSlideNext(o.children.eq(o.active.index),o.oldIndex,o.active.index):"prev"==i&&o.settings.onSlidePrev(o.children.eq(o.active.index),o.oldIndex,o.active.index),o.active.last=o.active.index>=x()-1,o.settings.pager&&I(o.active.index),o.settings.controls&&W(),"fade"==o.settings.mode)o.settings.adaptiveHeight&&o.viewport.height()!=p()&&o.viewport.animate({height:p()},o.settings.adaptiveHeightSpeed),o.children.filter(":visible").fadeOut(o.settings.speed).css({zIndex:0}),o.children.eq(o.active.index).css("zIndex",51).fadeIn(o.settings.speed,function(){t(this).css("zIndex",50),D()});else{o.settings.adaptiveHeight&&o.viewport.height()!=p()&&o.viewport.animate({height:p()},o.settings.adaptiveHeightSpeed);var s=0,n={left:0,top:0};if(!o.settings.infiniteLoop&&o.carousel&&o.active.last)if("horizontal"==o.settings.mode){var a=o.children.eq(o.children.length-1);n=a.position(),s=o.viewport.width()-a.outerWidth()}else{var l=o.children.length-o.settings.minSlides;n=o.children.eq(l).position()}else if(o.carousel&&o.active.last&&"prev"==i){var d=1==o.settings.moveSlides?o.settings.maxSlides-m():(x()-1)*m()-(o.children.length-o.settings.maxSlides),a=r.children(".bx-clone").eq(d);n=a.position()}else if("next"==i&&0==o.active.index)n=r.find("> .bx-clone").eq(o.settings.maxSlides).position(),o.active.last=!1;else if(e>=0){var c=e*m();n=o.children.eq(c).position()}if("undefined"!=typeof n){var g="horizontal"==o.settings.mode?-(n.left-s):-n.top;b(g,"slide",o.settings.speed)}}},r.goToNextSlide=function(){if(o.settings.infiniteLoop||!o.active.last){var t=parseInt(o.active.index)+1;r.goToSlide(t,"next")}},r.goToPrevSlide=function(){if(o.settings.infiniteLoop||0!=o.active.index){var t=parseInt(o.active.index)-1;r.goToSlide(t,"prev")}},r.startAuto=function(t){o.interval||(o.interval=setInterval(function(){"next"==o.settings.autoDirection?r.goToNextSlide():r.goToPrevSlide()},o.settings.pause),o.settings.autoControls&&1!=t&&A("stop"))},r.stopAuto=function(t){o.interval&&(clearInterval(o.interval),o.interval=null,o.settings.autoControls&&1!=t&&A("start"))},r.getCurrentSlide=function(){return o.active.index},r.getSlideCount=function(){return o.children.length},r.redrawSlider=function(){o.children.add(r.find(".bx-clone")).outerWidth(u()),o.viewport.css("height",p()),o.settings.ticker||S(),o.active.last&&(o.active.index=x()-1),o.active.index>=x()&&(o.active.last=!0),o.settings.pager&&!o.settings.pagerCustom&&(w(),I(o.active.index))},r.destroySlider=function(){o.initialized&&(o.initialized=!1,t(".bx-clone",this).remove(),o.children.each(function(){void 0!=t(this).data("origStyle")?t(this).attr("style",t(this).data("origStyle")):t(this).removeAttr("style")}),void 0!=t(this).data("origStyle")?this.attr("style",t(this).data("origStyle")):t(this).removeAttr("style"),t(this).unwrap().unwrap(),o.controls.el&&o.controls.el.remove(),o.controls.next&&o.controls.next.remove(),o.controls.prev&&o.controls.prev.remove(),o.pagerEl&&o.pagerEl.remove(),t(".bx-caption",this).remove(),o.controls.autoEl&&o.controls.autoEl.remove(),clearInterval(o.interval),o.settings.responsive&&t(window).unbind("resize",B))},r.reloadSlider=function(t){void 0!=t&&(n=t),r.destroySlider(),d()},d(),this}}(jQuery);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 2)))

/***/ },
/* 109 */
/*!****************************************!*\
  !*** onepage-scroll (bower component) ***!
  \****************************************/
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(/*! ./jquery.onepage-scroll.js */ 110);
	__webpack_require__(/*! ./onepage-scroll.css */ 111);

/***/ },
/* 110 */
/*!******************************************************************!*\
  !*** ./bower_components/onepage-scroll/jquery.onepage-scroll.js ***!
  \******************************************************************/
/***/ function(module, exports) {

	/* ===========================================================
	 * jquery-onepage-scroll.js v1.3.2
	 * ===========================================================
	 * Copyright 2013 Pete Rojwongsuriya.
	 * http://www.thepetedesign.com
	 *
	 * Create an Apple-like website that let user scroll
	 * one page at a time
	 *
	 * Credit: Eike Send for the awesome swipe event
	 * https://github.com/peachananr/onepage-scroll
	 *
	 * License: GPL v3
	 *
	 * ========================================================== */
	
	!function($){
	
	  var defaults = {
	    sectionContainer: "section",
	    easing: "ease",
	    animationTime: 1000,
	    pagination: true,
	    updateURL: false,
	    keyboard: true,
	    beforeMove: null,
	    afterMove: null,
	    loop: true,
	    responsiveFallback: false,
	    direction : 'vertical'
	  };
	
	  /*------------------------------------------------*/
	  /*  Credit: Eike Send for the awesome swipe event */
	  /*------------------------------------------------*/
	
	  $.fn.swipeEvents = function() {
	    return this.each(function() {
	
	      var startX,
	          startY,
	          $this = $(this);
	
	      $this.bind('touchstart', touchstart);
	
	      function touchstart(event) {
	        var touches = event.originalEvent.touches;
	        if (touches && touches.length) {
	          startX = touches[0].pageX;
	          startY = touches[0].pageY;
	          $this.off('touchmove').on('touchmove', touchmove);
	        }
	      }
	
	      function touchmove(event) {
	        if($("body").hasClass("disabled-onepage-scroll")) {
	          // if plugin is disabled, pass the event
	          return;
	        }
	        event.preventDefault();
	        var touches = event.originalEvent.touches;
	        if (touches && touches.length) {
	          var deltaX = startX - touches[0].pageX;
	          var deltaY = startY - touches[0].pageY;
	
	          if (deltaX >= 50) {
	            $this.trigger("swipeLeft");
	          }
	          if (deltaX <= -50) {
	            $this.trigger("swipeRight");
	          }
	          if (deltaY >= 50) {
	            $this.trigger("swipeUp");
	          }
	          if (deltaY <= -50) {
	            $this.trigger("swipeDown");
	          }
	          if (Math.abs(deltaX) >= 50 || Math.abs(deltaY) >= 50) {
	            $this.off('touchmove', touchmove);
	          }
	        }
	      }
	
	    });
	  };
	
	
	  $.fn.onepage_scroll = function(options){
	    var settings = $.extend({}, defaults, options),
	        el = $(this),
	        sections = $(settings.sectionContainer)
	    total = sections.length,
	        status = "off",
	        topPos = 0,
	        leftPos = 0,
	        lastAnimation = 0,
	        quietPeriod = 500,
	        paginationList = "";
	
	    $.fn.transformPage = function(settings, pos, index) {
	      if (typeof settings.beforeMove == 'function') settings.beforeMove(index);
	
	      // Just a simple edit that makes use of modernizr to detect an IE8 browser and changes the transform method into
	      // an top animate so IE8 users can also use this script.
	      if($('html').hasClass('ie8')){
	        if (settings.direction == 'horizontal') {
	          var toppos = (el.width()/100)*pos;
	          $(this).animate({left: toppos+'px'},settings.animationTime);
	        } else {
	          var toppos = (el.height()/100)*pos;
	          $(this).animate({top: toppos+'px'},settings.animationTime);
	        }
	      } else{
	        $(this).css({
	          "-webkit-transform": ( settings.direction == 'horizontal' ) ? "translate3d(" + pos + "%, 0, 0)" : "translate3d(0, " + pos + "%, 0)",
	          "-webkit-transition": "all " + settings.animationTime + "ms " + settings.easing,
	          "-moz-transform": ( settings.direction == 'horizontal' ) ? "translate3d(" + pos + "%, 0, 0)" : "translate3d(0, " + pos + "%, 0)",
	          "-moz-transition": "all " + settings.animationTime + "ms " + settings.easing,
	          "-ms-transform": ( settings.direction == 'horizontal' ) ? "translate3d(" + pos + "%, 0, 0)" : "translate3d(0, " + pos + "%, 0)",
	          "-ms-transition": "all " + settings.animationTime + "ms " + settings.easing,
	          "transform": ( settings.direction == 'horizontal' ) ? "translate3d(" + pos + "%, 0, 0)" : "translate3d(0, " + pos + "%, 0)",
	          "transition": "all " + settings.animationTime + "ms " + settings.easing
	        });
	      }
	      $(this).one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(e) {
	        if (typeof settings.afterMove == 'function') settings.afterMove(index);
	      });
	    }
	
	    $.fn.moveDown = function() {
	      var el = $(this)
	      index = $(settings.sectionContainer +".active").data("index");
	      current = $(settings.sectionContainer + "[data-index='" + index + "']");
	      next = $(settings.sectionContainer + "[data-index='" + (index + 1) + "']");
	      if(next.length < 1) {
	        if (settings.loop == true) {
	          pos = 0;
	          next = $(settings.sectionContainer + "[data-index='1']");
	        } else {
	          return
	        }
	
	      }else {
	        pos = (index * 100) * -1;
	      }
	      if (typeof settings.beforeMove == 'function') settings.beforeMove( next.data("index"));
	      current.removeClass("active")
	      next.addClass("active");
	      if(settings.pagination == true) {
	        $(".onepage-pagination li a" + "[data-index='" + index + "']").removeClass("active");
	        $(".onepage-pagination li a" + "[data-index='" + next.data("index") + "']").addClass("active");
	      }
	
	      $("body")[0].className = $("body")[0].className.replace(/\bviewing-page-\d.*?\b/g, '');
	      $("body").addClass("viewing-page-"+next.data("index"))
	
	      if (history.replaceState && settings.updateURL == true) {
	        var href = window.location.href.substr(0,window.location.href.indexOf('#')) + "#" + (index + 1);
	        history.pushState( {}, document.title, href );
	      }
	      el.transformPage(settings, pos, next.data("index"));
	    }
	
	    $.fn.moveUp = function() {
	      var el = $(this)
	      index = $(settings.sectionContainer +".active").data("index");
	      current = $(settings.sectionContainer + "[data-index='" + index + "']");
	      next = $(settings.sectionContainer + "[data-index='" + (index - 1) + "']");
	
	      if(next.length < 1) {
	        if (settings.loop == true) {
	          pos = ((total - 1) * 100) * -1;
	          next = $(settings.sectionContainer + "[data-index='"+total+"']");
	        }
	        else {
	          return
	        }
	      }else {
	        pos = ((next.data("index") - 1) * 100) * -1;
	      }
	      if (typeof settings.beforeMove == 'function') settings.beforeMove(next.data("index"));
	      current.removeClass("active")
	      next.addClass("active")
	      if(settings.pagination == true) {
	        $(".onepage-pagination li a" + "[data-index='" + index + "']").removeClass("active");
	        $(".onepage-pagination li a" + "[data-index='" + next.data("index") + "']").addClass("active");
	      }
	      $("body")[0].className = $("body")[0].className.replace(/\bviewing-page-\d.*?\b/g, '');
	      $("body").addClass("viewing-page-"+next.data("index"))
	
	      if (history.replaceState && settings.updateURL == true) {
	        var href = window.location.href.substr(0,window.location.href.indexOf('#')) + "#" + (index - 1);
	        history.pushState( {}, document.title, href );
	      }
	      el.transformPage(settings, pos, next.data("index"));
	    }
	
	    $.fn.moveTo = function(page_index) {
	      current = $(settings.sectionContainer + ".active")
	      next = $(settings.sectionContainer + "[data-index='" + (page_index) + "']");
	      if(next.length > 0) {
	        if (typeof settings.beforeMove == 'function') settings.beforeMove(next.data("index"));
	        current.removeClass("active")
	        next.addClass("active")
	        $(".onepage-pagination li a" + ".active").removeClass("active");
	        $(".onepage-pagination li a" + "[data-index='" + (page_index) + "']").addClass("active");
	        $("body")[0].className = $("body")[0].className.replace(/\bviewing-page-\d.*?\b/g, '');
	        $("body").addClass("viewing-page-"+next.data("index"))
	
	        pos = ((page_index - 1) * 100) * -1;
	
	        if (history.replaceState && settings.updateURL == true) {
	          var href = window.location.href.substr(0,window.location.href.indexOf('#')) + "#" + (page_index - 1);
	          history.pushState( {}, document.title, href );
	        }
	        el.transformPage(settings, pos, page_index);
	      }
	    }
	
	    function responsive() {
	      //start modification
	      var valForTest = false;
	      var typeOfRF = typeof settings.responsiveFallback
	
	      if(typeOfRF == "number"){
	        valForTest = $(window).width() < settings.responsiveFallback;
	      }
	      if(typeOfRF == "boolean"){
	        valForTest = settings.responsiveFallback;
	      }
	      if(typeOfRF == "function"){
	        valFunction = settings.responsiveFallback();
	        valForTest = valFunction;
	        typeOFv = typeof valForTest;
	        if(typeOFv == "number"){
	          valForTest = $(window).width() < valFunction;
	        }
	      }
	
	      //end modification
	      if (valForTest) {
	        $("body").addClass("disabled-onepage-scroll");
	        $(document).unbind('mousewheel DOMMouseScroll MozMousePixelScroll');
	        el.swipeEvents().off('swipeDown swipeUp');
	      } else {
	        if($("body").hasClass("disabled-onepage-scroll")) {
	          $("body").removeClass("disabled-onepage-scroll");
	          $("html, body, .wrapper").animate({ scrollTop: 0 }, "fast");
	        }
	
	        el.swipeEvents().off('swipeDown').on('swipeDown', function(event){
	          if (!$("body").hasClass("disabled-onepage-scroll")) event.preventDefault();
	          el.moveUp();
	        }).off('swipeUp').on('swipeUp', function(event){
	          if (!$("body").hasClass("disabled-onepage-scroll")) event.preventDefault();
	          el.moveDown();
	        });
	
	        $(document).bind('mousewheel DOMMouseScroll MozMousePixelScroll', function(event) {
	          event.preventDefault();
	          var delta = event.originalEvent.wheelDelta || -event.originalEvent.detail;
	          init_scroll(event, delta);
	        });
	      }
	    }
	
	
	    function init_scroll(event, delta) {
	      deltaOfInterest = delta;
	      var timeNow = new Date().getTime();
	      // Cancel scroll if currently animating or within quiet period
	      if(timeNow - lastAnimation < quietPeriod + settings.animationTime) {
	        event.preventDefault();
	        return;
	      }
	
	      if (deltaOfInterest < 0) {
	        el.moveDown()
	      } else {
	        el.moveUp()
	      }
	      lastAnimation = timeNow;
	    }
	
	    // Prepare everything before binding wheel scroll
	
	    el.addClass("onepage-wrapper").css("position","relative");
	    $.each( sections, function(i) {
	      $(this).css({
	        position: "absolute",
	        top: topPos + "%"
	      }).addClass("section").attr("data-index", i+1);
	
	
	      $(this).css({
	        position: "absolute",
	        left: ( settings.direction == 'horizontal' )
	            ? leftPos + "%"
	            : 0,
	        top: ( settings.direction == 'vertical' || settings.direction != 'horizontal' )
	            ? topPos + "%"
	            : 0
	      });
	
	      if (settings.direction == 'horizontal')
	        leftPos = leftPos + 100;
	      else
	        topPos = topPos + 100;
	
	
	      if(settings.pagination == true) {
	        paginationList += "<li><a data-index='"+(i+1)+"' href='#" + (i+1) + "'></a></li>"
	      }
	    });
	
	    el.swipeEvents().bind("swipeDown",  function(event){
	      if (!$("body").hasClass("disabled-onepage-scroll")) event.preventDefault();
	      el.moveUp();
	    }).bind("swipeUp", function(event){
	      if (!$("body").hasClass("disabled-onepage-scroll")) event.preventDefault();
	      el.moveDown();
	    });
	
	    // Create Pagination and Display Them
	    if (settings.pagination == true) {
	      if ($('ul.onepage-pagination').length < 1) $("<ul class='onepage-pagination'></ul>").prependTo("body");
	
	      if( settings.direction == 'horizontal' ) {
	        posLeft = (el.find(".onepage-pagination").width() / 2) * -1;
	        el.find(".onepage-pagination").css("margin-left", posLeft);
	      } else {
	        posTop = (el.find(".onepage-pagination").height() / 2) * -1;
	        el.find(".onepage-pagination").css("margin-top", posTop);
	      }
	      $('ul.onepage-pagination').html(paginationList);
	    }
	
	    if(window.location.hash != "" && window.location.hash != "#1") {
	      init_index =  window.location.hash.replace("#", "")
	
	      if (parseInt(init_index) <= total && parseInt(init_index) > 0) {
	        $(settings.sectionContainer + "[data-index='" + init_index + "']").addClass("active")
	        $("body").addClass("viewing-page-"+ init_index)
	        if(settings.pagination == true) $(".onepage-pagination li a" + "[data-index='" + init_index + "']").addClass("active");
	
	        next = $(settings.sectionContainer + "[data-index='" + (init_index) + "']");
	        if(next) {
	          next.addClass("active")
	          if(settings.pagination == true) $(".onepage-pagination li a" + "[data-index='" + (init_index) + "']").addClass("active");
	          $("body")[0].className = $("body")[0].className.replace(/\bviewing-page-\d.*?\b/g, '');
	          $("body").addClass("viewing-page-"+next.data("index"))
	          if (history.replaceState && settings.updateURL == true) {
	            var href = window.location.href.substr(0,window.location.href.indexOf('#')) + "#" + (init_index);
	            history.pushState( {}, document.title, href );
	          }
	        }
	        pos = ((init_index - 1) * 100) * -1;
	        el.transformPage(settings, pos, init_index);
	      } else {
	        $(settings.sectionContainer + "[data-index='1']").addClass("active")
	        $("body").addClass("viewing-page-1")
	        if(settings.pagination == true) $(".onepage-pagination li a" + "[data-index='1']").addClass("active");
	      }
	    }else{
	      $(settings.sectionContainer + "[data-index='1']").addClass("active")
	      $("body").addClass("viewing-page-1")
	      if(settings.pagination == true) $(".onepage-pagination li a" + "[data-index='1']").addClass("active");
	    }
	
	    if(settings.pagination == true)  {
	      $(".onepage-pagination li a").click(function (){
	        var page_index = $(this).data("index");
	        el.moveTo(page_index);
	      });
	    }
	
	
	    $(document).bind('mousewheel DOMMouseScroll MozMousePixelScroll', function(event) {
	      event.preventDefault();
	      var delta = event.originalEvent.wheelDelta || -event.originalEvent.detail;
	      if(!$("body").hasClass("disabled-onepage-scroll")) init_scroll(event, delta);
	    });
	
	
	    if(settings.responsiveFallback != false) {
	      $(window).resize(function() {
	        responsive();
	      });
	
	      responsive();
	    }
	
	    if(settings.keyboard == true) {
	      $(document).keydown(function(e) {
	        var tag = e.target.tagName.toLowerCase();
	
	        if (!$("body").hasClass("disabled-onepage-scroll")) {
	          switch(e.which) {
	            case 38:
	              if (tag != 'input' && tag != 'textarea') el.moveUp()
	              break;
	            case 40:
	              if (tag != 'input' && tag != 'textarea') el.moveDown()
	              break;
	            case 32: //spacebar
	              if (tag != 'input' && tag != 'textarea') el.moveDown()
	              break;
	            case 33: //pageg up
	              if (tag != 'input' && tag != 'textarea') el.moveUp()
	              break;
	            case 34: //page dwn
	              if (tag != 'input' && tag != 'textarea') el.moveDown()
	              break;
	            case 36: //home
	              el.moveTo(1);
	              break;
	            case 35: //end
	              el.moveTo(total);
	              break;
	            default: return;
	          }
	        }
	
	      });
	    }
	    return false;
	  }
	
	
	}(window.jQuery);

/***/ },
/* 111 */
/*!************************************************************!*\
  !*** ./bower_components/onepage-scroll/onepage-scroll.css ***!
  \************************************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../~/css-loader!./onepage-scroll.css */ 112);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../~/style-loader/addStyles.js */ 43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./onepage-scroll.css", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./onepage-scroll.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 112 */
/*!***************************************************************************!*\
  !*** ./~/css-loader!./bower_components/onepage-scroll/onepage-scroll.css ***!
  \***************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(/*! ./../../~/css-loader/lib/css-base.js */ 40)();
	// imports
	
	
	// module
	exports.push([module.id, ".enable-page-scroller,.enable-page-scroller body{-webkit-transition:opacity .4s;transition:opacity .4s}.enable-page-scroller,.enable-page-scroller body,.onepage-wrapper{display:block;position:static;padding:0;width:100%;height:100%}.enable-page-scroller body{overflow:hidden}.onepage-wrapper{display:block;position:relative;padding:0;-webkit-transform-style:preserve-3d}.onepage-wrapper,.onepage-wrapper .section{width:100%;height:100%}.onepage-pagination{position:absolute;right:10px;top:50%;z-index:5;list-style:none;margin:0;padding:0}.onepage-pagination li{padding:0;text-align:center}.onepage-pagination li a{padding:10px;width:4px;height:4px;display:block}.onepage-pagination li a:before{content:'';position:absolute;width:4px;height:4px;background:rgba(0,0,0,.85);border-radius:10px;-webkit-border-radius:10px;-moz-border-radius:10px}.onepage-pagination li a.active:before{width:10px;height:10px;background:none;border:1px solid #000;margin-top:-4px;left:8px}.disabled-onepage-scroll,.disabled-onepage-scroll .wrapper{overflow:auto}.disabled-onepage-scroll .onepage-wrapper .section{position:relative!important;top:auto!important;left:auto!important}.disabled-onepage-scroll .onepage-wrapper{-webkit-transform:none!important;transform:none!important;-ms-transform:none!important;min-height:100%}.disabled-onepage-scroll .onepage-pagination{display:none}.disabled-onepage-scroll .onepage-wrapper,body.disabled-onepage-scroll,html{position:inherit}.disabled-onepage-scroll{overflow:auto}", ""]);
	
	// exports


/***/ },
/* 113 */
/*!**********************************************************************!*\
  !*** ./pixo/assets/jquery.easy-pie-chart/jquery.easypiechart.min.js ***!
  \**********************************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/**!
	 * easyPieChart
	 * Lightweight plugin to render simple, animated and retina optimized pie charts
	 *
	 * @license 
	 * @author Robert Fleischmann <rendro87@gmail.com> (http://robert-fleischmann.de)
	 * @version 2.1.6
	 **/
	!function(a,b){ true?module.exports=b(__webpack_require__(/*! jquery */ 2)):"function"==typeof define&&define.amd?define(["jquery"],b):b(a.jQuery)}(this,function(a){var b=function(a,b){var c,d=document.createElement("canvas");a.appendChild(d),"undefined"!=typeof G_vmlCanvasManager&&G_vmlCanvasManager.initElement(d);var e=d.getContext("2d");d.width=d.height=b.size;var f=1;window.devicePixelRatio>1&&(f=window.devicePixelRatio,d.style.width=d.style.height=[b.size,"px"].join(""),d.width=d.height=b.size*f,e.scale(f,f)),e.translate(b.size/2,b.size/2),e.rotate((-0.5+b.rotate/180)*Math.PI);var g=(b.size-b.lineWidth)/2;b.scaleColor&&b.scaleLength&&(g-=b.scaleLength+2),Date.now=Date.now||function(){return+new Date};var h=function(a,b,c){c=Math.min(Math.max(-1,c||0),1);var d=0>=c?!0:!1;e.beginPath(),e.arc(0,0,g,0,2*Math.PI*c,d),e.strokeStyle=a,e.lineWidth=b,e.stroke()},i=function(){var a,c;e.lineWidth=1,e.fillStyle=b.scaleColor,e.save();for(var d=24;d>0;--d)d%6===0?(c=b.scaleLength,a=0):(c=.6*b.scaleLength,a=b.scaleLength-c),e.fillRect(-b.size/2+a,0,c,1),e.rotate(Math.PI/12);e.restore()},j=function(){return window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||function(a){window.setTimeout(a,1e3/60)}}(),k=function(){b.scaleColor&&i(),b.trackColor&&h(b.trackColor,b.trackWidth||b.lineWidth,1)};this.getCanvas=function(){return d},this.getCtx=function(){return e},this.clear=function(){e.clearRect(b.size/-2,b.size/-2,b.size,b.size)},this.draw=function(a){b.scaleColor||b.trackColor?e.getImageData&&e.putImageData?c?e.putImageData(c,0,0):(k(),c=e.getImageData(0,0,b.size*f,b.size*f)):(this.clear(),k()):this.clear(),e.lineCap=b.lineCap;var d;d="function"==typeof b.barColor?b.barColor(a):b.barColor,h(d,b.lineWidth,a/100)}.bind(this),this.animate=function(a,c){var d=Date.now();b.onStart(a,c);var e=function(){var f=Math.min(Date.now()-d,b.animate.duration),g=b.easing(this,f,a,c-a,b.animate.duration);this.draw(g),b.onStep(a,c,g),f>=b.animate.duration?b.onStop(a,c):j(e)}.bind(this);j(e)}.bind(this)},c=function(a,c){var d={barColor:"#ef1e25",trackColor:"#f9f9f9",scaleColor:"#dfe0e0",scaleLength:5,lineCap:"round",lineWidth:3,trackWidth:void 0,size:110,rotate:0,animate:{duration:1e3,enabled:!0},easing:function(a,b,c,d,e){return b/=e/2,1>b?d/2*b*b+c:-d/2*(--b*(b-2)-1)+c},onStart:function(){},onStep:function(){},onStop:function(){}};if("undefined"!=typeof b)d.renderer=b;else{if("undefined"==typeof SVGRenderer)throw new Error("Please load either the SVG- or the CanvasRenderer");d.renderer=SVGRenderer}var e={},f=0,g=function(){this.el=a,this.options=e;for(var b in d)d.hasOwnProperty(b)&&(e[b]=c&&"undefined"!=typeof c[b]?c[b]:d[b],"function"==typeof e[b]&&(e[b]=e[b].bind(this)));e.easing="string"==typeof e.easing&&"undefined"!=typeof jQuery&&jQuery.isFunction(jQuery.easing[e.easing])?jQuery.easing[e.easing]:d.easing,"number"==typeof e.animate&&(e.animate={duration:e.animate,enabled:!0}),"boolean"!=typeof e.animate||e.animate||(e.animate={duration:1e3,enabled:e.animate}),this.renderer=new e.renderer(a,e),this.renderer.draw(f),a.dataset&&a.dataset.percent?this.update(parseFloat(a.dataset.percent)):a.getAttribute&&a.getAttribute("data-percent")&&this.update(parseFloat(a.getAttribute("data-percent")))}.bind(this);this.update=function(a){return a=parseFloat(a),e.animate.enabled?this.renderer.animate(f,a):this.renderer.draw(a),f=a,this}.bind(this),this.disableAnimation=function(){return e.animate.enabled=!1,this},this.enableAnimation=function(){return e.animate.enabled=!0,this},g()};a.fn.easyPieChart=function(b){return this.each(function(){var d;a.data(this,"easyPieChart")||(d=a.extend({},b,a(this).data()),a.data(this,"easyPieChart",new c(this,d)))})}});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 2)))

/***/ },
/* 114 */
/*!*****************************************!*\
  !*** ./pixo/assets/gmap/jquery.gmap.js ***!
  \*****************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/**
	 * jQuery gMap v3
	 *
	 * @url         http://www.smashinglabs.pl/gmap
	 * @author      Sebastian Poreba <sebastian.poreba@gmail.com>
	 * @version     3.3.3
	 * @date        27.12.2012
	 */
	/*jslint white: false, undef: true, regexp: true, plusplus: true, bitwise: true, newcap: true, strict: true, devel: true, maxerr: 50, indent: 4 */
	/*global window, jQuery, $, google, $googlemaps */
	(function($) {
	  'use strict';
	
	  /**
	     * Internals and experimental section
	     */
	  var Cluster = function() {
	    this.markers = [];
	    this.mainMarker = false;
	    this.icon = 'http://www.google.com/mapfiles/marker.png';
	  };
	
	  /**
	     * For iterating over all clusters to find if any is close enough to be merged with marker
	     *
	     * @param marker
	     * @param currentSize - calculated as viewport percentage (opts.clusterSize).
	     * @return bool.
	     */
	  Cluster.prototype.dist = function(marker) {
	    return Math.sqrt(Math.pow(this.markers[0].latitude - marker.latitude, 2) +
	            Math.pow(this.markers[0].longitude - marker.longitude, 2));
	  };
	
	  Cluster.prototype.setIcon = function(icon) {
	    this.icon = icon;
	  };
	
	  Cluster.prototype.addMarker = function(marker) {
	    this.markers[this.markers.length] = marker;
	  };
	
	  /**
	     * returns one marker if there is only one or
	     * returns special cloister marker if there are more
	     */
	  Cluster.prototype.getMarker = function() {
	    if (this.mainmarker) {return this.mainmarker; }
	    var gicon, title;
	    if (this.markers.length > 1) {
	      gicon = new $googlemaps.MarkerImage('http://chart.googleapis.com/chart?chst=d_map_pin_letter&chld=' + this.markers.length + '%7cff776b%7c000000');
	      title = 'cluster of ' + this.markers.length + ' markers';
	    } else {
	      gicon = new $googlemaps.MarkerImage(this.icon);
	      title = this.markers[0].title;
	    }
	    this.mainmarker = new $googlemaps.Marker({
	      position: new $googlemaps.LatLng(this.markers[0].latitude, this.markers[0].longitude),
	      icon: gicon,
	      title: title,
	      map: null
	    });
	    return this.mainmarker;
	  };
	
	  // global google maps objects
	  var $googlemaps = google.maps,
	      $geocoder = new $googlemaps.Geocoder(),
	      $markersToLoad = 0,
	      overQueryLimit = 0,
	      methods = {};
	  methods = {
	    /**
	         * initialisation/internals
	         */
	
	    init: function(options) {
	      var k,
	          // Build main options before element iteration
	          opts = $.extend({}, $.fn.gMap.defaults, options);
	
	                // recover icon array
	                for (k in $.fn.gMap.defaults.icon) {
	        if (!opts.icon[k]) {
	          opts.icon[k] = $.fn.gMap.defaults.icon[k];
	        }
	                }
	
	      // Iterate through each element
	      return this.each(function() {
	        var $this = $(this),
	                    center = methods._getMapCenter.apply($this, [opts]),
	                    i, $data;
	
	        if (opts.zoom == 'fit') {
						          opts.zoomFit = true;
	                    opts.zoom = methods._autoZoom.apply($this, [opts]);
	        }
	
	        var mapOptions = {
	          zoom: opts.zoom,
	          center: center,
	          mapTypeControl: opts.mapTypeControl,
	          mapTypeControlOptions: {},
	          zoomControl: opts.zoomControl,
	          zoomControlOptions: {},
	          panControl: opts.panControl,
	          panControlOptions: {},
	          scaleControl: opts.scaleControl,
	          scaleControlOptions: {},
	          streetViewControl: opts.streetViewControl,
	          streetViewControlOptions: {},
	          mapTypeId: opts.maptype,
	          scrollwheel: opts.scrollwheel,
	          maxZoom: opts.maxZoom,
	          minZoom: opts.minZoom
	        };
	        if (opts.controlsPositions.mapType) {mapOptions.mapTypeControlOptions.position = opts.controlsPositions.mapType}
	        if (opts.controlsPositions.zoom) {mapOptions.zoomControlOptions.position = opts.controlsPositions.zoom}
	        if (opts.controlsPositions.pan) {mapOptions.panControlOptions.position = opts.controlsPositions.pan}
	        if (opts.controlsPositions.scale) {mapOptions.scaleControlOptions.position = opts.controlsPositions.scale}
	        if (opts.controlsPositions.streetView) {mapOptions.streetViewControlOptions.position = opts.controlsPositions.streetView}
	
	        if (opts.styles) {mapOptions.styles = opts.styles}
	
	        mapOptions.mapTypeControlOptions.style = opts.controlsStyle.mapType;
	        mapOptions.zoomControlOptions.style = opts.controlsStyle.zoom;
	
	        mapOptions = $.extend(mapOptions, opts.extra);
	
	        // Create map and set initial options
	        var $gmap = new $googlemaps.Map(this, mapOptions);
	
	        if (opts.log) {console.log('map center is:'); }
	        if (opts.log) {console.log(center); }
	
	        // Create map and set initial options
	
	        $this.data('$gmap', $gmap);
	
	        $this.data('gmap', {
	                    'opts': opts,
	                    'gmap': $gmap,
	                    'markers': [],
	                    'markerKeys' : {},
	                    'infoWindow': null,
	                    'clusters': []
	        });
	
	        // Check for map controls
	        if (opts.controls.length !== 0) {
	                    // Add custom map controls
	                    for (i = 0; i < opts.controls.length; i += 1) {
	            $gmap.controls[opts.controls[i].pos].push(opts.controls[i].div);
	                    }
	        }
	
	        if (opts.clustering.enabled) {
	                    $data = $this.data('gmap');
	                    (function(markers) {$data.markers = markers;}(opts.markers));
	                    methods._renderCluster.apply($this, []);
	
	                    $googlemaps.event.addListener($gmap, 'bounds_changed', function() {
	            methods._renderCluster.apply($this, []);
	                    });
	        } else {
	                    if (opts.markers.length !== 0) {
	            methods.addMarkers.apply($this, [opts.markers]);
	                    }
	        }
	
	        methods._onComplete.apply($this, []);
	      });
	    },
	
	
	    _delayedMode: false,
	
	    /**
	         * Check every 100ms if all markers were loaded, then call onComplete
	         */
	    _onComplete: function() {
	      var $data = this.data('gmap'),
	                that = this;
	      if ($markersToLoad !== 0) {
	        window.setTimeout(function() {methods._onComplete.apply(that, []); }, 100);
	        return;
	      }
	      if (methods._delayedMode) {
	        var center = methods._getMapCenter.apply(this, [$data.opts, true]);
	        methods._setMapCenter.apply(this, [center]);
					if ($data.opts.zoomFit) {
						var zoom = methods._autoZoom.apply(this, [$data.opts, true]);
						$data.gmap.setZoom(zoom);
					}
	      }
	      $data.opts.onComplete();
	    },
	
	    /**
	         * set map center when map is loaded (check every 100ms)
	         */
	    _setMapCenter: function(center) {
	      var $data = this.data('gmap');
	      if ($data && $data.opts.log) {console.log('delayed setMapCenter called'); }
	      if ($data && $data.gmap !== undefined && $markersToLoad == 0) {
	        $data.gmap.setCenter(center);
	      } else {
	        var that = this;
	        window.setTimeout(function() {methods._setMapCenter.apply(that, [center]); }, 100);
	      }
	    },
	
	    /**
	         * calculate boundaries, optimised and independent from Google Maps
	         */
	    _boundaries: null,
	    _getBoundaries: function(opts) {
	      // if(methods._boundaries) {return methods._boundaries; }
	      var markers = opts.markers, i;
	      var mostN = 1000,
	                mostE = -1000,
	                mostW = 1000,
	                mostS = -1000;
	      if (markers) {
	        for (i = 0; i < markers.length; i += 1) {
	                    if (!markers[i].latitude || !markers[i].longitude) continue;
	
	                    if (mostN > markers[i].latitude) {mostN = markers[i].latitude; }
	                    if (mostE < markers[i].longitude) {mostE = markers[i].longitude; }
	                    if (mostW > markers[i].longitude) {mostW = markers[i].longitude; }
	                    if (mostS < markers[i].latitude) {mostS = markers[i].latitude; }
	                    if (opts.log) {
	                      console.log(markers[i].latitude, markers[i].longitude, mostN, mostE, mostW, mostS);
	                    }
	        }
	        methods._boundaries = {N: mostN, E: mostE, W: mostW, S: mostS};
	      }
	
	      if (mostN == -1000) methods._boundaries = {N: 0, E: 0, W: 0, S: 0};
	
	      return methods._boundaries;
	    },
	
	    /**
	         * Priorities order:
	         * - latitude & longitude in options
	         * - address in options
	         * - latitude & longitude of first marker having it
	         * - address of first marker having it
	         * - failsafe (0,0)
	         *
	         * Note: with geocoding returned value is (0,0) and callback sets map center. It's not very nice nor efficient.
	         *       It is quite good idea to use only first option
	         */
	    _getMapCenter: function(opts, fromMarkers) {
	      // Create new object to geocode addresses
	
	      var center,
	                that = this, // 'that' scope fix in geocoding
	                i,
	                selectedToCenter,
	                most; //hoisting
	
	      if (opts.markers.length && (opts.latitude == 'fit' || opts.longitude == 'fit')) {
	        if (fromMarkers) {
	          opts.markers = methods._convertMarkers(data.markers);
	        }
	
	        most = methods._getBoundaries(opts);
	        center = new $googlemaps.LatLng((most.N + most.S) / 2, (most.E + most.W) / 2);
	        if (opts.log) {
	          console.log(fromMarkers, most, center);
	        }
	        return center;
	      }
	
	      if (opts.latitude && opts.longitude) {
	        // lat & lng available, return
	        center = new $googlemaps.LatLng(opts.latitude, opts.longitude);
	        return center;
	      } else {
	        center = new $googlemaps.LatLng(0, 0);
	      }
	
	      // Check for address to center on
	      if (opts.address) {
	        // Get coordinates for given address and center the map
	        $geocoder.geocode(
	            {address: opts.address},
	            function(result, status) {
	                        if (status === google.maps.GeocoderStatus.OK) {
	                methods._setMapCenter.apply(that, [result[0].geometry.location]);
	                        } else {
	                if (opts.log) {console.log('Geocode was not successful for the following reason: ' + status); }
	                        }
	            }
	        );
	        return center;
	      }
	
	      // Check for a marker to center on (if no coordinates given)
	      if (opts.markers.length > 0) {
	        selectedToCenter = null;
	
	        for (i = 0; i < opts.markers.length; i += 1) {
	                    if (opts.markers[i].setCenter) {
	            selectedToCenter = opts.markers[i];
	            break;
	                    }
	        }
	
	        if (selectedToCenter === null) {
	                    for (i = 0; i < opts.markers.length; i += 1) {
	            if (opts.markers[i].latitude && opts.markers[i].longitude) {
	              selectedToCenter = opts.markers[i];
	              break;
	            }
	            if (opts.markers[i].address) {
	              selectedToCenter = opts.markers[i];
	            }
	                    }
	        }
	        // failed to find any reasonable marker (it's quite impossible BTW)
	        if (selectedToCenter === null) {
	                    return center;
	        }
	
	        if (selectedToCenter.latitude && selectedToCenter.longitude) {
	                    return new $googlemaps.LatLng(selectedToCenter.latitude, selectedToCenter.longitude);
	        }
	
	        // Check if the marker has an address
	        if (selectedToCenter.address) {
	                    // Get the coordinates for given marker address and center
	                    $geocoder.geocode(
	                        {address: selectedToCenter.address},
	                        function(result, status) {
	                if (status === google.maps.GeocoderStatus.OK) {
	                  methods._setMapCenter.apply(that, [result[0].geometry.location]);
	                } else {
	                  if (opts.log) {console.log('Geocode was not successful for the following reason: ' + status); }
	                }
	                        }
	                    );
	        }
	      }
	      return center;
	    },
	
	
	    /**
	         * clustering
	         */
	    _renderCluster: function() {
	      var $data = this.data('gmap'),
	                markers = $data.markers,
	                clusters = $data.clusters,
	                opts = $data.opts,
	                i,
	                j,
	                viewport;
	
	      for (i = 0; i < clusters.length; i += 1) {
	        clusters[i].getMarker().setMap(null);
	      }
	      clusters.length = 0;
	
	      viewport = $data.gmap.getBounds();
	
	      if (!viewport) {
	        var that = this;
	        window.setTimeout(function() {methods._renderCluster.apply(that); }, 1000);
	        return;
	      }
	
	      var ne = viewport.getNorthEast(),
	                sw = viewport.getSouthWest(),
	                width = ne.lat() - sw.lat(),
	                // height = ne.lng() - sw.lng(), // unused
	                clusterable = [],
	                best,
	                bestDist,
	                maxSize = width * opts.clustering.clusterSize / 100,
	                dist,
	                newCluster;
	
	      for (i = 0; i < markers.length; i += 1) {
	        if (markers[i].latitude < ne.lat() &&
	            markers[i].latitude > sw.lat() &&
	                    markers[i].longitude < ne.lng() &&
	                    markers[i].longitude > sw.lng()) {
	                    clusterable[clusterable.length] = markers[i];
	        }
	      }
	
	      if (opts.log) {console.log('number of markers ' + clusterable.length + '/' + markers.length); }
	      if (opts.log) {console.log('cluster radius: ' + maxSize); }
	
	      for (i = 0; i < clusterable.length; i += 1) {
	        bestDist = 10000;
	        best = -1;
	        for (j = 0; j < clusters.length; j += 1) {
	                    dist = clusters[j].dist(clusterable[i]);
	                    if (dist < maxSize) {
	            bestDist = dist;
	            best = j;
	            if (opts.clustering.fastClustering) {break; }
	                    }
	        }
	        if (best === -1) {
	                    newCluster = new Cluster();
	                    newCluster.addMarker(clusterable[i]);
	                    clusters[clusters.length] = newCluster;
	        } else {
	                    clusters[best].addMarker(clusterable[i]);
	        }
	      }
	
	      if (opts.log) {console.log('Total clusters in viewport: ' + clusters.length); }
	
	      for (j = 0; j < clusters.length; j += 1) {
	        clusters[j].getMarker().setMap($data.gmap);
	      }
	    },
	
	    _processMarker: function(marker, gicon, gshadow, location) {
	      var $data = this.data('gmap'),
	                $gmap = $data.gmap,
	                opts = $data.opts,
	                gmarker,
	                markeropts;
	
	      if (location === undefined) {
	        location = new $googlemaps.LatLng(marker.latitude, marker.longitude);
	      }
	
	      if (!gicon) {
	
	        // Set icon properties from global options
	        var _gicon = {
	                    image: opts.icon.image,
	                    iconSize: new $googlemaps.Size(opts.icon.iconsize[0], opts.icon.iconsize[1]),
	                    iconAnchor: new $googlemaps.Point(opts.icon.iconanchor[0], opts.icon.iconanchor[1]),
	                    infoWindowAnchor: new $googlemaps.Size(opts.icon.infowindowanchor[0], opts.icon.infowindowanchor[1])
	        };
	        gicon = new $googlemaps.MarkerImage(_gicon.image, _gicon.iconSize, null, _gicon.iconAnchor);
	      }
	
	      if (!gshadow) {
	        var _gshadow = {
	                    image: opts.icon.shadow,
	                    iconSize: new $googlemaps.Size(opts.icon.shadowsize[0], opts.icon.shadowsize[1]),
	                    anchor: (_gicon && _gicon.iconAnchor) ? _gicon.iconAnchor : new $googlemaps.Point(opts.icon.iconanchor[0], opts.icon.iconanchor[1])
	        };
	      }
	
	      markeropts = {
	        position: location,
	        icon: gicon,
	        title: marker.title,
	        map: null,
	        draggable: ((marker.draggable === true) ? true : false)
	                };
	
	      if (!opts.clustering.enabled) {markeropts.map = $gmap; }
	
	      gmarker = new $googlemaps.Marker(markeropts);
	      gmarker.setShadow(gshadow);
	      $data.markers.push(gmarker);
	
	      if (marker.key) {$data.markerKeys[marker.key] = gmarker; }
	
	      // Set HTML and check if info window should be opened
	      var infoWindow;
	      if (marker.html) {
	        var infoContent = typeof(marker.html) === 'string' ? opts.html_prepend + marker.html + opts.html_append : marker.html;
	        var infoOpts = {
	                    content: infoContent,
	                    pixelOffset: marker.infoWindowAnchor
	        };
	
	        if (opts.log) {console.log('setup popup with data'); }
	        if (opts.log) {console.log(infoOpts); }
	        infoWindow = new $googlemaps.InfoWindow(infoOpts);
	
	        $googlemaps.event.addListener(gmarker, 'click', function() {
	                    if (opts.log) {console.log('opening popup ' + marker.html); }
	                    if (opts.singleInfoWindow && $data.infoWindow) {$data.infoWindow.close(); }
	                    infoWindow.open($gmap, gmarker);
	                    $data.infoWindow = infoWindow;
	        });
	      }
	      if (marker.html && marker.popup) {
	        if (opts.log) {console.log('opening popup ' + marker.html); }
	        infoWindow.open($gmap, gmarker);
	        $data.infoWindow = infoWindow;
	      }
	
	      if (marker.onDragEnd) {
	        $googlemaps.event.addListener(gmarker, 'dragend', function(event) {
	                    if (opts.log) {console.log('drag end');}
	                    marker.onDragEnd(event);
	        });
	      }
	
	    },
	
	    _convertMarkers: function(googleMarkers) {
	      var markers = [], i;
	      for (i = 0; i < googleMarkers.length; i += 1) {
	        markers[i] = {
	                    latitude: googleMarkers[i].getPosition().lat(),
	                    longitude: googleMarkers[i].getPosition().lng()
	        };
	      }
	      return markers;
	    },
	
	    _geocodeMarker: function(marker, gicon, gshadow) {
	      var that = this;
	      $geocoder.geocode({'address': marker.address}, function(results, status) {
	        if (status === $googlemaps.GeocoderStatus.OK) {
	                    $markersToLoad -= 1;
	                    if (that.data('gmap').opts.log) {console.log('Geocode was successful with point: ', results[0].geometry.location); }
	                    methods._processMarker.apply(that, [marker, gicon, gshadow, results[0].geometry.location]);
	        } else {
	                    if (status === $googlemaps.GeocoderStatus.OVER_QUERY_LIMIT) {
	            if ((!that.data('gmap').opts.noAlerts) && (overQueryLimit === 0)) {alert('Error: too many geocoded addresses! Switching to 1 marker/s mode.'); }
	
	            overQueryLimit += 1000;
	            window.setTimeout(function() {
	              methods._geocodeMarker.apply(that, [marker, gicon, gshadow]);
	            }, overQueryLimit);
	                    }
	                    if (that.data('gmap').opts.log) {console.log('Geocode was not successful for the following reason: ' + status); }
	        }
	      });
	    },
	
	    _autoZoom: function(options, fromMarkers) {
	      var data = $(this).data('gmap'),
	                opts = $.extend({}, data ? data.opts : {}, options),
	                i, boundaries, resX, resY, baseScale = 39135.758482;
	      if (opts.log) {console.log('autozooming map');}
	
	      if (fromMarkers) {
	        opts.markers = methods._convertMarkers(data.markers);
	      }
	
	      boundaries = methods._getBoundaries(opts);
	
	      resX = (boundaries.E - boundaries.W) * 111000 / this.width();
	      resY = (boundaries.S - boundaries.N) * 111000 / this.height();
	
	      for (i = 2; i < 20; i += 1) {
	        if (resX > baseScale || resY > baseScale) {
	                    break;
	        }
	        baseScale = baseScale / 2;
	      }
	      return i - 2;
	    },
	
	    /**
	         * public methods section
	         */
	
	    /**
	         * add array of markers
	         * @param markers
	         */
	    addMarkers: function(markers) {
	      var opts = this.data('gmap').opts;
	
	      if (markers.length !== 0) {
	        if (opts.log) {console.log('adding ' + markers.length + ' markers');}
	        // Loop through marker array
	        for (var i = 0; i < markers.length; i += 1) {
	                    methods.addMarker.apply(this, [markers[i]]);
	        }
	      }
	    },
	
	    /**
	         * add single marker
	         * @param marker
	         */
	    addMarker: function(marker) {
	      var opts = this.data('gmap').opts;
	
	      if (opts.log) {console.log('putting marker at ' + marker.latitude + ', ' + marker.longitude + ' with address ' + marker.address + ' and html ' + marker.html); }
	
	      // Create new icon
	      // Set icon properties from global options
	      var _gicon = {
	        image: opts.icon.image,
	        iconSize: new $googlemaps.Size(opts.icon.iconsize[0], opts.icon.iconsize[1]),
	        iconAnchor: new $googlemaps.Point(opts.icon.iconanchor[0], opts.icon.iconanchor[1]),
	        infoWindowAnchor: new $googlemaps.Size(opts.icon.infowindowanchor[0], opts.icon.infowindowanchor[1])
	      },
	          _gshadow = {
	            image: opts.icon.shadow,
	            iconSize: new $googlemaps.Size(opts.icon.shadowsize[0], opts.icon.shadowsize[1]),
	            anchor: new $googlemaps.Point(opts.icon.shadowanchor[0], opts.icon.shadowanchor[1])
	          };
	
	      // not very nice, but useful
	      marker.infoWindowAnchor = _gicon.infoWindowAnchor;
	
	      if (marker.icon) {
	        // Overwrite global options
	        if (marker.icon.image) { _gicon.image = marker.icon.image; }
	        if (marker.icon.iconsize) { _gicon.iconSize = new $googlemaps.Size(marker.icon.iconsize[0], marker.icon.iconsize[1]); }
	
	        if (marker.icon.iconanchor) { _gicon.iconAnchor = new $googlemaps.Point(marker.icon.iconanchor[0], marker.icon.iconanchor[1]); }
	        if (marker.icon.infowindowanchor) { _gicon.infoWindowAnchor = new $googlemaps.Size(marker.icon.infowindowanchor[0], marker.icon.infowindowanchor[1]); }
	
	        if (marker.icon.shadow) { _gshadow.image = marker.icon.shadow; }
	        if (marker.icon.shadowsize) { _gshadow.iconSize = new $googlemaps.Size(marker.icon.shadowsize[0], marker.icon.shadowsize[1]); }
	
	        if (marker.icon.shadowanchor) { _gshadow.anchor = new $googlemaps.Point(marker.icon.shadowanchor[0], marker.icon.shadowanchor[1]); }
	      }
	
	      var gicon = new $googlemaps.MarkerImage(_gicon.image, _gicon.iconSize, null, _gicon.iconAnchor);
	      var gshadow = new $googlemaps.MarkerImage(_gshadow.image, _gshadow.iconSize, null, _gshadow.anchor);
	
	      // Check if address is available
	      if (marker.address) {
	        // Check for reference to the marker's address
	        if (marker.html === '_address') {
	                    marker.html = marker.address;
	        }
	
	        if (marker.title == '_address') {
	                    marker.title = marker.address;
	        }
	
	        if (opts.log) {console.log('geocoding marker: ' + marker.address); }
	        // Get the point for given address
	        $markersToLoad += 1;
	        methods._delayedMode = true;
	        methods._geocodeMarker.apply(this, [marker, gicon, gshadow]);
	      } else {
	        // Check for reference to the marker's latitude/longitude
	        if (marker.html === '_latlng') {
	                    marker.html = marker.latitude + ', ' + marker.longitude;
	        }
	
	        if (marker.title == '_latlng') {
	                    marker.title = marker.latitude + ', ' + marker.longitude;
	        }
	
	        // Create marker
	        var gpoint = new $googlemaps.LatLng(marker.latitude, marker.longitude);
	        methods._processMarker.apply(this, [marker, gicon, gshadow, gpoint]);
	      }
	    },
	
	    /**
	         *
	         */
	    removeAllMarkers: function() {
	      var markers = this.data('gmap').markers, markerKeys = this.data('gmap').markerKeys, i;
	
	      for (i = 0; i < markers.length; i += 1) {
	        markers[i].setMap(null);
	        delete markers[i];
	      }
	      markers.length = 0;
	
	      for (i in markerKeys) {
	        delete markerKeys[i];
	      }
	    },
	
	    removeMarker: function(marker) {
	      var markers = this.data('gmap').markers, markerKeys = this.data('gmap').markerKeys, i = markers.indexOf(marker);
	
	      if (i !== -1) {
	        markers[i].setMap(null);
	        delete markers[i];
	        markers.splice(i, 1);
	      }
	
	      for (i in markerKeys) {
	        if (markerKeys[i] === marker) {
	          delete markerKeys[i];
	        }
	      }
	    },
	
	    /**
	         * get marker by key, if set previously
	         * @param key
	         */
	    getMarker: function(key) {
	      return this.data('gmap').markerKeys[key];
	    },
	
	    /**
	         * should be called if DOM element was resized
	         * @param nasty
	         */
	    fixAfterResize: function(nasty) {
	      var data = this.data('gmap');
	      $googlemaps.event.trigger(data.gmap, 'resize');
	
	      if (nasty) {
	        data.gmap.panTo(new google.maps.LatLng(0, 0));
	      }
	      data.gmap.panTo(this.gMap('_getMapCenter', data.opts));
	    },
	
	    /**
	         * change zoom, works with 'fit' option as well
	         * @param zoom
	         */
	    setZoom: function(zoom, opts, fromMarkers) {
	      var $map = this.data('gmap').gmap;
	      if (zoom === 'fit') {
	        zoom = methods._autoZoom.apply(this, [opts, fromMarkers]);
	      }
	      $map.setZoom(parseInt(zoom));
	    },
	
	    changeSettings: function(options) {
	      var data = this.data('gmap'),
	                markers = [], i, originalMarkers;
	      if (options.markers === undefined) {
	        options.markers = methods._convertMarkers(data.markers);
	      }
	      else if (options.markers.length !== 0 && options.markers[0].latitude === undefined) {
	        options.markers = methods._convertMarkers(options.markers);
	      }
	
	      if (options.zoom) methods.setZoom.apply(this, [options.zoom, options]);
	      if (options.latitude || options.longitude) {
	        data.gmap.panTo(methods._getMapCenter.apply(this, [options]));
	      }
	
	      // add controls and maptype
	    },
	
	    mapclick: function(callback) {
	      google.maps.event.addListener(this.data('gmap').gmap, 'click', function(event) {
	        callback(event.latLng);
	      });
	    },
	
	    geocode: function(address, callback, errorCallback) {
	      $geocoder.geocode({'address': address}, function(results, status) {
	        if (status === $googlemaps.GeocoderStatus.OK) {
	                    callback(results[0].geometry.location);
	        } else if (errorCallback) {
	                    errorCallback(results, status);
	        }
	      });
	    },
	
	    getRoute: function(options) {
	
	      var $data = this.data('gmap'),
	          $gmap = $data.gmap,
	          $directionsDisplay = new $googlemaps.DirectionsRenderer(),
	          $directionsService = new $googlemaps.DirectionsService(),
	          $travelModes = { 'BYCAR': $googlemaps.DirectionsTravelMode.DRIVING, 'BYBICYCLE': $googlemaps.DirectionsTravelMode.BICYCLING, 'BYFOOT': $googlemaps.DirectionsTravelMode.WALKING },
	          $travelUnits = { 'MILES': $googlemaps.DirectionsUnitSystem.IMPERIAL, 'KM': $googlemaps.DirectionsUnitSystem.METRIC },
	          displayObj = null,
	          travelMode = null,
	          travelUnit = null,
	          unitSystem = null;
	
	      // look if there is an individual or otherwise a default object for this call to display route text informations
	      if (options.routeDisplay !== undefined) {
	        displayObj = (options.routeDisplay instanceof jQuery) ? options.routeDisplay[0] : ((typeof options.routeDisplay == 'string') ? $(options.routeDisplay)[0] : null);
	      } else if ($data.opts.routeFinder.routeDisplay !== null) {
	        displayObj = ($data.opts.routeFinder.routeDisplay instanceof jQuery) ? $data.opts.routeFinder.routeDisplay[0] : ((typeof $data.opts.routeFinder.routeDisplay == 'string') ? $($data.opts.routeFinder.routeDisplay)[0] : null);
	      }
	
	      // set route renderer to map
	      $directionsDisplay.setMap($gmap);
	      if (displayObj !== null) {
	        $directionsDisplay.setPanel(displayObj);
	      }
	
	      // get travel mode and unit
	      travelMode = ($travelModes[$data.opts.routeFinder.travelMode] !== undefined) ? $travelModes[$data.opts.routeFinder.travelMode] : $travelModes['BYCAR'];
	      travelUnit = ($travelUnits[$data.opts.routeFinder.travelUnit] !== undefined) ? $travelUnits[$data.opts.routeFinder.travelUnit] : $travelUnits['KM'];
	
	      // build request
	      var request = {
	        origin: options.from,
	        destination: options.to,
	        travelMode: travelMode,
	        unitSystem: travelUnit
	      };
	
	      // send request
	      $directionsService.route(request, function(result, status) {
	        // show the rout or otherwise show an error message in a defined container for route text information
	        if (status == $googlemaps.DirectionsStatus.OK) {
	                    $directionsDisplay.setDirections(result);
	        } else if (displayObj !== null) {
	                    $(displayObj).html($data.opts.routeFinder.routeErrors[status]);
	        }
	      });
	      return this;
	    }
	  };
	
	
	  // Main plugin function
	  $.fn.gMap = function(method) {
	    // Method calling logic
	    if (methods[method]) {
	      return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
	    } else if (typeof method === 'object' || !method) {
	      return methods.init.apply(this, arguments);
	    } else {
	      $.error('Method ' + method + ' does not exist on jQuery.gmap');
	    }
	  };
	
	  // Default settings
	  $.fn.gMap.defaults = {
	    log: false,
	    address: '',
	    latitude: null,
	    longitude: null,
	    zoom: 3,
	    maxZoom: null,
	    minZoom: null,
	    markers: [],
	    controls: {},
	    scrollwheel: true,
	    maptype: google.maps.MapTypeId.ROADMAP,
	
	    mapTypeControl: true,
	    zoomControl: true,
	    panControl: false,
	    scaleControl: false,
	    streetViewControl: true,
	
	    controlsPositions: {
	      mapType: null,
	      zoom: null,
	      pan: null,
	      scale: null,
	      streetView: null
	    },
	    controlsStyle: {
	      mapType: google.maps.MapTypeControlStyle.DEFAULT,
	      zoom:	google.maps.ZoomControlStyle.DEFAULT
	    },
	
	    singleInfoWindow: true,
	
	    html_prepend: '<div class="gmap_marker">',
	    html_append: '</div>',
	    icon: {
	      image: 'http://www.google.com/mapfiles/marker.png',
	      iconsize: [20, 34],
	      iconanchor: [9, 34],
	      infowindowanchor: [9, 2],
	      shadow: 'http://www.google.com/mapfiles/shadow50.png',
	      shadowsize: [37, 34],
	      shadowanchor: [9, 34]
	    },
	
	    onComplete: function() {},
	
	    routeFinder: {
	      travelMode: 'BYCAR',
	      travelUnit: 'KM',
	      routeDisplay: null,
	      routeErrors:	{
	        'INVALID_REQUEST': 'The provided request is invalid.',
	        'NOT_FOUND': 'One or more of the given addresses could not be found.',
	        'OVER_QUERY_LIMIT': 'A temporary error occured. Please try again in a few minutes.',
	        'REQUEST_DENIED': 'An error occured. Please contact us.',
	        'UNKNOWN_ERROR': 'An unknown error occured. Please try again.',
	        'ZERO_RESULTS': 'No route could be found within the given addresses.'
	      }
	    },
	
	    clustering: {
	      enabled: false,
	      fastClustering: false,
	      clusterCount: 10,
	      clusterSize: 40 //radius as % of viewport width
	    },
	    extra: {}
	  };
	}(jQuery));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 2)))

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** pixo/js/pixo.js
 **/